(function () {
  'use strict';
  angular
    .module('tms', [
          'ngAnimate',
          'ngCookies',
          'ngTouch',
          'ngSanitize',
          'ngMap',
          'highcharts-ng',
          'ui.router',
          'ui.router.stateHelper',
          'ui.bootstrap',
          'ui.mask',
          'ui.validate',
          'restangular',
          'ngFileUpload',
          'LocalStorageModule',
          'infinite-scroll',
          'ckeditor',
          'angular-loading-bar',
          'toastr',
          'colorpicker.module',
          'timer'
      ])
    .value('appVersion', '{version}')
    .value('THROTTLE_MILLISECONDS', 400);
})();

(function () {
	'use strict';

	angular.module('tms').controller('TourController', TourController);

	function TourController($scope, $state, $stateParams, EventsService, $timeout, toastr, LocationsService, ckEditorOptions, Upload, SiteService, AuthService, calendarOptions) {
		var vm = this;
    var userData = AuthService.init();
    // vm.userData = userData;
    
    vm.loading = false;
		vm.tour = [];
    vm.item = {
      datePublish: null
    };
//start search
    vm.items = []; 
    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;   
    vm.sortOrder = null; 
    vm.selectedItem = {};   
    vm.disableScroll = true;

    vm.filters = { 
      name: null,
      status: null
   };

    getList();

    vm.lang = [
      {name: 'ua', id: '1', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''},
      {name: 'ru', id: '2', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''},
      {name: 'en', id: '3', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''}
    ];

vm.load = function () {     
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }



vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };

    vm.filter = function(){
      // if (!vm.filters.status)
      // vm.filters.status = null;
      vm.offset = 0;
      // vm.count = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }
    function getList() {
      var query = _.extend({}, vm.filters, {sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      SiteService.tour.list(query).then(function (response) {
        // vm.items = (clear) ? response.items : vm.items.concat(response.items);
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
//end search

		vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    //vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions;    

    if ($state.current.name === 'main.site.tour.edit') {
  vm.edit = true;
      if ($stateParams.id)
      SiteService.tour.get($stateParams.id).then(function (response) {
        response.datePublish = moment(response.datePublish)
				vm.item = response;
			});
    EventsService.events.list().then(function (response) {
          vm.event = response.items;
       }); 
}	

		vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.tourform.$valid) {
        return;
      }

      vm.item.create_lang = vm.lang;      
      vm.item.tours_desktop =_.map(vm.item.tours_desktop, 'id');
      vm.item.tours_desktop_retina =_.map(vm.item.tours_desktop_retina, 'id');
      vm.item.tours_mobile =_.map(vm.item.tours_mobile, 'id');
      vm.item.tours_mobile_retina =_.map(vm.item.tours_mobile_retina, 'id');      

      // vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.tour.save(vm.item).then(function(){
        toastr.success('Тур збережено!');
        $state.go('main.site.tour');
      }).finally(function(){
        vm.loading = false;
      });
		}

		vm.delete = function(n) {
      n.deleted = true;
      SiteService.tour.delete(n.id);
		}

    //for label desktop     
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','tour_image':'tour_image','tour_id':vm.item.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.tours_desktop = vm.item.tours_desktop || [];
            $timeout(function () {
              vm.item.tours_desktop.push(response.data);
              
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }
    }

     vm.removeTours_desktop = function(tour) {
      var i = _.findIndex(vm.item.tours_desktop, {id: tour.id});
      vm.item.tours_desktop.splice(i, 1);
      vm.item.deletedTours_desktop.push(tour.id);
      }


    //for label desktop_retina     
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','tour_image':'tour_image','tour_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.tours_desktop_retina = vm.item.tours_desktop_retina || [];
            $timeout(function () {
              vm.item.tours_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeTours_desktop_retina = function(tour) {
      var i = _.findIndex(vm.item.tours_desktop_retina, {id: tour.id});
      vm.item.tours_desktop_retina.splice(i, 1);
      vm.item.deletedTours_desktop_retina.push(tour.id);
    }

//for label mobile   
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','tour_image':'tour_image','tour_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.tours_mobile = vm.item.tours_mobile || [];
            $timeout(function () {
              vm.item.tours_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeTours_mobile = function(tour) {
      var i = _.findIndex(vm.item.tours_mobile, {id: tour.id});
      vm.item.tours_mobile.splice(i, 1);
      vm.item.deletedTours_mobile.push(tour.id);
    }

    //for label mobile_retina   
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','tour_image':'tour_image','tour_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.tours_mobile_retina = vm.item.tours_mobile_retina || [];
            $timeout(function () {
              vm.item.tours_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeTours_mobile_retina = function(tour) {
      var i = _.findIndex(vm.item.tours_mobile_retina, {id: tour.id});
      vm.item.tours_mobile_retina.splice(i, 1);
      vm.item.deletedTours_mobile_retina.push(tour.id);
    } 

	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('SlidesController', SlidesController);

	function SlidesController($scope, $state, $stateParams, $timeout, toastr, Upload, AuthService, SiteService, LocationsService, EventsService) {
    var vm = this;
    var userData = AuthService.init();

    vm.getTours = EventsService.getTours();

    vm.loading = false;
    vm.slides = [];
    vm.item = {};
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line


    if ($state.current.name === 'main.site.slides.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.slides.get($stateParams.id).then(function (response) {
				vm.item = response;
			});
      LocationsService.getCities().then(function (response) {
        vm.cities = response.items;
      });
		}

		if ($state.current.name === 'main.site.slides') {
      SiteService.slides.list().then(function (response) {
        vm.slides = response.items;
      });
		}

    vm.delete = function(slide) {
      slide.deleted = true;
      SiteService.slides.delete(slide.id);
    };

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.slide.$valid) {
        return;
      }
      vm.loading = true;
      SiteService.slides.save(vm.item).then(function () {
        toastr.success('Слайд збережено!');
        $state.go('main.site.slides');
      }).finally(function () {
        vm.loading = false;
      })
    }

    vm.uploadFile = function (file, small, retina) {
      if (!file)
        return;
      file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
      });
      file.upload.then(function (response) {
        $timeout(function () {
			if (!retina){
          (small) ? vm.item.smallSlideID = response.data.id : vm.item.bigSlideID = response.data.id;
          (small) ? vm.item.smallSlideUrl = response.data.url : vm.item.bigSlideUrl = response.data.url;
			}
			else
			{
			(small) ? vm.item.smallSlideIDRetina = response.data.id : vm.item.bigSlideIDRetina = response.data.id;
			(small) ? vm.item.smallSlideUrlRetina = response.data.url : vm.item.bigSlideUrlRetina = response.data.url;
			
			}
        });
      }, function (response) {
        if (response.status > 0) {
          toastr.warning(response.status + ': ' + response.data);
        }
      });
    }

	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('RecommendationsController', RecommendationsController);

	function RecommendationsController($scope, $state, $stateParams, toastr, $uibModal, SiteService, EventsService) {
        var vm = this;

        vm.items = [];
        vm.events = [];
        vm.addedEvents = [];

        getList();

        vm.save = function () {

            if (vm.addedEvents.length <= 0) {
                return;
            }

            $scope.$broadcast('show-errors-check-validity');
            if (!vm.form.$valid) {
                return;
            }

            SiteService.recommendations.save({events: vm.addedEvents}).then(function (response) {
                vm.addedEvents = [];
                vm.afterSave(response);
            });
        };

        vm.delete = function (event) {

            $uibModal.open({
                templateUrl: 'app/main/site/recommendations/modal/modal.delete.html',
                size: 'sm',
                controller: function ($scope, $uibModalInstance) {
                    var scope = $scope;

                    scope.ok = function () {
                        SiteService.recommendations.delete(event.id).then(function (response) {
                            $uibModalInstance.dismiss();
                            vm.afterSave(response, 'Успішно видалено');
                        });
                    };

                    scope.close = function () {
                        $uibModalInstance.dismiss();
                    };
                }
            });
        };

        vm.afterSave = function (response, successMessage) {
            if (response.error_code) {
                toastr.error(response.error_msg);
            } else if (response.success) {
                if (angular.isUndefined(successMessage)) {
                    successMessage = 'Успішно збережено';
                }
                toastr.success(successMessage, '', {
                    "timeOut": "5000"
                });
            }
            getList();
        };

        function getList() {
            SiteService.recommendations.getList().then(function (response) {
                vm.items = response.items || [];
                vm.count = response.count;
            }).then(function () {
                return EventsService.events.list({status: 'in_sales'});
            }).then(function (response) {
                var events = response.items || [];
                var recIds = vm.items.map(function (rec) {
                    return +rec.id;
                });
                vm.events = events.filter(function (event) {
                    return !recIds.includes(+event.id)
                });
            });
        }
    }
})();

(function () {
  'use strict';

  angular.module('tms').service('FBPixelService', FBPixelService);

  function FBPixelService(Restangular) {

    var self = this

    var Pixels = Restangular.one('/fb-pixels')
    var Pixel = Restangular.one('/fb-pixel')

    self.getList = function (filters) {
      return Pixels.get(filters)
    }

    self.get = function (id) {
      return Pixel.one(id+'').get()
    }

    self.save = function (data) {
      if(data.id) {
        return Pixel.one(data.id+'').customPUT(data, '', {})
      }
      return Pixel.customPOST(data, '', {})
    }

    self.delete = function (id) {
      return Pixel.one(id+'').remove();
    }

  }
})();

(function () {
	'use strict';

	angular.module('tms').controller('FBPixelEditController', FBPixelEditController);

	function FBPixelEditController($scope, $state, $stateParams, LocationsService, FBPixelService, toastr) {
		var vm = this;

    vm.cityList = LocationsService.getCities();

    vm.pixel = {
      status: 'not_active'
    }

    if($stateParams.id) {
      FBPixelService.get($stateParams.id).then(function (json) {
        vm.pixel = json
      })
    }

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if(vm.pixelform.$valid) {
        FBPixelService.save(vm.pixel).then(function () {
          toastr.success('Зміни збережені!');
          $state.go('main.site.fb-pixel');
        })
      }
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('FBPixelController', FBPixelController);

	function FBPixelController(FBPixelService) {
		var vm = this;

    vm.items = [];

    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.disableScroll = true;

    getList()

    vm.load = function() {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
        getList();
    }

    vm.sort = function (sort) {
      if (sort === vm.sortOrder)
        sort = '-' + sort;
      vm.sortOrder = sort;
      vm.offset = 0;
      vm.items = [];
      getList();
    }

    vm.delete = function(item) {
      FBPixelService.delete(item.id).then(function(){
        var index = vm.items.indexOf(item)
        if(index != -1) {
          vm.items.splice(index, 1);
        }
      });
    }

    function getList() {
      var query = _.extend({}, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      FBPixelService.getList(query).then(function (response) {
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }


  }

})();

(function () {
	'use strict';

	angular.module('tms').controller('NewsController', NewsController);

	function NewsController($scope, $state, $stateParams, $timeout, toastr, ckEditorOptions, Upload, SiteService, AuthService, calendarOptions) {
		var vm = this;
    var userData = AuthService.init();

   

    vm.loading = false;
		vm.news = [];
    vm.item = {
      datePublish: null
    };
//start search
    vm.items = [];    
    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.disableScroll = true;
    vm.selectedItem = {};

    vm.filters = { 
      name: null,
      status: null
      // _datePublish: null
    };
 
    vm.calendarOptions = calendarOptions;

    getList();

// vm.applyDateFilter = function(){
//       if (vm.filters._datePublish)
//         vm.filters.datePublish = moment(vm.filters._datePublish).format('YYYY-MM-DD');   
//         vm.filter({});   
//     };


vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }

    vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };
// vm.applyFilter = function(ac){
//       $timeout(function(){
//         // handling filter reset
//         if (angular.isUndefined(vm.filters[ac]) || vm.filters[ac] === '') {
//           vm.filter();
//         }
//         if (ac && vm.filters[ac]) {
//           vm.filter();
//         }
//       });
//     };

    vm.filter = function(){      
      //vm.filters.status = null;
      vm.offset = 0;
      // vm.count = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }
    
    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      SiteService.news.list(query).then(function (response) {
        // vm.items = (clear) ? response.items : vm.items.concat(response.items);
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
//end search

		vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    
    vm.ckEditorOptions = ckEditorOptions;


		if ($state.current.name === 'main.site.news.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.news.get($stateParams.id).then(function (response) {
        response.datePublish = moment(response.datePublish)
				vm.item = response;
			});
    SiteService.artists.list().then(function (response) {
        vm.artists = response.items;
      });
    SiteService.area.list().then(function (response) {
        vm.area = response.items;
      });
   
		}

		// if ($state.current.name === 'main.site.news') {
		// 	SiteService.news.list().then(function (response) {
		// 		vm.news = response.items;
		// 	});
		// }

		vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.newsform.$valid) {
        return;
      }

      vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')

      vm.loading = true;
      SiteService.news.save(vm.item).then(function(){
        toastr.success('Новину збережено!');
        $state.go('main.site.news');
      }).finally(function(){
        vm.loading = false;
      });
		}

		vm.delete = function (item) {
      item.deleted = true;
      SiteService.news.delete(item.id);
		}

   //  vm.uploadFile = function (file, ckeditor) {
   //    if (!file)
   //      return;
			// vm.loading = true;
   //    toastr.success('Фото добавлено! Обновіть сторінку.');

   //    file.upload = Upload.upload({
   //      url: '/index.php/file',
   //      data: {file: file,'types': vm.item.types,'news_id':vm.item.id},        
   //      headers: {'Authorization': 'Bearer ' + userData.access_token}
   //    });
   //    file.upload.then(function (response) {
   //      vm.loading = false;
   //      if (ckeditor) {
   //        vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
   //      } else {
   //         vm.item.posters =  vm.item.posters || [];
         
   //         $timeout(function () {            
   //           vm.item.posters.push(response.data);           

   //          vm.item.types = response.data.types;
   //          vm.item.imageID = response.data.id;
   //          vm.item.imageUrl = response.data.url;            
   //        });
   //      }          
   //    }, function (response) {
			// 	vm.loading = false;

   //      if (response.status > 0) {
   //        toastr.warning(response.status + ': ' + response.data);
   //      }
      
   //    });
   //  }

    //for label desktop     
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
     
      if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','news_id':vm.item.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.news_desktop = vm.item.news_desktop || [];
            $timeout(function () {
              vm.item.news_desktop.push(response.data);
              
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }
    }

     vm.removeNews_desktop = function(news) {
      var i = _.findIndex(vm.item.news_desktop, {id: news.id});
      vm.item.news_desktop.splice(i, 1);
      vm.item.deletedNews_desktop.push(news.id);
      }


    //for label desktop_retina     
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','news_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.news_desktop_retina = vm.item.news_desktop_retina || [];
            $timeout(function () {
              vm.item.news_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeNews_desktop_retina = function(news) {
      var i = _.findIndex(vm.item.news_desktop_retina, {id: news.id});
      vm.item.news_desktop_retina.splice(i, 1);
      vm.item.deletedNews_desktop_retina.push(news.id);
    }

//for label mobile   
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','news_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.news_mobile = vm.item.news_mobile || [];
            $timeout(function () {
              vm.item.news_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeNews_mobile = function(news) {
      var i = _.findIndex(vm.item.news_mobile, {id: news.id});
      vm.item.news_mobile.splice(i, 1);
      vm.item.deletedNews_mobile.push(news.id);
    }

    //for label mobile_retina   
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
     
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','news_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.news_mobile_retina = vm.item.news_mobile_retina || [];
            $timeout(function () {
              vm.item.news_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeNews_mobile_retina = function(news) {
      var i = _.findIndex(vm.item.news_mobile_retina, {id: news.id});
      vm.item.news_mobile_retina.splice(i, 1);
      vm.item.deletedNews_mobile_retina.push(news.id);
    } 

	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('GeoCityLangController', GeoCityLangController);

	function GeoCityLangController($scope, $state, $timeout, calendarOptions, AuthService, Upload, $stateParams, toastr, ckEditorOptions, SiteService) {
	var vm = this;
  var userData = AuthService.init();
  vm.userData = userData;


    vm.loading = false;   
    vm.geocitylang = [];
    vm.item = {
      //datePublish: null
    };
//start search
    vm.items = [];
    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.disableScroll = true;
    vm.selectedItem = {};

    vm.filters = { 
      // phone: null,
      // type: null,
      name: null
      // _dateCreate: null,
      // status: null
     }

    vm.calendarOptions = calendarOptions;

    getList();

vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }

vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };

// vm.applyDateFilter = function(){
//       if (vm.filters._dateCreate)
//         vm.filters.dateCreate = moment(vm.filters._dateCreate).format('YYYY-MM-DD');
      
//       vm.filter({});
//     };

    vm.filter = function(){
      // if (!vm.filters.status)
      //   vm.filters.status = null;
      vm.offset = 0;
      // vm.count = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }

    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      SiteService.geocitylang.list(query).then(function (response) {
        // vm.items = (clear) ? response.items : vm.items.concat(response.items);
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }

    // vm.getType = function(type) {
    //   if (_.find(vm.typesList, {id: type})) {
    //     return _.find(vm.typesList, {id: type}).name;
    //   }
    // }
//end search

    vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    // vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions;
    

    if ($state.current.name === 'main.site.geocitylang.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.geocitylang.get($stateParams.id).then(function (response) {
        //response.datePublish = moment(response.datePublish)
				vm.item = response;
			});
		}

	vm.save = function(){
      $scope.$broadcast('show-errors-check-validity');
      if(!vm.geocitylangform.$valid){
        return;
      }

      //vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.geocitylang.save(vm.item).then(function(){
        toastr.success('Місто збережене!');
        $state.go('main.site.geocitylang');
      }).finally(function(){
        vm.loading = false;
      });
		}

             
   
    
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('ChoicePlaceController', ChoicePlaceController);

	function ChoicePlaceController($scope, $state, $stateParams, EventService, $timeout, toastr, LocationsService, ckEditorOptions, Upload, SiteService, AuthService, calendarOptions) {
		var vm = this;
    var userData = AuthService.init();
    vm.userData = userData;
    
    vm.loading = false;
		vm.choiceplace = [];
    vm.item = {
      datePublish: null
    };


		vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    //vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions
    

    if ($state.current.name === 'main.site.choiceplace.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.choiceplace.get($stateParams.id).then(function (response) {
        response.datePublish = moment(response.datePublish)
				vm.item = response;
			});
        EventService.getEvent().then(function (response) {
          vm.event = response.items;
       });
		}

		if ($state.current.name === 'main.site.choiceplace') {
			SiteService.choiceplace.list().then(function (response) {
				vm.choiceplace = response.items;
			});
		}

		vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.choiceplaceform.$valid) {
        return;
      }

      vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.choiceplace.save(vm.item).then(function(){
        toastr.success('Місце збережено!');
        $state.go('main.site.choiceplace');
      }).finally(function(){
        vm.loading = false;
      });
		}

		vm.delete = function (item) {
      item.deleted = true;
      SiteService.choiceplace.delete(item.id);
		}

    vm.uploadFile = function (file, ckeditor) {
      if (!file)
        return;
			vm.loading = true;

      file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
      });
      file.upload.then(function (response) {
        vm.loading = false;
        if (ckeditor) {
          vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
        } else {
          $timeout(function () {
            vm.item.imageID = response.data.id;
            vm.item.imageUrl = response.data.url;
          });
        }
      }, function (response) {
				vm.loading = false;
        if (response.status > 0) {
          toastr.warning(response.status + ': ' + response.data);
        }
      });
    }

	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('ChoiceController', ChoiceController);

  function ChoiceController($scope, $state, $stateParams, EventsService, $timeout, toastr, LocationsService, ckEditorOptions, Upload, SiteService, AuthService, calendarOptions) {
    var vm = this;
    var userData = AuthService.init();
    var defaultBackground = 'white';
    vm.userData = userData;
    
    vm.loading = false;
    vm.choice = [];   
    vm.item = {
      datePublish: null,
      background: defaultBackground
    };
//start search
    vm.items = [];
    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.sortOrder = null; 
    vm.selectedItem = {};
    vm.disableScroll = true;

    vm.filters = { 
      name: null,
      status: null
    };

    getList();

vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }

vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };

vm.filter = function(){
      // if (!vm.filters.status)
      // vm.filters.status = null;
      vm.offset = 0;
      vm.count = 0;
      vm.items = [];
       vm.disableScroll = true;
      getList();
    }

function getList() {
      var query = _.extend({}, vm.filters, {sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      SiteService.choice.list(query).then(function (response) {
        // vm.items = (clear) ? response.items : vm.items.concat(response.items);
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
//end search

    vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    //vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions;
    

    if ($state.current.name === 'main.site.choice.edit') {
      vm.edit = true;
      if ($stateParams.id)
      SiteService.choice.get($stateParams.id).then(function (response) {
        response.datePublish = moment(response.datePublish)
        vm.item = response;
        if (!vm.item.background) {
            vm.item.background = defaultBackground;
        }
      });
       
      SiteService.choiceplace.list().then(function (response) {
          vm.choiceplace = response.items;
       });
      SiteService.georegion.list().then(function (response) {
        vm.georegion = response.items;
      });
      EventsService.events.list().then(function (response) {
          vm.event = response.items;
       });       
            
    }

    // if ($state.current.name === 'main.site.choice') {
    //   SiteService.choice.list().then(function (response) {
    //     vm.choice = response.items;
    //   });
    // }

    // vm.genUrlAlias = function () {
        
    //     if (!vm.choice.id){
    //         return;
    //     }
        
    //     SiteService.choice.getUrlAlias(vm.choice.id).then(function (response) {
    //         vm.choice.urlAlias = response;
    //     });

    // }

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.choiceform.$valid) {
        return;
      }

      vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.choice.save(vm.item).then(function(){
        toastr.success('Підбірка збережена!');
        $state.go('main.site.choice');
      }).finally(function(){
        vm.loading = false;
      });
    }

    vm.delete = function (item) {
      item.deleted = true;
      SiteService.choice.delete(item.id);
    }

    //for label desktop     
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','choice_id':vm.item.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.choice_desktop = vm.item.choice_desktop || [];
            $timeout(function () {
              vm.item.choice_desktop.push(response.data);
              
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }
    }

     vm.removeChoice_desktop = function(choice) {
      var i = _.findIndex(vm.item.choice_desktop, {id: choice.id});
      vm.item.choice_desktop.splice(i, 1);
      vm.item.deletedChoice_desktop.push(choice.id);
      }


    //for label desktop_retina     
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','choice_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.choice_desktop_retina = vm.item.choice_desktop_retina || [];
            $timeout(function () {
              vm.item.choice_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeChoice_desktop_retina = function(choice) {
      var i = _.findIndex(vm.item.choice_desktop_retina, {id: choice.id});
      vm.item.choice_desktop_retina.splice(i, 1);
      vm.item.deletedChoice_desktop_retina.push(choice.id);
    }

//for label mobile   
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','choice_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.choice_mobile = vm.item.choice_mobile || [];
            $timeout(function () {
              vm.item.choice_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeChoice_mobile = function(choice) {
      var i = _.findIndex(vm.item.choice_mobile, {id: choice.id});
      vm.item.choice_mobile.splice(i, 1);
      vm.item.deletedChoice_mobile.push(choice.id);
    }

    //for label mobile_retina   
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','choice_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.choice_mobile_retina = vm.item.choice_mobile_retina || [];
            $timeout(function () {
              vm.item.choice_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeChoice_mobile_retina = function(choice) {
      var i = _.findIndex(vm.item.choice_mobile_retina, {id: choice.id});
      vm.item.choice_mobile_retina.splice(i, 1);
      vm.item.deletedChoice_mobile_retina.push(choice.id);
    }

  }

})();

(function () {
	'use strict';

	angular.module('tms').controller('ArtistsController', ArtistsController);

	function ArtistsController($scope, $state, $timeout, AuthService, Upload, $stateParams, toastr, ckEditorOptions, SiteService, calendarOptions) {
	var vm = this;
  var userData = AuthService.init();
  vm.userData = userData;
  vm.urlAliasPattern = /^[a-zA-Z 0-9-]+$/;
  // vm.descriptionPattern < 255;

    vm.loading = false;
    vm.artists = [];
    vm.item = {
     dateArt: null
    };
//start search
    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.disableScroll = true;
    vm.filters = { names: null, status: null};
    vm.items = [];
    vm.selectedItem = {};

 getList();

vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }

vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };

    vm.filter = function(){
      // if (!vm.filters.status)
      //   vm.filters.status = null;
      vm.offset = 0;
      // vm.count = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }
    function getList() {
      var query = _.extend({}, vm.filters, { limit: vm.limit, offset: vm.offset });
      SiteService.artists.list(query).then(function (response) {
        // vm.items = (clear) ? response.items : vm.items.concat(response.items);
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
//end search

    vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions
    
    if ($state.current.name === 'main.site.artists.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.artists.get($stateParams.id).then(function (response) {
        response.dateArt = moment(response.dateArt)
				vm.item = response;
			});
     
		}

		// if ($state.current.name === 'main.site.artists') {
		// 	SiteService.artists.list().then(function (response) {
		// 		vm.artists = response.items;
		// 	});
		// }

  vm.genUrlAlias = function () {
        
        if (!vm.item.id){
            return;
        }
        
        SiteService.artists.getUrlAlias(vm.item.id).then(function (response) {
            vm.item.urlAlias = response;
        });

    }

	vm.save = function(){
      $scope.$broadcast('show-errors-check-validity');
      if(!vm.artistsform.$valid){
        return;
      }
      // if (vm.artistsform.description.$error.maxlength) {
      //   toastr.warning('Загальний опис НЕ БІЛЬШЕ 255 символів');
      //   return;
      // }

      vm.item.dateArt =  moment(vm.item.dateArt).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.artists.save(vm.item).then(function(){
        toastr.success('Артиста добавленно!');
        $state.go('main.site.artists');
      }).finally(function(){
        vm.loading = false;
      });
		}

     //for label desktop     
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','artists_id':vm.item.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.artists_desktop = vm.item.artists_desktop || [];
            $timeout(function () {
              vm.item.artists_desktop.push(response.data);
              
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }
    }

     vm.removeArtists_desktop = function(artists) {
      var i = _.findIndex(vm.item.artists_desktop, {id: artists.id});
      vm.item.artists_desktop.splice(i, 1);
      vm.item.deletedArtists_desktop.push(artists.id);
      }


    //for label desktop_retina     
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','artists_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.artists_desktop_retina = vm.item.artists_desktop_retina || [];
            $timeout(function () {
              vm.item.artists_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArtists_desktop_retina = function(artists) {
      var i = _.findIndex(vm.item.artists_desktop_retina, {id: artists.id});
      vm.item.artists_desktop_retina.splice(i, 1);
      vm.item.deletedArtists_desktop_retina.push(artists.id);
    }

//for label mobile   
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','artists_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.artists_mobile = vm.item.artists_mobile || [];
            $timeout(function () {
              vm.item.artists_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArtists_mobile = function(artists) {
      var i = _.findIndex(vm.item.artists_mobile, {id: artists.id});
      vm.item.artists_mobile.splice(i, 1);
      vm.item.deletedArtists_mobile.push(artists.id);
    }

    //for label mobile_retina   
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','artists_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.artists_mobile_retina = vm.item.artists_mobile_retina || [];
            $timeout(function () {
              vm.item.artists_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArtists_mobile_retina = function(artists) {
      var i = _.findIndex(vm.item.artists_mobile_retina, {id: artists.id});
      vm.item.artists_mobile_retina.splice(i, 1);
      vm.item.deletedArtists_mobile_retina.push(artists.id);
    } 
           
   
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('AreaController', AreaController);

	function AreaController($scope, $state, $timeout, LocationsService, calendarOptions, AuthService, Upload, $stateParams, toastr, ckEditorOptions, SiteService) {
	var vm = this;
  var userData = AuthService.init();
  vm.userData = userData;


    vm.loading = false;   
    vm.area = [];
    vm.item = {
      //datePublish: null
    };


//start search
    vm.citiesGet = LocationsService.getCities();

    vm.items = [];
    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.disableScroll = true;
    vm.calendarOptions = calendarOptions;

    vm.filters = { 
      name: null
    }    

    getList();

vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      // if (vm.count > vm.offset)
      getList();
    }

// vm.applyFilter = function(ac){
//       $timeout(function(){
//         if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
//           return;
//         }
//         vm.filter({});
//       })
//     };

vm.applyFilter = function(ac){
      $timeout(function(){
        // handling filter reset
        if (angular.isUndefined(vm.filters[ac]) || vm.filters[ac] === '') {
          vm.filter();
        }
        if (ac && vm.filters[ac]) {
          vm.filter();
        }
      });
    };


// vm.applyDateFilter = function(){
//       if (vm.filters._dateCreate)
//         vm.filters.dateCreate = moment(vm.filters._dateCreate).format('YYYY-MM-DD');
      
//       vm.filter({});
//     };

vm.filter = function(){
   vm.offset = 0;
   vm.count = 0;
   vm.items = [];
   vm.disableScroll = true;
   getList(true);
  }

    function getList(clear) {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      SiteService.area.list(query).then(function (response) {
        vm.items = (clear) ? response.items : vm.items.concat(response.items);
        // vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }

    // vm.getType = function(type) {
    //   if (_.find(vm.typesList, {id: type})) {
    //     return _.find(vm.typesList, {id: type}).name;
    //   }
    // }
//end search

    vm.title = $state.current.title;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    // vm.calendarOptions = calendarOptions;
    vm.ckEditorOptions = ckEditorOptions;
    

    if ($state.current.name === 'main.site.area.edit') {
			vm.edit = true;
      if ($stateParams.id)
      SiteService.area.get($stateParams.id).then(function (response) {
        //response.datePublish = moment(response.datePublish)
				vm.item = response;
			});
		}

		// if ($state.current.name === 'main.site.area') {
		// 	SiteService.area.list().then(function (response) {
		// 		vm.area = response.items;
		// 	});
		// }

  vm.genUrlAlias = function () {
        
        if (!vm.area.id){
            return;
        }
        
        SiteService.area.getUrlAlias(vm.area.id).then(function (response) {
            vm.area.urlAlias = response;
        });

    }

	vm.save = function(){
      $scope.$broadcast('show-errors-check-validity');
      if(!vm.areaform.$valid){
        return;
      }

      //vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
      //vm.item.currentEvent = moment(vm.item.currentEvent)
      vm.loading = true;
      SiteService.area.save(vm.item).then(function(){
        toastr.success('Локація збережена!');
        $state.go('main.site.area');
      }).finally(function(){
        vm.loading = false;
      });
		}

      //for label desktop     
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','area_id':vm.item.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.area_desktop = vm.item.area_desktop || [];
            $timeout(function () {
              vm.item.area_desktop.push(response.data);
              
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }
    }

     vm.removeArea_desktop = function(area) {
      var i = _.findIndex(vm.item.area_desktop, {id: area.id});
      vm.item.area_desktop.splice(i, 1);
      vm.item.deletedArea_desktop.push(area.id);
      }


    //for label desktop_retina     
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','area_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.area_desktop_retina = vm.item.area_desktop_retina || [];
            $timeout(function () {
              vm.item.area_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArea_desktop_retina = function(area) {
      var i = _.findIndex(vm.item.area_desktop_retina, {id: area.id});
      vm.item.area_desktop_retina.splice(i, 1);
      vm.item.deletedArea_desktop_retina.push(area.id);
    }

//for label mobile   
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','area_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.area_mobile = vm.item.area_mobile || [];
            $timeout(function () {
              vm.item.area_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArea_mobile = function(area) {
      var i = _.findIndex(vm.item.area_mobile, {id: area.id});
      vm.item.area_mobile.splice(i, 1);
      vm.item.deletedArea_mobile.push(area.id);
    }

    //for label mobile_retina   
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','area_id':vm.item.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.item.description = vm.item.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.item.area_mobile_retina = vm.item.area_mobile_retina || [];
            $timeout(function () {
              vm.item.area_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }
    
   vm.removeArea_mobile_retina = function(area) {
      var i = _.findIndex(vm.item.area_mobile_retina, {id: area.id});
      vm.item.area_mobile_retina.splice(i, 1);
      vm.item.deletedArea_mobile_retina.push(area.id);
    }

          
   
    
	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('EncashmentPercentListController', EncashmentPercentListController);

  function EncashmentPercentListController($scope, EncashmentService, LocationsService, $q) {
    var vm = this;

    vm.cashesList = EncashmentService.getCashes();

    vm.countryList = LocationsService.getCountries();

    vm.isFilter = false

    vm.items = []

    vm.cashID = EncashmentService.lastCashID

    $scope.$watch('vm.countryID', function(){
      vm.cityList = LocationsService.getCities({countryID: vm.countryID});
    })

    $scope.$watch('vm.cityID', function(){
      if(vm.cityID) {
        vm.cashesList = EncashmentService.getCashes({cityID: vm.cityID});
      }
    })

    $scope.$watch('vm.cashID', function () {
      if(vm.cashID) {
        $q.all([
          EncashmentService.getPercentsCash(vm.cashID),
          EncashmentService.getCashiers(vm.cashID)
        ]).then(function (data) {
          var cach = data[0]
          var cashiers = data[1]
          vm.items = [cach].concat(cashiers)
        })
      }
    })



  }

})();

(function () {
  'use strict';

  angular.module('tms').controller('EncashmentPercentEditController', EncashmentPercentEditController);

  function EncashmentPercentEditController($state, $stateParams, type, EventsService, EncashmentService, toastr) {
    var vm = this;
    var model;

    vm.type = type

    vm.events = []

    vm.saveEncashment = function () {
      if(model) {

        var data = {
          pickupPercent: vm.pickupPercent,
          printPercent: vm.printPercent,
          salePercent: vm.salePercent,
          events: vm.events
        }

        model.save(data).then(function () {
          toastr.success('Зміни збережені!');
          $state.go('main.encashment.percents');
        })
      }
    }

    vm.deleteEvent = function (item) {
      var index = vm.events.indexOf(item)
      if(index != -1) {
        vm.events.splice(index, 1);
      }
    }

    function isValidEvent(id) {
      return !_.find(vm.events, {id: +id})
    }

    vm.addEvent = function () {

      if(!isValidEvent(vm.eventID)) return

      EventsService.events.get(vm.eventID).then(function (json) {
        vm.events.push({
          id: json.id,
          name: json.name,
          cityName: json.cityName,
          dateStart: json.dateStart,
          pickupPercent: 0,
          printPercent: 0,
          salePercent: 0
        })
      })
    }

    if($stateParams.id) {
      model = EncashmentService.percents(type, $stateParams.id)
      model.get().then(function (json) {
        angular.merge(vm, json)
      })
    }

  }

})();

(function () {
  'use strict';

  angular.module('tms').controller('EncashmentManagerController', EncashmentManagerController);

  function EncashmentManagerController($scope, EncashmentService, LocationsService, AuthService, calendarOptions) {
    var vm = this;
    var API = '/index.php';
    var user = AuthService.init();


    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;

    vm.cashesList = EncashmentService.getCashes();

    vm.cityList = LocationsService.getCities();

    vm.calendarOptions = calendarOptions;

    vm.items = []

    vm.filters = {}

    getList();

    vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      getList();
    }

    vm.clear = function () {
      vm.filters = {
        cashID: null,
        cashierID: null,
        cityID: null,
        eventID: null,
        dateFrom: null,
        dateTo: null
      }
    }

    vm.clear()

    vm.find = function () {
      vm.offset = 0;
      vm.items = [];
      getList()
    }

    $scope.$watch('vm.filters.cashID', function (newVal) {
      if(newVal) {
        vm.cashiersList = EncashmentService.getCashiers(newVal)
      }
    })

    function formatDate(date) {
      if(date)
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    function getList() {
      var query = _.extend({}, vm.filters, { limit: vm.limit, offset: vm.offset }, {dateFrom: formatDate(vm.filters.dateFrom), dateTo: formatDate(vm.filters.dateTo)});
      EncashmentService.getEncashments(query).then(function (json) {
        vm.items = vm.items.concat(json.encashments);
        vm.totalSum = json.totalSum
        vm.totalDebt = json.totalDebt
        vm.count = json.totalCount;
        json.xlsUrl = json.xlsUrl.split('?');
        vm.xlsUrl = API + json.xlsUrl[0] + '?access_token=' + user.access_token + '&=' + (json.xlsUrl[1] || '');
        vm.disableScroll = (vm.count >= vm.offset) ? false : true;
      });
    }


  }

})();

(function () {
  'use strict';

  angular.module('tms').controller('EncashmentManagerAddController', EncashmentManagerAddController);

  function EncashmentManagerAddController($scope, EncashmentService, LocationsService, toastr, $state, calendarOptions) {
    var vm = this;
    var model

    vm.cashesList = EncashmentService.getCashes();

    vm.cityList = LocationsService.getCities();

    vm.calendarOptions = calendarOptions;

    vm.items = []

    vm.encashment = {
      cashID: null,
      date: null,
      dateCreateTo: null
    }

    vm.saveEncashment = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (model && vm.encashmentform.$valid) {
        vm.encashment.date = formatDate(vm.encashment.date)
        model.save(vm.encashment).then(function () {
          toastr.success('Зміни збережені!');
          $state.go('main.encashment.manager');
        })
      }
    }

    $scope.$watch('vm.encashment.cashID', function () {
      if(vm.encashment.cashID) {
        vm.cashiersList = EncashmentService.getCashiers(vm.encashment.cashID)
        model = EncashmentService.encashment(vm.encashment.cashID)
        model.get().then(update)
      }
    })

    $scope.$watch('vm.encashment.eventID', function () {
      var filters = {}
      if(vm.encashment.eventID) {
        filters.eventID = vm.encashment.eventID
      }
      model && model.get(filters).then(update)
    })

    function update(json) {
      vm.items = json.collections
      vm.salesCount = json.salesCount
      vm.salesSum = json.salesSum
      vm.currentDebt = json.currentDebt
      vm.encashment.sum = json.currentDebt
    }

    function formatDate(date) {
      if(date)
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').controller('WidgetsController', WidgetsController);

	function WidgetsController($scope, PlayersService, PlayerWidgetsService) {
    var vm = this;

		$scope.$watch('vm.filters.companyID', function(val) {

			PlayerWidgetsService.getList({companyID: val})
				.then(function(data) {
					vm.items = data.plain().items;
				})
		})

		vm.getPlayers = PlayersService.searchList({limit: 500});

		vm.delete = function(widget) {
			PlayerWidgetsService.delete(widget.id)
				.then(function() {
						widget.deleted = true;
					})
		}
		
	}
})();

(function () {
	'use strict';

	angular.module('tms').controller('WidgetEditController', WidgetEditController);

	function WidgetEditController($scope, $stateParams, $state, PlayersService, OrdermanagerService, concatIdsAndNamesService,
                                PlayerWidgetsService, toastr, calendarOptions) {
    var vm = this;
    var dateTypes = ['dateStart', 'dateEnd'];

		vm.widgetTypes = [{name: 'Зал', id: 'hall'}, {name: 'Кнопка', id: 'button'}];
    vm.calendarOptions = calendarOptions;
    vm.widget = { dateStart: null, dateEnd:  null, isActive: false };

    if ($stateParams.id) {
      PlayerWidgetsService.get($stateParams.id)
        .then(prepareDates)
        .then(function(data) {
          vm.widget = data.plain();
        })
    }

    $scope.$watch('vm.widget.companyID', function () {
      vm.getPlayerUser = OrdermanagerService.getUsers({companyID: vm.widget.companyID})
        .then(concatIdsAndNamesService);
    });

		$scope.$watch('vm.widget.type', function (val) {
			if (vm.widget.id) {
				return
			}
			vm.widget.code = PlayerWidgetsService.getCodeSample(val);
		});

    vm.getPlayers = PlayersService.searchList({limit: 500});

    vm.save = function() {
      $scope.$broadcast('show-errors-check-validity');

      if (!vm.widgetForm.$valid) {
        return;
      }

			vm.loading = true;
      var widgetCopy = angular.extend({}, vm.widget);

      _.each(widgetCopy, function (v, i) {
        if (v && dateTypes.indexOf(i) > -1) {
          widgetCopy[i] = moment(v).format('YYYY-MM-DD HH:mm:ss') + '';
				} else if (dateTypes.indexOf(i) > -1) {
					widgetCopy[i] = null;
				}
      });

      PlayerWidgetsService.save(widgetCopy)
        .then(function() {
          $state.go('main.configs.widgets');
          toastr.success('Віджет збережений!');
        })
				.finally(function() {
					vm.loading = false;
				});
    }

    function prepareDates(data) {
      dateTypes.forEach(function (el) {
        if (data[el]) {
          data[el] = moment(data[el]);
        }
      });
      return data;
    }

	}

})();

(function () {
	'use strict';

	angular.module('tms').service('PlayerWidgetsService', PlayerWidgetsService);

	function PlayerWidgetsService(Restangular) {
    var PlayerWidgets = Restangular.one('player/widgets'),
      PlayerWidget = Restangular.one('player/widget'),
			codeSamples = {
				hall: "<iframe src='https://kasa.in.ua/api/public/1509/KEY’ width='100%' height='800px'></iframe>",
				button: "<a href='https://kasa.in.ua/EVENT'><img src='https://test-kasa.in.ua/images/widget/kasa_button.png' alt='Придбати квиток на kasa.in.ua' title='Придбати квиток на kasa.in.ua' width='130px' height='28px' border='0'></a>"
			};

    this.getList = function(filters) {
      return PlayerWidgets.get(filters);
    }

    this.get = function(id) {
      return PlayerWidget.one(id).get();
    }

    this.save = function(data) {
      if (data.id) {
        return PlayerWidget.one(data.id+'').customPUT(data, '', '');
      }
      return PlayerWidget.post('', data);
    }

    this.delete = function(id) {
      return PlayerWidget.one(id+'').remove();
    };

		this.getCodeSample = function(type) {
			return codeSamples[type] || '';
		};
  }
})();

(function () {
  'use strict';

  angular.module('tms').service('UsersService', UsersService);

  function UsersService($q, $log, Restangular, $uibModal) {
    var Users = Restangular.one('users');
    var User = Restangular.one('user');
    var Search = Restangular.one('users-list');

    var userRoles = {
      user: 'Користувач',
      admin: 'Адміністратор',
      call_centre: 'Колл-центр',
      cashier: 'Касир',
      senior_cashier: 'Старший касир',
      order_manager: 'Менеджер з продажу',
      organizer_manager: 'Менеджер організації',
      read_organizer: 'Організатор',
      financier: 'Бухгалтер',
      technical_support: 'Технічна підтримка',
      read_admin: 'Адміністратор без прав запису'
    };

    var userStatuses = {
      active: 'Активний',
      frozen: 'Неактивний',
      banned: 'Заблокований',
      deleted: 'Видалений'
    };

    this.getList = function (filters) {
      return Users.get(filters);
    };

    this.get = function (id) {
      return User.one(id + '').get();
    };

    this.save = function (data) {
      if (data.id)
        return User.one(data.id + '').customPUT(data, '', '');
      else
        return User.post('', data);
    };

    this.delete = function (id) {
      return User.one(id + '').remove();
    };
    // TODO current method is only used in test src/app/main/api/api.controller.js
    // should be removed if test is not relevant anymore
    this.getRoles = function () {
      return userRoles;
    }

    this.getStatuses = function () {
      return userStatuses;
    };

    this.searchList = function (filters) {
      return Search.get(filters);
    };

    this.changePassword = function (userId) {
      return $uibModal.open({
        templateUrl: 'app/main/configs/users/modal/user-change-password.html',
        resolve: {
          userId: function () {
            return userId
          }
        },
        size: 'sm',
        controller: function ($scope, $uibModalInstance, userId) {
          $scope.ok = function () {
            User.one(userId + '').customPUT($scope.model)
              .then(function () {
                $uibModalInstance.close();
              });
          };
          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result;
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').controller('UsersController', UsersController);

	function UsersController($timeout, UsersService, PermissionsService, calendarOptions) {
    var vm = this;

		PermissionsService.getRoles().then(function(response){
			vm.rolesList = _.map(response.plain(), function(i){
				return {id: i.name, name: i.description};
			});
		});

    vm.items = [];

    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.disableScroll = true;

    vm.filters = {
      email: null,
      name: null,
      phone: null,
      role: null,
      _dateRegisterFrom: null,
      _dateRegisterTo: null
    }

    vm.calendarOptions = calendarOptions;

    getList();

    vm.applyDateFilter = function(){
      if (vm.filters._dateRegisterFrom)
        vm.filters.dateRegisterFrom = moment(vm.filters._dateRegisterFrom).format('YYYY-MM-DD');
      if (vm.filters._dateRegisterTo)
        vm.filters.dateRegisterTo = moment(vm.filters._dateRegisterTo).format('YYYY-MM-DD');
      vm.filter({});
    };

    vm.load = function() {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
        getList();
    }

    vm.applyFilter = function(ac){
			$timeout(function(){
				if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
					return;
				}
				vm.filter({});
			})
    };

    vm.filter = function(){
      vm.offset = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }

    vm.delete = function(user) {
      user.deleted = true;
      UsersService.delete(user.id);
    }

    vm.formatDate = function(date) {
      return moment(date).format('D MMM YYYY, HH:mm');
    }

    vm.decodeToken = function(decode) {
      return btoa( unescape( encodeURIComponent(decode) ) );
    }

    vm.getRole = function(role) {
			if (_.find(vm.rolesList, {id: role})) {
				return _.find(vm.rolesList, {id: role}).name;
			}
    }

    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      UsersService.getList(query).then(function (response) {
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('UserEditController', UserEditController);

	function UserEditController($state, $scope, $stateParams, $window, toastr, UsersService, PlayersService, AuthService, PermissionsService, SubdivisionsService, calendarOptions) {
    var vm = this;

    vm.loading = false;
    vm.user = {
     dateTokenExpired: null
    };

    vm.cashierRoles = [
        'cashier',
        'senior_cashier'
    ];

    vm.printTypes = [
      {name: 'А4', id: 'a4'},
      {name: 'А5', id: 'a5'},
      {name: 'Бланк', id: 'e_blank'},
      {name: 'Друк заборонений', id: null}
    ];

    vm.statusList = UsersService.getStatuses();

		PermissionsService.getRoles().then(function(response){
			vm.rolesList = _.map(response.plain(), function(i){
				return {id: i.name, name: i.description};
			});
		});

    vm.calendarOptions = calendarOptions;

    vm.user = {printType: 'Друк заборонений', printBlankType: null};

    vm.companySearch = null;

    $scope.$watch('vm.companySearch', function(){
      var searchString = (vm.companySearch && vm.companySearch.length > 2) ? vm.companySearch : null;
      PlayersService.getList({name: searchString}).then(function (response) {
        vm.companyList = response.items;
      });
    });

    PlayersService.getCashes().then(function (response) {
        vm.cashList = _.map(response.items || [], function (item) {
            return {
                id: item.id,
                name: item.name
            };
        });
    });

    SubdivisionsService.getList().then(function (response) {
        vm.subdivisionList = _.map(response.items || [], function (item) {
            return {
                id: item.id,
                name: item.name + " (" + item.id + ")"
            };
        });
    });

    // vm.artistsSearch = null;
    // $scope.$watch('vm.artistsSearch', function(){
    //   var searchStringart = (vm.artistsSearch && vm.artistsSearch.length > 2) ? vm.artistsSearch : null;
    //   SiteService.getList({names: searchStringart}).then(function (response) {
    //     vm.artistsList = response.items;
    //   });
    // });

    if ($stateParams.id) {
      vm.mode = $stateParams.id;
      UsersService.get($stateParams.id).then(function (response) {
        vm.loginInInfo = angular.copy(response.plain());
        response.dateTokenExpired = moment(response.dateTokenExpired)        
        vm.user = response;        
        vm.user.ticketsRotation = vm.user.ticketsRotationAngle;
        vm.user.statusCaption = vm.statusList[response.status];
        vm.companySearch = response.companyName;
        var pt = _.find(vm.printTypes, {id: response.printBlankType});
        vm.user.printType = (pt) ? pt['name'] : null;
      });
    }

    
    vm.decodeToken = function(decode) {
      return btoa( unescape( encodeURIComponent(decode) ) );
    }

    

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.usercreate.$valid){
        return;
      }
      vm.loading = true;
      vm.user.dateTokenExpired =  moment(vm.user.dateTokenExpired).format('YYYY-MM-DD HH:mm:ss')
      vm.user.ticketsRotationAngle = parseInt(vm.user.ticketsRotation) || 0;
      if (!vm.cashierRoles.includes(vm.user.role) && angular.isDefined(vm.user.cashID)) {
          vm.user.cashID = null;
      }
      if (angular.isUndefined(vm.user.subdivisionID)) {
          vm.user.subdivisionID = null;
      }
      UsersService.save(vm.user).then(function () {
        AuthService.updateMe(vm.user);
        $state.go('main.configs.users');
        toastr.success('Користувач збережений!');
      }).finally(function () {
        vm.loading = false;
      });
    }

    

    vm.changeUser = function () {
      AuthService.setUser(vm.loginInInfo);
      AuthService.updateMe(vm.loginInInfo);
      $state.go(AuthService.init().home).then(function () {
        $window.location.reload();
      });
    }

    vm.changePassword = function () {
      UsersService.changePassword(vm.user.id)
        .then(toastr.success.bind(toastr, 'Пароль змінений'));
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').service('SubdivisionsService', SubdivisionsService);

	function SubdivisionsService(Restangular) {
		var Subdivisions = Restangular.one('subdivisions');
		// list of users that can be subdivision managers
		var SubdivisionUsers = Restangular.one('subdivision-users');
		// list of users that are in subdivisions already
		var SubdivisionManagers = Restangular.one('subdivision-managers');

		this.getList = function (filters) {
			return Subdivisions.get(filters);
		};

		this.get = function (id) {
			return Subdivisions.one(id+'').get();
		};

		this.save = function (data) {
			if (data.id) {
				return Subdivisions.one(data.id+'').customPUT(data, '', '');
			} else {
				return Subdivisions.post('', data);
			}
		};

		this.delete = function (id) {
			return Subdivisions.one(id+'').remove();
		};

		this.getUsers = function () {
			return SubdivisionUsers.get();
		};

		this.getManagers = function () {
			return SubdivisionManagers.get();
		};
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('SubdivisionsController', SubdivisionsController);

	function SubdivisionsController(SubdivisionsService) {
        var vm = this;

        vm.items = [];

        vm.count = 0;
        vm.offset = 0;
        vm.limit = 30;
        vm.sortOrder = null;
        vm.disableScroll = true;

        vm.filters = {};

        getList();

        vm.load = function() {
            vm.offset = vm.offset + vm.limit;
            if (vm.count > vm.offset) {
                getList();
            }
        };

        vm.applyFilter = function(ac) {
            if (ac && ac !== "id" && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
                return;
            }
            vm.filter({});
        };

        vm.filter = function() {
          vm.offset = 0;
          vm.items = [];
          getList();
        };

        vm.delete = function(item) {
            SubdivisionsService.delete(item.id).then(function() {
                item.deleted = true;
            });
        };

        function getList() {
            var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
            SubdivisionsService.getList(query).then(function (response) {
                vm.items = vm.items.concat(response.items);
                vm.count = response.count;
                vm.disableScroll = vm.count <= vm.offset;
            });
        }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('SubdivisionEditController', SubdivisionEditController);

	function SubdivisionEditController($state, $scope, $stateParams, toastr, $uibModal, SubdivisionsService, LocationsService) {
        var vm = this;

        SubdivisionsService.getUsers().then(function (response) {
            vm.users = response || [];
        });
        LocationsService.getCities().then(function (response) {
            vm.cities = response.items || [];
        });

        if ($stateParams.id) {
            vm.mode = $stateParams.id;
            SubdivisionsService.get($stateParams.id).then(function (response) {
                vm.subdivision = response;
            });
        }

        vm.save = function () {
            $scope.$broadcast('show-errors-check-validity');
            if (!vm.form.$valid) {
                return;
            }

            SubdivisionsService.save(vm.subdivision).then(function (response) {
                $state.go('main.configs.subdivisions');
                vm.afterSave(response);
            });
        };

        vm.delete = function () {
            if (angular.isDefined(vm.subdivision.id)) {
                $uibModal.open({
                    templateUrl: 'app/main/configs/subdivisions/modal/modal.delete.html',
                    size: 'sm',
                    controller: function ($scope, $uibModalInstance) {

                        var scope = $scope;

                        scope.ok = function () {
                            SubdivisionsService.delete(vm.subdivision.id).then(function (response) {
                                $uibModalInstance.dismiss();
                                vm.afterSave(response, 'Успішно видалено');
                            });
                        };

                        scope.close = function () {
                            $uibModalInstance.dismiss();
                        };
                    }
                });
            }
        };

        vm.afterSave = function (response, successMessage) {
            if (response.error_code) {
                toastr.error(response.error_msg);
            } else if (response.success) {
                if (angular.isUndefined(successMessage)) {
                    successMessage = 'Підрозділ збережений';
                }
                toastr.success(successMessage, '', {
                    "timeOut": "5000"
                });
                $state.go('main.configs.subdivisions');
            }
        };
    }

})();

(function () {
  'use strict';

  angular.module('tms').controller('ReturnController', ReturnController);

  function ReturnController(ReportService) {
    var vm = this;

    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.disableScroll = true;
    vm.items = [];

    load();

    vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset) {
        load();
      }
    };

    function load() {
      var filters = {offset: vm.offset, limit: vm.limit};
      ReportService.getReturnedTickets(filters).then(function (response) {
        vm.items = vm.items.concat(response.plain().items);
        vm.count = response.plain().count;
        vm.disableScroll = vm.count < vm.offset;
      })
    }
  }
})();

// TODO remove when not needed
(function () {
	'use strict';

	angular.module('tms').controller('ProblemTicketsController', ProblemTicketsController);

	function ProblemTicketsController(ReportService) {
    var vm = this;

    vm.barcodesDuplicatesXlsUrl = ReportService.getProblemTicketXlsUrl('/report/barcodes-duplicates-xls');
    vm.salesDuplicatesXlsUrl = ReportService.getProblemTicketXlsUrl('/report/sales-duplicates-xls');
    vm.oldSystemBarcodesXlsUrl = ReportService.getProblemTicketXlsUrl('/report/old-system-barcodes-xls');
  }
})();

(function () {
	'use strict';

	angular.module('tms').service('PlayersService', PlayersService);

	function PlayersService(Restangular) {
		var Players = Restangular.one('companies');
		var Player = Restangular.one('company');
		var Search = Restangular.one('companies-list');
		var Cashes = Restangular.one('cashes');

    var playerRoles = {
      organizer: 'Організатор',
      ticket_agency: 'Білетна агенція',
      individual: 'Індивідуальний',
      cash: 'Каса'
    };

    var playerStatuses = {
      active: 'Активний',
      disabled: 'Вимкнений',
      deleted: 'Видалений'
    };

		this.getList = function (filters) {
			return Players.get(filters);
		};

    this.searchList = function (filters) {
			return Search.get(filters);
		};

    this.getUsers = function (filters) {
			return Player.one('officials-list').get(filters);
		};

		this.get = function (id) {
			return Player.one(id+'').get();
		};

		this.save = function (data) {
			if (data.id)
				return Player.one(data.id+'').customPUT(data, '', '');
			else
				return Player.post('', data);
		};

		this.delete = function (id) {
			return Player.one(id+'').remove();
		};

    this.getRoles = function() {
      return playerRoles;
    }

    this.getStatuses = function() {
      return playerStatuses;
    }

    this.search = function(filters){
      return Search.get(filters);
    }

    this.getCashes = function () {
		return Cashes.get();
	}
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('PlayersController', PlayersController);

	function PlayersController(PlayersService) {
    var vm = this;

    vm.roles = PlayersService.getRoles();
    vm.items = [];

    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.disableScroll = true;

    vm.filters = {}

    getList();

    vm.load = function() {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
        getList();
    }

    vm.applyFilter = function(ac){
      if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3))
        return;
      vm.filter({});
    };

    vm.filter = function(){
      vm.offset = 0;
      vm.items = [];
      getList();
    }

    vm.delete = function(user) {
      PlayersService.delete(user.id).then(function(){
        user.deleted = true;
      });
    }

    vm.getRole = function(role) {
      return vm.roles[role];
    }

    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      PlayersService.getList(query).then(function (response) {
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('PlayersEditController', PlayersEditController);

	function PlayersEditController($state, $scope, $stateParams, toastr, UsersService, PlayersService) {
    var vm = this;

    vm.loading = false;

    vm.printTypes = [
      {name: 'А4', id: 'a4'},
      {name: 'А5', id: 'a5'},
      {name: 'Бланк', id: 'e_blank'},
      {name: 'Друк заборонений', id: null}
    ];

    vm.playerRoles = _.map(PlayersService.getRoles(), function (v, i) {
      return {id: i, name: v};
    });

    if ($stateParams.id) {
      vm.mode = $stateParams.id;
      PlayersService.get($stateParams.id).then(function (response) {
        vm.player = response;
        vm.player.edrpou = parseInt(response.edrpou);
      });
    }

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.playercreate.$valid)
        return;
      vm.player.edrpou = vm.player.edrpou + '';
      vm.loading = true;
      PlayersService.save(vm.player).then(function () {
        $state.go('main.configs.players');
        toastr.success('Гравець збережений!');
      }).finally(function () {
        vm.loading = false;
      });
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').service('ChoicePlaceService', ChoicePlaceService);

	function ChoicePlaceService($q, $log, Restangular) {

    this.getChoicePlace = function() {
      return Restangular.one('/place-list').get();
    }

      

	}

})();

(function () {
	'use strict';

  var groups = [
    {id: 1, name: 'Налаштування подій', items: ['menuEvent', 'listEvents', 'viewEvent', 'createEvent', 'updateEvent', 'eventSalesToggle', 'clientsReport']},
    {id: 2, name: 'Налаштування схем/локацій', items: ['listHalls', 'hallEditor', 'hallPrices', 'manageBarcodes']},
    {id: 3, name: 'Налаштування замовлень', items: ['menuOM', 'menuCashier', 'listOrders', 'createOrder', 'viewOrder', 'updateOrder', 'cancelOrder', 'listTickets', 'returnTicket', 'printTicket', 'setOrderTypeInvite', 'updateTicket', 'storyTicket', 'ticketsXls', 'secondPrintTicket', 'scEventsSold']},
    {id: 4, name: 'Налаштування квот', items: ['menuQuota', 'viewQuotas', 'manageQuotas', 'quotaDelete', 'invoiceQuota', 'convertQuota', 'quotaXls']},
    {id: 5, name: 'Налаштування статистики', items: ['menuStatistic', 'eventsStatistics', 'ordersStatistics', 'extendedEventStats', 'widgetsStatistics']},
    {id: 6, name: 'Конфігурації', items: ['menuConfig', 'listUsers', 'viewUser', 'manageUsers', 'listCompanies', 'viewCompany', 'manageCompanies', 'listCashes', 'viewCash', 'manageCashes', 'manageRoles', 'manageRbac', 'hallEditor', 'uploadFiles', 'listWidgets', 'manageWidgets']},
    {id: 7, name: 'Інкасації', items: ['menuEncashment', 'manageEncashments', 'encashmentSettings', 'encashmentsXls']},
    {id: 8, name: 'Адміністрування сайту', items: ['menuSite', 'fbPixelSettings']},
    {id: 9, name: 'Налаштування Артисти', items: ['listArtists','manageArtists']},
    {id: 10, name: 'Налаштування Турів', items: ['listTour','manageTour']},
    {id: 11, name: 'Налаштування Новин', items: ['listNews','manageNews']},
    {id: 12, name: 'Налаштування Підбірки', items: ['listChoice','manageChoice']},
    // {id: 13, name: 'Налаштування площатки сайту', items: ['menuSite', 'listChoicePlace','manageChoicePlace']},
    {id: 14, name: 'Налаштування Локація', items: ['listArea','manageArea']},
    {id: 15, name: 'Налаштування Слайди', items: ['listSlider','manageSlider']},
    {id: 10, name: 'Налаштування Міст', items: ['listGeo','manageGeo']},
    {id: 16, name: 'Експорт бд', items: ['export']},
    {id: 17, name: 'Iншi', items: ['menuAPI']},
    {id: 18, name: 'Партнери', items: ['partnersList', 'partnersEdit', 'partnersView']},
    {id: 19, name: 'Налаштування сервісного збору', items: ['serviceCharge']},
    {id: 20, name: 'Налаштування Підрозділів', items: ['manageSubdivisions', 'viewRespEvents', 'viewRespEventsAll']},
    {id: 21, name: 'Рекомендації', items: ['manageRecommendations']}
     // 'viewChoice', 'createChoice', 'updateChoice',
  ];

	angular.module('tms').service('PermissionsService', PermissionsService);

	function PermissionsService(Restangular) {
		var self = this;
    var Access = Restangular.one('access');

    self.permissionsList = function() {
      return Access.one('permissions').get().then(function(response){
        return _.flatten(_.map(response, 'children'));
      });
    }

    self.getGroups = function() {
      return groups;
    }

    self.getRoles = function() {
      return Access.one('roles').get();
    }

    self.setRole = function(data) {
      return Access.one('role').one(data.id+'').customPUT(data);
    }

    self.getUser = function(id) {
      return Access.one('user').one(id+'').get();
    }

    self.setUser = function(id, data) {
      return Access.one('user').one(id+'').customPUT(data);
    }

    self.getCompanyEventAccess = function (id, filters) {
      return Access.one('company-events').one((id).toString()).get(filters);
    }

    self.setCompanyEventAccess = function (id, data) {
      return Access.one('company-events').one((id).toString()).customPUT(data);
    }

    self.getUserEventAccess = function (id, filters) {
      return Access.one('user-events').one((id).toString()).get(filters);
    }

    self.setUserEventAccess = function (id, filters, data) {
      return Access.one('user-events').one((id).toString()).customPUT(data, null, filters);
    }

    self.resetUserEventAccess = function (id) {
      return Access.one('user-events').one((id).toString()).remove();
    }

	}
})();

(function () {
	'use strict';

	angular.module('tms').controller('PermissionsController', PermissionsController);

	function PermissionsController($log, $scope, $state, toastr, PermissionsService, AuthService) {
    var vm = this;

    vm.state = '';
    vm.groups = PermissionsService.getGroups();
    vm.selectedUserPermitions = {};

    vm.getInfo = function (p) {
      var temp = _.find(vm.items, {name: p});
      return (temp) ? temp['description'] : '';
    };

    if ($state.current.name === 'main.configs.permissions') {
      vm.state = 'permissions';
      AuthService.permissionsList().then(function(response){
        vm.items = response;
      });
    }

    if ($state.current.name === 'main.configs.permissions.user') {
      vm.state = 'user';
      vm.edit = true;
      vm.userID = parseInt($state.params.id) || AuthService.init().id;
      $log.log(vm.userID, AuthService.init().accessList);
      PermissionsService.permissionsList().then(function(response){
        vm.items = response;
      });
      PermissionsService.getUser(vm.userID).then(function(response){
        vm.userData = response.plain();
        $log.log(vm.userData);
      });
    }

    if ($state.current.name === 'main.configs.roles') {
      vm.state = 'roles';
      PermissionsService.permissionsList().then(function(response){
        vm.items = response;
      });
      PermissionsService.getRoles().then(function(response){
        vm.roles = response;
        vm.rolesList = _.map(response, function(i){
          return {id: i.name, name: i.description, permissions: i.children};
        });

      });
    }

    vm.save = function () {
      $log.log(vm.userData);
      PermissionsService.setUser(vm.userID, vm.userData).then(function(response){
        response.id = vm.userID;
        toastr.success('Користувач збережений!');
      });
    };

    vm.saveRole = function () {
      var children = _.map(vm.items, 'name')
        .filter(function(name) {
          return vm.selectedUserPermitions[name];
        });
      vm.role.children = children;
      PermissionsService.setRole(vm.role).then(function(response){
        //$log.log(response);
        vm.role.permissions = response.children;
        toastr.success('Доступи збереженi!');
      });
    };

    $scope.$watch('vm.roleID', function(newVal){
      if (!newVal)
        return;
      vm.selectedUserPermitions = {};
      vm.role = _.find(vm.rolesList, {id: newVal});
      _.map(vm.role.permissions, 'name')
        .forEach(function(name){
          vm.selectedUserPermitions[name] = true;
        });
    });

	}

})();

(function () {
	'use strict';

	angular.module('tms').service('NewsService', NewsService);

	function NewsService($q, $log, Restangular) {

    this.getNews = function() {
      return Restangular.one('/news-list').get();
    }

   

	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('MapController', MapController);

	function MapController($scope, $state, $stateParams, toastr, SiteService, LocationsService, PlayersService, UsersService) {
    var vm = this;

    vm.item = {address: {}};

    SiteService.cashes.getList().then(function (response) {
      vm.cashes = response.items;
    });

    $scope.$watch('vm.citySearch', function(){
      if (!vm.citySearch || vm.citySearch.length < 3)
        return;
      vm.citiesGet = LocationsService.getCities({name: vm.citySearch});
    });

    if ($state.current.name === 'main.configs.cashier.edit') {
      vm.edit = true;
      if ($stateParams.id)
      SiteService.cashes.get($stateParams.id).then(function (response) {
        vm.item = response;
        vm.item.description = angular.fromJson(response.description);
        vm.citiesGet = LocationsService.getCities({id: response.address.cityID});
        vm.players = PlayersService.searchList();
        $scope.$watch('vm.item.companyID', function(){
          vm.users = UsersService.searchList({role: 'cashier', companyID: vm.item.companyID});
        });
      });
      else {
        vm.citiesGet = LocationsService.getCities();

      }
    }

    vm.save = function () {
      vm.loading = true;
      SiteService.cashes.save(vm.item).then(function(){
        toastr.success('Касу збережено!');
        $state.go('main.configs.cashier');
      }).finally(function(){
        vm.loading = false;
      });
		}

		vm.delete = function (item) {
      item.deleted = true;
      SiteService.cashes.delete(item.id);
		}
	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('MailstatController', MailstatController);

  function MailstatController($scope, OrderService, $timeout, calendarOptions) {
    var vm = this;

    vm.statuses = [
      {name: 'Відправлено', id: 'true'},
      {name: 'Не відправлено', id: 'false'}
    ];
    vm.limit = 30;
    vm.count = 0;
    vm.offset = 0;
    vm.disableScroll = true;
    vm.items = [];

    vm.calendarOptions = calendarOptions;

    vm.filters = {
      dateSendTo: null,
      dateSendFrom: null,
      orderID: null,
      sended: null,
      email: null
    };

    vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      load();
    };

    $timeout(startFilterWatching, 1000);

    function startFilterWatching() {
      $scope.$watch('vm.filters', function () {
        vm.offset = 0;
        vm.items = [];
        load();
      }, true);
    }

    function load() {
      var filter = angular.extend({offset: vm.offset, limit: vm.limit}, vm.filters);
      filter.dateSendTo = filter.dateSendTo ? moment(filter.dateSendTo).format('YYYY-MM-DD') : null;
      filter.dateSendFrom = filter.dateSendFrom ? moment(filter.dateSendFrom).format('YYYY-MM-DD') : null;
      OrderService.getMailLog(filter)
        .then(function (data) {
          vm.items = vm.items.concat(data.items);
          vm.count = data.count;
          vm.disableScroll = vm.count < vm.offset;
        });
    }
  }
})();

(function () {
	'use strict';

	angular.module('tms').service('LocationsService', LocationsService);

	function LocationsService($q, $log, Restangular) {

    this.getCountries = function() {
      return Restangular.one('/geo/countries').get();
    }

    this.getCities = function (filters) {
      return Restangular.one('/geo/cities').get(filters );
    }

    
    this.getCitiesByName = function (filters) {
      return Restangular.one('/geo/cities').get({name: filters });
    }

    this.getHalls = function (filters) {
      return Restangular.one('/halls').get(filters);
    }

    this.getZones = function(filters) {
      return Restangular.one('/scheme/zones-list').get(filters);
    }

    this.getHallZones = function(filters) {
      return Restangular.one('/schemes').get(filters);
    }

	}

})();

(function () {
	'use strict';

	angular.module('tms').service('ExtEventService', ExtEventService);

	function ExtEventService(Restangular) {
		var Events = Restangular.one('apieventslist');

		this.getList = function (filters) {
			return Events.get(filters);
		};
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('ExtEventsController', ExtEventsController);

	function ExtEventsController(ExtEventService, EventsService) {
        var vm = this;

        vm.items = [];

        vm.count = 0;
        vm.offset = 0;
        vm.limit = 30;
        vm.sortOrder = null;
        vm.disableScroll = true;

        vm.filters = {}

        getList();

        vm.stringify = function(obj){
            
            return angular.toJson(obj);   
        }
        
        vm.applyFilter = function(ac){
          if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3))
            return;
          vm.filter({});
        };

        vm.filter = function(){
          vm.offset = 0;
          vm.items = [];
          getList();
        }
        
        vm.inSales = function(item, status){
          var e = {id: item.localEventId, status: status ? 'in_sales' : 'new'};
          EventsService.events.save(e).then(function () {
            item.localStatus = status ? 'in_sales' : 'new';
          });
        };

        function getList() {
          var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
          ExtEventService.getList(query).then(function (response) {
            vm.items = vm.items.concat(response.items);
            vm.count = response.count;
            vm.disableScroll = (vm.count > vm.offset) ? false : true;
          });
        }
	}

})();

// TODO remove when not needed
(function () {
	'use strict';

	angular.module('tms').controller('ExportDbController', ExportDbController);

	function ExportDbController($scope,$window,toastr,$state,EventsService,SiteService, LocationsService) {
    var vm = this;
    vm.item = {};
    
    EventsService.events.list().then(function (response) {
          vm.event = response.items;
       });

    vm.cityList = LocationsService.getCities();


	vm.save = function(){
      $scope.$broadcast('show-errors-check-validity');    
      vm.loading = true;
      if (!vm.item.currentEvent[0]) {       
        toastr.warning('Виберіть подію');
        return;
      }       

      SiteService.export.save(vm.item).then(function(data){          
       // console.log(data);
       $window.open('/' + data.downloadPath);
        toastr.success('Експорт зробленно!');
        $state.go('main.configs.export-db');
      }).finally(function(){
        vm.loading = false;
      });
      
		}

    vm.saveCity = function(){
      $scope.$broadcast('show-errors-check-validity');    
      vm.loading = true; 
      if (!vm.item.cityID[0]) {       
        toastr.warning('Виберіть місто');
        return;
      }    

      SiteService.exportcity.save(vm.item).then(function(data){          
       // console.log(data);
       $window.open('/' + data.downloadPath);
        toastr.success('Експорт зробленно!');
        $state.go('main.configs.export-db');
      }).finally(function(){
        vm.loading = false;
      });
      
    }
    
  }
})();

(function () {
	'use strict';

	angular.module('tms').controller('EventPermissionsUserController', EventPermissionsUserController);

	function EventPermissionsUserController($scope, $state, $stateParams, calendarOptions, $timeout, $log, LocationsService, PermissionsService, ModalService, toastr) {
    var vm = this;

    var defaultFilters = {
      eventID: null,
      cityID: null,
      _dateFrom: null,
      _dateTo: null
    }

    vm.filters = angular.copy(defaultFilters);

    getList();

    vm.event = {
      access: 'allowed'
    }

    vm.calendarOptions = calendarOptions;

    vm.getCities = LocationsService.getCities();

    $scope.$watch('vm.filters.cityID', function (newValue, oldValue) {
      if ((newValue && oldValue && newValue !== oldValue) || (!newValue && oldValue) || (newValue && !oldValue)) {
        vm.applyFilter('cityID');
      }
    });

    $scope.$watch('vm.filters.eventID', function (newValue, oldValue) {
      if ((newValue && oldValue && newValue !== oldValue) || (!newValue && oldValue) || (newValue && !oldValue)) {
        vm.applyFilter('eventID');
      }

      if (newValue === '') {
        vm.eventReset = !vm.eventReset;
      }
    });

    $scope.$watch('vm.filters._dateFrom', function (newValue, oldValue) {
      if (!newValue && oldValue) {
        vm.applyDateFilter()
      }
    });

    $scope.$watch('vm.filters._dateTo', function (newValue, oldValue) {
      if (!newValue && oldValue) {
        vm.applyDateFilter()
      }
    });

    vm.applyFilter = function (ac) {
			if (vm.stopWatching || (ac && vm.filters[ac] && vm.filters[ac] !== '' && (vm.filters[ac].length < 3))) {
				return;
			}
			getList();
    };

    vm.applyDateFilter = function() {
      if (vm.filters._dateFrom) {
        vm.filters.dateFrom = moment(vm.filters._dateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        delete vm.filters.dateFrom;
      }

      if (vm.filters._dateTo) {
        vm.filters.dateTo = moment(vm.filters._dateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        delete vm.filters.dateTo;
      }

      if (vm.stopWatching) {
        return;
      }
      getList();
    };

    vm.save = function (noStateChange) {
      if (!vm.events || +vm.events.length === 0) {
        return;
      }

      vm.loading = true;

      PermissionsService.setUserEventAccess(
        $stateParams.id, vm.filters, vm.events
      ).then(function () {
        toastr.success('Доступи до подій збережені!');

        if (noStateChange) {
          getList();
        } else {
          $state.go('main.configs.users');
        }
      }).finally(function(){
        vm.loading = false;
      });
    }

    vm.addEvent = function () {
      $scope.$broadcast('show-errors-check-validity');

      if (!vm.eventForm.$valid) {
        return;
      }

      var eventAlreadyExist = _.find(vm.events, {id: +vm.event.id});

      if (eventAlreadyExist) {
        return;
      }

      vm.events.push(vm.event);
      vm.save(true);
    }

    vm.resetAccess = function () {
      ModalService.confirm(
        'Персональні настройки доступу користувача до подій будут стерті. Ви дійсно бажаєте надати доступ по гравцю?',
        'Підтвердити дію'
      ).then(function () {
        return PermissionsService.resetUserEventAccess($stateParams.id)
      }).then(function () {
        getList();
      })
    }

    vm.clearFilters = function () {
      // avoiding multiple requests
      vm.stopWatching = true;

      vm.filters = angular.copy(defaultFilters);
      vm.eventReset = !vm.eventReset;

      $timeout(function () {
        vm.stopWatching = false;
      }, 0)
      getList();
    }

    function getList() {
      if ($stateParams.id) {
        vm.loading = true;
        PermissionsService.getUserEventAccess(
          $stateParams.id, vm.filters
        ).then(function (response) {
          vm.events = response.plain();
        }).catch(function (err) {
          $log.error(err);
        }).finally(function () {
          vm.loading = false;
        })
      }
    }

  }
})();

(function () {
	'use strict';

	angular.module('tms').controller('EventPermissionsPlayerController', EventPermissionsPlayerController);

	function EventPermissionsPlayerController($scope, $state, $timeout, $stateParams, calendarOptions, $log, LocationsService, PermissionsService, toastr) {
    var vm = this;

    var defaultFilters = {
      eventID: null,
      cityID: null,
      _dateFrom: null,
      _dateTo: null
    }

    vm.filters = angular.copy(defaultFilters);

    getList();

    vm.event = {
      access: 'allowed'
    }

    vm.calendarOptions = calendarOptions;

    vm.getCities = LocationsService.getCities();

    $scope.$watch('vm.filters.cityID', function (newValue, oldValue) {
      if ((newValue && oldValue && newValue !== oldValue) || (!newValue && oldValue) || (newValue && !oldValue)) {
        vm.applyFilter('cityID');
      }
    });

    $scope.$watch('vm.filters.eventID', function (newValue, oldValue) {
      if ((newValue && oldValue && newValue !== oldValue) || (!newValue && oldValue) || (newValue && !oldValue)) {
        vm.applyFilter('eventID');
      }

      if (newValue === '') {
        vm.eventReset = !vm.eventReset;
      }
    });

    // handling date reset only
    $scope.$watch('vm.filters._dateFrom', function (newValue, oldValue) {
      if (!newValue && oldValue) {
        vm.applyDateFilter()
      }
    });
    // handling date reset only
    $scope.$watch('vm.filters._dateTo', function (newValue, oldValue) {
      if (!newValue && oldValue) {
        vm.applyDateFilter()
      }
    });

    vm.applyFilter = function (ac) {
			if (vm.stopWatching || (ac && vm.filters[ac] && vm.filters[ac] !== '' && (vm.filters[ac].length < 3))) {
				return;
			}
			getList();
    };

    vm.applyDateFilter = function() {
      if (vm.filters._dateFrom) {
        vm.filters.dateFrom = moment(vm.filters._dateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        delete vm.filters.dateFrom;
      }

      if (vm.filters._dateTo) {
        vm.filters.dateTo = moment(vm.filters._dateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else {
        delete vm.filters.dateTo;
      }

      if (vm.stopWatching) {
        return;
      }
      getList();
    };

    vm.save = function (noStateChange) {
      if (!vm.events || +vm.events.length === 0) {
        return;
      }
      vm.loading = true;

      PermissionsService.setCompanyEventAccess($stateParams.id, vm.events).then(function () {
        toastr.success('Доступи до подій збережені!');
        if (noStateChange) {
          getList();
        } else {
          $state.go('main.configs.players');
        }
      }).finally(function(){
        vm.loading = false;
      });
    }

    vm.addEvent = function () {
      $scope.$broadcast('show-errors-check-validity');

      if (!vm.eventForm.$valid) {
        return;
      }

      var eventAlreadyExist = _.find(vm.events, {id: +vm.event.id});

      if (eventAlreadyExist) {
        return;
      }

      vm.events.push(vm.event);
      vm.save(true);
    }

    vm.clearFilters = function () {
      // avoiding multiple requests
      vm.stopWatching = true;

      vm.filters = angular.copy(defaultFilters);
      vm.eventReset = !vm.eventReset;

      $timeout(function () {
        vm.stopWatching = false;
      }, 0)
      getList();
    }

    function getList() {
      if ($stateParams.id) {
        vm.loading = true;
        PermissionsService.getCompanyEventAccess(
          $stateParams.id, vm.filters
        ).then(function (response) {
          vm.events = response.plain();
        }).catch(function (err) {
          $log.error(err);
        }).finally(function () {
          vm.loading = false;
        })
      }
    }

  }
})();

(function () {
	'use strict';

	angular.module('tms').service('EventService', EventService);

	function EventService($q, $log, Restangular) {

    this.getEvent = function() {
      return Restangular.one('/events-list').get();
    }

      

	}

})();

(function () {
	'use strict';

	angular.module('tms').service('CityListService', CityListService);

	function CityListService(Restangular) {
        var Areas = Restangular.one('geo/areas');
        var Regions = Restangular.one('geo/regions');
		var Cities = Restangular.one('geo/cities-list');
		var City = Restangular.one('geo/city');
        var Search = Restangular.one('geo/cities-list');

        var cityStatuses = {
          active: {name: 'Так', value: 'true'},
          inactive: {name: 'Ні', value: 'false'}
        };

		this.getList = function (filters) {
			return Cities.get(filters);
		};
        
        this.getRegionList = function (filters) {
			return Regions.get(filters);
		};
        
        this.getAreaList = function (filters) {
			return Areas.get(filters);
		};

        this.searchList = function (filters) {
			return Search.get(filters);
		};

        this.getUsers = function (filters) {
			return City.one('officials-list').get(filters);
		};

		this.get = function (id) {
			return City.one(id+'').get();
		};

		this.save = function (data) {
			if (data.id)
				return City.one(data.id+'').customPUT(data, '', '');
			else
				return City.post('', data);
		};

		this.delete = function (id) {
			return City.one(id+'').remove();
		};

        this.getStatuses = function() {
          return cityStatuses;
        }

        this.search = function(filters){
          return Search.get(filters);
        }
	}
})();

(function () {
	'use strict';

	angular.module('tms').controller('CityListController', CityListController);

	function CityListController(CityListService) {
    var vm = this;


    vm.items = [];
    vm.cityRegions = [];
    vm.cityAreas = [];
    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.disableScroll = true;

    vm.filters = {}

    CityListService.getRegionList().then(function (response) {
        
        vm.cityRegions = response.items;
        
        CityListService.getAreaList().then(function (response) {
            
            vm.cityAreas = response.items;
            
            getList();            
        });
    });

    vm.load = function() {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
        getList();
    }

    vm.applyFilter = function(ac){
      if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3))
        return;
      vm.filter({});
    };

    vm.filter = function(){
      vm.offset = 0;
      vm.items = [];
      getList();
    }

    vm.delete = function(user) {
      CityListService.delete(user.id).then(function(){
        user.deleted = true;
      });
    }

    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      CityListService.getList(query).then(function (response) {
        vm.items = vm.items.concat(response.items);
        vm.items.map(function(el){
            var regionFiltered = vm.cityRegions.filter(function(reg){return (reg.id == el.regionID)});  
            el.regionName = (regionFiltered && regionFiltered.length) ? regionFiltered[0].name : '';
            
            var areaFiltered = vm.cityAreas.filter(function(area){return (area.id == el.areaID)});  
            el.areaName = (areaFiltered && areaFiltered.length) ? areaFiltered[0].name : '';
        });
        vm.count = response.count;
        vm.disableScroll = (vm.count > vm.offset) ? false : true;
      });
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('CityListEditController', CityListEditController);

	function CityListEditController($state, $scope, $stateParams, toastr, UsersService, CityListService) {
    var vm = this;

    vm.loading = false;

    $scope.$watch('vm.city.areaID', function (param) {
      vm.getRegions(param); 
    });
    
    vm.cityStatuses = _.map(CityListService.getStatuses(), function (v) {
      return {id: v.value, name: v.name};
    });
    
     vm.getAreas = function (){
        CityListService.getAreaList().then(function (response) {
            vm.cityAreas = response.items; 
        });
    };
    
    vm.getRegions = function(areaID){
        CityListService.getRegionList().then(function(response) {
            vm.cityRegions = (areaID) ? response.items.filter(function(item){return(item.areaID == areaID)}) : response.items;
        });
    };
    
    if ($stateParams.id) {
      vm.mode = $stateParams.id;
      CityListService.get($stateParams.id).then(function (response) {
        vm.city = response;
        vm.city.isActiveS = String(vm.city.isActive);
      });
      
      vm.getRegions();
      vm.getAreas(); 
      
    }
    else{
      vm.getRegions();
      vm.getAreas();
    }

    vm.getRegions = function(areaID){
        CityListService.getRegionList().then(function(response) {
            vm.cityRegions = (areaID) ? response.items.filter(function(item){return(item.areaID == areaID)}) : response.items;
        });
    }
    
    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.citycreate.$valid)
        return;
      vm.loading = true;
      vm.city.isActive = (vm.city.isActiveS === 'true'); 
      CityListService.save(vm.city).then(function () {
        $state.go('main.configs.city-list');
        toastr.success('Запис збережено!');
      }).finally(function () {
        vm.loading = false;
      });
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').controller('CashierStatisticsController', CashierStatisticsController);

	function CashierStatisticsController($log, $scope, calendarOptions, ReportService, EventsService, LocationsService, PlayersService, UsersService, AuthService, concatIdsAndNamesService) {
		var vm = this;

		vm.userData = AuthService.init();
		vm.isAdmin = vm.userData.role === 'admin';

    vm.cities = [];
    vm.events = [];
    vm.results = [];

		vm.loading = false;
    vm.citySearch = null;
		vm.filters = {
			dateCreateFrom: null,
			dateCreateTo: null,
			datePrintFrom: null,
			datePrintTo: null,
			paymentDateFrom: null,
			paymentDateTo: null,
			limit: 300,
			offset: 0,
      cityID: null,
      userSearch: null,
      cashID: null,
      searchType: 'orders',
      ticketStatus: 'active',
      orderStatus: ['created_by_cashier', 'pickup', 'no_money', 'invite']
		};
		vm.calendarOptions = calendarOptions;

    vm.showCashInfo = vm.userData.role !== 'cashier';

    vm.showStatus = function (status) {
      if (vm.filters.orderStatus.length > 0) {
        return vm.filters.orderStatus.indexOf(status) > -1
      } else {
        return true;
      }
    }



    vm.t = function (e) {
      if (e) e.stopPropagation();
      vm.loadCities({name: vm.citySearch});
    };

    vm.e = function (e) {
      if (e) e.stopPropagation();
      vm.loadCities({name: vm.citySearch});
    };

    vm.filter = function (params) {
			vm.filters = _.merge(vm.filters, params);
		};

    vm.loadCities = function(filters) {
      LocationsService.getCities(filters).then(function (response) {
        vm.cities = response.items;
      });
    };

    vm.loadUsers = function () {
      var cashID = (_.isArray(vm.filters.cashID)) ?  vm.filters.cashID.join(',') : vm.filters.cashID;
      if (!cashID || cashID=='')
        cashID = null;
      UsersService.searchList({name: vm.filters.userSearch, companyID: cashID}).then(concatIdsAndNamesService).then(function (response) {
        vm.users = response;
      });
    };

    PlayersService.searchList({offset: 0, limit: 100, type: 'cash'}).then(function (response) {
      vm.players = response;
    });

    $scope.$watch('vm.filters.cashID', function(){
      vm.loadUsers();
    });

    vm.loadCities();
    vm.loadUsers();

		vm.load = function () {
			// set current user id as cashierID when no event and cash is selected
			if (!vm.filters.eventID.length && !vm.filters.cashID.length && !vm.filters.cashierID.length) {
				vm.filters.cashierID = [AuthService.init().id];
			}

			vm.loading = true;
			var filters = _.extend({}, vm.filters);
			_.each(filters, function (v, i) {
				if (_.isArray(v))
					filters[i] = v.join(',');
        if (!v || v=='')
          filters[i] = null;
			});

      filters.dateCreateFrom && (filters.dateCreateFrom = moment(filters.dateCreateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      filters.dateCreateTo && (filters.dateCreateTo = moment(filters.dateCreateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
      filters.datePrintFrom && (filters.datePrintFrom = moment(filters.datePrintFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      filters.datePrintTo && (filters.datePrintTo = moment(filters.datePrintTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
      filters.paymentDateFrom && (filters.paymentDateFrom = moment(filters.paymentDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      filters.paymentDateTo && (filters.paymentDateTo = moment(filters.paymentDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));

			ReportService.cashierStatistic(filters).then(function (response) {
				vm.results = response.events;
        vm.total = response.total;
			}).finally(function () {
				vm.loading = false;
			});
		}
	}

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistregion', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
        inputModel: '=?',
        outputModel: '=?',
        onChange: '&onChange',
				disabled: '=?',
        searchString: '=?'
			},
			templateUrl: 'app/components/directives/select-list-region/select-listregion.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistplace', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
        inputModel: '=?',
        outputModel: '=?',
        onChange: '&onChange',
				disabled: '=?',
        searchString: '=?'
			},
			templateUrl: 'app/components/directives/select-list-place/select-listplace.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistevent', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
                inputModel: '=?',
                outputModel: '=?',
                onChange: '&onChange',
				disabled: '=?',
                searchString: '=?',
                selectedView: '@?'
			},
			templateUrl: 'app/components/directives/select-list-event/select-list-event.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
		$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;
        $scope.selectedView = attrs.$attr.selectedView || null;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistchoice', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
        inputModel: '=?',
        outputModel: '=?',
        onChange: '&onChange',
				disabled: '=?',
        searchString: '=?'
			},
			templateUrl: 'app/components/directives/select-list-choice/select-listchoice.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistartist', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
        inputModel: '=?',
        outputModel: '=?',
        onChange: '&onChange',
				disabled: '=?',
        searchString: '=?'
			},
			templateUrl: 'app/components/directives/select-list-artist/select-listartist.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlistarea', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
        inputModel: '=?',
        outputModel: '=?',
        onChange: '&onChange',
				disabled: '=?',
        searchString: '=?'
			},
			templateUrl: 'app/components/directives/select-list-area/select-listarea.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('selectlist', function () {
		return {
			require: '?^^form',
			restrict: 'EA',
			scope: {
				inputMethod: '&inputMethod',
                inputModel: '=?',
                outputModel: '=?',
                onChange: '&onChange',
				disabled: '=?',
                searchString: '=?',
                placeholder: '@?'
			},
			templateUrl: 'app/components/directives/select-list/select-list.html',
			link: function ($scope, el, attrs, formController) {
        var active = [];
        function init(data) {
          data = $scope.outputModel;
          if ($scope.list.length) { // $scope.outputModel &&
            active = !_.isArray(data) ? [data] : data;
            if (!active[0]) {
              $scope.clear();
              return;
            }
            active.forEach(function(id) {
              $scope.set(id);
            });
          }
        }

        function output() {
          var out = _.map($scope.selected, 'id');
          return $scope.multiselect ? out : out[0];
        }

        $scope.list = [];
				$scope.searchString = '';
        $scope.multiselect = attrs.$attr.multiselect || false;
        $scope.hidesearch = attrs.$attr.hidesearch || false;
        $scope.placeholder = attrs.$attr.placeholder || 'Вибрати';
        $scope.isOpen = false;

        // FUNCTIONS

        $scope.set = function(id, e) {
          if (e)
            e.stopPropagation();
          var item = _.find($scope.list, {id: id}) || _.find($scope.list, {id: (id+'')});
          if (item) {
            item.selected = !item.selected;
            if (!$scope.multiselect) {
              $scope.clear(item.id);
						}
          }
        }

        $scope.clear = function(ignore) {
          _.each($scope.selected, function(item){
            if (item.id != ignore)
              item.selected = false;
          });
          // if (!ignore)
          //   $scope.outputModel = null;
          //   console.log(ignore, 123, $scope.selected)
          $scope.onChange();
        }

        $scope.clearSearch = function ($event) {
          $event.stopPropagation();
          $scope.searchString = '';
        }
				// handling $dirty flag inside forms
				$scope.setDirty = function () {
					if (formController) {
						formController.$setDirty();
					}
				}

        // WATCH

        $scope.$watch('selected', function () {
          //if (output())
            $scope.outputModel = output();
        }, true);

        $scope.$watch('outputModel', function (newVal) {
          if (!angular.equals(newVal, output())) {
            init();
					}
					// reducing $scope.onChange calls dublicating
					// no need to call $scope.onChange for !multiselect, because $scope.set calls
					// $scope.clear for !multiselect, which calls $scope.onChange
          if (angular.isFunction($scope.onChange) && $scope.multiselect) {
            $scope.onChange();
					}
        }, true);

        $scope.$watch('inputModel', function () {
          if (!$scope.inputModel)
            return;
          $scope.list = angular.copy($scope.inputModel);
          init();
        });

        $scope.$watch('inputMethod()', function () {
          if ($scope.inputMethod() && $scope.inputMethod().then)
            $scope.inputMethod().then(function(response){
              $scope.list = angular.copy(response.items || response)
              init();
            });
        });

        var openListener = $scope.$watch('isOpen', function (newVal) {
            if (newVal && angular.isUndefined($scope.initialized)) {
                $scope.initialized = true;
                openListener();
            }
        });
			}
		}
	});

})();

(function (angular) {
  'use strict';

  angular.module('tms').directive('multiselectDropdown', directive);

  function directive($q) {
    return {
      restrict: 'EA',
      require: 'ngModel',
      scope: {
        items: '=',
        options: '='
      },
      templateUrl: 'app/components/directives/multiselectDropdown/multiselectDropdown.html',
      link: link
    };

    function link(scope, el, attrs, ctrl) {

      scope.cfg = angular.extend({
        selectAll: true,
        search: true,
        multiselect: true,
        searchLen: 3
      }, scope.options);

      scope.filter = function (f) {
        var def = $q.defer();
        if (angular.isArray(scope.items)) {
          scope.list = f ?
            scope.items.filter(function (item) {
              return (item.name || '').startWith(f);
            }) : scope.items;
          def.resolve();

        } else if (angular.isFunction(scope.items)) {

          scope.items(f).then(function (data) {
            scope.list = data;
            def.resolve();
          });
        } else def.reject('Type of the \'items\' field could not be identified');

        return def.promise;
      };

      function updateModel() {
        var ids = scope.list.filter(function(it) { return it.selected; }).map(function (it) {
          return it.id;
        });
        ctrl.$setViewValue(scope.cfg.multiselect ? ids : ids[0]);
      }

      scope.search = function (filter) {
        if (!filter || filter.length >= scope.cfg.searchLen)
          scope.filter(filter || null);
      };

      scope.selectAll = function () {
        if (scope.list && scope.list.length) {
          var s = scope.selected ? scope.selected.length : 0;
          var l = scope.list ? scope.list.length : 0;
          var all = s < l;
          scope.list.forEach(function (item) {
            item.selected = all;
          });
        }
      };

      scope.select = function (item, setmodel) {
        item.selected = !item.selected;
        if (!scope.cfg.multiselect)
          scope.selected.forEach(function (it) {
            it.id != item.id && (it.selected = false);
          });
        setmodel !== false && updateModel();
      };

      scope.filter()
        .then(function () {
          if (scope.ngModel) {
            if (scope.cfg.multiselect && scope.ngModel.length)
              scope.ngModel.forEach(function (id) {
                scope.select({id: id}, false);
              });
            else
              scope.select({id: scope.ngModel}, false);
          }
        });
    }
  }

})(angular);

(function () {
  'use strict';

  angular.module('tms').directive('eventsList', function ($timeout, EventsService) {
    return {
      restrict: 'EA',
      scope: {
        disabled: '=',
        cityID: '=city',
        outputModel: '=?',
        onChange: '&onChange',
        initID: '=init',
        hideall: '=?',
        reset: '=?',
        eventStatus: '=?'
      },
      templateUrl: 'app/components/directives/eventslist/events.list.html',
      link: function ($scope, el, attrs) {
        $scope.events = [];
        $scope.active = {};
        $scope.eventsCount = 0;
        $scope.searchObj = {
          eventSearch: null
          //eventStatus: $scope.eventStatus || ['new', 'in_sales', 'out_of_sales']
        };

        $scope.multiselect = attrs.$attr.multiselect;
        $scope.hidestate = attrs.$attr.hidestate;
        // $scope.hideall = attrs.$attr.hideall;

        var f, multiselect = attrs.$attr.multiselect;

        $scope.search = function () {
          // preventing unwanted requests
          if ($scope.searchObj.eventSearch && $scope.searchObj.eventSearch.length < 3) {
            return;
          }

          EventsService.search({
            name: $scope.searchObj.eventSearch || null,
            //status: $scope.searchObj.eventStatus.join(','),
            cityID: $scope.cityID || null
          }).then(function (response) {
            $scope.events = response.plain();
          });
        }
       


      $scope.clear = function ($event) {
          if ($event)
            $event.stopPropagation();
          $scope.searchObj.eventSearch = null;
          // no need for search call here, $scope.searchObj is watched
        }

        $scope.remove = function(id, $event) {
          $event.stopPropagation();
          delete $scope.active[id];
          f = _.find($scope.events, {id: parseInt(id)});
          if (f) f.selected = false;
          $scope.eventsCount = _.size($scope.active);
        }

        $scope.set = function (event) {
          if (!event) {
            $scope.active = {};
          } else {
            if (!$scope.active[event.id]) {
              if (!multiselect) {
                $scope.active = {};
                f = _.find($scope.events, {selected: true});
                if (f) f.selected = false;
              }
              $scope.active[event.id] = event;
            } else
              delete $scope.active[event.id];
            event.selected = !event.selected;
          }
          $scope.eventsCount = _.size($scope.active);
        }

        $scope.set();

        EventsService.search().then(function (response) {
          $scope.events = response;
        });

        $scope.$watch('reset', function () {
          $scope.searchObj.eventStatus = $scope.eventStatus; // || ['new', 'in_sales', 'out_of_sales'];
          $scope.clear();
          $scope.set();
        });

        $scope.$watch('searchObj', function () {
          $scope.search();
        }, true);

        $scope.$watch('cityID', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          $scope.search();
        });

        $scope.$watch('outputModel', function (newVal) {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          output = multiselect ? output : output[0];
          if (newVal && !angular.equals(newVal, output)) {
            // EventsService.events.get(newVal).then(function (response) {
            //   $scope.set(response);
            // });

            // var id = multiselect ? newVal : newVal;

            // newVal appeared to be not array
            var id = multiselect && angular.isArray(newVal) ? newVal.join() : newVal;

            EventsService.search({id: id}).then(function (response) {
              _.each(response.plain(), function (v) {
                $scope.set(v);
              })
            });
          }
        }, true);

        $scope.$watch('active', function () {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          $scope.outputModel = multiselect ? output : output[0];
          if (angular.isFunction($scope.onChange))
          $timeout(function () {
            $scope.onChange();
          });
        }, true);

      }
    }
  });

})();

(function () {
	'use strict';

	angular.module('tms').directive('eventsFilter', function ($timeout, EventsService) {
		return {
			restrict: 'EA',
			scope: {
				disabled: '=',
        cityID: '=city',
        outputModel: '=?',
        onChange: '&onChange',
        initID: '=init',
        hideall: '=?',
        reset: '=?',
				eventStatus: '=?'
			},
			templateUrl: 'app/components/directives/events/events.filter.html',
			link: function ($scope, el, attrs) {
        $scope.events = [];
        $scope.active = {};
        $scope.eventsCount = 0;
        $scope.searchObj = {
          eventSearch: null,
          eventStatus: $scope.eventStatus || ['new', 'in_sales', 'out_of_sales']
        };

        $scope.multiselect = attrs.$attr.multiselect;
        $scope.hidestate = attrs.$attr.hidestate;
        // $scope.hideall = attrs.$attr.hideall;

        var f, multiselect = attrs.$attr.multiselect;

				$scope.search = function () {
					// preventing unwanted requests
          if ($scope.searchObj.eventSearch && $scope.searchObj.eventSearch.length < 3) {
            return;
					}

					EventsService.search({
						name: $scope.searchObj.eventSearch || null,
            status: $scope.searchObj.eventStatus.join(','),
            cityID: $scope.cityID || null
					}).then(function (response) {
						$scope.events = response.plain();
					});
				}

        $scope.clear = function ($event) {
          if ($event)
            $event.stopPropagation();
          $scope.searchObj.eventSearch = null;
					// no need for search call here, $scope.searchObj is watched
        }

        $scope.remove = function(id, $event) {
          $event.stopPropagation();
          delete $scope.active[id];
          f = _.find($scope.events, {id: parseInt(id)});
          if (f) f.selected = false;
          $scope.eventsCount = _.size($scope.active);
        }

				$scope.set = function (event) {
					if (!event) {
						$scope.active = {};
					} else {
            if (!$scope.active[event.id]) {
              if (!multiselect) {
                $scope.active = {};
                f = _.find($scope.events, {selected: true});
                if (f) f.selected = false;
              }
              $scope.active[event.id] = event;
            } else
              delete $scope.active[event.id];
            event.selected = !event.selected;
					}
          $scope.eventsCount = _.size($scope.active);
				}

				$scope.set();

        EventsService.search().then(function (response) {
          $scope.events = response;
        });

        $scope.$watch('reset', function () {
          $scope.searchObj.eventStatus = $scope.eventStatus || ['new', 'in_sales', 'out_of_sales'];
          $scope.clear();
          $scope.set();
        });

        $scope.$watch('searchObj', function () {
          $scope.search();
        }, true);

        $scope.$watch('cityID', function (newVal, oldVal) {
					if (newVal === oldVal) {
						return;
					}
          $scope.search();
        });

        $scope.$watch('outputModel', function (newVal) {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          output = multiselect ? output : output[0];
          if (newVal && !angular.equals(newVal, output)) {
            // EventsService.events.get(newVal).then(function (response) {
            //   $scope.set(response);
            // });

						// var id = multiselect ? newVal : newVal;

						// newVal appeared to be not array
            var id = multiselect && angular.isArray(newVal) ? newVal.join() : newVal;

            EventsService.search({id: id}).then(function (response) {
              _.each(response.plain(), function (v) {
                $scope.set(v);
              })
            });
          }
        }, true);

				$scope.$watch('active', function () {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          $scope.outputModel = multiselect ? output : output[0];
          if (angular.isFunction($scope.onChange))
          $timeout(function () {
            $scope.onChange();
          });
				}, true);

			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('citiesFilter', function (LocationsService) {
		return {
			restrict: 'EA',
			scope: {
				onChange: '&onChange',
				disabled: '='
			},
			templateUrl: 'app/components/directives/cities/cities.filter.html',
			link: function ($scope) {
				$scope.citySearch = null;

				$scope.search = function (e) {
					if (e)
						e.stopPropagation();
					if (!$scope.citySearch) $scope.citySearch = null;
					LocationsService.getCities({
						name: $scope.citySearch
					}).then(function (response) {
						$scope.cities = response.items;
					});
				}

				$scope.set = function (id, name) {
					if (!id) {
						$scope.cityName = null;
						$scope.cityID = null;
					} else {
						$scope.cityName = name;
						$scope.cityID = id;
					}
				}

				$scope.set();
				$scope.search();

				$scope.$watch('cityID', function () {
					if (angular.isFunction($scope.action)) {
						$scope.action({
							cityID: $scope.cityID
						});
					}
				}, true);

			}
		}
	});

})();

(function () {
  'use strict';

  angular.module('tms').directive('choiceplaceList', function ($timeout, ChoicePlaceService) {
    return {
      restrict: 'EA',
      scope: {
        disabled: '=',
        cityID: '=city',
        outputModel: '=?',
        onChange: '&onChange',
        initID: '=init',
        hideall: '=?',
        reset: '=?',
        choicplaceStatus: '=?'
      },
      templateUrl: 'app/components/directives/choiceplacelist/choiceplace.list.html',
      link: function ($scope, el, attrs) {
        $scope.choiceplace = [];
        $scope.active = {};
        $scope.choicplaceCount = 0;
        $scope.searchObj = {
          choicplaceSearch: null
          //eventStatus: $scope.eventStatus || ['new', 'in_sales', 'out_of_sales']
        };

        $scope.multiselect = attrs.$attr.multiselect;
        $scope.hidestate = attrs.$attr.hidestate;
        // $scope.hideall = attrs.$attr.hideall;

        var f, multiselect = attrs.$attr.multiselect;

        $scope.search = function () {
          // preventing unwanted requests
          if ($scope.searchObj.choicplaceSearch && $scope.searchObj.choicplaceSearch.length < 3) {
            return;
          }

          ChoicePlaceService.search({
            name: $scope.searchObj.choicplaceSearch || null,
            //status: $scope.searchObj.eventStatus.join(','),
            cityID: $scope.cityID || null
          }).then(function (response) {
            $scope.choiceplace = response.plain();
          });
        }
       


      $scope.clear = function ($choicplace) {
          if ($choicplace)
            $choicplace.stopPropagation();
          $scope.searchObj.choicplaceSearch = null;
          // no need for search call here, $scope.searchObj is watched
        }

        $scope.remove = function(id, $choicplace) {
          $choicplace.stopPropagation();
          delete $scope.active[id];
          f = _.find($scope.choiceplace, {id: parseInt(id)});
          if (f) f.selected = false;
          $scope.choiceplaceCount = _.size($scope.active);
        }

        $scope.set = function (choicplace) {
          if (!choicplace) {
            $scope.active = {};
          } else {
            if (!$scope.active[choicplace.id]) {
              if (!multiselect) {
                $scope.active = {};
                f = _.find($scope.choiceplace, {selected: true});
                if (f) f.selected = false;
              }
              $scope.active[choicplace.id] = choicplace;
            } else
              delete $scope.active[choicplace.id];
            choicplace.selected = !choicplace.selected;
          }
          $scope.choiceplaceCount = _.size($scope.active);
        }

        $scope.set();

        ChoicePlaceService.search().then(function (response) {
          $scope.choiceplace = response;
        });

        $scope.$watch('reset', function () {
          $scope.searchObj.choicplaceStatus = $scope.choicplaceStatus; // || ['new', 'in_sales', 'out_of_sales'];
          $scope.clear();
          $scope.set();
        });

        $scope.$watch('searchObj', function () {
          $scope.search();
        }, true);

        $scope.$watch('cityID', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          $scope.search();
        });

        $scope.$watch('outputModel', function (newVal) {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          output = multiselect ? output : output[0];
          if (newVal && !angular.equals(newVal, output)) {
            // EventsService.events.get(newVal).then(function (response) {
            //   $scope.set(response);
            // });

            // var id = multiselect ? newVal : newVal;

            // newVal appeared to be not array
            var id = multiselect && angular.isArray(newVal) ? newVal.join() : newVal;

            ChoicePlaceService.search({id: id}).then(function (response) {
              _.each(response.plain(), function (v) {
                $scope.set(v);
              })
            });
          }
        }, true);

        $scope.$watch('active', function () {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          $scope.outputModel = multiselect ? output : output[0];
          if (angular.isFunction($scope.onChange))
          $timeout(function () {
            $scope.onChange();
          });
        }, true);

      }
    }
  });

})();

(function () {
  'use strict';

  angular.module('tms').directive('choiceList', function ($timeout, ChoiceService) {
    return {
      restrict: 'EA',
      scope: {
        disabled: '=',
        cityID: '=city',
        outputModel: '=?',
        onChange: '&onChange',
        initID: '=init',
        hideall: '=?',
        reset: '=?',
        choicStatus: '=?'
      },
      templateUrl: 'app/components/directives/choicelist/choice.list.html',
      link: function ($scope, el, attrs) {
        $scope.choice = [];
        $scope.active = {};
        $scope.choicCount = 0;
        $scope.searchObj = {
          choicSearch: null
          //eventStatus: $scope.eventStatus || ['new', 'in_sales', 'out_of_sales']
        };

        $scope.multiselect = attrs.$attr.multiselect;
        $scope.hidestate = attrs.$attr.hidestate;
        // $scope.hideall = attrs.$attr.hideall;

        var f, multiselect = attrs.$attr.multiselect;

        $scope.search = function () {
          // preventing unwanted requests
          if ($scope.searchObj.choicSearch && $scope.searchObj.choicSearch.length < 3) {
            return;
          }

          ChoiceService.search({
            name: $scope.searchObj.choicSearch || null,
            //status: $scope.searchObj.eventStatus.join(','),
            cityID: $scope.cityID || null
          }).then(function (response) {
            $scope.choice = response.plain();
          });
        }
       


      $scope.clear = function ($choic) {
          if ($choic)
            $choic.stopPropagation();
          $scope.searchObj.choicSearch = null;
          // no need for search call here, $scope.searchObj is watched
        }

        $scope.remove = function(id, $choic) {
          $choic.stopPropagation();
          delete $scope.active[id];
          f = _.find($scope.choice, {id: parseInt(id)});
          if (f) f.selected = false;
          $scope.choiceCount = _.size($scope.active);
        }

        $scope.set = function (choic) {
          if (!choic) {
            $scope.active = {};
          } else {
            if (!$scope.active[choic.id]) {
              if (!multiselect) {
                $scope.active = {};
                f = _.find($scope.choice, {selected: true});
                if (f) f.selected = false;
              }
              $scope.active[choic.id] = choic;
            } else
              delete $scope.active[choic.id];
            choic.selected = !choic.selected;
          }
          $scope.choiceCount = _.size($scope.active);
        }

        $scope.set();

        ChoiceService.search().then(function (response) {
          $scope.choice = response;
        });

        $scope.$watch('reset', function () {
          $scope.searchObj.choicStatus = $scope.choicStatus; // || ['new', 'in_sales', 'out_of_sales'];
          $scope.clear();
          $scope.set();
        });

        $scope.$watch('searchObj', function () {
          $scope.search();
        }, true);

        $scope.$watch('cityID', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          $scope.search();
        });

        $scope.$watch('outputModel', function (newVal) {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          output = multiselect ? output : output[0];
          if (newVal && !angular.equals(newVal, output)) {
            // EventsService.events.get(newVal).then(function (response) {
            //   $scope.set(response);
            // });

            // var id = multiselect ? newVal : newVal;

            // newVal appeared to be not array
            var id = multiselect && angular.isArray(newVal) ? newVal.join() : newVal;

            ChoiceService.search({id: id}).then(function (response) {
              _.each(response.plain(), function (v) {
                $scope.set(v);
              })
            });
          }
        }, true);

        $scope.$watch('active', function () {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          $scope.outputModel = multiselect ? output : output[0];
          if (angular.isFunction($scope.onChange))
          $timeout(function () {
            $scope.onChange();
          });
        }, true);

      }
    }
  });

})();

(function () {
  'use strict';

  angular.module('tms').directive('artistsList', function ($timeout, ArtistsService) {
    return {
      restrict: 'EA',
      scope: {
        disabled: '=',
        cityID: '=city',
        outputModel: '=?',
        onChange: '&onChange',
        initID: '=init',
        hideall: '=?',
        reset: '=?',
        artistStatus: '=?'
      },
      templateUrl: 'app/components/directives/artistslist/artists.list.html',
      link: function ($scope, el, attrs) {
        $scope.artists = [];
        $scope.active = {};
        $scope.artistCount = 0;
        $scope.searchObj = {
          artistSearch: null
          //eventStatus: $scope.eventStatus || ['new', 'in_sales', 'out_of_sales']
        };

        $scope.multiselect = attrs.$attr.multiselect;
        $scope.hidestate = attrs.$attr.hidestate;
        // $scope.hideall = attrs.$attr.hideall;

        var f, multiselect = attrs.$attr.multiselect;

        $scope.search = function () {
          // preventing unwanted requests
          if ($scope.searchObj.artistSearch && $scope.searchObj.artistSearch.length < 3) {
            return;
          }

          ArtistsService.search({
            name: $scope.searchObj.artistSearch || null,
            //status: $scope.searchObj.eventStatus.join(','),
            cityID: $scope.cityID || null
          }).then(function (response) {
            $scope.artists = response.plain();
          });
        }
       


      $scope.clear = function ($artist) {
          if ($artist)
            $artist.stopPropagation();
          $scope.searchObj.artistSearch = null;
          // no need for search call here, $scope.searchObj is watched
        }

        $scope.remove = function(id, $artist) {
          $artist.stopPropagation();
          delete $scope.active[id];
          f = _.find($scope.artists, {id: parseInt(id)});
          if (f) f.selected = false;
          $scope.artistsCount = _.size($scope.active);
        }

        $scope.set = function (artist) {
          if (!artist) {
            $scope.active = {};
          } else {
            if (!$scope.active[artist.id]) {
              if (!multiselect) {
                $scope.active = {};
                f = _.find($scope.artists, {selected: true});
                if (f) f.selected = false;
              }
              $scope.active[artist.id] = artist;
            } else
              delete $scope.active[artist.id];
            artist.selected = !artist.selected;
          }
          $scope.artistsCount = _.size($scope.active);
        }

        $scope.set();

        ArtistsService.search().then(function (response) {
          $scope.artists = response;
        });

        $scope.$watch('reset', function () {
          $scope.searchObj.artistStatus = $scope.artistStatus; // || ['new', 'in_sales', 'out_of_sales'];
          $scope.clear();
          $scope.set();
        });

        $scope.$watch('searchObj', function () {
          $scope.search();
        }, true);

        $scope.$watch('cityID', function (newVal, oldVal) {
          if (newVal === oldVal) {
            return;
          }
          $scope.search();
        });

        $scope.$watch('outputModel', function (newVal) {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          output = multiselect ? output : output[0];
          if (newVal && !angular.equals(newVal, output)) {
            // EventsService.events.get(newVal).then(function (response) {
            //   $scope.set(response);
            // });

            // var id = multiselect ? newVal : newVal;

            // newVal appeared to be not array
            var id = multiselect && angular.isArray(newVal) ? newVal.join() : newVal;

            ArtistsService.search({id: id}).then(function (response) {
              _.each(response.plain(), function (v) {
                $scope.set(v);
              })
            });
          }
        }, true);

        $scope.$watch('active', function () {
          var output = _.map($scope.active, function (v, i) {
            return i;
          });
          $scope.outputModel = multiselect ? output : output[0];
          if (angular.isFunction($scope.onChange))
          $timeout(function () {
            $scope.onChange();
          });
        }, true);

      }
    }
  });

})();

(function () {
	'use strict';

	angular.module('tms').service('WidgetService', WidgetService);

	function WidgetService($q, $log, AuthService) {

		var self = this;
		var user = AuthService.init();

    var temp = {
      "localhost": "https://dev-hall.test-kasa.in.ua",
      "tms.net.ua": "https://hall.tms.net.ua"
    };

  var url = temp[document.location.hostname] || 'https://dev-hall.test-kasa.in.ua'; // eslint-disable-line

		// -------------------------------------------------------------------------

    (function(i,s,o,g,r,a,m){i['KasaObject']=r;i[r]=i[r]||function(k,v){
      (i[r].q=i[r].q||{})[k]=v;},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script', url + '/public/dist/app.js','__kasa');

		__kasa("access_token", user.access_token); // eslint-disable-line

		self.init = $q(function (resolve) {
			__kasa("init", function (widget) { // eslint-disable-line
				self.widget = widget;
				// widget.on('log', function (mode, action, status, info) {
				// 	$log.log('Widget:', mode, action, status, info);
				// });
				resolve(self.widget);
			});
		});

    // -------------------------------------------------------------------------

    self.getUrl = function(){
      return url;
    }

    // mode = 'location', 'hall', 'order', 'quota', 'price'
    // action = 'load', 'save', 'delete'
    // status = 'success', 'fail'
    self.listen = function(callback){
      self.init.then(function(widget){
        widget.off('log');
        widget.on('log', function (mode, action, status, info) {
          callback(mode, action, status, info);
        });
      });
    }

    self.setQuota = function(quoteId, eventID, action){
      self.init.then(function(widget){
        self.refresh(widget);
        if (eventID)
          widget.setQuota(quoteId, eventID, action);
        else {
          widget.setQuota(quoteId);
        }
      });
    }

    self.setEvent = function(eventId){
      self.init.then(function(widget){
        self.refresh(widget);
        widget.setEvent(eventId);
      });
    }

    self.setModeAdmin = function(eventId){
      self.init.then(function(widget){
        self.refresh(widget);
        widget.setModeAdmin(eventId);
      });
    }

    self.setOrder = function(orderID, eventID){
      self.init.then(function(widget){
        if(!eventID) {
          self.refresh(widget);
        }
        widget.setOrder(orderID, eventID);
      });
    }

    self.setEditHall = function(hallID){
      self.init.then(function(widget){
        self.refresh(widget);
        widget.setEditHall(hallID);
      });
    }

    // -------------------------------------------------------------------------

    self.refresh = function(widget) {
      __kasa("access_token", AuthService.init().access_token); // eslint-disable-line
      widget.insert('#kasa-in-ua');
    }

    // -------------------------------------------------------------------------
	}
})();

(function () {
	'use strict';

	angular.module('tms').controller('WidgetsStatisticsController', WidgetsStatisticsController);

	function WidgetsStatisticsController(ReportService) {
		var vm = this;

    ReportService.getWidgetSalesReport().then(function (response) {
      vm.response = response.plain();
    });

	}

})();

(function () {
    'use strict';

    angular.module('tms').config(runRoutingSetup);

    function runRoutingSetup($stateProvider, stateHelperProvider) {
    stateHelperProvider.state({
            name: 'main.statistics',
            url: 'statistics',
            title: 'Статистика',
            template: '<div ui-view class="fade-in-down-big"></div>',
            menu: true,
            abstract: true,
            position: 20,
            permissions: ['eventsStatistics'],
            params: {
                route: 'statistics'
            },
            children:
                [{
                  name: 'event',
                  url: '/:id',
                  title: 'Статистика',
                  controller: 'StatisticsController as vm',
                  templateUrl: 'app/main/statistics/statistics.view.html',
                  menu: true,
                  permissions: ['eventsStatistics']
                },{
                  name: 'full',
                  url: '/full/:id',
                  title: 'Розширена статистика',
                  controller: 'FullStatisticsController as vm',
                  templateUrl: 'app/main/statistics/full.view.html',
                  menu: true,
                  permissions: ['extendedEventStats']
                },{
                  name: 'clients',
                  url: '/clients/:event',
                  controller: 'ClientsStatisticsController as vm',
                  templateUrl: 'app/main/statistics/clients.view.html',
                  title: 'Звіт по клієнтам',
                  menu: false,
                  permissions: ['clientsReport']
                },{
                  name: 'eventSalesByPerson',
                  url: '/dev-clients/:event',
                  controller: 'DevClientsStatisticsController as vm',
                  templateUrl: 'app/main/statistics/dev-clients.view.html',
                  title: 'Dev - Звіт',
                  menu: true,
                  permissions: ['extendedEventStats']
                }]
    });

      stateHelperProvider.state({
        name: 'main.statistics.widgets',
        url: '/widgets/',
        title: 'Продажі через віджет',
        controller: 'WidgetsStatisticsController as vm',
        templateUrl: 'app/main/statistics/widgets.html',
        menu: true,
        position: 21,
        permissions: ['widgetsStatistics']
      });
    }

})();

(function () {
	'use strict';

	angular.module('tms').controller('StatisticsController', StatisticsController);

	function StatisticsController($scope, $stateParams, AuthService, ReportService, LocationsService, calendarOptions) {
		var vm = this;

		vm.userData = AuthService.init();

		vm.filters = {
			paymentDateFrom: null,
			paymentDateTo: null,
			eventID: null
		};

		vm.calendarOptions = calendarOptions;

		vm.chartConfig = {
			title: {
				text: 'Динаміка продажу, без врахування квот'
			},
      options: {
        tooltip: {
          split: true,
          distance: 30,
          padding: 5
        }
      },
			xAxis: {
				categories: []
			},
			yAxis: {
				title: {
					text: 'Кiлькiсть бiлетiв'
				}
			},
			series: [{
				name: 'Продано',
				data: []
        }, {
				name: 'Бронь',
				data: []
        }]
		};

    vm.citiesGet = LocationsService.getCities();

		vm.getStat = function () {
      if (!(vm.filters.eventID.length || (vm.filters.paymentDateFrom && vm.filters.paymentDateTo))) {
        return;
      }

			vm.loading = true;

      var filters = _.extend({}, vm.filters);
      filters.eventID = filters.eventID.toString();

      ReportService.eventTotal(filters).then(function (response) {
        vm.contractorsXlsUrl = ReportService.getoredersXLSurl(response.contractorsXlsUrl);
				vm.response = response;

				vm.chartConfig.series[0].data = [];
				vm.chartConfig.series[1].data = [];
				vm.chartConfig.xAxis.categories = [];
				_.each(response.dates, function (d) {
					vm.chartConfig.series[0].data.push(d.soldCount);
					vm.chartConfig.series[1].data.push(d.reservedCount);
					vm.chartConfig.xAxis.categories.push(d.date);
				});
			}).finally(function () {
				vm.loading = false;
			});
		}

		vm.percent = function (data) {
			if (!data || +data === 0 || +vm.response.totalCount === 0) {
				return 0;
			}
			return parseFloat(parseInt(data) / parseInt(vm.response.totalCount) * 100).toFixed(2);
		}

    if ($stateParams.id) {
      vm.initEvent = $stateParams.id;
      vm.filters.eventID = $stateParams.id;
      vm.getStat();
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('FullStatisticsController', FullStatisticsController);

	function FullStatisticsController($scope, $stateParams, ReportService, LocationsService) {
		var vm = this;

		vm.filters = {
			eventID: null
		};

		vm.menuItems = [{
			id: 'remains-of-tickets',
			title: 'Залишки квиткiв',
			templateUrl: 'app/main/statistics/tables/remains-of-tickets.html'
		},{
			id: 'payment-and-delivery-types',
			title: 'Способи оплати та доставки',
			templateUrl: 'app/main/statistics/tables/payment-and-delivery-types.html'
		},{
			id: 'by-contractors',
			title: 'По контрагентах',
			templateUrl: 'app/main/statistics/tables/by-contractors.html'
		},{
      id: 'kg-9',
			title: 'КГ-9',
			templateUrl: 'app/main/statistics/tables/kg-9.html'
		},{
      id: 'kg-10',
			title: 'КГ-10',
			templateUrl: 'app/main/statistics/tables/kg-10.html'
		}];

		vm.selectedMenuItem = vm.menuItems[0];

		vm.citiesGet = LocationsService.getCities();

		vm.select = function(item) {
			vm.selectedMenuItem = item;
		}

		$scope.$watch('vm.filters.eventID', function() {
			updateReportTable();
		})

		$scope.$watch('vm.selectedMenuItem', function() {
			updateReportTable();
		})

		var updateReportTable = function() {
			if (!vm.selectedMenuItem || !vm.selectedMenuItem.id || !vm.filters || !vm.filters.eventID) {
				return;
			}

			switch (vm.selectedMenuItem.id) {
				case 'remains-of-tickets':
					ReportService.eventExtended(vm.filters).then(prepareZones)
						.then(function(response) {
							vm.response = response;
						})
					break;
				case 'payment-and-delivery-types':
					ReportService.getPaymentAndDeliveryReport(vm.filters).then(function(response) {
						vm.response = response.plain();
					})
					break;
				case 'by-contractors':
					ReportService.getByContractorsReport(vm.filters).then(function(response) {
						vm.response = response.plain();
					})
					break;
				case 'kg-9':
					ReportService.getKG9Report(vm.filters).then(function(response) {
						vm.response = response.plain();
					})
					break;
				case 'kg-10':
					ReportService.getKG10Report(vm.filters).then(function(response) {
						vm.response = response.plain();
					})
					break;
				default:
			}
		}

		var prepareZones = function (response) {
			_.each(response.zones, function(zone){
				zone.rows = [];
				_.each(zone.prices, function(price){
					_.each(price.rows, function(row){
						row.price = price.price;
						zone.rows.push(row);
					});
				});
			});
			return response.plain();
		}

    if ($stateParams.id) {
      vm.initEvent = $stateParams.id;
      vm.filters.eventID = $stateParams.id;
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('DevClientsStatisticsController', DevClientsStatisticsController);

	function DevClientsStatisticsController($scope, $stateParams, $window, ReportService, OrdermanagerService, LocationsService) {
		var vm = this;
        var reportBodyLevel2Total = [];
        var reportBodyLevel2_1Total = [];
        vm.reportBodyLevel2_1GrandTotal = {};

        
        //Initial data
        vm.dataIsLoaded = false;
        vm.byinvite = true;
        
        vm.ticketFilter = {
          paidbycc: true,
          eticket: true,
          byinvite: true,
          byquota: true
        };

        vm.filters = {
            eventID: null,
            moneyRecipientID: null
        };

        vm.citiesGet = LocationsService.getCities();
        
        vm.moneyRecipient = OrdermanagerService.getUsers();
        
        vm.getXls = function(){
            $window.open(vm.reportXlsUrl,'_self');
        }
        
        vm.getStat = function () {
            if (!(vm.filters.eventID.length)) {
                return;
            }
            var filters = _.extend({}, vm.filters, vm.ticketFilter);
            filters.eventID = filters.eventID.toString();

            ReportService.eventSalesByPerson(filters).then(function (response) {
                vm.dataIsLoaded = true;
                vm.reportXlsUrl = ReportService.getoredersXLSurl(response.reportXlsUrl);
                vm.responce = response;
                vm.reportGrandHeader = response.reportGrandHeader;
                vm.reportGrandHeaderTotal = 0;
                vm.reportGrandHeaderTicketsTotal = 0;
                vm.reportGrandHeader.forEach(function(el){
                    vm.reportGrandHeaderTotal += el.ticket_sum*1;
                    vm.reportGrandHeaderTicketsTotal += el.tickets_count*1;
                })

                var el_level1 = [];
                vm.reportBodyLevel1 = []
                response.reportBody.filter(function(levelData){
                    if (el_level1.filter(function(el){ return (el == levelData.ticket_seller_id )}).length == 0){
                        el_level1.push(levelData.ticket_seller_id);
                        return levelData;
                    }
                }).forEach(function(el){
                    vm.reportBodyLevel1[el.ticket_by_quota_type] = vm.reportBodyLevel1[el.ticket_by_quota_type] || [];
                    vm.reportBodyLevel1[el.ticket_by_quota_type].push(el)
                    });
                    
                vm.reportBodyLevel2_1GrandTotal['ticket_cost_total'] = 0;
                vm.reportBodyLevel2_1GrandTotal['tickets_count'] = 0;
        
                vm.reportBodyLevel1.forEach(function(reportBodyLevel1){
                    reportBodyLevel1.forEach(function(el){
                        el.reportBodyLevel2 = el.reportBodyLevel2 || [];
                        el.reportBodyLevel2_1 = el.reportBodyLevel2_1 || [];
                        reportBodyLevel2Total[el.ticket_seller_id] = [];
                        reportBodyLevel2_1Total[el.ticket_seller_id] = [];
                        response.reportBody.filter(function(levelData){ if (levelData.ticket_seller_id == el.ticket_seller_id) { return el;}}).forEach(function(obj){
                            switch (obj['ticket_by_invite_type']){
                                case 0:
                                    //Продані білети
                                    reportBodyLevel2Total[el.ticket_seller_id]['ticket_cost_total'] = reportBodyLevel2Total[el.ticket_seller_id]['ticket_cost_total'] || 0;
                                    reportBodyLevel2Total[el.ticket_seller_id]['tickets_count'] = reportBodyLevel2Total[el.ticket_seller_id]['tickets_count'] || 0;
                                    reportBodyLevel2Total[el.ticket_seller_id]['ticket_cost_total'] += obj['ticket_cost_total']*1;
                                    reportBodyLevel2Total[el.ticket_seller_id]['tickets_count'] += obj['tickets_count']*1;
                                    el.reportBodyLevel2.push(obj);
                                break;
                                case 1:
                                    //Запрошення
                                    reportBodyLevel2_1Total[el.ticket_seller_id]['ticket_cost_total'] = reportBodyLevel2_1Total[el.ticket_seller_id]['ticket_cost_total'] || 0;
                                    reportBodyLevel2_1Total[el.ticket_seller_id]['tickets_count'] = reportBodyLevel2_1Total[el.ticket_seller_id]['tickets_count'] || 0;
                                    reportBodyLevel2_1Total[el.ticket_seller_id]['ticket_cost_total'] += obj['ticket_cost_total']*1;
                                    reportBodyLevel2_1Total[el.ticket_seller_id]['tickets_count'] += obj['tickets_count']*1;
                                    vm.reportBodyLevel2_1GrandTotal['ticket_cost_total'] += obj['ticket_cost_total']*1;
                                    vm.reportBodyLevel2_1GrandTotal['tickets_count'] += obj['tickets_count']*1;
                                    el.reportBodyLevel2_1.push(obj);
                                break;
                            } 
                        });
                    });
                });
                
                
            }, function (){
                vm.dataIsLoaded = false;
            });
        }
        
        vm.getReportBodyLevel2Total = function(ticket_seller_id){
            return reportBodyLevel2Total[ticket_seller_id];
        }
        
        vm.getReportBodyLevel2_1Total = function(ticket_seller_id){
            return reportBodyLevel2_1Total[ticket_seller_id];
        }
        
	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('ClientsStatisticsController', ClientsStatisticsController)

  function ClientsStatisticsController($scope, $stateParams, ReportService) {
    var vm = this;

    vm.filters = {
      onlyBuyers: true,
      eventID: $stateParams.event
    }

    $scope.$watch('vm.filters', function () {
      vm.clientsReportLink = ReportService.getClientsReportLink(vm.filters);
    }, true);
  }
})();

(function () {
	'use strict';

	angular.module('tms').service('SiteService', SiteService);

	function SiteService($q, $log, Restangular) {
  var Area = Restangular.one('area');
    var GeoRegion = Restangular.one('georegion');
    var Tour = Restangular.one('tour');
    var GeoCityLang = Restangular.one('geocitylang');
    var Choice = Restangular.one('choice');
    var ChoicePlace = Restangular.one('choiceplace');
    // var Lang = Restangular.one('lang');        
    var Artists = Restangular.one('artists');
    var News = Restangular.one('news');
    var Slides = Restangular.one('sliders');
    var Slide = Restangular.one('slider');
    var Cashes = Restangular.one('cashes');
    var Cash = Restangular.one('cash');
    var ArtistsUrlAlias = Restangular.one('artists/genurlalias');
    var Export = Restangular.one('export');
    var ExportCity = Restangular.one('export/city');
    var Recommendations = Restangular.one('recommendations');
        

    var list = {};

    this.export = {    
       save: function(data) {
          return Export.customPOST(data, '', {});
        }
     }
    this.exportcity = {    
       save: function(data) {
          return ExportCity.customPOST(data, '', {});
        }
     }
  

        this.georegion = {
       
        list: function (filters) {
        
        return GeoRegion.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
        get: function(id) {
            return GeoRegion.one(id+'').get();
        },
        
        save: function(data) {
            if (data.id)
                return GeoRegion.one(data.id+'').customPUT(data, '', {});
            else
               return GeoRegion.customPOST(data, '', {});
         } 
        }

        this.area = {
        // list: function() {
        //     return Area.get();
        // },
        list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return Area.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
        get: function(id) {
            return Area.one(id+'').get();
        },
        // getUrlAlias : function (id){
        //  return AreaUrlAlias.get({'id':id+''});
        //     },
        save: function(data) {
            if (data.id)
                return Area.one(data.id+'').customPUT(data, '', {});
            else
               return Area.customPOST(data, '', {});
        }
        // ,
        //delete: function(id) {
        //    return Area.one(id+'').remove();
        //}
        

  }
  this.artists = {
        // list: function() {
        //     return Artists.get();
        // },
        list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return Artists.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
        get: function(id) {
            return Artists.one(id+'').get();
        },
        getUrlAlias : function (id){
         return ArtistsUrlAlias.get({'id':id+''});
            },
        save: function(data) {
            if (data.id)
                return Artists.one(data.id+'').customPUT(data, '', {});
            else
               return Artists.customPOST(data, '', {});
        }
        // ,
        //delete: function(id) {
        //    return Artists.one(id+'').remove();
        //}
        

  }

  // this.choicePivot = {
  //       // list: function() {
  //       //     return Artists.get();
  //       // },
  //       list: function (filters) {
  //       // if (list.count)
  //       //  return $q.resolve(list);
  //       return ChoicePivot.get(filters).then(function (response) {
  //         angular.merge(list, response);
  //         return response;
  //       });
  //     },
  //       get: function(id) {
  //           return ChoicePivot.one(id+'').get();
  //       },
  //       // getUrlAlias : function (id){
  //       //  return ArtistsUrlAlias.get({'id':id+''});
  //       //     },
  //       save: function(data) {
  //           if (data.id)
  //               return ChoicePivot.one(data.id+'').customPUT(data, '', {});
  //           else
  //              return ChoicePivot.customPOST(data, '', {});
  //       }
        // ,
        //delete: function(id) {
        //    return Artists.one(id+'').remove();
        //}
        

  // }

  this.choiceplace = {
        // list: function() {
        //     return Artists.get();
        // },
        list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return ChoicePlace.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });


      },
        get: function(id) {
            return ChoicePlace.one(id+'').get();
        },
        // getUrlAlias : function (id){
        //  return ArtistsUrlAlias.get({'id':id+''});
        //     },
        save: function(data) {
            if (data.id)
                return ChoicePlace.one(data.id+'').customPUT(data, '', {});
            else
               return ChoicePlace.customPOST(data, '', {});
        }
                

  }
  
  // this.list2 = function (filters) {
  //     return ChoicePlace.get(filters);
  //   };

  this.tour = {
      list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return Tour.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
      get: function(id) {
        return Tour.one(id+'').get();
      },
      save: function(data) {
        if (data.id)
          return Tour.one(data.id+'').customPUT(data, '', {});
        else
          return Tour.customPOST(data, '', {});
      }
      // ,
      // delete: function(id) {
      //   return Tour.one(id+'').remove();
      // }
    }   

      this.geocitylang = {
      list: function (filters) {
        return GeoCityLang.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
      get: function(id) {
        return GeoCityLang.one(id+'').get();
      },
      save: function(data) {
        if (data.id)
          return GeoCityLang.one(data.id+'').customPUT(data, '', {});
        else
          return GeoCityLang.customPOST(data, '', {});
      }
      
    } 

    // this.lang = {
    //   list: function (filters) {
    //     return Lang.get(filters).then(function (response) {
    //       angular.merge(list, response);
    //       return response;
    //     });
    //   },
    //   get: function(id) {
    //     return Lang.one(id+'').get();
    //   }
      
    // } 

    this.choice = {

      list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return Choice.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
      get: function(id) {
        return Choice.one(id+'').get();
      },
      save: function(data) {
        if (data.id)
          return Choice.one(data.id+'').customPUT(data, '', {});
        else
          return Choice.customPOST(data, '', {});
      }
      // ,
      // delete: function(id) {
      //   return Choice.one(id+'').remove();
      // }
    }    

    this.news = {

      list: function (filters) {
        // if (list.count)
        //  return $q.resolve(list);
        return News.get(filters).then(function (response) {
          angular.merge(list, response);
          return response;
        });
      },
      get: function(id) {
        return News.one(id+'').get();
      },
      save: function(data) {
        if (data.id)
          return News.one(data.id+'').customPUT(data, '', {});
        else
          return News.customPOST(data, '', {});
      }
      // ,
      // delete: function(id) {
      //   return News.one(id+'').remove();
      // }
    }
    this.slides = {
      list: function() {
        return Slides.get();
      },
      get: function(id) {
        return Slide.one(id+'').get();
      },
      save: function(data) {
        data.bigSlideID = parseInt(data.bigSlideID);
        data.smallSlideID = parseInt(data.smallSlideID);
        if (data.id)
          return Slide.one(data.id+'').customPUT(data);
        else
          return Slide.post('', data);
      }
      // ,
      // delete: function(id) {
      //   return Slide.one(id+'').remove();
      // }
    }
    this.cashes = {
      getList: function() {
        return Cashes.get();
      },
      get: function(id) {
        return Cash.one(id+'').get();
      },
      save: function(data) {
        if (data.id)
          return Cash.one(data.id+'').customPUT(data);
        else
          return Cash.post('', data);
      },
      delete: function(id) {
        return Cash.one(id+'').remove();
      }
    },
        this.recommendations = {
            getList: function() {
                return Recommendations.get();
            },
            save: function(data) {
                return Recommendations.post('', data);
            },
            delete: function(id) {
                return Recommendations.one(id+'').remove();
            }
        }
	}
})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
			name: 'main.site',
			url: 'site',
			title: 'Сайт',
			template: '<div ui-view class="fade-in-down-big"></div>',
			menu: true,
			abstract: true,
			position: 100,
          permissions: ['menuSite'],
			children: [
				{
					name: 'news',
					url: '/news',
					title: 'Новини',
					controller: 'NewsController as vm',
					templateUrl: 'app/main/site/news/news.view.html',
					menu: true,
          permissions: ['listNews']
        },{
          name: 'news.edit',
          url: '/news/:id',
          title: 'Новина',
          controller: 'NewsController as vm',
          templateUrl: 'app/main/site/news/news.edit.view.html',
          menu: false,
          permissions: ['manageNews']
        },{
          name: 'tour',
          url: '/tour',
          title: 'Тури',
          controller: 'TourController as vm',
          templateUrl: 'app/main/site/tour/tour.view.html',
          menu: true,
          permissions: ['listTour']
        },{
          name: 'tour.edit',
          url: '/tour/:id',
          title: 'Тур',
          controller: 'TourController as vm',
          templateUrl: 'app/main/site/tour/tour.edit.html',
          menu: false,
          permissions: ['manageTour']
        },{
          name: 'geocitylang',
          url: '/geocitylang',
          title: 'Міста',
          controller: 'GeoCityLangController as vm',
          templateUrl: 'app/main/site/geocitylang/geocitylang.view.html',
          menu: true,
          permissions: ['listGeo']
        },{
          name: 'geocitylang.edit',
          url: '/geocitylang/:id',
          title: 'Місто',
          controller: 'GeoCityLangController as vm',
          templateUrl: 'app/main/site/geocitylang/geocitylang.edit.html',
          menu: false,
          permissions: ['manageGeo']
        },{
          name: 'choice',
          url: '/choice',
          title: 'Підбірки',
          controller: 'ChoiceController as vm',
          templateUrl: 'app/main/site/choice/choice.view.html',
          menu: true,
          permissions: ['listChoice']
        },{
          name: 'choice.edit',
          url: '/choice/:id',
          title: 'Підбірка',
          controller: 'ChoiceController as vm',
          templateUrl: 'app/main/site/choice/choice.edit.html',
          menu: false,
          permissions: ['manageChoice']
          },
          
        // {
        //   name: 'choiceplace',
        //   url: '/choiceplace',
        //   title: 'Місця підбірки',
        //   controller: 'ChoicePlaceController as vm',
        //   templateUrl: 'app/main/site/choiceplace/choiceplace.view.html',
        //   menu: true,
        //   permissions: ['manageSlider']
        // },{
        //   name: 'choiceplace.edit',
        //   url: '/choiceplace/:id',
        //   title: 'Місця підбірки',
        //   controller: 'ChoicePlaceController as vm',
        //   templateUrl: 'app/main/site/choiceplace/choiceplace.edit.html',
        //   menu: false,
        //   permissions: ['manageSlider']
        // },
         {
           name: 'area',
           url: '/area',
           title: 'Локація',
           controller: 'AreaController as vm',
           templateUrl: 'app/main/site/area/area.view.html',
           menu: true,
           permissions: ['listArea']
           },{
            name: 'area.edit',
            url: '/area/:id',
            title: 'Локація',
            controller: 'AreaController as vm',
            templateUrl: 'app/main/site/area/area.edit.html',
            menu: false,
            permissions: ['manageArea']
        },{
           name: 'artists',
           url: '/artists',
           title: 'Артисти',
           controller: 'ArtistsController as vm',
           templateUrl: 'app/main/site/artists/artists.view.html',
           menu: true,
           permissions: ['listArtists']
           },{
            name: 'artists.edit',
            url: '/artists/:id',
            title: 'Артисти',
            controller: 'ArtistsController as vm',
            templateUrl: 'app/main/site/artists/artists.edit.html',
            menu: false,
            permissions: ['manageArtists']
        },{
  name: 'slides',
  url: '/slides',
  title: 'Слайди',
  controller: 'SlidesController as vm',
  templateUrl: 'app/main/site/slides/slides.view.html',
  menu: true,
  permissions: ['listSlider']
        },{
          name: 'slides.edit',
          url: '/slides/:id',
          title: 'Слайд',
          controller: 'SlidesController as vm',
          templateUrl: 'app/main/site/slides/slides.edit.html',
          menu: false,
          permissions: ['manageSlider']
        }, {
          name: 'fb-pixel',
          url: '/fb-pixel',
          title: 'FB Pixel',
          controller: 'FBPixelController as vm',
          templateUrl: 'app/main/site/pixel/pixel.view.html',
          menu: true,
          permissions: ['fbPixelSettings']
        }, {
          name: 'fb-pixel.edit',
          url: '/fb-pixel/:id',
          title: 'FB Pixel Edit',
          controller: 'FBPixelEditController as vm',
          templateUrl: 'app/main/site/pixel/pixel.edit.view.html',
          menu: false,
          permissions: ['fbPixelSettings']
        }, {
          name: 'recommendations',
          url: '/recommendations',
          title: 'Рекомендовані події',
          controller: 'RecommendationsController as vm',
          templateUrl: 'app/main/site/recommendations/recommendations.view.html',
          menu: true,
          permissions: ['manageRecommendations']
        }
      ]
		});

	}

})();

(function () {
    'use strict';

    angular.module('tms').service('ServiceChargeService', ServiceChargeService);

    function ServiceChargeService($q, $log, $state, $uibModal, Restangular) {

        var List = Restangular.one('service-charge/list');
        var View = Restangular.one('service-charge/view');
        var Create = Restangular.one('service-charge/create');
        var Update = Restangular.one('service-charge/update');
        var Delete = Restangular.one('service-charge/delete');
        var Types = Restangular.one('service-charge/types');

        this.list = function (filters) {
            return List.get(filters);
        };

        this.view = function (id) {
            return View.one(id+'').get();
        };

        this.create = function (data) {
            return Create.customPOST(data, '', {});
        };

        this.update = function (data) {
            return Update.customPUT(data, '', {});
        };

        this.delete = function (id, vm) {
            $uibModal.open({
                templateUrl: 'app/main/service-charge/modal/modal.delete.html',
                size: 'sm',
                resolve: {
                    id: function () {
                        return id;
                    },
                    vm: function () {
                        return vm;
                    }
                },
                controller: function ($scope, $uibModalInstance, id, vm) {

                    $scope.ok = function () {
                        Delete.one(id+'').remove().then(function (response) {
                            $uibModalInstance.dismiss();
                            vm.afterSave(response, 'Успішно видалено');
                        });
                    };

                    $scope.close = function () {
                        $uibModalInstance.dismiss();
                    };
                }
            });
        };

        this.getTypes = function () {
            return Types.get();
        };
    }
})();

(function () {
    'use strict';

    angular.module('tms').config(runRoutingSetup);

    function runRoutingSetup(stateHelperProvider) {
        stateHelperProvider.state({
            name: 'main.service-charge',
            url: 'service-charge',
            title: 'Управління СЗ',
            controller: 'ServiceChargeController as vm',
            templateUrl: 'app/main/service-charge/service-charge.list.html',
            menu: true,
            position: 990,
            permissions: ['serviceCharge']
        });

        stateHelperProvider.state({
            name: 'main.service-charge-edit',
            url: 'service-charge/edit/:id',
            title: 'Редагування СЗ',
            controller: 'ServiceChargeEditController as vm',
            templateUrl: 'app/main/service-charge/service-charge.edit.html',
            menu: false,
            position: 1,
            permissions: ['serviceCharge']
        });
    }
})();

(function () {
    'use strict';

    angular.module('tms').controller('ServiceChargeEditController', ServiceChargeEditController);

    function ServiceChargeEditController($scope, $state, $stateParams, $timeout, toastr, AuthService, ServiceChargeService, EventsService, PlayersService) {
        var vm = this;
        vm.userData = AuthService.init();
        vm.serviceCharge = {
            active: true,
            rate_type: 'percent',
            tickets_type: 'all',
            payment_type: 'all',
            events_type: 'some',
            cashes_type: 'all'
        };
        vm.events = [];
        vm.cashes = [];
        vm.rateTypes = [];
        vm.ticketsTypes = [];
        vm.paymentTypes = [];
        vm.eventsTypes = [];
        vm.cashesTypes = [];

        ServiceChargeService.getTypes().then(function (response) {
            vm.rateTypes = response.rate || [];
            vm.ticketsTypes = response.tickets || [];
            vm.paymentTypes = response.payment || [];
            vm.eventsTypes = response.events || [];
            vm.cashesTypes = response.cashes || [];
        });
        EventsService.events.list().then(function (response) {
            vm.events = response.items || [];
        });
        PlayersService.getCashes().then(function (response) {
            vm.cashes = response.items || [];
        });

        if ($stateParams.id) {
            ServiceChargeService.view($stateParams.id).then(function (response) {
                vm.serviceCharge = response.data || {};
            });
        }

        vm.save = function () {
            $scope.$broadcast('show-errors-check-validity');
            if (!vm.form.$valid) {
                return;
            }
            if (angular.isUndefined(vm.serviceCharge.id)) {
                ServiceChargeService.create(vm.serviceCharge).then(function (response) {
                    vm.afterSave(response, 'Успішно створено');
                });
            } else {
                ServiceChargeService.update(vm.serviceCharge).then(function (response) {
                    vm.afterSave(response);
                });
            }
        };

        vm.afterSave = function (response, successMessage) {
            if (response.error) {
                toastr.error(response.error);
            } else if (response.info) {
                toastr.warning(response.info);
            } else if (response.success) {
                if (angular.isUndefined(successMessage)) {
                    successMessage = 'Успішно змінено';
                }
                toastr.success(successMessage, '', {
                    "timeOut": "5000"
                });
                $state.go('main.service-charge');
            }
        };

        vm.delete = function () {
            if (angular.isDefined(vm.serviceCharge.id)) {
                ServiceChargeService.delete(vm.serviceCharge.id, vm);
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('tms').controller('ServiceChargeController', ServiceChargeController);

    function ServiceChargeController($scope, $state, $stateParams, ServiceChargeService, $timeout, toastr, AuthService) {
        var vm = this;
        vm.userData = AuthService.init();

        vm.items = [];
        vm.count = 0;
        vm.offset = 0;
        vm.limit = 30;
        vm.sortOrder = null;
        vm.disableScroll = true;

        getList();

        vm.load = function () {
            vm.offset = vm.offset + vm.limit;
            if (vm.count > vm.offset) {
                getList();
            }
        };

        function getList() {
            var query = _.extend({}, {sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
            ServiceChargeService.list(query).then(function (response) {
                if (response.error){
                    toastr.error(response.error);
                }
                vm.items = vm.items.concat(response.items);
                vm.count = response.count;
                vm.disableScroll = vm.count <= vm.offset;
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('tms').service('ResponsibleService', ResponsibleService);

    function ResponsibleService($q, $log, $state, Restangular) {

        var Responsible = Restangular.one('responsible');

        this.getEvents = function (filters) {
            return Responsible.one('events').get(filters);
        };
    }
})();

(function () {
    'use strict';

    angular.module('tms').config(runRoutingSetup);

    function runRoutingSetup(stateHelperProvider) {
        stateHelperProvider.state({
            name: 'main.responsible-events',
            url: 'responsible/events',
            title: 'Аналітика продажів',
            controller: 'ResponsibleController as vm',
            templateUrl: 'app/main/responsible/responsible.events.html',
            menu: true,
            position: 990,
            permissions: ['viewRespEvents']
        });
    }
})();

(function () {
    'use strict';

    angular.module('tms').controller('ResponsibleController', ResponsibleController);

    function ResponsibleController($scope, $state, $stateParams, AuthService, ResponsibleService) {
        var vm = this;
        vm.user = AuthService.init();
        vm.viewAll = vm.user.accessList.permissions.includes('viewRespEventsAll');

        vm.items = [];

        vm.count = 0;
        vm.offset = 0;
        vm.limit = 30;
        vm.sortOrder = null;
        vm.disableScroll = true;

        vm.filters = {
            name: '',
            filterUser: true
        };

        getList();

        vm.load = function() {
            vm.offset = vm.offset + vm.limit;
            if (vm.count > vm.offset) {
                getList();
            }
        };

        vm.applyFilter = function(ac) {
            if (ac === "name" && vm.filters[ac] !== '' && (vm.filters[ac].length < 3)) {
                return;
            }
            vm.filter({});
        };

        vm.filter = function() {
            vm.offset = 0;
            vm.items = [];
            getList();
        };

        function getList() {
            var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
            ResponsibleService.getEvents(query).then(function (response) {
                vm.items = vm.items.concat(response.items);
                vm.count = response.count;
                vm.ratingLimits = response.ratingLimits;
                vm.disableScroll = vm.count <= vm.offset;
            });
        }
    }

})();

(function () {
	'use strict';

	angular.module('tms').service('ReportService', ReportService);

	function ReportService($q, $log, $httpParamSerializer, Restangular, AuthService) {
		var Report = Restangular.one('report');
    var API = '/index.php';

    this.eventSalesByPerson  = function(filters){
      return Report.one('event-sales-by-person').get(filters);
    };

	this.eventTotal = function(filters) {
      var data = _.extend({}, filters);
      data.dateFrom = filters.paymentDateFrom ? moment(filters.paymentDateFrom).format('YYYY-MM-DD') : null;
      data.dateTo = filters.paymentDateTo ? moment(filters.paymentDateTo).format('YYYY-MM-DD') : null;
      delete data.paymentDateFrom;
      delete data.paymentDateTo;
      return Report.one('event-total').get(data);
    }

    this.eventExtended = function(filters) {
      return Report.one('event-extended').one(filters.eventID+'').get();
    }

    this.getPaymentAndDeliveryReport = function(filters) {
      return Report.one('payment-and-delivery').one((filters.eventID).toString()).get();
    }

		this.getByContractorsReport = function(filters) {
			return Report.one('contractors-sales').one((filters.eventID).toString()).get();
		}

    this.getKG9Report = function(filters) {
			return Report.one('kg-9').one((filters.eventID).toString()).get();
		}

    this.getKG10Report = function(filters) {
			return Report.one('kg-10').one((filters.eventID).toString()).get();
		}

    this.getReturnedTickets = function (filters) {
      return Report.one('tickets-returned').get(filters);
    }

    this.cashierStatistic = function (filters) {
      return Report.one('cashier-events').get(filters);
    }

    this.cashierEvents = function(filters) {
      return Report.one('cashier-events').get(filters);
    }

    this.getWidgetSalesReport = function () {
      return Report.one('widget-sales').get();
    }

    this.getXLSurl = function(id) {
      return API + '/report/quota-xls/' + id + '?access_token=' + AuthService.init().access_token + '&ticketsStatus=sold,not_sold';
    }
    this.getoredersXLSurl = function (url) {
      return API + url + '&access_token=' + AuthService.init().access_token;
    }
    this.getClientsReportLink = function (filters) {
      return API + '/report/clients-xls' + '?access_token=' + AuthService.init().access_token + '&' + $httpParamSerializer(filters)
    }
    // /report/clients-xls

    // TODO remove when not needed
    this.getProblemTicketXlsUrl = function (url) {
      return API + url + '?access_token=' + AuthService.init().access_token;
    }

	}
})();

(function () {
  'use strict';

  angular.module('tms').service('QuotesService', QuotesService);

  function QuotesService($q, $log, Restangular, OrderService, $uibModal, AuthService) {
    var Quotes = Restangular.one('quotas');
    var Quote = Restangular.one('quota');

    var self = this;

    this.getList = function (filters) {
      return Quotes.get(filters);
    }

    this.getTickets = function (id, filter) {
      filter = (filter) ? filter.filter(function (i) {
        if (i) return i;
      }).join(',') : null;
      return Quote.one('invoice').one(id + '').get({ticketsStatus: filter});
    }

    this.getTicketsFull = function (filter) {
      return Restangular.one('tickets').get(filter);
    };

    this.get = function (id) {
      return Quote.one(id + '').get();
    }

    this.save = function (data) {
      if (data.id)
        return Quote.one(data.id + '').customPUT(data, '', '');
      else
        return Quote.post('', data);
    }

    this.returnTicketsFromInvite = function (data) {
      return Quote.one('return-tickets-from-invite', + data.id).customPUT(data, '', '');
    }

    this.delete = function (id) {
      return Quote.one(id + '').remove();
    }

    this.print = function (id, limit) {
      return Quote.one('print').one(id + '').post('', {limit: limit});
    }

    this.createorder = function (id) {
      return Restangular.one('quota-to-order').post(id, {});
    };

    this.printToZip = function (quotaID, arg) {
      var data = {};
      if (_.isArray(arg))
        data = {ids: arg};
      else
        data = {quotaID: quotaID};
      OrderService.ticketZip(data)
        .success(function (response) {
          var blob = new Blob([response.data], {type: 'application/zip'});
          saveAs(blob, "tickets.zip"); // eslint-disable-line
        });
    };

    this.getTicketsCountToPrint = function (count, maxCount, quote, printToFile, full, setInvite) {
      var def = $q.defer();
      open(full);
      function open(full) {
        $uibModal.open({
          templateUrl: 'app/main/quotes/modal/quotes.print.html',
          size: full ? 'lg' : 'sm',
          resolve: {
            count: function () {
              return count;
            },
            maxCount: function () {
              return parseInt(maxCount) || 0;
            },
            printToFile: function () {
              return printToFile;
            },
            full: function () {
              return full;
            }
          },
          controller: function ($scope, $uibModalInstance, count, maxCount, printToFile, full) {
            $scope.showfull = full || false;
            $scope.max = maxCount;
            $scope.limit = maxCount;// count;
            $scope.printToFile = printToFile;
            $scope.checklist = {
              selected: [],
              selectAll: false
            };
            $scope.setInvite = setInvite || false

            $scope.sortBy = function (row) {
              if ($scope.sort === row)
                $scope.sort = '-' + row;
              else
                $scope.sort = row;
            }

            if ($scope.setInvite) {
              $scope.sortBy('paymentStatus');
            }

            if (full) {
              self.getTicketsFull({quotaID: quote.id}).then(function(response){
                $scope.tickets  = response.plain().items;
              }).then(setChecklistForSetInvite);
            }

            $scope.ok = function () {
              def.resolve($scope.limit);
              $uibModalInstance.close();
            };
            $scope.close = function () {
              def.reject();
              $uibModalInstance.dismiss();
            };
            $scope.full = function () {
              //def.resolve(0, true, count, maxCount, printToFile, full);
              $uibModalInstance.dismiss();
              open(true);
            };
            $scope.printSelected = function(){
              if (!setInvite) {
                def.resolve($scope.checklist.selected);
              } else {
                var newSelected = _.filter($scope.checklist.selected, function (item) {
                  return item.paymentStatus !== 'invite';
                });
                var selectedIds = _.map($scope.checklist.selected, 'id')
                var newNotSelected = _.filter($scope.tickets, function (item) {
                  return _.indexOf(selectedIds, item.id) === -1 && item.paymentStatus === 'invite';
                })

                def.resolve({setInvite: newSelected, unSetInvite: newNotSelected});
              }
              $uibModalInstance.close();
            }

            $scope.toggleSelectAll = function() {
              if ($scope.checklist.selectAll) {
                $scope.checklist.selected = angular.copy($scope.tickets);
              } else {
                $scope.checklist.selected = [];
              }
            };

            $scope.$watch('checklist.selected.length', function () {
              if ($scope.checklist && $scope.checklist.selected && $scope.tickets && +$scope.checklist.selected.length === +$scope.tickets.length) {
                $scope.checklist.selectAll = true;
              } else {
                $scope.checklist.selectAll = false;
              }
            })

            function setChecklistForSetInvite() {
              if (!setInvite) {
                return;
              }
              $scope.checklist.selected = _.filter($scope.tickets, function (item) {
                return item.paymentStatus === 'invite';
              });
            }
          }
        });
      }
      return def.promise;
    };

    this.validateBeforeSetInvite = function (quote, toFile, full) {
      var self = this,
        setInvite = true;

      full = true;

      return this.getTicketsCountToPrint((quote.availableForPrintCount - quote.printedTicketsCount || 0), quote.availableForPrintCount, quote, toFile, full, setInvite)
        .then(function (tickets) {

          var hasPrinted = tickets.setInvite.concat(tickets.unSetInvite).some(function (t) {
            return t.printStatus == "printed";
          });

          var resultTickets = {
            setInvite: _.map(tickets.setInvite, 'id'),
            unSetInvite: _.map(tickets.unSetInvite, 'id')
          };

          if ((tickets && hasPrinted)) {
            return self.confirmPrintBag({
              message: 'Серед обраних квитків є роздруковані. За подальші дії Ви можете понести матеріальну відповідальність.',
              button: {ok: true, cancel: true}
            })
              .then(function () {
                return resultTickets
              });
          }

          return $q.resolve(resultTickets);
        });
    };

    this.validateBeforePrint = function (quote, toFile, full) {
      var self = this;
      if (!AuthService.access(['printTicket'])) {
        self.confirmPrintBag({
          message: 'Вам не надано права друку.',
          button: {cancel: true}
        });
        return $q.reject();
      }

      if (!quote.availableForPrintCount) {
        self.confirmPrintBag({
          message: 'Всі квитки в квоті повернуті. Немає квитків доступних до друку.',
          button: {cancel: true}
        });
        return $q.reject();
      }

      return this.getTicketsCountToPrint((quote.availableForPrintCount - quote.printedTicketsCount || 0), quote.availableForPrintCount, quote, toFile, full)
        .then(function (count) {

          if (_.isArray(count)) {
            var tickets = count;
            count = count.length;
            var hasPrinted = tickets.some(function (t) {
              return t.printStatus == "printed";
            });
            var printedTicketsCount = tickets.filter(function (t) {
              return t.printStatus == "printed";
            }).length;
            var ids = tickets.map(function(t){ return t.id;});
          }
// -
          if (!AuthService.access(['secondPrintTicket']) && count > quote.ticketsCount) {
            return self.confirmPrintBag({
              message: 'Серед обраних є вже роздруковані квитки. Вам не надано права повторного друку.',
              button: {cancel: true}
            })
              .then(function () {
                return ids || count;
              });
          } else if ((tickets && hasPrinted) || count > (quote.availableForPrintCount - quote.printedTicketsCount)) {
            return self.confirmPrintBag({
              message: 'Серед обраних квитків є роздруковані. Бажаєте роздрукувати примусово? Факт друку буде зарахований за Вами. За подальші дії Ви можете понести матеріальну відповідальність.',
              button: {ok: true, cancel: true}
            })
              .then(function () {

                if (printedTicketsCount) {
                  quote.printedTicketsCount = quote.printedTicketsCount + count - printedTicketsCount;
                } else {
                  quote.printedTicketsCount = count
                }

                return ids || count;
              });
          }
          // no printed tickets, so simply increment quote.printedTicketsCount by count
          quote.printedTicketsCount = quote.printedTicketsCount + count;

          return $q.resolve(ids || count);
        });
    };

    this.confirmPrintBag = function (data) {
      return $uibModal.open({
        templateUrl: 'app/main/quotes/modal/ks-confirm-print-modal.html',
        resolve: {
          message: function () {
            return data.message
          },
          button: function () {
            return data.button || {ok: true, cancel: true}
          }
        },
        controller: function ($scope, $uibModalInstance, message, button) {

          $scope.message = message;
          $scope.button = button;

          $scope.ok = function () {
            $uibModalInstance.close();
          };
          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result
    };

    this.confirmWithoutSaving = function () {
      return $uibModal.open({
        templateUrl: 'app/main/quotes/modal/ks-confirm-without-save-modal.html',
        controller: function ($scope, $uibModalInstance) {
          $scope.button = {ok: true, cancel: true};

          $scope.ok = function () {
            $uibModalInstance.close();
          };
          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result;
    }
  }
})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.quotes',
      url: 'quotes',
      title: 'Квоти',
      template: '<div ui-view class="fade-in-down-big"></div>',
      menu: true,
      abstract: true,
      position: 30,
      permissions: ['menuQuota'],
      children: [
        {
          name: 'list',
          url: '/list',
          title: 'Список квот',
          controller: 'QuotesListController as vm',
          templateUrl: 'app/main/quotes/quotes.list.view.html',
          menu: true,
          permissions: ['viewQuotas']
        },{
          name: 'new',
          url: '/new',
          title: 'Квота',
          controller: 'QuotesEditController as vm',
          templateUrl: 'app/main/quotes/quotes.edit.view.html',
          menu: true,
          permissions: ['manageQuotas'],
          params: {
            agentedit: false,
            event: 0,
            back: false
          }
        },{
          name: 'edit',
          url: '/edit/:id',
          title: 'Квота',
          controller: 'QuotesEditController as vm',
          templateUrl: 'app/main/quotes/quotes.edit.view.html',
          menu: false,
          permissions: ['manageQuotas'],
          params: {
            agentedit: false,
            event: 0,
            back: false
          }
        },{
          name: 'view',
          url: '/view/:id',
          title: 'Прегляд квоти',
          controller: 'QuotesEditController as vm',
          templateUrl: 'app/main/quotes/quotes.view.view.html',
          menu: false,
          permissions: ['viewQuotas']
        }
      ]
		});
	}


})();

(function () {
	'use strict';

	angular.module('tms').controller('QuotesListController', QuotesListController);

	function QuotesListController($scope, $state, $window, QuotesService, PlayersService, ReportService,
                                LocationsService) {
		var vm = this;

		vm.limit = 30;
    vm.count = 0;
		vm.offset = 0;
    vm.sortOrder = null;
    vm.disableScroll = true;
    vm.status = '';

    vm.filters = {};
    vm.items = [];
    vm.playersGet = PlayersService.searchList({limit: 500});
    vm.citiesGet = LocationsService.getCities();


    // getList();

    $scope.$watch('vm.filters', function () {
      vm.offset = 0;
      vm.items = [];
      getList();
    }, true);


    vm.sort = function (sort) {
      if (sort === vm.sortOrder)
        sort = '-' + sort;
      vm.sortOrder = sort;
      vm.filter({});
    }

		vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      getList();
		}

    vm.delete = function(quote) {
      QuotesService.delete(quote.id).then(function(){
        quote.deleted = true;
      });
    }

    vm.print = function(quote) {
      QuotesService.validateBeforePrint(quote)
        .then(function (count) {
          if (_.isArray(count)) {
            var ids = count;
            count = count.length;
          }
          var url = '';
          quote.printed = true;
          if (!ids)
            url = $state.href('print-quote', {quote: quote.id, limit: count});
          else
            url = $state.href('print', {quotaID: quote.id, tickets: ids});
          $window.open(url, '_blank');
        });
    };

    vm.printToZip = function (quote) {
      QuotesService.validateBeforePrint(quote, true)
        .then(function (count) {
          QuotesService.printToZip(quote.id, count);
        });
    };

    vm.getXLSurl = function(id){
      return ReportService.getXLSurl(id);
    };

    vm.formatDate = function(date) {
      return moment(date, 'DD.MM.YYYY HH:mm').format('D MMMM YYYY, HH:mm');
    };

    function getList() {
      var query = _.extend({}, vm.filters, { sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      QuotesService.getList(query).then(function (response) {
        vm.items = vm.items.concat(response.items);
        vm.count = response.count;
        vm.disableScroll = (vm.count >= vm.offset) ? false : true;
      });
    }
	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('QuotesEditController', QuotesEditController);

  function QuotesEditController($log, $scope, $state, $stateParams, $window, $q, QuotesService, EventsService, PlayersService,
                                ReportService, WidgetService, AuthService, OrderService) {
    var vm = this;

    var KASA_IN_UA = 11;

    vm.events = [];
    vm.companies = [];
    vm.tickets = [];
    vm.newQuote = true;
    vm.userData = AuthService.init();
    vm.title = $state.current.title;
    vm.ticketsStatus = ['sold', 'not_sold', 'returned', 'transmitted'];
    vm.quotaXLS = ReportService.getXLSurl($stateParams.id);

    vm.quote = {
      id: parseInt($stateParams.id),
      eventID: parseInt($stateParams.event),
      orderID: parseInt($stateParams.event),
      providerName: vm.userData.companyName,
      //providerID: vm.userData.companyID,
      providerID: KASA_IN_UA,
      status: 'new'
    };

    vm.types = [
      {id: 'quota', name: 'Фiзична'},
      {id: 'e_quota', name: 'Електронна'},
      {id: 'single_space', name: 'ЄБП', access: 'EBD'}
    ];

    vm.goback = function () {
      if ($stateParams.back === 'view')
        $state.go('main.quotes.view', {id: vm.quote.id});
      else
        $state.go('main.quotes.list');
    };

    vm.goToView = function(form) {
       (form.$dirty ? QuotesService.confirmWithoutSaving() : $q.resolve())
         .then(function() {
           $state.go('main.quotes.view', {id: vm.quote.id});
         });
    };

    if (vm.quote.id) {
      vm.newQuote = false;
      vm.title = 'Редагувати квоту';
      vm.titleView = 'Перегляд Квоти';
      QuotesService.get(vm.quote.id).then(function (response) {
        response.partnerFee = parseInt(response.partnerFee);
        vm.quote = response;
        vm.eventName = response.eventName;
        WidgetService.setQuota(vm.quote.id, vm.quote.eventID, $stateParams.agentedit ? 'agentEdit' : 0);
        vm.hideInfo = true;
        calcExpectedTotalFee();
        calcRealTotalFee();
      });

      $scope.$watch('vm.ticketsStatus', function () {
        QuotesService.getTickets(vm.quote.id, vm.ticketsStatus).then(function (response) {
          if (typeof response != 'undefined'){
              vm.tickets = response.tickets;
              vm.xlsUrl = '/index.php' + response.xlsUrl + '&access_token=' + vm.userData.access_token;
          }
          calcTotalInfo();
        });
      }, true);
    }

    vm.companies = PlayersService.search({limit: 50})
      .then(function (data) {
        vm.quote.providerID = KASA_IN_UA; // because it's still undefined
        return data;
      });

    EventsService.events.list().then(function (response) {
      vm.events = response.items;
    });

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.quotecreate.$valid) {
        return;
      }
      vm.loading = true;
      QuotesService.save(vm.quote).then(function (response) {
        response.partnerFee = parseInt(response.partnerFee);
        vm.quote = response;
        vm.hideInfo = true;
        vm.quotecreate.$setPristine();
        WidgetService.setQuota(response.id, response.eventID);
      }).finally(function () {
        vm.loading = false;
      });
    };

    vm.close = function () {
      // $scope.quote.status = 'canceled';
      // NetworkService.saveQuote($scope.quote);
    };

    vm.setInvite = function () {
      QuotesService.validateBeforeSetInvite(vm.quote)
        .then(function (tickets) {
          var updateRequests = []
          if (tickets && tickets.setInvite && +tickets.setInvite.length > 0) {
            updateRequests.push(OrderService.updateTickets({ids: tickets.setInvite, status: 'in_quota',payment: {status: 'invite'}}))
          }

          if (tickets && tickets.unSetInvite && +tickets.unSetInvite.length > 0) {
            updateRequests.push(QuotesService.returnTicketsFromInvite({id: vm.quote.id, ids: tickets.unSetInvite}))
          }

          if (+updateRequests.length > 0) {
            vm.loading = true;
            $q.all(updateRequests)
              .finally(function () {
                vm.loading = false;
              });
          }
        })
    };

    vm.print = function() {
      QuotesService.validateBeforePrint(vm.quote)
        .then(function (count) {
          if (_.isArray(count)) {
            var ids = count;
            count = count.length;
          }
          var url = '';
          vm.quote.printed = true;
          if (!ids)
            url = $state.href('print-quote', {quote: vm.quote.id, limit: count});
          else
            url = $state.href('print', {quotaID: vm.quote.id, tickets: ids});
          $window.open(url, '_blank');
        });
      // QuotesService.validateBeforePrint(vm.quote)
      //   .then(function (count) {
      //     vm.quote.printed = true;
      //     var url = $state.href('print-quote', {quote: vm.quote.id, limit: count});
      //     $window.open(url, '_blank');
      //   });
    };

    vm.printToZip = function () {
      QuotesService.validateBeforePrint(vm.quote, true)
        .then(function (count) {
          QuotesService.printToZip(vm.quote.id, count);
        });
    };

    vm.createorder = function () {
      vm.loading = true;
      QuotesService.createorder(vm.quote.id).then(function (response) {
        $log.log(response);
        $state.go('main.ordermanager', {search: response.id});
      }).finally(function () {
        vm.loading = false;
      });
    };

    WidgetService.listen(function (mode, action, status) {
      if (mode + '' === 'quota' && action === 'save' && status === 'success') {
        vm.savedsuccess = true;
        $scope.$apply();
      }
    });

    function calcTotalInfo() {
      vm.totalTickets = {count: 0, cost: 0};
      vm.tickets.forEach(function (item) {
        vm.totalTickets.count += item.count;
        vm.totalTickets.cost += item.cost;
      });
    }

    function calcExpectedTotalFee() {
      QuotesService.getTickets(vm.quote.id, ['sold', 'not_sold']).then(function (response) {
        var cost = 0;
        if (typeof response != 'undefined'){
            response.tickets.forEach(function (item) {
              cost += item.cost;
            });
        }
        vm.expectedTotalFee = vm.quote.partnerFeeType !== 'fee' ?
        (vm.quote.partnerFee / 100) * cost :
          vm.quote.partnerFee;
      });
    }

    function calcRealTotalFee() {
      QuotesService.getTickets(vm.quote.id, ['sold']).then(function (response) {
        var cost = 0;
        if (typeof response != 'undefined'){
            response.tickets.forEach(function (item) {
              cost += item.cost;
            });
        }
        vm.realTotalFee = vm.quote.partnerFeeType !== 'fee' ?
        (vm.quote.partnerFee / 100) * cost :
          vm.quote.partnerFee;
      });
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').service('PartnersService', PartnersService);

	function PartnersService($q, $log, $state, $uibModal, Restangular) {
  var Partner = Restangular.one('partner/list');
  var PartnerView = Restangular.one('partner/view');
  var PartnerAdd = Restangular.one('partner/add');
  var PartnerDel = Restangular.one('partner/del');
  var PartnerSave = Restangular.one('partner/update');
  var PartnerViewArea = Restangular.one('partner/area/view');
  var PartnerUpdateArea = Restangular.one('partner/area/update');
  var PartnerAreaFiles = Restangular.one('partner/area-files');
  var PartnerEventInfo = Restangular.one('partner/event-info');
  var list = {};

  // this.getPartners = function (filters) {
  //     return Restangular.one('/partner/list').get(filters );
  //   }

 this.partner = {
       list: function (filters) {
         // if (list.count)
         //  return $q.resolve(list);
         return Partner.get(filters).then(function (response) {
           angular.merge(list, response);
           return response;
         });
       },
       get: function (id) {
         return PartnerView.one(id + '').get();
       },
       info: function (params){
         return PartnerEventInfo.get(params)
       },
       add: function (data) {
         return PartnerAdd.customPOST(data, '', {});
       },
       del: function (data) {
         return PartnerDel.customDELETE('', {}, {}, data);
       },
       save: function(data) {
         return PartnerSave.one(data.id + '').customPUT(data, '', {});
       },
       viewArea: function (params) {
         $uibModal.open({
           templateUrl: 'app/main/partners/modal/modal.view-area.html',
           size: 'lg',
           resolve: {
             params: function () {
               return params;
             }
           },
           controller: function ($scope, $uibModalInstance, toastr, params) {
             $scope.warning = 'Loading...';
             $scope.eventId = params.eventId;

             $scope.formData = {
               partnerId: params.partnerId,
               partnerEventId: params.partnerEventId,
               partnerHallId: params.partnerHallId,
               areaFileId: null,
               partnerZones: [],
               clear: false
             };

             PartnerViewArea.customPOST(params, '', {}).then(function (response) {
               if (response.info) {
                 $scope.warning = response.info;
                 return;
               }

               $scope.allowEdit = response.allowEdit;
               $scope.eventId = response.eventId;
               $scope.statusInSales = response.statusInSales;
               $scope.initAreaId = response.areaId;
               $scope.initAreaFileId = response.areaFileId;
               $scope.partnerHallName = response.partnerHallName;
               $scope.areas = response.areas;
               $scope.areaFiles = [];
               $scope.zones = response.zones ? response.zones : [];
               $scope.newZonesEnabled = false;
               $scope.missingApiZones = response.missingApiZones;

               $scope.formData.areaId = response.areaId;
               $scope.formData.areaFileId = response.areaFileId;
               $scope.formData.partnerZones = response.partnerZones ? response.partnerZones : [];
               $scope.showZones = $scope.formData.partnerZones.length > 0;

               $scope.formData.partnerZones.forEach(function (value, index) {
                 // дублируем список наших зон для каждой отдельной партнерской зоны
                 $scope.formData.partnerZones[index].zones = angular.copy($scope.zones);
                 var zone = $scope.formData.partnerZones[index].zones.find(function (item) {
                   return item.id === value.zoneId;
                 });
                 // делаем выбраной уже проставленную в базе зону
                 if (zone) {
                   zone.selected = true;
                 }else {
                   $scope.newZonesEnabled = true;
                 }
               });

               $scope.warning = null;
             });

             $scope.$watch('formData.areaId', function (newVal) {
               if (angular.isDefined(newVal) && newVal !== null) {
                 PartnerAreaFiles.one(newVal + '').get().then(function (response) {
                   $scope.areaFiles = response;
                 });
               } else {
                 $scope.areaFiles = [];
               }
             });

             $scope.ok = function () {
               if ($scope.warning) {
                 $uibModalInstance.dismiss();
                 return;
               }

               if (!$scope.allowEdit) {
                 var wasChanged = $scope.formData.partnerZones.filter(function (value) {
                   if (angular.isUndefined(value.zoneId)) {
                     value.zoneId = null;
                   }
                   return value.zoneId !== value.initZoneId;
                 });
                 if (wasChanged.length === 0) {
                   $uibModalInstance.dismiss();
                   return;
                 }
               }

               var data = angular.copy($scope.formData);
               if (angular.isUndefined(data.areaFileId)) {
                 data.areaFileId = null;
               }
               if ($scope.formData.areaFileId !== $scope.initAreaFileId) {
                 data.partnerZones = [];
               } else {
                 data.partnerZones.forEach(function (value, index) {
                   delete data.partnerZones[index].zones;
                 });
               }
               data.newZonesEnabled = !!($scope.newZonesEnabled && $scope.eventId);

               PartnerUpdateArea.customPUT(data, '', {}).then(function (response) {
                 if (response.error) {
                   toastr.error(response.error);
                 } else if (response.info) {
                   toastr.warning(response.info);
                 } else if (response.success) {
                   toastr.success('Успішно змінено', '', {
                     "timeOut": "5000"
                   });
                   $uibModalInstance.dismiss();
                 }
               });
             };

             $scope.close = function () {
               $uibModalInstance.dismiss();
             };

             $scope.clear = function () {
               if (!$scope.allowEdit) {
                 return;
               }

               if ($scope.eventId){
                   $uibModal.open({
                     templateUrl: 'app/main/partners/modal/modal.dialog.html',
                     resolve: {
                       formData: function () {
                         return $scope.formData;
                       }
                     },
                     scope: $scope,
                     controller: function ($scope, $uibModalInstance) {
                       $scope.ok = function () {
                         var data = angular.copy($scope.$resolve.formData);
                         data.areaFileId = null;
                         data.partnerZones = [];
                         data.clear = true;

                         PartnerUpdateArea.customPUT(data, '', {}).then(function (response) {
                           if (response.error) {
                             toastr.error(response.error);
                           } else if (response.info) {
                             toastr.warning(response.info);
                           } else if (response.success) {
                             toastr.success('Успішно очищено', '', {
                               "timeOut": "5000"
                             });
                             $scope.initAreaId = null;
                             $scope.initAreaFileId = null;
                             $scope.formData.areaId = null;
                             $scope.formData.areaFileId = null;
                             $scope.formData.partnerZones = [];
                             $scope.showZones = false;
                           }
                         });


                         $uibModalInstance.close();
                         return;
                       };
                       $scope.cancel = function () {
                         $uibModalInstance.dismiss();
                         return;
                       };
                     }
                   });
               }else{
                 var data = angular.copy($scope.formData);
                 data.areaFileId = null;
                 data.partnerZones = [];
                 data.clear = true;

                 PartnerUpdateArea.customPUT(data, '', {}).then(function (response) {
                   if (response.error) {
                     toastr.error(response.error);
                   } else if (response.info) {
                     toastr.warning(response.info);
                   } else if (response.success) {
                     toastr.success('Успішно очищено', '', {
                       "timeOut": "5000"
                     });
                     $scope.initAreaId = null;
                     $scope.initAreaFileId = null;
                     $scope.formData.areaId = null;
                     $scope.formData.areaFileId = null;
                     $scope.formData.partnerZones = [];
                     $scope.showZones = false;
                   }
                 });
               }
             };
           }
         });
       }
        // save: function(data) {
      //   if (data.id)
      //     return Partner.one(data.id+'').customPUT(data, '', {});
      //   else
      //     return Partner.customPOST(data, '', {});
      // }
      // delete: function(id) {
      //   return Partner.one(id+'').remove();
      // }
    }

	}
})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);
function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.partners',
			url: 'partner/list',
      title: 'Партнери',
      controller: 'PartnersController as vm',
      templateUrl: 'app/main/partners/partners.list.html',
      menu: true,
      position: 990,
      permissions: ['partnersList']
		});

 stateHelperProvider.state({
          name: 'main.view',
          url: 'partner/view/:id',
          title: 'Партнер',
          controller: 'PartnersController as vm',
          templateUrl: 'app/main/partners/partners.view.html',
          menu: false,
          position: 1,
          permissions: ['partnersView']
        });
  stateHelperProvider.state({
    name: 'main.edit',
    url: 'partner/edit/:id',
    title: 'Партнер',
    controller: 'PartnersController as vm',
    templateUrl: 'app/main/partners/partners.edit.html',
    menu: false,
    position: 2,
    permissions: ['partnersEdit']
  });
/*  stateHelperProvider.state({
    name: 'main.add',
    url: 'partner/add/:id',
    title: 'Партнер',
    controller: 'PartnersController as vm',
    templateUrl: 'app/main/partners/partners.view.html',
    menu: false,
    position: 3,
    permissions: ['partnersEdit']
  });*/
   }
})();

(function () {
  'use strict';

  angular.module('tms').controller('PartnersController', PartnersController);

  function PartnersController($scope, $state, $stateParams, PartnersService, EventService, $timeout, toastr, SubdivisionsService,
                              LocationsService, ckEditorOptions, Upload, SiteService, AuthService, $uibModal, EventsService) {
    var vm = this;
    var userData = AuthService.init();
    vm.userData = userData;

    vm.loading = false;
    vm.partner = [];
    vm.item = {
      datePublish: null
    };
//start search
    vm.items = [];
    vm.count = 0;
    vm.offset = 0;
    vm.limit = 30;
    vm.sortOrder = null;
    vm.selectedItem = {};
    vm.disableScroll = true;

    vm.filters = {
      name: null,
      status: null
   };
   getList();


vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      if (vm.count > vm.offset)
      getList();
    }

vm.applyFilter = function(ac){
      $timeout(function(){
        if (ac && vm.filters[ac]!=='' && (vm.filters[ac].length < 3)) {
          return;
        }
        vm.filter({});
      })
    };

    vm.filter = function(){
      // if (!vm.filters.status)
      // vm.filters.status = null;
      vm.offset = 0;
      // vm.count = 0;
      vm.items = [];
      vm.disableScroll = true;
      getList();
    }
    function getList() {
      var query = _.extend({}, vm.filters, {sort: vm.sortOrder, limit: vm.limit, offset: vm.offset });
      if ($state.current.name === 'main.partners') {
        PartnersService.partner.list(query).then(function (response) {
          if (response.error){
            toastr.error(response.error,'Помилка',{
              "showDuration": "300",
              "hideDuration": "300",
              "timeOut": "5000",
              "extendedTimeOut": "1000",
              "showEasing": "swing",
              "hideEasing": "linear",
              "showMethod": "fadeIn",
              "hideMethod": "fadeOut"
            });
          }
          // vm.items = (clear) ? response.items : vm.items.concat(response.items);
          vm.items = vm.items.concat(response.items);
          vm.count = response.count;
          vm.disableScroll = (vm.count > vm.offset) ? false : true;
        });
      }
    }

    vm.info = function(n) {
      $uibModal.open({
        templateUrl: 'app/main/partners/modal/modal.info-area.html',
        size: 'md',
        windowClass: 'info-modal',
        controller: function ($scope, $uibModalInstance, constants) {
          var scope = $scope;
          scope.constants = constants;
          scope.infoPartnerZones = null;
          scope.baseInfo = n;
          var params = {
            "partnerId" : $stateParams.id,
            "partnerEventId" : n.partnerEventId
          };
          PartnersService.partner.info(params).then(function (response) {
            if (response.error){
              toastr.error(response.error,'Помилка',{
                "showDuration": "300",
                "hideDuration": "300",
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
              });
            }
            scope.infoPartnerZones = response.partnerZones || [];
          });
          scope.skip = function () {
            $uibModalInstance.dismiss();
          };
          scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    vm.add = function(n) {

        $uibModal.open({
            templateUrl: 'app/main/partners/modal/modal.responsible.html',
            size: 'md',
            controller: function ($scope, $uibModalInstance, constants) {
                var scope = $scope;
                scope.constants = constants;

                scope.responsibleType = null;
                scope.responsibleID = null;

                EventsService.getResponsibleTypes().then(function (response) {
                    scope.responsibleTypes = response || [];
                });

                SubdivisionsService.getList().then(function (response) {
                    scope.subdivisionList = _.map(response.items || [], function (item) {
                        return {
                            id: item.id,
                            name: item.name + " (" + item.id + ")"
                        };
                    });
                });

                SubdivisionsService.getManagers().then(function (response) {
                    scope.subdivisionManagers = response || [];
                });

                $scope.$watch('scope.responsibleType', function (newValue, oldValue) {
                    if (!oldValue) {
                        return;
                    }
                    scope.responsibleID = null;
                });

                scope.ok = function () {
                    n.responsibleType = scope.responsibleType;
                    n.responsibleID = scope.responsibleID;
                    $uibModalInstance.dismiss();
                    vm.addSend(n);
                };

                scope.skip = function () {
                    $uibModalInstance.dismiss();
                    vm.addSend(n);
                };

                scope.close = function () {
                    $uibModalInstance.dismiss();
                };
            }
        });
    };

    vm.addSend = function(n){

      n.partnerId = $stateParams.id;
      PartnersService.partner.add(n).then(function(data){
        vm.item.items[n.partnerEventId].systemId = data.systemId;
          if (data.error){
            toastr.error(data.error,'Помилка',{
              "showDuration": "300",
              "hideDuration": "300",
              "timeOut": "5000",
              "extendedTimeOut": "1000",
              "showEasing": "swing",
              "hideEasing": "linear",
              "showMethod": "fadeIn",
              "hideMethod": "fadeOut"
            });
          }else if(data.info){
            toastr.warning(data.info,'Інфо',{
              "showDuration": "300",
              "hideDuration": "300",
              "timeOut": "5000",
              "extendedTimeOut": "1000",
              "showEasing": "swing",
              "hideEasing": "linear",
              "showMethod": "fadeIn",
              "hideMethod": "fadeOut"
            });
          }else {
            toastr.success('Записано!', '', {
              "showDuration": "300",
              "hideDuration": "300",
              "timeOut": "1000",
              "extendedTimeOut": "1000",
              "showEasing": "swing",
              "hideEasing": "linear",
              "showMethod": "fadeIn",
              "hideMethod": "fadeOut"
            });
          }
      }).finally(function(){
        //vm.data = data;
      //  vm.loading = false;
      });
    }

    vm.del = function(n){
      // vm.loading = true;
      PartnersService.partner.del(n).then(function(data){
        vm.item.items[n.partnerEventId].systemId = data.systemId;
        if (data.error){
          toastr.error(data.error,'Помилка',{
            "showDuration": "300",
            "hideDuration": "300",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
        }else if(data.info){
          toastr.warning(data.info,'Інфо',{
            "showDuration": "300",
            "hideDuration": "300",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
        }else {
          toastr.warning('Знято з продажі!', '', {
            "showDuration": "300",
            "hideDuration": "300",
            "timeOut": "1000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
        }
        //$state.go('main.site.artists');
      }).finally(function(){
        //  vm.loading = false;
      });
    }

    vm.viewArea = function(data){
      data.partnerId = $stateParams.id;
      PartnersService.partner.viewArea(data);
    };
//end search


    // vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    //vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    // vm.calendarOptions = calendarOptions;
    // vm.ckEditorOptions = ckEditorOptions;
    vm.title = $state.current.title;
    if ($state.current.name === 'main.view') {
      //console.log(vm.item.items);
      vm.edit = true;
      if ($stateParams.id)
      PartnersService.partner.get($stateParams.id).then(function (response) {
        //vm.item = vm.item.concat(response.item);
        vm.item = response;
        vm.itemsLength = Object.keys(vm.item.items).length;

      });
    }

/*    if ($state.current.name === 'main.add') {
      vm.edit = true;
     // vm.loading = true;
      if ($stateParams.id)
/!*         PartnersService.partner.add($stateParams.id).then(function(response){
           toastr.success('збережено!');
           $state.go('main.add');
           vm.add = response;
        }).finally(function(){
           vm.loading = false;
         });*!/
        PartnersService.partner.add($stateParams.id).then(function (response) {
          //vm.item = vm.item.concat(response.item);
          vm.add = response;
          // console.log(vm.item);
        });
    }*/

  /*  if ($state.current.name === 'main.partners.list') {
     SiteService.partner.list().then(function (response) {
       vm.tour = response.items;
     });
    }
*/
  vm.save = function () {
   $scope.$broadcast('show-errors-check-validity');
       if (!vm.partnerform.$valid) {
         return;
       }
    PartnersService.partner.save(vm.item).then(function(){
           toastr.success('Збережено!','',{
          "showDuration": "300",
          "hideDuration": "300",
          "timeOut": "1000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "fadeIn",
          "hideMethod": "fadeOut"
        });
           $state.go('main.partners');
        }).finally(function(){
           vm.loading = false;
         });

  }

    // vm.save = function () {
    //   $scope.$broadcast('show-errors-check-validity');
    //   if (!vm.tourform.$valid) {
    //     return;
    //   }

    //   vm.item.datePublish =  moment(vm.item.datePublish).format('YYYY-MM-DD HH:mm:ss')
    //   //vm.item.currentEvent = moment(vm.item.currentEvent)
    //   vm.loading = true;
    //   SiteService.tour.save(vm.item).then(function(){
    //     toastr.success('Тур збережено!');
    //     $state.go('main.site.tour');
    //   }).finally(function(){
    //     vm.loading = false;
    //   });
    // }

    // vm.delete = function(n) {
    //   n.deleted = true;
    //   SiteService.tour.delete(n.id);
    // }
  }

})();

(function () {
  'use strict';

  angular.module('tms').service('OrdermanagerService', OrdermanagerService);

  function OrdermanagerService($window, $log, $uibModal, OrderService, AuthService, UsersService, PlayersService, LocationsService, $q,
                               $timeout) {
    var self = this;

    self.actions = {
      printed: 'друк',
      sold: 'продаж',
      created: 'створення',
      updated: 'редагування',
      deleted: 'видалення',
      canceled: 'скасування',
      returned: 'повернення',
      failed: 'помилка',
      hide: 'схований',
      reserved: 'резервування',
      set_price: 'змiна цiни',
      add_to_quota: 'додавання до квоти',
      archived: 'архiв'
    }

    self.getPlayers = function (filters) {
      return PlayersService.searchList(filters);
    }

    self.getUsers = function (filters) {
      return UsersService.searchList(filters);
    }

    self.getZones = function (filters) {
      return LocationsService.getZones(filters);
    }

    self.prepare = function (filter) {
      var filters = _.extend({}, filter);

      _.each(filters, function (v, i) {
        if (_.isArray(v)) {
          filters[i] = v.join(',');
        }
        if (moment(v).isValid() && (i.indexOf('ate') > 0)) {
          filters[i] = moment(v).format('YYYY-MM-DD HH:mm:ss') + '';
        }
        if (filters[i] === '' || filters[i] === false)
          filters[i] = null;
      });

      return filters;
    }

    self.history = function (ticket, order) {
      $uibModal.open({
        templateUrl: 'app/main/ordermanager/parts/modal.history.html',
        size: 'lg',
        resolve: {
          ticket: function () {
            return ticket;
          },
          order: function () {
            return order;
          }
        },
        controller: function ($log, $scope, $uibModalInstance, ticket, order) {
          OrderService.ticketHistory(ticket.id, order.type == 'order', order.id).then(function (response) {
            $scope.history = response.items;
          });
          $scope.ok = function () {
            $uibModalInstance.dismiss();
          };
          $scope.actions = self.actions;
          $scope.info = OrderService.getInfo;
        }
      });
    };

    self.details = function (ticket, order) {
      $uibModal.open({
        templateUrl: 'app/main/ordermanager/parts/modal.details.html',
        resolve: {
          ticket: function () {
            return ticket;
          },
          order: function () {
            return order;
          }
        },
        controller: function ($log, $scope, $uibModalInstance, ticket) {
          OrderService.ticketHistory(ticket.id, order.type == 'order', order.id).then(function (response) {
            $scope.history = response.items.length ? response.items[0] : {};
          });
          $scope.ticket = ticket;
          $scope.ok = function () {
            $uibModalInstance.dismiss();
          };
          $scope.actions = self.actions;
          $scope.info = OrderService.getInfo;
        }
      });
    };

    self.orderDdetails = function (orderId) {
      OrderService.get(orderId)
        .then(function (order) {
          var def = $q.defer();
          $uibModal.open({
            templateUrl: 'app/main/ordermanager/parts/modal.order.edit.details.html',
            resolve: {
              order: function () {
                return order;
              }
            },
            controller: function ($log, $scope, $uibModalInstance, order, LocationsService) {
              $scope.close = function () {
                $uibModalInstance.dismiss();
                def.reject();
              };
              $scope.ok = function () {
                if ($scope.orderupdateform.$valid) {
                  OrderService.save(order);
                  $uibModalInstance.close();
                  def.resolve();
                }
              };
              $scope.order = order;
              $scope.citiesGet = LocationsService.getCities();
            }
          });
          return def.promise;
        });
    };

    self.confirmPrintBag = function (data) {

      return $uibModal.open({
        templateUrl: 'app/main/ordermanager/modal/ks-confirm-print-modal.html',
        resolve: {
          message: function () {
            return data.message
          },
          button: function () {
            return data.button || {ok: true, cancel: true}
          }
        },
        controller: function ($scope, $uibModalInstance, message, button) {

          $scope.message = message;
          $scope.button = button;

          $scope.ok = function () {
            $uibModalInstance.close();
          };
          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result
    };

    self.systemPopup = function (data) {
      return $uibModal.open({
        templateUrl: 'app/main/ordermanager/modal/ks-confirm-system-modal.html',
        resolve: {
          message: function () {
            return data.message
          },
          button: function () {
            return data.button || {ok: true}
          }
        },
        controller: function ($scope, $uibModalInstance, message, button) {

          $scope.message = message;
          $scope.button = button;

          $scope.ok = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result
    };

    self.savePrintBag = function (ids) {
      return OrderService.printTickets({ids: ids})
    };

    self.editBag = function (bag, orders) {
      var modalInstance = $uibModal.open({
          // size: 'lg',
          templateUrl: 'app/main/ordermanager/modal/ks-order-modal.html',
          resolve: {
            items: function () {
              return bag.tickets;
            }
          },
          controller: function ($scope, $uibModalInstance, LocationsService, items) {
            $scope.citiesGet = LocationsService.getCities();
            $scope.deliveryTypes = OrderService.deliveryType;
            $scope.deliveryStatuses = OrderService.deliveryStatus;
            $scope.paymentStatuses = OrderService.paymentStatus;
            $scope.paymentTypes = OrderService.paymentType;
            $scope.printStatuses = OrderService.printStatus;
            $scope.statuses = _.filter(OrderService.status, function (item) {
              return item.id !== "new" && item.id != "sold" && item.id != "reserved";
            });
            $scope.items = angular.copy(items);
            var tickets = {
              delivery: {
                type: _all('deliveryType'),
                status: _all('deliveryStatus'),
                address: {
                  cityID: _all('deliveryCityID'),
                  address: _all('deliveryAddress')
                },
                postService: {
                  // fixing update fro deliveryType after the ticket was created for the first time
                  // cityID: _all('deliveryCityID'),
                  address: _all('deliveryAddress'),
                  number: _all('deliveryBranchNumber')
                }
              },
              payment: {
                status: _all('paymentStatus'),
                type: !_any('paymentStatus', 'invite') ? _all('paymentType') : null
              },
              ignoreTicketsLifeTime: _all('ignoreLifeTime'),
              visitor: {
                firstName: _all('clientFirstName'),
                middleName: _all('clientMiddleName'),
                lastName: _all('clientLastName')
              },
              printStatus: _all('printStatus'),
              status: _all('status')
            };

            $scope.tickets = angular.copy(tickets);
            var cityID = tickets.delivery.address.cityID;
            //TODO: HACK! because select-list component erase fields values!
            $timeout(function () {
              $scope.tickets = angular.copy(tickets);
            }, 500);
            $timeout(function () {
              $scope.tickets.delivery.address.cityID =  cityID;
            }, 500);

            $scope.items.forEach(function (item) {
              item.visitor = {
                firstName: _all('clientFirstName'),
                middleName: _all('clientMiddleName'),
                lastName: _all('clientLastName')
              };
            });

            $scope.edit = {
              client: bag.client || {},
              description: bag.description || ''
            };

            $scope.cantPrint = function () {
              return _.find(items, {printStatus: 'printed'});
            };
            $scope.ok = function () {
              $uibModalInstance.close({edit: $scope.edit, tickets: $scope.items, update: $scope.tickets});
            };
            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            function _all(prop) {
              var val = items[0][prop];
              return items.every(function (e) {
                return e[prop] === val;
              }) ? val : null;
            }

            function _any(prop, val) {
              return items.some(function (e) {
                return e[prop] === val;
              }) ? val : null;
            }
          }
        }
      );
      modalInstance.result.then(function (data) {
        var update = [],
          status = angular.copy(data.update.status);

        delete data.update.status;

        //-------start e-commerce --------
          //----start purchase section
        var item;
        var result = [];
        var refund = [];
          var total = 0;
          for (item in data.tickets) {
            if (AuthService.init().role !== 'admin') {
              if (data.tickets[item].partnerApi === true && data.tickets[item].paymentStatus == 'paid' && data.update.payment.status == 'not_paid') {
                return self.systemPopup({
                  message: 'Заборонено скасовувати оплачені партнерські квитки!'
                })
              }
            }

            if (data.tickets[item].paymentStatus == 'not_paid' && data.update.payment.status == 'paid') {
              total += parseInt(data.tickets[item].price);
              result.push(
                {
                  'name': data.tickets[item].eventShortName,
                  'id': data.tickets[item].eventID + '',
                  'price': data.tickets[item].price,
                  'brand': data.tickets[item].artistsNames,
                  'category': data.tickets[item].category,
                  'variant': data.tickets[item].zoneNumber,
                  'quantity': 1,
                  'coupon': ''
                }
              );
            } else if(status === 'returned' || (data.tickets[item].paymentStatus == 'paid' && data.update.payment.status == 'not_paid')){
            refund.push(
                {
                  'id': data.tickets[item].eventID + '',
                  'quantity': 1
                }
              );
            }
          }

          $window.dataLayer = $window.dataLayer || [];
          if (result.length > 0) {
            $window.dataLayer.push({
              'ecommerce': {
                'currencyCode': 'UAH',
                'purchase': {
                  'actionField': {
                    'id': data.tickets[0].orderID + '',
                    'affiliation': 'TMS',
                    'revenue': total + '',
                    'tax': parseInt(data.tickets[0].service_charge) > 0 ? parseInt(total) * parseInt(data.tickets[0].service_charge) / 100 + '' : '0',
                    'shipping': '',
                    'coupon': ''
                  },
                  'products': result
                }
              },
              'event': 'gtm-ee-event',
              'gtm-ee-event-category': 'Enhanced Ecommerce',
              'gtm-ee-event-action': 'Purchase',
              'gtm-ee-event-non-interaction': 'False'
            });
            console.log('Purchase - Зміна статусу', {
              'ecommerce': {
                'currencyCode': 'UAH',
                'purchase': {
                  'actionField': {
                    'id': data.tickets[0].orderID + '',
                    'affiliation': 'TMS',
                    'revenue': total + '',
                    'tax': parseInt(data.tickets[0].service_charge) > 0 ? parseInt(total) * parseInt(data.tickets[0].service_charge) / 100 + '' : '0',
                    'shipping': '',
                    'coupon': ''
                  },
                  'products': result
                }
              },
              'event': 'gtm-ee-event',
              'gtm-ee-event-category': 'Enhanced Ecommerce',
              'gtm-ee-event-action': 'Purchase',
              'gtm-ee-event-non-interaction': 'False'
            });
          }
        //----start refund section

        if (refund.length > 0) {
          $window.dataLayer.push({
            'ecommerce': {
              'currencyCode': 'UAH',
              'refund': {
                'actionField': {
                  'id': data.tickets[0].orderID + ''
                },
                'products': refund
              }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Partial Refund',
            'gtm-ee-event-non-interaction': 'False'
          });
          console.log('Refund - Зміна статусу', {
            'ecommerce': {
              'currencyCode': 'UAH',
              'refund': {
                'actionField': {
                  'id': data.tickets[0].orderID + ''
                },
                'products': refund
              }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Partial Refund',
            'gtm-ee-event-non-interaction': 'False'
          });
        }

         // console.log($window.dataLayer);
//-------end e-commerce --------

        _.each(bag.tickets, function (t) {
          var upt = _.find(data.tickets, {id: t.id});
          var price = {};
          if (upt.price !== t.price) {
            price.price = upt.price;
          }
          if (upt.discount !== t.discount) {
            price.discount = upt.discount;
          }
          if (upt.visitor && upt.visitor.firstName) {
            price.visitor = {firstName: upt.visitor.firstName};
          }


          // setting status returned for already returned tickets caused tickets from other orders
          // with these ids to be returned
          if (!status || (t.status === 'returned' && status === 'returned')) {
            update.push(angular.extend({}, {id: t.id}, {orderID: t.orderID}, data.update, price));
          } else if (status) {
            update.push(angular.extend({}, {id: t.id}, {orderID: t.orderID}, data.update, price, {status: status}));
          }
        });

        OrderService.updateTickets(update, bag.tickets[0]).then(function () {
          var done = [];
          _.each(bag.tickets, function (t) {
            if (data.update.payment) {
              t.paymentType = data.update.payment.type || t.paymentType;
              t.paymentStatus = data.update.payment.status || t.paymentStatus;
            }
            if (data.update.delivery) {
              t.deliveryType = data.update.delivery.type || t.deliveryType;
              t.deliveryStatus = data.update.delivery.status || t.deliveryStatus;
            }
            t.status = status || t.status;
            t.discountPrice = parseInt(t.price) - parseInt(t.price) * parseInt(t.discount) / 100;
            t.printStatus = data.update.printStatus || t.printStatus;
            if (done.indexOf(t.orderID) < 0) {
              done.push(t.orderID);
              OrderService.get(t.orderID).then(function (response) {
                var upd = _.find(orders, {id: t.orderID});
                angular.merge(upd, response.plain());
              });
            }
          });
        });
      });
    };
  }
})
();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup($stateProvider) {
		$stateProvider.state('main.ordermanager', {
			url: 'ordermanager/:id',
      title: 'Менеджер замовлень',
      controller: 'OrdermanagerController as vm',
      templateUrl: 'app/main/ordermanager/ordermanager.view.html',
      params: {
        search: null
      },
      menu: true,
      position: 10,
      // permissions: ['menuOM', 'listOrders', 'updateOrder', 'viewOrder']
      permissions: ['menuOM', 'listOrders', 'viewOrder']
		});
	}

})();

(function () {
  'use strict';

  angular.module('tms').controller('OrdermanagerController', OrdermanagerController);

  function OrdermanagerController($scope, $state, $stateParams, $window, $q, toastr, OrdermanagerService, AuthService,
                                  OrderService, LocationsService, ReportService, QuotesService, ModalService, $uibModal,
                                  concatIdsAndNamesService, calendarOptions) {

    var vm = this;
    var filters = {};

    vm.companyID = AuthService.init().companyID;
    vm.fIdPattern = /^[0-9]+$/;

    // BAG
    vm.canPrint = false;
    vm.bag = {
      orders: [],
      tickets: []
    };

    vm.clearBag = function () {
      _.each(vm.bag.tickets, function (t) {
        t.selected = false;
      });
      _.each(vm.orders, function (o) {
        o.selected = false;
      });
      vm.canPrint = false;
      vm.bag = {
        orders: [],
        tickets: []
      };
    };

    // Clear

    vm.clear = function () {
      vm.eventReset = _.uniqueId();
      vm.orders = [];
      vm.showbag = false;
      vm.filters = {
        dateCreateFrom: null,
        dateCreateTo: null,
        printDateFrom: null,
        printDateTo: null,
        paymentDateFrom: null,
        paymentDateTo: null,
        eventID: null,
        limit: 20,
        offset: 0,
        insertCashierParams: false,
        ticketStatus: ['active']
        // creatorCompanyID: AuthService.init().companyID
      };
      vm.tickets = 0;
      vm.price = 0;
      vm.count = 0;
      vm.done = false;
      vm.clearBag();
    };

    vm.clear();


    vm.history = OrdermanagerService.history;
    vm.details = OrdermanagerService.details;
    vm.orderDdetails = function (event, order) {
      event.stopPropagation();
      OrdermanagerService.orderDdetails(order.id);
    };

    vm.editBag = OrdermanagerService.editBag;

    vm.calendarOptions = calendarOptions;

    if (parseInt($stateParams.id)) {
      vm.initEvent = $stateParams.id;
      vm.filters.eventID = $stateParams.id;
      vm.companyID = 1;
    }

    if ($state.current.name === 'main.cashier.search') {
      vm.searchorder = 'searchorder';
      vm.companyID = 1;
    }

    vm.citiesGet = LocationsService.getCities();

    vm.players = OrdermanagerService.getPlayers();

    $scope.$watch('vm.filters.moneyRecipientCompanyID', function () {
      vm.moneyRecipient = OrdermanagerService.getUsers({companyID: vm.filters.moneyRecipientCompanyID})
        .then(concatIdsAndNamesService);
    });

    $scope.$watch('vm.filters.printerCompanyID', function () {
      vm.printerCompany = OrdermanagerService.getUsers({companyID: vm.filters.printerCompanyID})
        .then(concatIdsAndNamesService);
    });

    $scope.$watch('vm.filters.creatorCompanyID', function () {
      vm.creatorCompany = OrdermanagerService.getUsers({companyID: vm.filters.creatorCompanyID})
        .then(concatIdsAndNamesService);
    });

    $scope.$watch('vm.filters.eventID', function () {
      if (vm.filters.eventID && vm.filters.eventID.length === 1)
        vm.zones = OrdermanagerService.getZones({eventID: vm.filters.eventID[0]});
      else vm.zones = null;
    });

    $scope.$watch('vm.filters.creatorType', function (newValue, oldValue) {
      if ((newValue !== oldValue ) && (newValue !== 'cashiers')) {
        vm.filters.creatorCompanyID = null;
        vm.filters.creatorID = null;
      }
    }, false)

    // BAG


    var printBlankType = AuthService.init().printBlankType;

    $scope.$watch('vm.bag', function () {
      // vm.bag.active =  _.filter(vm.bag.tickets, 'selected') || [];
      vm.bagSuma = _.sumBy(vm.bag.tickets, function (o) {
        return parseInt(o.price);
      });
      vm.bagLength = vm.bag.tickets.length;
      // if (printBlankType) {
      //
      //   var returned = _.filter(vm.bag.tickets, {status: 'returned'}).length;
      //   var cancelled = _.filter(vm.bag.tickets, {status: 'cancelled'}).length;
      //   var printed = _.filter(vm.bag.tickets, {printStatus: 'printed'}).length;
      //   var invite = _.filter(vm.bag.tickets, {status: 'invite'}).length; // vm.bag.payment.status === 'invite'
      //   vm.canPrint = !(returned || cancelled || printed) || invite;
      //   if (vm.bag.payment)
      //   if (vm.bag.payment.status === 'invite' && returned)
      //     vm.canPrint = false;
      // }
    }, true);

    vm.select = function (order, t) {
      if (t) {
        t.orderID = order.id;
        vm.bag.tickets = _.xor(vm.bag.tickets, [t]);
        order.selected = (_.uniqBy(order.tickets, 'selected').length === 1) ? t.selected : order.selected;
      } else {
        (!order.tickets ? vm.getTickets(order) : $q.resolve())
          .then(function () {
            _.each(order.tickets, function (ot) {
              ot.orderID = order.id;
              ot.selected = order.selected;
            });
            if (order.selected) {
              vm.bag.tickets = _.union(vm.bag.tickets, order.tickets);
              order.showTickets = true;
            } else {
              vm.bag.tickets = _.difference(vm.bag.tickets, order.tickets);
            }
          });
      }
      vm.showbag = true;
    };

    function _validateBeforePrint() {
      var info = {
        notAllowPrintTickets: [],
        printedTickets: [],
        notPaidTickets: []
      };

      info = _.reduce(vm.bag.tickets, function (info, ticket) {
        if (ticket.allowPrint !== true) {
          info.notAllowPrintTickets.push(ticket)
        }

        if (ticket.printStatus === 'printed') {
          info.printedTickets.push(ticket)
        }

        if (ticket.paymentStatus !== 'paid' && ticket.paymentStatus !== 'invite') {
          info.notPaidTickets.push(ticket)
        }

        return info

      }, info);

      var print = $q.resolve();

      if (info.notAllowPrintTickets.length) {
        print = print.then(function () {
          return OrdermanagerService.confirmPrintBag({
            message: 'Серед обраних є вже роздруковані квитки. Вам не надано права повторного друку.',
            button: {ok: false, cancel: true}
          })
        })
      }

      if (info.notPaidTickets.length) {
        print = print.then(function () {
          return OrdermanagerService.confirmPrintBag({
            message: 'Серед обраних квитків є не оплачені. Факт оплати буде зараховано за вами! Бажаєте продовжити?'
          })
        })
      }

      if (info.printedTickets.length) {
        print = print.then(function () {
          return OrdermanagerService.confirmPrintBag({
            message: 'В цьому замовленні вже є роздруковані квитки. Роздрукувати примусово?<br>За подальші дії Ви несете матеріальну відповідальність'
          })
        })
      }

      return print;
    }

    vm.printBag = function () {
      _validateBeforePrint()
        .then(function () {
          var url = '';
          var defaultPrintParams = {
            printStatus: 'printed',
            blankType: printBlankType,
            deliveryStatus: 'current',
            status: 'sold'
          };
          // paymentStatus for invite tickets should not change after print
          // for !invite tickets should change to paid after print
          var inviteTicketsIds = _.compact( _.map(vm.bag.tickets, function(t) {
            if (t.paymentStatus === 'invite' && t.status !== 'returned') {
              return t.id;
            }
          }));
          var nonInviteTicketsIds = _.compact( _.map(vm.bag.tickets, function(t) {
            if (t.paymentStatus !== 'invite' && t.status !== 'returned') {
              return t.id;
            }
          }));
          // paymentType for not paid tickets should change to cash after cashier print
          var notPaidTicketsIds = _.compact( _.map(vm.bag.tickets, function(t) {
            if (t.paymentStatus === 'not_paid' && t.status !== 'returned') {
              return t.id;
            }
          }));
          var remainingTicketsIds = _.compact( _.map(vm.bag.tickets, function(t) {
            if (t.paymentStatus !== 'invite' && t.paymentStatus !== 'not_paid' && t.status !== 'returned') {
              return t.id;
            }
          }));
     //     console.log('vm.bag', vm.bag.tickets);
          // handling print for cashier
          if ($state.params.insertCashierParams) {
            vm.ecommercePurchase(vm.bag.tickets);
            url = $state.href('print', {tickets: _.map(vm.bag.tickets, 'id'), route: 'cashier_manager'});

            vm.updateTickets(_.extend({}, defaultPrintParams, {deliveryStatus:'past', deliveryType:'pickup'}), true, inviteTicketsIds);

            vm.updateTickets(_.extend({}, defaultPrintParams, {deliveryStatus:'past', deliveryType:'pickup', paymentStatus: 'paid', paymentType: 'cash'}) , true, notPaidTicketsIds);

            vm.updateTickets(_.extend({}, defaultPrintParams, {deliveryStatus:'past', deliveryType:'pickup', paymentStatus: 'paid'}) , true, remainingTicketsIds);

          } else {
            vm.ecommercePurchase(vm.bag.tickets);
            url = $state.href('print', {tickets: _.map(vm.bag.tickets, 'id')});

            vm.updateTickets(defaultPrintParams, true, inviteTicketsIds);

            vm.updateTickets(_.extend({}, defaultPrintParams, {paymentStatus: 'paid'}), true, nonInviteTicketsIds);
          }

          $window.open(url, '_blank');
        })
        .then(vm.clearBag)
    };

    vm.ecommercePurchase = function(d) {
//-------start e-commerce --------
      var total = 0;
      var purchase = [];
        for (var item in d) {
          total += parseInt(d[item].price);
          purchase.push(
            {
              'name': d[item].eventShortName,
              'id': d[item].eventID + '',
              'price': d[item].price,
              'brand': d[item].artistsNames,
              'category': d[item].category,
              'variant': d[item].zoneNumber,
              'quantity': 1,
              'coupon': ''
            }
          );
        }


      $window.dataLayer = $window.dataLayer || [];
      if (purchase.length > 0) {
        $window.dataLayer.push({
          'ecommerce': {
            'currencyCode': 'UAH',
            'purchase': {
              'actionField': {
                'id': d[0].orderID + '',
                'affiliation': 'TMS',
                'revenue': total + '',
                'tax': parseInt(d[0].service_charge) > 0 ? parseInt(total) * parseInt(d[0].service_charge) / 100 + '' : '0',
                'shipping': '',
                'coupon': ''
              },
              'products': purchase
            }
          },
          'event': 'gtm-ee-event',
          'gtm-ee-event-category': 'Enhanced Ecommerce',
          'gtm-ee-event-action': 'Purchase',
          'gtm-ee-event-non-interaction': 'False'
        });
        console.log('Purchase - Друк', {
          'ecommerce': {
            'currencyCode': 'UAH',
            'purchase': {
              'actionField': {
                'id': d[0].orderID + '',
                'affiliation': 'TMS',
                'revenue': total + '',
                'tax': parseInt(d[0].service_charge) > 0 ? parseInt(total) * parseInt(d[0].service_charge) / 100 + '' : '0',
                'shipping': '',
                'coupon': ''
              },
              'products': purchase
            }
          },
          'event': 'gtm-ee-event',
          'gtm-ee-event-category': 'Enhanced Ecommerce',
          'gtm-ee-event-action': 'Purchase',
          'gtm-ee-event-non-interaction': 'False'
        });
      }
    };

    vm.printToZip = function () {
      _validateBeforePrint()
        .then(function () {
          var ids = _.map(vm.bag.tickets, 'id');
          return OrdermanagerService.savePrintBag(ids)
        })
        .then(function () {
          vm.ecommercePurchase(vm.bag.tickets);
          OrderService.ticketZip({ids: _.map(vm.bag.tickets, 'id')}).success(function (response) {
            var blob = new Blob([response.data], {type: 'application/zip'});
            saveAs(blob, "tickets.zip"); // eslint-disable-line
          });
          vm.clearBag();
        });
    };

    vm.printQuote = function (e, quote) {
      e.stopPropagation();
      QuotesService.validateBeforePrint(quote)
        .then(function (count) {
          if (_.isArray(count)) {
            var ids = count;
            count = count.length;
          }
          var url = '';
          quote.printed = true;
          if (!ids)
            url = $state.href('print-quote', {quote: quote.id, limit: count});
          else
            url = $state.href('print', {quotaID: quote.id, tickets: ids});
          vm.clearBag();
          $window.open(url, '_blank');
        });
    };

    vm.printQuoteToZip = function (e, quote) {
      e.stopPropagation();
      QuotesService.validateBeforePrint(quote, true)
        .then(function (count) {
          QuotesService.printToZip(quote.id, count);
          vm.clearBag();
        });
    };

    vm.returnTickets = function () {
      var info = {
        partnerApiTickets: [],
        paidTickets: []
      };

      info = _.reduce(vm.orders[0].tickets, function (info, ticket) {
        if (ticket.partnerApi === true){
          info.partnerApiTickets.push(ticket)
        }

        if (ticket.paymentStatus === "paid"){
          info.paidTickets.push(ticket)
        }

        return info
      }, info);


        if (info.partnerApiTickets.length && (vm.orders[0].tickets.length !== vm.bag.tickets.length)) {
          return OrdermanagerService.systemPopup({
            message: 'Заборонено скасовувати частину партнерських квитків!'
          })
        }
      if (AuthService.init().role !== 'admin') {
        if (info.partnerApiTickets.length && info.paidTickets.length) {
          return OrdermanagerService.systemPopup({
            message: 'Заборонено скасовувати оплачені партнерські квитки!'
          })
        }
      }

      if (info.paidTickets.length){
        vm.updateTickets({status: 'returned', paymentStatus: 'paid'});
      }else {
        vm.updateTickets({status: 'returned'});
      }
    };

    vm.updateTickets = function (diff, dontAPI, ids) {

      //-------start e-commerce --------
      if (diff.status === 'returned') {
        var result = [];
        for (var item in vm.orders[0].tickets) {
          if (vm.orders[0].tickets[item].status !== 'returned') {
            result.push(
              {
                'id': vm.orders[0].tickets[item].eventID + '',
                'quantity': 1
              }
            );
          }
        }
        $window.dataLayer = $window.dataLayer || [];
        if (result.length > 0) {
          $window.dataLayer.push({
            'ecommerce': {
              'currencyCode': 'UAH',
              'refund': {
                'actionField': {
                  'id': vm.orders[0].tickets[0].orderID + ''
                },
                'products': result
              }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Partial Refund',
            'gtm-ee-event-non-interaction': 'False'
          });
          console.log('Refund - Скасування', {
            'ecommerce': {
              'currencyCode': 'UAH',
              'refund': {
                'actionField': {
                  'id': vm.orders[0].tickets[0].orderID + ''
                },
                'products': result
              }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Partial Refund',
            'gtm-ee-event-non-interaction': 'False'
          });
        }
      }
    //  console.log($window.dataLayer);

//-------end e-commerce --------

      // setting status returned for already returned tickets caused tickets from other orders
      // with these ids to be returned
      var noReturnedTicketsForSecondReturn = _.filter(vm.bag.tickets, function (item) {
        return !(diff.status === 'returned' && item.status === 'returned')
      });

      ids = ids || _.map(noReturnedTicketsForSecondReturn, 'id');

      var data = _.extend({}, {ids: ids}, diff);

      _.each(vm.bag.tickets, function (t) {
        if (+_.indexOf(ids, (t.id)) !== -1) {
          _.extend(t, diff);
        }
      });

      if (dontAPI) {
        return;
      }
      vm.loading = true;
      OrderService.updateTickets(data)
        .catch(function (error) {
        if (error.data.error_code === 412){
          $uibModal.open({
              templateUrl: 'app/main/ordermanager/modal/ks-confirm-refund-modal.html',
              resolve: {
                message: function () {
                  return error.data.error_msg;
                },
                button: function () {
                  return data.button || {ok: true, cancel: true}
                }
              },
              controller: function ($scope, $uibModalInstance, message, button) {
                var scope = $scope;
                scope.message = message;
                scope.button = button;

                scope.ok = function () {
                  data.forceRefund = true;
                  OrderService.updateTickets(data);
                  console.log('ok');
                  $uibModalInstance.close();
                };
                scope.cancel = function () {
                  console.log('cancel');
                  $uibModalInstance.dismiss();
                };
              }
            }).result;

        }
      })
        .finally(function () {
        vm.loading = false;
        vm.clearBag();
      });
    };

    vm.sendMail = function () {
      if (!vm.bag.tickets.length) {
        return
      }

      var allTicketsPayed = vm.bag.tickets.every(function (item) {
        return item.paymentStatus != 'not_paid';
      });

      if (!allTicketsPayed) {
        return ModalService.alert('Дане замовлення не оплачене (серед обраних квитків є неоплачені). Ви не можете надіслати неоплачені квитки', 'Повідомлення');
      }

      var orderID = vm.bag.tickets[0].orderID;

      toastr.success('Надсилання квитків за замовленням #'+orderID+' розпочато');

      OrderService.get(orderID)
        .then(function(data) {
          return data.plain();
        })
        .then(function(order) {

          if (order.client && order.client.email) {
            return handleSendMail();
          } else {
            order.client = order.client || {};
            var modalInstance = $uibModal.open({
                templateUrl: 'app/main/ordermanager/modal/ks-email-modal.html',
                resolve: {
                  order: order
                },
                controller: function ($uibModalInstance, order) {
                  var vm = this;
                  vm.ok = function() {
                    order.client.email = vm.email;
                    $uibModalInstance.close(order);
                  }

                  vm.cancel = $uibModalInstance.dismiss.bind($uibModalInstance);
                },
                controllerAs: 'vm'
              }
            );

            modalInstance.result
              .then(function(order) {
                return OrderService.save(order)
              })
              .then(function() {
                return handleSendMail()
              })
          }
        })

      function handleSendMail() {
        toastr.success('Квитки за замовленням #'+orderID+' поставлені в чергу на відправку.');
        return OrderService.sendMail(vm.bag.tickets.map(function (t) {
          return t.id;
        })).then(function(){
            toastr.success('Квитки за замовленням #'+orderID+' успішно відправлені.');
        }, function(){
            toastr.warning('При відправці квитків за замовленнями #'+orderID+' виникла помилка.');
            });
      }
    };

    vm.sendPaymentLink = function () {
      OrderService.sendPaymentLinkMail(
        vm.bag.tickets
          .map(function (t) {
            return t.orderID;
          })
          .filter(function (value, index, self) {
            return self.indexOf(value) === index;
          }));
    };

    vm.sendTicketNotPay = function () {
      OrderService.sendPaymentLinkMail(
        vm.bag.tickets
          .map(function (t) {
            return t.orderID;
          })
          .filter(function (value, index, self) {
            return self.indexOf(value) === index;
          }));
    };

    // vm.sendTicketPay = function () {
    //   OrderService.sendPaymentLinkMail(
    //     vm.bag.tickets
    //       .map(function (t) {
    //         return t.orderID;
    //       })
    //       .filter(function (value, index, self) {
    //         return self.indexOf(value) === index;
    //       }));
    // };




    vm.hasReturnedTickets = function () {
      return vm.bag.tickets.some(function (o) {
        return o.status === 'returned';
      });
    }

    vm.setInvite = function () {
      vm.updateTickets({payment: {status: 'invite'}});
      vm.updateTickets({paymentStatus: 'invite'}, true);
    };

    vm.isSetInviteBtnDisabled = function () {
        //return true; // button disabled temporarily
      var userCompanyID = AuthService.init().companyID;
      return !vm.bag.tickets.length || (
        vm.bag.tickets.some(function (o) {
          return !(
            (+userCompanyID === 11) ||
            (+userCompanyID === +o.eventOrganizerID && +o.clientCompanyID === +o.eventOrganizerID)
          );
        })
      )
    };

    vm.isSendMailBtnDisabled = function () {
      return !vm.bag.tickets.length || vm.hasReturnedTickets() ||
        vm.bag.tickets.some(function (o) {
          return o.paymentType !== 'credit_card' || o.deliveryType !== 'internet';
        });
    };

    vm.isSendPayLinkMailBtnDisabled = function () {
      if (vm.bag.tickets.length && !vm.hasReturnedTickets()) {
        var orderId = vm.bag.tickets[0].orderID;
        return !vm.orders.find(function (o) {
          return o.id == orderId &&
            o.tickets.every(function (o) {
              return o.paymentType == 'credit_card';
            });
        })
      }
      return true;
    };

    // --- MAIN

    //TODO: Change for something better
    if ($state.params.insertCashierParams) {
      vm.filters.insertCashierParams = true;
    }

    vm.find = function () {
      if (vm.loading) {
        return;
      }

      vm.orders = [];
      vm.filters.offset = 0;
      $state.params.insertCashierParams && (vm.filters.insertCashierParams = !vm.filters.id);
      vm.clearBag();

      vm.filters.dateCreateFrom && (vm.filters.dateCreateFrom = moment(vm.filters.dateCreateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      vm.filters.dateCreateTo && (vm.filters.dateCreateTo = moment(vm.filters.dateCreateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
      vm.filters.printDateFrom && (vm.filters.printDateFrom = moment(vm.filters.printDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      vm.filters.printDateTo && (vm.filters.printDateTo = moment(vm.filters.printDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));
      vm.filters.paymentDateFrom && (vm.filters.paymentDateFrom = moment(vm.filters.paymentDateFrom).startOf('day').format('YYYY-MM-DD HH:mm:ss'));
      vm.filters.paymentDateTo && (vm.filters.paymentDateTo = moment(vm.filters.paymentDateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss'));

      load();
    };

    vm.load = function () {
      if (vm.loading === false) {
        vm.filters.offset += vm.filters.limit;
        if (vm.count > vm.filters.offset)
          load();
      }
    };

    function load() {
      filters = OrdermanagerService.prepare(vm.filters);
      vm.loading = true;
      vm.done = false
      OrderService.getList(filters).then(function (response) {
        vm.orders = vm.orders.concat(response.items);
        vm.tickets = response.totalTicketsCount || 0;
        vm.price = response.totalTicketsCost || 0;
        vm.count = response.count || 0;
        vm.xlsUrl = ReportService.getoredersXLSurl(response.xlsUrl);
        vm.csvUrl = ReportService.getoredersXLSurl(response.csvUrl);
        vm.done = true
      }).finally(function () {
        vm.loading = false;
      });
    }

    vm.getOrderTotal = function(order){
        return parseInt(order.product.price) + parseInt(order.totalTicketsCost);
    }

    vm.getTickets = function (order, trigger) {
      if (!trigger) {
        order.showTickets = !order.showTickets;

        if (!order.showTickets) {
          order.selected = false;
          vm.select(order);
          return;
        }
      }

      var ticketsUrl = order.ticketsUrl.replace(/&eventID=\d*,\d*/, ''); //TODO: HACK: Response is empty

      var limit = (order.loadmore) ? order.loadmore + 100 : 1000;
      return OrderService.getTickets({}, ticketsUrl + '&limit=' + limit).then(function (response) {
        order.tickets = response.items;
        order.combopay = response.combopay;
        var serviceCharge = 0;
        for (var i = 0; i < order.tickets.length; i++) {
          serviceCharge += +order.tickets[i].service_charge;
        }
        order.serviceCharge = serviceCharge;
        if (limit < order.ticketsCount)
          order.loadmore = limit;
        else order.loadmore = 0;
        order.partnerApi = !!order.tickets.find(function (item) {
          return item.partnerApi === true;
        });
      });
      // OrderService.get(order.id).then(function(response){
      //   angular.merge(order, response.plain());
      // });
    }

    //----

    if ($stateParams.search) {
      vm.filters.id = parseInt($stateParams.search);
      vm.find();
    }

  }

})();

(function () {
	'use strict';

	angular.module('tms').service('OrderService', OrderService);

	function OrderService($http, $state, Restangular, AuthService) {
		var self = this;

    var Order = Restangular.one('order');
    var Orders = Restangular.one('orders');
    var Tickets = Restangular.one('tickets');
    var Story = Restangular.one('ticket').one('story');
    var PartnerPush = Restangular.one('partner/push');

    self.get = function(id) {
      return Order.one(id + '').get();
    }

    self.create = function(data) {
      return Order.post('', data);
    }

    self.partnerPush = function(data) {
      return PartnerPush.customPOST(data, '', {});
    }

    self.save = function(data) {
			// handling save for cashier
			var route = '';
			if ($state.params.insertCashierParams) {
				route = {route: 'cashier_manager'};
			}

			return Order.one(data.id + '').customPUT(data, '', route);
    }

		self.delete = function (id) {
			return Order.one(id + '').remove();
		}

    self.getList = function(filters) {
      return Orders.get(_.extend({}, filters, {access_token: AuthService.init().access_token}));
    }

    self.getTickets = function(filters, url) {
      url = (url) ? url.replace('/tickets', '') : '';
      return Restangular.one('').customGET('tickets' + url, filters);
    }

    self.updateTickets = function (data) {
      return Tickets.customPUT(data);
    };

    self.getTicketsServiceCharge = function (data) {
        return Tickets.one('service-charge').post('', data);
    };

    self.printTickets = function (data) {
      return Tickets.one('print').customPUT(data);
    };

    self.ticketHistory = function (id, isOrder, orderOrQuoteId) {
      var p = {};
      p[isOrder ? 'orderID' : 'quotaID'] = orderOrQuoteId;
      return Story.one(id+'').get(p);
    };

    self.ticketZip = function (data) {
      var req = {
        method: 'POST',
        responseType: "arraybuffer",
        cache: false,
        url: 'index.php/tickets/zip?access_token='+AuthService.init().access_token,
        transformResponse: function (data) {
          var response = {};
          response.data = data;
          return response;
        },
        data: data
      };
      return $http(req);
    };

    self.sendMail = function (ticketsIds) {
      var req = {
        method: 'POST',
        responseType: "arraybuffer",
        cache: false,
        url: 'index.php/tickets/mail?access_token='+AuthService.init().access_token,
        transformResponse: function (data) {
          var response = {};
          response.data = data;
          return response;
        },
        data: {ids: ticketsIds}
      };
      return $http(req);
    };

    self.sendPaymentLinkMail = function (orderIds) {
      var req = {
        method: 'POST',
        responseType: "arraybuffer",
        cache: false,
        url: 'index.php/order/mail?access_token='+AuthService.init().access_token,
        transformResponse: function (data) {
          var response = {};
          response.data = data;
          return response;
        },
        data: {ids: orderIds}
      };
      return $http(req);
    };

    // self.sendTicketNotPayMail = function (orderIds) {
    //   var req = {
    //     method: 'POST',
    //     responseType: "arraybuffer",
    //     cache: false,
    //     url: 'index.php/order/mail?access_token='+AuthService.init().access_token,
    //     transformResponse: function (data) {
    //       var response = {};
    //       response.data = data;
    //       return response;
    //     },
    //     data: {ids: ticketsIds}
    //   };
    //   return $http(req);
    // };

    // self.sendTicketPayMail = function (orderIds) {
    //   var req = {
    //     method: 'POST',
    //     responseType: "arraybuffer",
    //     cache: false,
    //     url: 'index.php/order/mail?access_token='+AuthService.init().access_token,
    //     transformResponse: function (data) {
    //       var response = {};
    //       response.data = data;
    //       return response;
    //     },
    //     data: {ids: orderIds}
    //   };
    //   return $http(req);
    // };

    self.getMailLog = function (filter) {
      var url = 'index.php/mail-logs';
      var params = angular.merge(filter, {access_token: AuthService.init().access_token});
      return $http.get(url, {params: params})
        .then(function (response) {
          return response.data;
        });
    };


    self.deliveryType = [
      {name: 'Самовивіз', id: 'pickup'},
      {name: 'Нова пошта з відділення', id: 'post_service'},
      {name: 'Кур’єром по місту', id: 'courier'},
      {name: 'Електронний квиток', id: 'internet'}
    ];
    self.deliveryStatus = [
      {name: 'Не відправлявся', id: 'future'},
      {name: 'Надіслано клієнту', id: 'current'},
      {name: 'Отримано клієнтом', id: 'past'},
      {name: 'Повернено від клієнта', id: 'canceled'}
    ];
    self.paymentStatus = [
      {name: 'Оплачено', id: 'paid'},
      {name: 'Не оплачено', id: 'not_paid'},
      {name: 'Запрошення', id: 'invite', access: 'setOrderTypeInvite'}
    ];
    self.paymentType = [
      {name: 'Платіжна система', id: 'credit_card'},
      {name: 'Готівкою', id: 'cash'}
    ];
    self.printStatus = [
      {name: 'Роздруковано', id: 'printed'},
      {name: 'Не роздруковано', id: 'not_printed'}
    ];
    self.status = [
      {name: 'Створений', id: 'new'},
      {name: 'Активний', id: 'active'},
			{name: 'Проданий', id: 'sold'},
			{name: 'Заброньований', id: 'reserved'},
      {name: 'Скасований', id: 'returned', access: 'cancelOrder'}
    ];
    self.blankType = [
      {name: 'Бланк', id: 'e_blank'},
      {name: 'А4', id: 'a4'},
      {name: 'А5', id: 'a5'}
    ];


    self.getInfo = function(table, id) {
      if (!id)
        return null;
      var r = _.find(self[table], {id: id});
      return r ? r['name'] : null;
    }

	}
})();

(function () {
  'use strict';

  angular.module('tms').controller('OrderEditController', OrderEditController);

  function OrderEditController($scope, $state, $timeout, $window, toastr, AuthService, OrderService, EventsService, LocationsService, ModalService, WidgetService) {
    var vm = this;

    vm.cities = [];
    vm.events = [];

    vm.user = AuthService.init();
    vm.canPrint = vm.user.printBlankType;

    vm.showResetOrderNotification = false;
    var resetOrderNotificationMsg = 'Замовлення буде скасовано. Ви дійсно хочете перейти на іншу сторінку?'

    vm.loading = false;
    vm.citySearch = null;
    vm.showFav = true;

    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.eventStatus = ['new', 'in_sales', 'out_of_sales'];
    vm.filters = {
      limit: 100,
      offset: 0,
      cityID: null
    };
    vm.order = {create: true, paymentStatus: false, deliveryType: 'Самовивіз', ticketsPrice: 0};
    vm.orderu = {
      type: 'reserve',
      payment: {},
      delivery: {type: 'pickup'},
      address: {},
      client: {address: {}},
      postService: {}
    };

    vm.serviceCharge = 0;

    vm.deliveryTypes = [
      {name: 'Самовивіз', id: 'pickup'},
      {name: 'Нова пошта з відділення', id: 'post_service'},
      {name: 'Кур’єром по місту', id: 'courier'}//,
      //{name: 'Електронний квиток', id: 'internet'}
    ];
    vm.paymentStatuses = [
      {name: 'Оплачено', id: 'paid'},
      {name: 'Не оплачено', id: 'not_paid'}
    ];
    vm.paymentTypes = [
      {name: 'Платіжна система', id: 'credit_card'},
      {name: 'Готівкою', id: 'cash'}
    ];

    vm.t = function (e) {
      if (e) e.stopPropagation();
      vm.loadCities({name: vm.citySearch});
    }

    vm.loadEvents = function () {
      EventsService.events.list({cityID: vm.filters.cityID, status: 'in_sales'}).then(function (response) {
        vm.events = response.items;
      });
    }

    vm.loadCities = function (filters) {
      LocationsService.getCities(filters).then(function (response) {
        vm.cities = response.items;
      });
    }

    vm.citiesGet = function (filters) {
      return LocationsService.getCitiesByName(filters)
        .then(function (response) {
          return response.items;
        });
    };

    vm.loadCities();
    vm.loadEvents();

    EventsService.events.list({mode: 'favorites', status: 'in_sales'}).then(function (response) {
      vm.favFvents = response.items;
    });

    $scope.$watch('vm.filters.eventID', function () {
      if (vm.filters.eventID)
        vm.selectItem(vm.filters.eventID);
    });

    $scope.$watch('vm.order.tickets', function (newVal) {

      if (angular.isUndefined(newVal) || newVal.length === 0) {
        vm.order.ticketsPrice = 0;
        vm.serviceCharge = 0;
        return;
      }

      OrderService.getTicketsServiceCharge({
        tickets: newVal,
        cashId: vm.user.cashId || null
      }).then(function (response) {
        if (response.error) {
          toastr.error(response.error);
        } else {
          vm.order.ticketsPrice = response.ticketsPrice;
          if (response.serviceCharge > 0) {
            vm.serviceCharge = response.serviceCharge;
          }
        }
      });
    });

    vm.selectFav = function (id) {
      vm.filters.eventID = parseInt(id) + '';
    }

    vm.selectItem = function (eventID) {
      vm.filters.eventID = eventID;
      vm.selectedItem = {id: eventID};
      vm.showFav = false;
      EventsService.events.get(eventID).then(function (response) {
        vm.selectedItem = response;
      });
      if (!vm.orderID)
        OrderService.create({
          eventID: eventID
        }).then(function (response) {
          vm.orderID = response.id;
          vm.orderu.id = response.id;
          vm.order = response;

          $timeout(function () {
            WidgetService.setOrder(response.id);
            WidgetService.setOrder(response.id, eventID);
          });
        });
      else
        $timeout(function () {
          WidgetService.setOrder(vm.orderID, eventID);
        });
    }

    vm.update = function (cb) {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.orderupdateform.$valid) {
        vm.blockPrint = false;
        return;
      }

      $scope.$broadcast('timer-stop');
      vm.showResetOrderNotification = false;

      OrderService.partnerPush(vm.orderu).then(function (r) {
        if (r.error_msg) {
          deleteOrder();
          toastr.warning(r.error_msg,'Інфо',{
            "showDuration": "300",
            "hideDuration": "300",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          });
          $state.reload();
          return;
        }

        vm.loading = true;
        OrderService.save(vm.orderu).then(function () {
          toastr.success('Сформовано замовлення #' + vm.orderu.id);
        }).finally(function () {
          vm.loading = false;
          $state.reload();
          if (cb)
            cb();
        });


      });


    }

    vm.getTickets = function () {
      return OrderService.getTickets({orderID: vm.order.id}).then(function (response) {
        vm.order.tickets = response.items;
      });
    };


    // vm.getTicketsCost = function () {
    //   return OrderService.getTicketsCost().then(function (response) {
    //     vm.order.costs = response.items;
    //   });
    // };


    vm.favorite = function (e) {
      e.stopPropagation();
      vm.selectedItem.isFavorite = !vm.selectedItem.isFavorite;
      EventsService.events.favorite(vm.filters.eventID, vm.selectedItem.isFavorite).then(function () {
        EventsService.events.list({mode: 'favorites', status: 'in_sales'}).then(function (response) {
          vm.favFvents = response.items;
        });
      });
    };

    vm.print = function () {
      vm.blockPrint = true;
      vm.update(function () {
        var url = $state.href('print', {tickets: vm.order.tickets});
        $window.open(url, '_blank');
      });
    }

    vm.back = function () {
      vm.showResetOrderNotification = false;
      deleteOrder();
      $state.reload();
    }

    $scope.$on('$destroy', function () {
      angular.element($window).off("beforeunload", beforeunloadHandler);
      removeStateChangeStartListener()
    })

    //----

    WidgetService.listen(function (mode, action, status, info) {
      if (mode + '' === 'order' && action === 'save' && status === 'success') {

        vm.order.tickets = info.ticketsIDs;
        vm.info = info.key;



        if (vm.info === 'book') {
          vm.orderu.delivery.type = 'pickup';
          vm.orderu.payment.type = 'cash';
          vm.orderu.payment.status = 'not_paid';
          $window.scrollTo(0, 0);
          $timeout(function () {
            angular.element('#clientname').focus();
          });
          vm.showResetOrderNotification = true;
          setPageLeaveHandlers();
        }

        if (vm.info === 'buy') {
          vm.orderu.delivery.type = 'pickup';
          vm.orderu.payment.type = 'cash';
          vm.orderu.payment.status = 'paid';
          $window.scrollTo(0, 0);
          $timeout(function () {
            angular.element('#clientname').focus();
          });
          vm.showResetOrderNotification = true;
          setPageLeaveHandlers();
        }

        if (vm.info === 'print') {
          vm.orderu.delivery.type = 'pickup';
          vm.orderu.payment.type = 'cash';
          vm.orderu.payment.status = 'paid';
          vm.orderu.type = 'order';
          vm.orderu.status = 'sold'

          vm.loading = true;
          OrderService.save(vm.orderu).then(function () {
            var url = $state.href('print', {tickets: info.ticketsIDs});
            $window.open(url, '_blank');
            $timeout(function () {
              $state.reload();
            });
          }).finally(function () {
            vm.loading = false;
          });
        }

        $scope.$apply();
      }
    });

    function deleteOrder() {
      if (vm.orderID) {
        OrderService.delete(vm.orderID);
      }
    }

    function beforeunloadHandler() {
      if (!vm.showResetOrderNotification) {
        return;
      }
      return resetOrderNotificationMsg;
    }

    var removeStateChangeStartListener = function () {};

    function setPageLeaveHandlers() {
      removeStateChangeStartListener();
      angular.element($window).off('beforeunload', beforeunloadHandler);

      removeStateChangeStartListener = $scope.$on('$stateChangeStart', function(event, next) {
        if (!vm.showResetOrderNotification) {
          return;
        }
        event.preventDefault();

        ModalService.confirm(
          resetOrderNotificationMsg,
          'Підтвердити дію'
        ).then(function () {
          deleteOrder();
          vm.showResetOrderNotification = false;
          $state.go(next)
        })
      });

      angular.element($window).on('beforeunload', beforeunloadHandler);
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.help',
			url: 'help',
      title: 'Інструкції',
      templateUrl: 'app/main/help/help.view.html',
      menu: true,
      position: 1000,
      permissions: []
		});
	}

})();

(function () {
	'use strict';

	angular.module('tms').service('EventsService', EventsService);

	function EventsService($q, $log, $state, Restangular, AuthService ) {
	var Events = Restangular.one('events');
    var Event = Restangular.one('event');
    var EventUrlAlias = Restangular.one('event/genurlalias');
    var Search = Restangular.one('events-list');

    var list = {};

    this.eventStatusList =  {
      new: 'Проект',
      in_process: 'Діюча',
      archived: 'Архів',
      in_sales: 'В Продажi',
      out_of_sales: 'Завершена'
    };

    this.categories = {
      concert: 'Концерт',
      theater: 'Театр',
      sport: 'Спорт',
      children: 'Дітям',
      festival: 'Фестиваль',
      circus: 'Цирк',
      humor: 'Гумор',
      workshop: 'Семінар',
      film: 'Кіно',      
      other: 'Інші'



    };

     this.genre = {
      Pop: 'Поп',
      Authors: 'Авторські',
      Indie: 'Інді',
      Blues: 'Блюз',
      Rock: 'Рок',
      HipHop: 'Хіп-хоп',
      Jazz: 'Джаз',
      Electonic: 'Електро',
      Classical: 'Класична',      
      Folk: 'Народна',
      Other: 'Інші'



    };

    this.schemeCheckStatuses = ["new", "in_sales", "in_process"];

    // this.getEvent = function (filters) {
      // return Restangular.one('/events-list').get(filters );
    // }

    this.currencies = function(){
      return Restangular.one('currencies-list').get();
    }

    this.getDiscountTypes = function(){
        return Restangular.all('event/discount-type/list').getList().$object;
    };

    this.getResponsibleTypes = function(){
        return Events.one('responsible-types').get();
    };

    this.getTours = function(){
      return Restangular.one('tours-list').get();
    }
    
    this.getEventProviders = function(){
      return Restangular.one('event-providers').get();
    }
    
    this.getRemoteAreaZone = function(eventId, remoteLocationId, remoteEventId, eventProviderId){
      return Restangular.one('remote-scheme').get({
          'local_event_id': eventId,
          'remote_location_id': remoteLocationId,
          'remote_event_id': remoteEventId,
          'event_provider_id': eventProviderId
          });
    }
    
       

		this.events = {
			list: function (filters) {
				// if (list.count)
				// 	return $q.resolve(list);
				return Events.get(filters).then(function (response) {
					angular.merge(list, response);
					return response;
				});
			},
			get: function (id) {
				return Event.one(id+'').get();
			},
            getUrlAlias : function (id){
                return EventUrlAlias.get({'id':id+''});
            },
			save: function (data) {
				if (data.id)
					return Event.one(data.id+'').customPUT(data, '', '');
				else
					return Event.post('', data);
			},
			delete: function (id) {
				return Event.one(id+'').remove();
			},
            favorite: function(id, isFavorite) {
                var method = isFavorite ? 'post' : 'remove'
                return Event.one('favorites').one(String(id))[method]();
            },
            generatePromocodes: function(id) {
                return Event.one('promocode/generate').one(String(id)).get();
            },
            loadPromocodes: function(id) {
                return Event.one('promocode/load').one(String(id)).get();
            }
		}

    this.search = function (filters) {
			if (!filters) {
				filters = {};
			}
			if ($state.params.insertCashierParams) {
				filters.route = 'cashier_manager';
			} else if ($state.params.route === 'statistics') {
				filters.route = 'statistics';
			}
      return Search.get(filters);
    }

    this.eventStatus = function(item) {
      return this.eventStatusList[item];
    }

    this.multieventCreate = function (req_data, eventId) {
      return Restangular.one('event/multievent-create/'+eventId+'?access_token='+AuthService.init().access_token).customPOST(req_data, '', {});
    };
	}
})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.events',
			url: 'events',
      title: 'Подiï',
      controller: 'EventsController as vm',
      templateUrl: 'app/main/events/events.list.html',
      menu: true,
      position: 1,
      permissions: ['listEvents']
		});

      stateHelperProvider.state({
          name: 'main.new_ext_event',
          url: 'events/edit/:event',
          title: 'Подiя',
          controller: 'EventEditController as vm',
          templateUrl: 'app/main/events/event.edit.html',
          menu: false,
          position: 1,
          permissions: ['listEvents']
        });

    stateHelperProvider.state({
      name: 'main.event',
			url: 'event/:id',
      title: 'Подiя',
      template: '<div ui-view class="event"></div>',
      menu: false,
      children: [
        {
          name: 'edit',
          url: '/edit',
          title: 'Подiя',
          templateUrl: 'app/main/events/event.edit.html',
          controller: 'EventEditController as vm',
          menu: false,
          permissions: ['updateEvent']
        }, {
          name: 'prices',
          url: '/prices',
          title: 'Конструктор цiн',
          templateUrl: 'app/main/events/event.prices.html',
          // template: '<header ng-include="\'app/main/events/event.header.html\'"></header><div id="kasa-in-ua"></div>',
          controller: 'EventEditController as vm',
          menu: false,
          permissions: ['hallPrices']
        }, {
          name: 'hall',
          url: '/hall',
          title: 'Схема залу',
          template: '<header ng-include="\'app/main/events/event.header.html\'"></header><div id="kasa-in-ua"></div>',
          controller: 'EventEditController as vm',
          menu: false,
          permissions: ['hallEditor']
        }, {
          name: 'statistics',
          url: '/statistics',
          title: 'Статистика',
          templateUrl: 'app/main/events/event.statistics.html',
          controller: 'EventEditController as vm',
          menu: false,
          permissions: ['hallPrices']
        }
      ]
		});
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('EventsController', EventsController);

	function EventsController($log, $timeout, $scope, EventsService, LocationsService, AuthService, ReportService, SubdivisionsService, PlayersService, constants, $cookies) {

    var vm = this;
    vm.constants = constants;
    vm.user = AuthService.init();

    var now = new Date();
    var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

    // INIT

    vm.limit = 30;
    vm.count = 0;
	vm.offset = 0;
    vm.disableScroll = true;
    vm.status = '';

    var temp = {
      "dev-tms.test-kasa.in.ua": "https://test-kasa.in.ua",
      "tms.net.ua": "https://kasa.in.ua"
    };

    vm.kasalink = temp[document.location.hostname] || 'https://test-kasa.in.ua'; // eslint-disable-line

    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line

    var savedFilters = $cookies.getObject('eventsFilters') || {};

    vm.filters = {
        id: null,
        name: null,
        mode: savedFilters.mode || 'all',
        status: savedFilters.status || 'all_statuses',
        responsibleType: null,
        responsibleIds: [],
        orderBy: savedFilters.orderBy || 'date_create',
        schemeError: savedFilters.schemeError || null
    };
    vm.items = [];
    vm.selectedItem = {};
    vm.citiesGet = LocationsService.getCities();
    vm.players = PlayersService.searchList();

    EventsService.getResponsibleTypes().then(function (response) {
        vm.responsibleTypes = response || [];
    });

    SubdivisionsService.getList().then(function (response) {
        vm.subdivisionList = _.map(response.items || [], function (item) {
            return {
                id: item.id,
                name: item.name + " (" + item.id + ")"
            };
        });
    });

    SubdivisionsService.getManagers().then(function (response) {
        vm.subdivisionManagers = response || [];
    });

    $scope.$watch('vm.filters.responsibleType', function (newValue, oldValue) {
        if (!oldValue) {
            return;
        }
        vm.filters.responsibleIds = [];
    });

    // RUN
		// no need to call getList here, vm.applyFilter calls it at start

    // FUNCTIONS

    vm.load = function () {
      vm.offset = vm.offset + vm.limit;
      getList();
		}

    vm.applyFilter = function(ac){
      $timeout(function(){
				// handling filter reset
        if (angular.isUndefined(vm.filters[ac]) || vm.filters[ac] === '' || vm.filters[ac] === null) {
          vm.filter();
				}
        if (ac && vm.filters[ac]) {
          vm.filter();
				}
      });
    };

    vm.filterRemember = function () {
        var eventsFilters = {
            mode: vm.filters.mode,
            status: vm.filters.status,
            orderBy: vm.filters.orderBy,
            schemeError: vm.filters.schemeError
        };
        var opt = vm.user.remember ? { expires: exp } : {};
        $cookies.putObject('eventsFilters', eventsFilters, opt);
        vm.filter();
    };

    vm.filter = function(){
      if (!vm.filters.status)
        vm.filters.status = null;
      vm.offset = 0;
      vm.count = 0;
      vm.items = [];
      getList(true);
    }

    vm.xls = function(item){
      return ReportService.getoredersXLSurl('/report/sold-barcodes-csv/' + item.id + '?z=');
    }

    vm.inSales = function(item, status){
      var e = {id: item.id, status: status ? 'in_sales' : 'new'};
      EventsService.events.save(e).then(function () {
        item.status = status ? 'in_sales' : 'new';
      });
    };

    vm.toggleIndexation = function(item){
        var e = {id: item.id, allowIndexation: !item.allowIndexation};
        EventsService.events.save(e).then(function () {
            item.allowIndexation = !item.allowIndexation;
        });
    };

    vm.selectItem = function (item) {
      if (Date.parse(item.dateStart) < (new Date())) {
        item.isrunning = true;
      }

      item.showQuickStat = false;

      vm.selectedItem.active = false;
      vm.selectedItem = item;
      vm.selectedItem.active = true;
    }

    vm.favorite = function(item, e){
      e.stopPropagation();
      item.isFavorite = !item.isFavorite;
      EventsService.events.favorite(item.id, item.isFavorite);
    };

    vm.showQuickStat = function (item, e) {
      e.stopPropagation();
      vm.quickStat = null;

      item.showQuickStat = !item.showQuickStat;

      vm.selectedItem.active = false;
      vm.selectedItem = item;

      if (item.showQuickStat) {
        ReportService.eventTotal({eventID: item.id}).then(function (response) {
          item.quickStat = response.plain();
        })
      }
    };

    vm.formatDate = function(date) {
      return moment(date).format('D MMM YYYY, HH:mm');
    }

    vm.statusCaption = function(item) {
      return EventsService.eventStatus(item);
    }

    vm.schemeError = function(item) {
        return EventsService.schemeCheckStatuses.includes(item.status) && item.schemeError;
    }

    function getList(clear) {
        var filters = {};
        Object.assign(filters, vm.filters);
        if (filters.responsibleIds.length > 0) {
            filters.responsibleIds.map(function (id, i) {
                filters['responsibleIds[' + i + ']'] = id;
            });
            delete filters.responsibleIds;
        }
        var query = _.extend({}, filters, { limit: vm.limit, offset: vm.offset });
        EventsService.events.list(query).then(function (response) {
            vm.items = (clear) ? response.items : vm.items.concat(response.items);
            vm.count = response.count;
            vm.disableScroll = (vm.count > vm.offset) ? false : true;
        });
    }

    vm.hasPermission = function(permission) {
      return AuthService.access([permission]);
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').controller('EventEditController', EventEditController);

	function EventEditController($log, $scope, $state, $window, $stateParams, $timeout, toastr, ckEditorOptions, NgMap, constants,
                                 Upload, AuthService, ReportService, EventsService, LocationsService, WidgetService, PlayersService, SiteService, SubdivisionsService, $uibModal) {

	var vm = this;
	vm.constants = constants;

    var userData = AuthService.init();
    vm.userData = userData;

    // -------------------------------------------------------------------------
    // INIT
    vm.DISCOUNT_TYPE_IDENTIFIER = 1;
    vm.DISCOUNT_TYPE_PROMOCODE = 2;
    vm.DISCOUNT_TYPE_AUTO = 3;
    vm.loading = false;
    vm.shouldGenPromocodes = false;
    vm.mode = $state.current.name;
    vm.filters = {};
		vm.event = {
      discount: 0,
      tickets_count: 0,
      min_tickets_discounting: false,
      electronic_only: false,
      mask: null,
      generatedPromocode: false,
      barcodeType: 'code128',
      status: 'new',
      type: 'concert',
      // genre: 'other',
      dateCreate: new Date(),
      dateStart: null,
      dateEnd: null,
      dateEntry: null,
      dateSalesStart: new Date(),
      dateSalesEnd: null,
      scFee: 5,
      deletedPosters: [],
      ticketsLifeTime: 72,
      cvsss: false,
      ticketsType: 'all',
      ignoreTicketsLifeTime: true,
      printTemplateID: 1,
      provider: null,
      remoteLocationId: null,
      remoteEventId: null,
      longTime: null,
      expiryTime:null,
      displayAllDates: null,
      isChild: null
    };
    vm.dateEntry = false;
		// old key AIzaSyB_JLZbN7sxeRjDaTYinCyfYvdInE_mqEE
    vm.googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBBvPrqgF5ZNToadFOSd69PmOrkKgOHm5s";
    vm.geo = '50.4546600, 30.5238000';
    vm.calendarOptions = { locale: 'uk' };
		vm.barcodes = [
      'ean8',
      'ean13',
      'upc',
      'std25',
      'int25',
      'code11',
      'code39',
      'code93',
      'code128',
      'codabar',
      'msi',
      'datamatrix'
    ];
    vm.ckEditorOptions = ckEditorOptions;
    vm.csvExample = '/index.php/barcodes-csv-example?access_token=' + userData.access_token;
    vm.imagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : ''; // eslint-disable-line
    vm.ckImagesUrl = (document.location.hostname === "localhost") ? 'https://dev-tms.test-kasa.in.ua' : document.location.origin; // eslint-disable-line

    vm.categories = _.map(EventsService.categories, function (v, i) {
      return {id: i, name: v};
    });

    vm.genre = _.map(EventsService.genre, function (v, i) {
      return {id: i, name: v};
    });

    vm.eventStatusList = _.map(EventsService.eventStatusList, function (v, i) {
      return {id: i, name: v};
    });

    vm.lang = [
      {name: 'ua', id: '1', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''},
      {name: 'ru', id: '2', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''},
      {name: 'en', id: '3', a_name: '', description: '', meta_title: '', meta_description: '', keywords: ''}
    ];

    vm.discount_lang = [
      {name: 'ua', id: '1', event_description: '', checkout_description: '', checkout_error: ''},
      {name: 'ru', id: '2', event_description: '', checkout_description: '', checkout_error: ''},
      {name: 'en', id: '3', event_description: '', checkout_description: '', checkout_error: ''}
    ];

    vm.currenciesList = EventsService.currencies();

    vm.discountTypes = EventsService.getDiscountTypes();

    EventsService.getResponsibleTypes().then(function (response) {
        vm.responsibleTypes = response || [];
    });

    SubdivisionsService.getList().then(function (response) {
        vm.subdivisionList = _.map(response.items || [], function (item) {
            return {
                id: item.id,
                name: item.name + " (" + item.id + ")"
            };
        });
    });

    SubdivisionsService.getManagers().then(function (response) {
        vm.subdivisionManagers = response || [];
    });

    vm.urlAliasPattern = /^[a-zA-Z 0-9-]+$/;

    vm.blankType = [
      {name: 'А4', id: 'a4'},
      {name: 'А5', id: 'a5'},
      {name: 'Бланк', id: 'e_blank'}
    ];
    vm.printTemplates = [
      {name: 'За замовчуванням', id: '1'},
    //{name: 'Шаблон 1', id: '2'},
    //{name: 'Шаблон 2', id: '3'},
      {name: 'Шаблон 2023', id: '4'}
    ];

    vm.currentDate = new Date();


    vm.schemeError = function() {
        return EventsService.schemeCheckStatuses.includes(vm.event.status) && vm.event.schemeError;
    }

    // -------------------------------------------------------------------------
    // RUN

    if (vm.mode === 'main.event.edit' || vm.mode === 'main.new_ext_event')
      watch();

    if (vm.mode === 'main.event.prices') {
      $scope.$watch('vm.event.newid', function(){
        if (vm.event.newid)
          $state.go('main.event.prices', {id: vm.event.newid});
      });
    }

     if (vm.mode === 'main.new_ext_event'){
        ['dateStart', 'dateEnd', 'dateEntry', 'dateSalesStart', 'dateSalesEnd'].forEach(function (el) {
                  if (vm.event[el]) vm.event[el] = moment(vm.event[el]);
        });

        if (Date.parse(vm.event.dateStart) < (new Date())) {
            vm.isrunning = true;
            vm.eventStatusList = _.filter(vm.eventStatusList, function (el) {
                return el.id !== 'in_sales';
            });
        }

        vm.event.ticketsLifeTime = (vm.event.ticketsLifeTime) ? vm.event.ticketsLifeTime / 3600 : 72;

        if (vm.event.dateEntry)
            vm.dateEntry = true;

    }


    $timeout(function(){
        var e = angular.fromJson($stateParams.event);
        if ($stateParams.event) { for (var k in e) { vm.event[k] = e[k] } }
    }, 1000);


    if ($stateParams.id){

            EventsService.events.get($stateParams.id).then(function (response) {

                ['dateStart', 'dateEnd', 'dateEntry', 'dateSalesStart', 'dateSalesEnd'].forEach(function (el) {
                  if (response[el]) response[el] = moment(response[el]);
                });

                vm.event = response;
                if (vm.event.partner_isset === true && vm.mode === 'main.event.prices'){
                  toastr.warning('Доступ закритий - партнер');
                  return $state.go('main.events');
                }
                vm.event.newid = $stateParams.id;
                vm.event.cvsss = !response.updateBarcodes;


                if (!vm.event.printTemplateID) {
                  vm.event.printTemplateID = 1;
                }
                if (!vm.event.min_tickets) {
                    vm.event.min_tickets = 1;
                }
                if (!vm.event.min_tickets_discounting) {
                    vm.event.min_tickets_discounting = false;
                }

                if (Date.parse(response.dateStart) < (new Date())) {
                    vm.isrunning = true;
                    vm.eventStatusList = _.filter(vm.eventStatusList, function (el) {
                        return el.id !== 'in_sales';
                    });
                }

                vm.event.ticketsLifeTime = (response.ticketsLifeTime) ? response.ticketsLifeTime / 3600 : 72;

                if (vm.event.dateEntry)
                    vm.dateEntry = true;

                vm.xls = function(){
                    return ReportService.getoredersXLSurl('/report/barcodes-csv/' + vm.event.id + '?z=');
                }

                NgMap.getMap().then(function(map) {
                    if (map)
                        $timeout(function(){
                        google.maps.event.trigger(map, 'resize'); // eslint-disable-line
                        }, 150);
                });

                if (response.latitude && response.longitude)
                  vm.geo = response.latitude + ',' + response.longitude;
                        if (vm.mode === 'main.event.hall')
                            WidgetService.setEditHall(response.hallFileID);
                        if (vm.mode === 'main.event.prices')
                            WidgetService.setEvent($stateParams.id);

                vm.createPrintView();

                EventsService.getEventProviders().then(function (response) {
                    vm.eventProviders = response;
                });

            });

    }

     // -------------------------------------------------------------------------
    // WATCH

    function watch() {

      vm.players = PlayersService.searchList();
      vm.artists = SiteService.artists.list();

      vm.countryList = LocationsService.getCountries();
      $scope.$watch('vm.event.apiSource', function(){ vm.loadEventSource()}, true);
      $scope.$watch('[vm.event.eventSource.remoteLocationId, vm.event.eventSource.remoteEventId, vm.event.eventSource.eventProviderId]', function(){vm.loadEventSource()}, true);

      $scope.$watch('vm.event.countryID', function(){
        vm.cityList = LocationsService.getCities({countryID: vm.event.countryID});
        if  (!vm.event.countryID){
          vm.event.cityID = null;
          vm.event.hallID = null;
          vm.event.hallFileID = null;
        }
      }, true);

      $scope.$watch('vm.event.cityID', function(){
        vm.locationList = LocationsService.getHalls({cityID: vm.event.cityID});
        if  (!vm.event.countryID)
        {
          vm.event.hallID = null;
          vm.event.hallFileID = null;
        }
      }, true);

      $scope.$watch('vm.event.hallID', function(){
        vm.areaList = LocationsService.getHallZones({hallID: vm.event.hallID});
        if  (!vm.event.hallID) {
          vm.event.hallFileID = null;
        }
      }, true);

      $scope.$watch('vm.event.dateStart', function(val){
				// setting default values
        if (val && !vm.event.dateEnd) {
          vm.event.dateEnd = val.clone().add(2, 'hours');
        }
				if (val && !vm.event.dateEntry) {
					vm.event.dateEntry = val.clone().add(-2, 'hours');
				}
				if (val && !vm.event.dateSalesEnd) {
					vm.event.dateSalesEnd = val.clone().add(-2, 'hours');
				}
      });

      $scope.$watch('vm.event.discount_type', function (newValue) {
        if(newValue === null)
          $scope.vm.event.discount_type = 0;
      });

      $scope.$watch('vm.event.electronic_only', function (newValue) {
       if(newValue === null)
         $scope.vm.event.electronic_only =false;
      });

      $scope.$watch('vm.event.displayAllDates', function (newValue) {
        if (newValue === true){
          vm.event.longTime = false;
        }
      });

      $scope.$watch('vm.event.longTime', function (newValue) {
        if (newValue === true){
          vm.event.displayAllDates = false;
        }
      });

      $scope.$watch('vm.event.responsibleType', function (newValue, oldValue) {
          if (!oldValue) {
              return;
          }
          vm.event.responsibleID = null;
      });

    }

    // $scope.$watch('vm.event.categories', function (items) {
    //   if(vm.createevent) {
    //     var isValid = _.isArray(items) && !!items.length
    //     vm.createevent.$setValidity('vm.event.categories', isValid);
    //   }
    // }, true);

    // -------------------------------------------------------------------------
    // FUNCTIONS

    vm.loadEventSource = function(){
        if(vm.event.apiSource){
//            if (!vm.remoteAreaZones){
                if(vm.event.eventSource.eventProviderId && vm.event.eventSource.remoteEventId && vm.event.eventSource.remoteLocationId ){
                    vm.remoteAreaZones = [];
                    vm.zonesList = [];
                    EventsService.getRemoteAreaZone(vm.event.id, vm.event.eventSource.remoteLocationId, vm.event.eventSource.remoteEventId, vm.event.eventSource.eventProviderId).then(function (response) {
                        vm.remoteAreaZones = response;
                        LocationsService.getZones({eventID:vm.event.id}).then(function (response) {
                            vm.zonesList = response;
                            vm.zonesMaps = {};
                            vm.event.eventSource.remoteAreaZoneMap.forEach(function(el){
                               vm.zonesMaps[el.remote_zone_id] = el.local_zone_id;
                            });
                        });
                    });
                }
//            }
        }
    }

/*    vm.loadExternalZones = function(){
       EventsService.getRemoteAreaZone(vm.event.id).then(function (response) {
            vm.remoteAreaZones = response;
       });

    }
*/
    vm.genUrlAlias = function () {

        if (!vm.event.id){
            return;
        }

        EventsService.events.getUrlAlias(vm.event.id).then(function (response) {
            vm.event.urlAlias = response;
        });

    }

    vm.save = function () {
      $scope.$broadcast('show-errors-check-validity');
      if(!vm.createevent.$valid){
        return;
      }


      if (!vm.createevent.$valid && vm.event.urlAlias != ''){
          toastr.warning('Поле URL Alias включає не допустимі символи');
      }

      if (vm.event.apiSource && (!vm.event.eventSource.eventProviderId || !vm.event.eventSource.remoteLocationId || !vm.event.eventSource.remoteEventId)) {
        toastr.warning('Заповніть обов’язкові поля Джерела події');
        return;
      }

      //TODO
      if (!vm.createevent.$valid || !vm.event.organizerID) {
        toastr.warning('Заповніть обов’язкові поля');
        return;
      }

       if (!vm.event.artistsID[0]) {
        toastr.warning('Заповніть артиста');
        return;
      }

      // if (!vm.event.discount && vm.event.discount_type==1) {
      //   toastr.warning('Заповніть відсоток знижки');
      //   return;
      // }

       if (vm.zonesMaps){
           vm.event.eventSource.remoteAreaZoneMap = [];
           for (var key in vm.zonesMaps) {
               if (vm.remoteAreaZones[key]){
                    vm.event.eventSource.remoteAreaZoneMap.push({local_zone_id: vm.zonesMaps[key], remote_zone_id: key})
               }
           }
       }

      var e = angular.extend({}, vm.event),
        d = ['dateStart', 'dateCreate', 'dateEnd', 'dateEntry', 'dateSalesStart', 'dateSalesEnd'];
      _.each(e, function (v, i) {
        if (v && d.indexOf(i) > -1)
          e[i] = moment(v).format('YYYY-MM-DD HH:mm:ss') + '';
      });
      e.posters = _.map(e.posters, 'id');
      e.posters_desktop = _.map(e.posters_desktop, 'id');
      e.posters_desktop_retina = _.map(e.posters_desktop_retina, 'id');
      e.posters_mobile = _.map(e.posters_mobile, 'id');
      e.posters_mobile_retina = _.map(e.posters_mobile_retina, 'id');
      e.ticketsLifeTime = e.ticketsLifeTime * 3600;
      e.updateBarcodes = !vm.event.cvsss;
			e.categories = [e.type];
      e.create_lang = vm.lang;
      e.discount_lang = vm.discount_lang;

      if (angular.isUndefined(e.responsibleType)) {
          e.responsibleType = null;
          e.responsibleID = null;
      }

      vm.loading = true;
      EventsService.events.save(e).then(function (response) {
        toastr.success('Подiя збережена!');
        if (vm.shouldGenPromocodes) {
            vm.event.id = response.id;
            EventsService.events.generatePromocodes(response.id)
                .then(function (response) {
                    if (response.result) {
                        vm.event.generatedPromocode = true;
                        vm.event.discountExists = true;
                        toastr.success('Промокоди сгенеровано!');
                    } else {
                        toastr.error('Сталася помилка');
                    }
                });
            vm.shouldGenPromocodes = false;
        } else {
            $state.go('main.events');
        }
      }).finally(function () {
        vm.loading = false;
      })
    };

    vm.loadPromocodes = function () {
        EventsService.events.loadPromocodes(vm.event.id).then(function (response) {
            if (response.result) {
                $window.open('/' + response.downloadPath);
            } else {
                toastr.error('Сталася помилка');
            }
        });
    };

    vm.uploadFile = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валдацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
        });
        file.upload.then(function (response) {
          if (ckeditor) {
            vm.event.description = vm.event.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.event.posters = vm.event.posters || [];
            $timeout(function () {
              vm.event.posters.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFiles = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFile(files[i], errFiles, ckeditor);
        }
      }
    }

    vm.removePoster = function(poster) {
      var i = _.findIndex(vm.event.posters, {id: poster.id});
      vm.event.posters.splice(i, 1);
      vm.event.deletedPosters.push(poster.id);
    }

//for label desktop
    vm.uploadFileDesk = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];

      if (errFiles[0])
        toastr.error('Помилка валідацiï файлiв');

      // if (!vm.uploadFilesDesk.$invalidFiles){
      //     toastr.success('Афіша загрузилась!');
      // }

     if (file) {
        file.upload = Upload.upload({
        url: '/index.php/file',
        data: {file: file,'type':'desktop','event_id':vm.event.id},
        headers: {'Authorization': 'Bearer ' + userData.access_token}
        });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.event.description = vm.event.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.event.posters_desktop = vm.event.posters_desktop || [];
            $timeout(function () {
              vm.event.posters_desktop.push(response.data);

            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDesk = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {

          // if (files[i].size > 10485760){
          // toastr.warning('Афіша не відповідає формату.');
          // return;
      // }

         vm.uploadFileDesk(files[i], errFiles, ckeditor);
        }
      }

      // if (!vm.uploadFilesDesk){
      //     toastr.warning('Афіша не відповідає формату.9');
      // }

    }

    // vm.removePoster = function(poster) {
    //   var i = _.findIndex(vm.event.posters, {id: poster.id});
    //   vm.event.posters.splice(i, 1);
    //   vm.event.deletedPosters.push(poster.id);
    // }

    vm.removePoster_desktop = function(poster) {
      var i = _.findIndex(vm.event.posters_desktop, {id: poster.id});
      vm.event.posters_desktop.splice(i, 1);
      vm.event.deletedPosters_desktop.push(poster.id);
    }


    //for label desktop_retina
    vm.uploadFileDeskret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валідацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'desktop_retina','event_id':vm.event.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.event.description = vm.event.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.event.posters_desktop_retina = vm.event.posters_desktop_retina || [];
            $timeout(function () {
              vm.event.posters_desktop_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesDeskret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileDeskret(files[i], errFiles, ckeditor);
        }
      }
    }

    vm.removePoster_desktop_retina = function(poster) {
      var i = _.findIndex(vm.event.posters_desktop_retina, {id: poster.id});
      vm.event.posters_desktop_retina.splice(i, 1);
      vm.event.deletedPosters_desktop_retina.push(poster.id);
    }

//for label mobile
    vm.uploadFileMob = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валідацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile','event_id':vm.event.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.event.description = vm.event.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.event.posters_mobile = vm.event.posters_mobile || [];
            $timeout(function () {
              vm.event.posters_mobile.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMob = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMob(files[i], errFiles, ckeditor);
        }
      }
    }

    vm.removePoster_mobile = function(poster) {
      var i = _.findIndex(vm.event.posters_mobile, {id: poster.id});
      vm.event.posters_mobile.splice(i, 1);
      vm.event.deletedPosters_mobile.push(poster.id);
    }

    //for label mobile_retina
    vm.uploadFileMobret = function (file, errFiles, ckeditor) {
      vm.f = file;
      vm.errFile = errFiles && errFiles[0];
      if (errFiles[0])
        toastr.error('Помилка валідацiï файлiв');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/file',
          data: {file: file,'type':'mobile_retina','event_id':vm.event.id},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
          });

        file.upload.then(function (response) {
          if (ckeditor) {
            vm.event.description = vm.event.description + '<p><img alt="" src="' + vm.ckImagesUrl + response.data.url + '" /></p>';
          } else {
            vm.event.posters_mobile_retina = vm.event.posters_mobile_retina || [];
            $timeout(function () {
              vm.event.posters_mobile_retina.push(response.data);
            });
          }
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        }, function (evt) {
          file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      }
    }

    vm.uploadFilesMobret = function (files, errFiles, ckeditor) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          vm.uploadFileMobret(files[i], errFiles, ckeditor);
        }
      }
    }

    vm.removePoster_mobile_retina = function(poster) {
      var i = _.findIndex(vm.event.posters_mobile_retina, {id: poster.id});
      vm.event.posters_mobile_retina.splice(i, 1);
      vm.event.deletedPosters_mobile_retina.push(poster.id);
    }


   vm.setCodes = function(file, errFiles) {
      if (errFiles[0])
        toastr.error('Помилка валідацiï файлу');
      if (file) {
        file.upload = Upload.upload({
          url: '/index.php/upload-barcodes-csv/' + $stateParams.id,
          data: {file: file},
          headers: {'Authorization': 'Bearer ' + userData.access_token}
        });
        file.upload.then(function (response) {
          toastr.success('Файл завантажено');

					if (response && response.data && response.data.places_not_found && angular.isArray(response.data.places_not_found)
            && +response.data.places_not_found.length > 0
          ) {
            var msg = response.data.places_not_found.map(function (item) {
              return '<br>' + item;
            })
            toastr.warning('Не вдалось знайти місця: ' + msg)
					}

          if (response && response.data && response.data.barcodes_doubles && angular.isArray(response.data.barcodes_doubles)
            && +response.data.barcodes_doubles.length > 0
          ) {
            var msg1 = response.data.barcodes_doubles.map(function (item) {
              return '<br>' + item;
            })
            toastr.warning('Не унікальний штрихкод: ' + msg1)
					}
        }, function (response) {
          if (response.status > 0) {
            toastr.warning(response.status + ': ' + response.data);
          }
        });
      }
    };

    vm.inSales = function(status){
      var e = {id: $stateParams.id, status: status ? 'in_sales' : 'new'};
      EventsService.events.save(e).then(function (response) {
        vm.event = response;
        vm.event.cvsss = !response.updateBarcodes;

        if (!vm.event.printTemplateID) {
          vm.event.printTemplateID = 1;
        }
      });
    };

    vm.generatePromocodes = function() {
        vm.shouldGenPromocodes = true;
        vm.save();
    };

    vm.createPrintView = function() {
      // barcode show fix
      //vm.type = 'a4';

      $timeout(function () {
       // vm.type = 'a4';

        vm.tickets = [{
          "id": 123,
          "orderID": 124,
          "number": 21,
          "row": 32,
          "zone": "Fan-zone 2",
          "price": 100,
          "event": vm.event.name,
          "city": vm.event.cityName,
          "address": "Test str. 4",
          "area": vm.event.hallName,
          "time": "2016.06.30 06:21",
          "date": moment(vm.event.dateStart, 'YYYY.MM.dd HH:ss').toDate(),
          "barcode": "152351919862",
          "client": "Iм'я Клієнта",
          "barcodeType": vm.event.barcodeType,
          "printTemplateID": vm.event.printTemplateID || 1
        }];

        $timeout(function () {
          angular.element('.' + vm.tickets[0].barcode).show().barcode(vm.tickets[0].barcode, vm.tickets[0].barcodeType, {
            posX: -10, barWidth: 2, barHeight: 30, output: "svg"
          });
        });
      });
    }

    vm.multiEventModal = function () {
      return $uibModal.open({
        templateUrl: 'app/main/events/modal/multievent-modal.html',
        controller: function ($scope, $uibModalInstance) {
          var scope = $scope;
          scope.button = {ok: true, cancel: true};
          scope.multiEventCount = 1;
          scope.newDateStart = moment(new Date());
          var toastrParams = {
            "showDuration": "1000",
            "hideDuration": "1000",
            "timeOut": "1000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
          };

          scope.duplicateItem = function()
          {
         //   console.log($uibModalInstance);
            //console.log('event', vm.event);
            var len = $scope.multiEventCount;
            var start = 1;
            var arr = new Array(len);
              for (var i = 0; i < len; i++, start++) {
                arr[i] = start;
              }
              return arr;
          }


          scope.ok = function () {
            var data = [];
            angular.element('.modal-body .datepicker input.ng-pristine').each(function(i, sel) {
              var selectedVal = angular.element(sel).val();
              data.push(selectedVal);
            });
            EventsService.multieventCreate(data, vm.event.id)
              .then(function (response) {
                if (response.result === true) {
                  toastr.success('Події успішно згенеровані!', '', toastrParams);
                }else if (response.error.length > 0){
                  toastr.error(response.error, 'Помилка', toastrParams);
                }
              });
            $uibModalInstance.close();
          };

          scope.cancel = function () {
            $uibModalInstance.dismiss();
          };
        }
      }).result;
    }
        vm.showSchemeErrors = function () {
            if (!vm.event.schemeError || !vm.event.schemeErrorDetails) {
                return;
            }

            $uibModal.open({
                templateUrl: 'app/main/events/modal/modal.scheme-error.html',
                size: 'md',
                controller: function ($scope) {

                    var scope = $scope;

                    scope.schemeErrorDetails = vm.event.schemeErrorDetails;
                }
            });
        };
	}

})();

(function () {
  'use strict';

  angular.module('tms').service('EncashmentService', EncashmentService);

  function EncashmentService(Restangular) {
    var self = this;

    var Cashes = Restangular.one('/cashes-list')
    var Cashiers = Restangular.one('/encashments/cashiers')
    var Percents = Restangular.one('/encashment/percents')
    var Encashments = Restangular.one('/encashments')
    var Encashment = Restangular.one('/encashment')
    var cashesList = {}

    self.getCasheById = function (cashID) {
      return cashesList[cashID]
    }

    self.getCashes = function (filters) {
      return Cashes.get(filters).then(function (json) {
        cashesList = _.reduce(json, function (o, item) {
          o[item.id] = item
          return o
        }, {})

        return json
      })
    }

    self.getCashiers = function (cashID) {
      return Cashiers.one(cashID+'').get()
    }

    self.getPercentsCash = function (cashID) {
      return Percents.one('cash/'+cashID).get().then(function (json) {
        var cash = self.getCasheById(cashID)
        self.lastCashID = cashID
        return angular.merge({
          isCash: true,
          hasEventsPercents: !!json.events.length
        }, cash, json)
      });
    }

    self.percents = function (entity, id) {
      var rest = Percents.one(entity+'/'+id)
      return {
        get: function () {
          return rest.get()
        },
        save: function (data, params) {
          return rest.customPUT(data, '', params);
        }
      }
    }

    self.getEncashments = function (filters) {
      return Encashments.get(filters)
    }

    self.encashment = function (cashID) {
      var rest = Encashment.one(cashID+'')
      return {
        get: function (filters) {
          return rest.get(filters)
        },
        save: function (data) {
          return rest.customPOST(data, '', {})
        }
      }
    }

  }
})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.encashment',
      url: 'encashment',
      title: 'Інкасації',
      template: '<div ui-view class="fade-in-down-big"></div>',
      menu: true,
      abstract: true,
      position: 90,
      access: 8000,
      permissions: ['menuEncashment'],
      children: [
        {
          name: 'manager',
          url: '/manager',
          title: 'Список інкасацій',
          controller: 'EncashmentManagerController as vm',
          templateUrl: 'app/main/encashment/manager/encashment.manager.view.html',
          menu: true,
          access: 8000,
          permissions: ['encashmentSettings']
        },
        {
          name: 'manager-add',
          url: '/manager-add',
          title: 'Додати інкасацію',
          controller: 'EncashmentManagerAddController as vm',
          templateUrl: 'app/main/encashment/manager/encashment.manager.add.view.html',
          menu: false,
          access: 8000,
          permissions: ['encashmentSettings']
        },
        {
          name: 'percents',
          url: '/percents',
          title: 'Відсоток',
          controller: 'EncashmentPercentListController as vm',
          templateUrl: 'app/main/encashment/percent/encashment.percent.list.view.html',
          menu: true,
          access: 8000,
          permissions: ['encashmentSettings']
        },
        {
          name: 'percent-cash',
          url: '/percent-cash/:id',
          title: 'Відсоток каси',
          resolve:{
            type: function () {
              return 'cash'
            }
          },
          controller: 'EncashmentPercentEditController as vm',
          templateUrl: 'app/main/encashment/percent/encashment.percent.edit.view.html',
          menu: false,
          access: 9000,
          permissions: ['encashmentSettings']
        },
        {
          name: 'percent-cashier',
          url: '/percent-cashier/:id',
          title: 'Відсоток касира',
          resolve:{
            type: function () {
              return 'cashier'
            }
          },
          controller: 'EncashmentPercentEditController as vm',
          templateUrl: 'app/main/encashment/percent/encashment.percent.edit.view.html',
          menu: false,
          access: 9000,
          permissions: ['encashmentSettings']
        }
      ]
		});

	}

})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.configs',
			url: 'configs',
      title: 'Конфiгурацiï',
      template: '<div ui-view class="fade-in-down-big"></div>',
      menu: true,
      abstract: true,
      position: 70,
      access: 9000,
      permissions: ['menuConfig'],
      children: [
        // {
        //   name: 'ext-karabas',
        //   url: '/ext-karabas',
        //   title: 'Зовнішні карабас',
        //   controller: 'ExtEventsController as vm',
        //   templateUrl: 'app/main/configs/ext-karabas/events.list.view.html',
        //   menu: true,
        //   permissions: ['listCompanies']
        // },
        // {
        //   name: 'external-events',
        //   url: '/external-events',
        //   title: 'Зовнішні події',
        //   controller: 'ExtEventsController as vm',
        //   templateUrl: 'app/main/configs/external-events/events.list.view.html',
        //   menu: true,
        //   permissions: ['listCompanies']
        // },
        {
          name: 'players',
          url: '/players',
          title: 'Список гравцiв',
          controller: 'PlayersController as vm',
          templateUrl: 'app/main/configs/players/players.list.view.html',
          menu: true,
          permissions: ['listCompanies']
        },{
          name: 'player',
          url: '/players/:id',
          title: 'Гравець',
          controller: 'PlayersEditController as vm',
          templateUrl: 'app/main/configs/players/players.edit.html',
          menu: false,
          permissions: ['manageCompanies']
        },{
					name: 'cashier',
					url: '/cashier',
					title: 'Список кас',
					controller: 'MapController as vm',
					templateUrl: 'app/main/configs/map/map.list.html',
					menu: true,
          permissions: ['listCashes']
        },{
					name: 'cashier.edit',
					url: '/cashier/:id',
					title: 'Каса',
					controller: 'MapController as vm',
					templateUrl: 'app/main/configs/map/map.edit.html',
					menu: false,
          permissions: ['manageCashes']
        },{
          name: 'users',
          url: '/users',
          title: 'Список користувачiв',
          controller: 'UsersController as vm',
          templateUrl: 'app/main/configs/users/users.list.view.html',
          menu: true,
          permissions: ['listUsers']
        },{
          name: 'user',
          url: '/user/:id',
          title: 'Користувач',
          controller: 'UserEditController as vm',
          templateUrl: 'app/main/configs/users/users.edit.view.html',
          menu: false,
          permissions: ['manageUsers'],
          access: 9000
        },{
          name: 'locations',
          url: '/locations',
          title: 'Список локацiй',
          controller: function(WidgetService) {
            WidgetService.setModeAdmin();
          },
          templateUrl: 'app/main/configs/locations/locations.list.view.html',
          menu: true,
          access: 9000,
          permissions: ['hallEditor']
        },{
          name: 'subdivisions',
          url: '/subdivisions',
          title: 'Список підрозділів',
          controller: 'SubdivisionsController as vm',
          templateUrl: 'app/main/configs/subdivisions/subdivisions.list.view.html',
          menu: true,
          permissions: ['manageSubdivisions']
        },{
          name: 'subdivision',
          url: '/subdivision/:id',
          title: 'Підрозділ',
          controller: 'SubdivisionEditController as vm',
          templateUrl: 'app/main/configs/subdivisions/subdivisions.edit.html',
          menu: false,
          permissions: ['manageSubdivisions']
        },{
          name: 'widgets',
          url: '/widgets',
          title: 'Віджети партнерів',
          controller: 'WidgetsController as vm',
          templateUrl: 'app/main/configs/widgets/widgets.list.view.html',
          menu: true,
          access: 9000,
					permissions: ['listWidgets']
        },{
          name: 'widget',
          url: '/widget/:id',
          title: 'Віджет',
          controller: 'WidgetEditController as vm',
          templateUrl: 'app/main/configs/widgets/widgets.edit.view.html',
          menu: false,
					access: 9000,
					permissions: ['manageWidgets']
        },{
          name: 'permissions',
          url: '/permissions',
          title: 'Доступи',
          controller: 'PermissionsController as vm',
          templateUrl: 'app/main/configs/permissions/list.html',
          menu: false,
          permissions: ['manageRbac']
        },{
          name: 'permissions.user',
          url: '/permissions/user/:id',
          title: 'Доступи Користувача',
          menu: false,
          permissions: ['manageRbac'],
          controller: 'PermissionsController as vm',
          templateUrl: 'app/main/configs/permissions/list.html'
        },{
          name: 'event',
          menu: false,
          permissions: ['manageCompanies']
        },{
          name: 'event.permissions',
          menu: false,
          permissions: ['manageCompanies']
        },{
          name: 'event.permissions.player',
          url: '/event-permissions/player/:id',
          title: 'Доступ гравця до подій',
          menu: false,
          permissions: ['manageCompanies'],
          controller: 'EventPermissionsPlayerController as vm',
          templateUrl: 'app/main/configs/event-permissions/player.list.html'
        },{
          name: 'event.permissions.user',
          url: '/event-permissions/user/:id',
          title: 'Доступ користувача до подій',
          menu: false,
          permissions: ['manageCompanies'],
          controller: 'EventPermissionsUserController as vm',
          templateUrl: 'app/main/configs/event-permissions/user.list.html'
        },{
          name: 'roles',
          url: '/roles',
          title: 'Доступи Ролi',
          menu: true,
          permissions: ['manageRbac'],
          controller: 'PermissionsController as vm',
          templateUrl: 'app/main/configs/permissions/list.html'
        },{
          name: 'mailstat',
          url: '/mailstat',
          title: 'Статистика email',
          controller: 'MailstatController as vm',
          templateUrl: 'app/main/configs/mail/mail.list.html',
          menu: true,
          permissions: ['manageRbac']
        },{
          name: 'return',
          url: '/return',
          title: 'Статистика повернення',
          controller: 'ReturnController as vm',
          templateUrl: 'app/main/configs/return/return.list.html',
          menu: true,
          permissions: ['listUsers']
        }, {
          name: 'city-list',
          url: '/city-list',
          title: 'Список міст',
          controller: 'CityListController as vm',
          templateUrl: 'app/main/configs/city-list/city-list.list.view.html',
          menu: true,
          permissions: ['listCompanies']
        },{
          name: 'city',
          url: '/city-list/:id',
          title: 'Місто',
          controller: 'CityListEditController as vm',
          templateUrl: 'app/main/configs/city-list/city-list.edit.html',
          menu: false,
          permissions: ['manageCompanies']
        },
				// TODO remove when not needed
				{
					name: 'problem-tickets',
					url: '/problem-tickets',
					title: 'Проблемні квитки',
          controller: 'ProblemTicketsController as vm',
          templateUrl: 'app/main/configs/problem-tickets/view.html',
					menu: true,
					permissions: ['extendedEventStats']
				},{
          name: 'export-db',
          url: '/export-db',
          title: 'Експорт бази',
          controller: 'ExportDbController as vm',
          templateUrl: 'app/main/configs/export-db/view.html',
          menu: true,
          permissions: ['export']
        }

      ]
		});
	}

})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.cashier',
			url: 'cashier',
      title: 'Модуль касира',
      template: '<div ui-view class="fade-in-down-big"></div>',
      abstract: true,
      menu: true,
      position: 80,
      access: 300,
      permissions: ['menuCashier'],
			params: {
					insertCashierParams: true
			},
      children: [
        {
          name: 'order',
          url: '/order',
          title: 'Створити замовлення',
          controller: 'OrderEditController as vm',
          templateUrl: 'app/main/order/order.edit.view.html',
          menu: true,
          access: 300,
          permissions: ['createOrder']
        },{
          name: 'search',
          url: '/search/:search',
          title: 'Пошук замовлення',
          controller: 'OrdermanagerController as vm',
          templateUrl: 'app/main/ordermanager/ordermanager.view.html',
          menu: true,
          access: 300,
          permissions: ['listOrders', 'updateOrder']
        },{
          name: 'statistics',
          url: '/statistics',
          title: 'Статистика',
          controller: 'CashierStatisticsController as vm',
          templateUrl: 'app/main/cashier/statistics/cashier.statistics.view.html',
          menu: true,
          access: 300,
          permissions: ['ordersStatistics']
        },{
          name: 'close',
          url: 'close',
          title: 'Завершення работи',
          template: 'Завершення работи',
          menu: false
        },{
          name: 'control',
          url: 'control',
          title: 'Контроль каси',
          template: 'Контроль каси',
          menu: false
        }
      ]
		});
	}

})();

(function () {
	'use strict';

	angular.module('tms').service('ApiService', ApiService);

	function ApiService($q, $log, Restangular, AuthService, PlayersService, WidgetService) {

    var self = this;

    var Api = Restangular.allUrl('api', 'assets/api.json');
    var url = WidgetService.getUrl();
    if (document.location.hostname === 'localhost') // eslint-disable-line
      url = "https://dev-hall.test-kasa.in.ua";

    var Widget = Restangular.withConfig(function(RestangularConfigurer) {
      RestangularConfigurer.setBaseUrl(url);
      RestangularConfigurer.setDefaultHttpFields({useXDomain: true});
      RestangularConfigurer.setDefaultHeaders({ });
      RestangularConfigurer.setDefaultRequestParams({access_token: AuthService.init().access_token});
    });

    // self.setToken(Widget.setDefaultRequestParams({access_token: AuthService.init().access_token});)

    Api.customGET().then(function(response) {
      $log.log(response.plain());
    });


    self.Players = function(){

    }

    self.run = function(){
      PlayersService.search().then(function(response){
        $log.log(response)
      });
    }

    self.setprice = function(access_token, data){
      Widget.setDefaultRequestParams({access_token: access_token});
      return Widget.one('scheme').post('set-prices?eventId='+data.eventID, data); ///scheme/set-prices/?eventId=1087
    }

    self.getquote = function(access_token, data){
      Widget.setDefaultRequestParams({access_token: access_token});
      return Widget.one('quota').post(data.quoteID+'', data);
    }

    self.gethalls = function(access_token){
      Widget.setDefaultRequestParams({access_token: access_token});
      return Widget.one('halls').get();
    }

    self.setorder = function(access_token, data){
      Widget.setDefaultRequestParams({access_token: access_token});
      return Widget.one('order').post(data.orderID+'', data);
    }
	}

})();

(function () {
	'use strict';

	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup(stateHelperProvider) {
		stateHelperProvider.state({
      name: 'main.api',
			url: 'api',
      title: 'API',
      template: '<div ui-view class="fade-in-down-big"></div>',
      menu: false,
      abstract: true,
      position: 100,
      access: 9990,
      permissions: ['menuAPI'],
      children: [
        {
          name: 'tests',
          url: '/tests',
          title: 'Tests',
          controller: 'ApiController as vm',
          templateUrl: 'app/main/api/tests.html',
          menu: true,
          access: 9990
        },{
          name: 'explorer',
          url: '/explorer',
          title: 'Explorer',
          controller: 'ApiController as vm',
          templateUrl: 'app/main/api/explorer.html',
          menu: true,
          access: 9990
        }
      ]
		});
	}

})();

(function () {
	'use strict';

	mocha.setup('bdd');

  var expect = chai.expect,   // eslint-disable-line
      should = chai.should(); // eslint-disable-line

  function MyError(message) {
    this.name = 'Error';
    this.message = message || 'Сообщение по умолчанию';
  }
  MyError.prototype = Object.create(Error.prototype);
  MyError.prototype.constructor = MyError;

	angular.module('tms').controller('ApiController', ApiController);

	function ApiController($log, Restangular, AuthService, ApiService, PlayersService, UsersService, EventsService, QuotesService, OrderService) {
		var vm = this;

		mocha.suite.suites = [];

		$log.log(ApiService, vm);

    var admin = AuthService.init();

    var playerID;
    var userID;
    var newUserID;
    var eventID;
    var quoteID;
    var orderID;
    var email = 'autotest' + Math.round(new Date().getTime()/1000);
    var access_token;

    vm.playerRoles = PlayersService.getRoles();

    // INIT --------------------------------------------------------------------

		describe('Init', function () {
      var P = PlayersService.search();
			it('Players search list is array', function (done) {
        P.should.eventually.be.an('array').notify(done);
			});
      it('Players search list length > 1', function (done) {
        P.should.eventually.to.have.length.of.at.least(1).notify(done);
			});
      it('Create player', function (done) {
        var player = {name: 'autotest', type: 'organizer'}; // system_client
        PlayersService.save(player).then(function(response){
          response.should.have.property('id');
          playerID = response.id;
          done();
        }).catch(function (err) {
          done(err);
        });
			});
      it('Create user', function (done) {
        var user = {email: email, password: 'test', name: 'autotest', companyID: playerID};
        UsersService.save(user).then(function(response){
          response.should.have.property('id');
          userID = response.id;
          done();
        }).catch(function (err) {
          done(err);
        });
			});
		});

    // ROLES -------------------------------------------------------------------

    var roles = UsersService.getRoles();

    _.each(roles, function(role, name){
      describe('Role '+ role, function () {

        this.timeout(5000); // eslint-disable-line

        it('Set role', function (done) {
          UsersService.save({id: userID, role: name}).should.eventually.be.fulfilled.notify(done);
        });
        it('Login', function (done) {
          access_token = null;
          Restangular.one('auth').post('signin', {username: email, password: 'test'}).then(function (response) {
            access_token = response.access_token;
            Restangular.setDefaultHeaders({ 'Authorization': 'Bearer ' + response.access_token });
            done();
          });
        })
        it('Get Events', function (done) {
          EventsService.events.list().should.eventually.be.fulfilled.notify(done);
        });
        it('Get Events Search', function (done) {
          EventsService.search().should.eventually.be.fulfilled.notify(done);
        });

        it('Create Event', function (done) {
          eventID = null;
          EventsService.events.save({name: 'autotest', areaFileID: 1}).then(function(response){
            response.should.have.property('id');
            eventID = response.id;
            done();
          }).catch(function (err) {
            done(new MyError(err.data.error_msg + '    ', '', ''));
          });
        });

        it('Widget: Get Halls', function (done) {
          ApiService.gethalls(access_token).should.eventually.be.fulfilled.notify(done);
        });
        it('Widget: Set Price', function (done) {
          var data = {
            eventID: eventID,
            zoneId: 1,
            setPrice: {price: 999, places: [89, 88, 87, 86, 85]}
          };
          if (!eventID)
            this.skip(); // eslint-disable-line
          else
            ApiService.setprice(access_token, data).should.eventually.be.fulfilled.notify(done);
        });
        it('Create quote', function(done){
          quoteID = null;
          if (!eventID)
            this.skip(); // eslint-disable-line
          else
            QuotesService.save({
              name: 'autotest',
              eventID: eventID,
              organizerID: playerID,
              partnerID: playerID
            }).then(function(response){
              response.should.have.property('id');
              quoteID = response.id;
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });
        it('Widget: Set quote && get saved data', function (done) {
          var data = {
            quoteID: quoteID,
            id: 1,
            places: [86, 85]
          };
          if (!quoteID)
            this.skip(); // eslint-disable-line
          else
            ApiService.getquote(access_token, data).then(function(response){
              response.should.have.deep.property('checkedPlacesCount').and.equal('2');
              response.should.have.deep.property('checkedPlacesCost').and.equal('1998'); //999x2
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });

        it('Create order', function (done) {
          orderID = null;
          if (!eventID)
            this.skip(); // eslint-disable-line
          else
            OrderService.create({eventID: eventID}).then(function(response){
              response.should.have.property('id');
              orderID = response.id;
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });

        it('Widget: Set order', function (done) {
          var data = {
            orderID: orderID,
            id: 1,
            places: [86, 85]
          };
          if (!orderID)
            this.skip(); // eslint-disable-line
          else
            ApiService.setorder(access_token, data).then(function(response){
              response.should.have.deep.property('soldPlacesCount').and.equal('2');
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });

        it('Get tickets', function (done) {
          if (!orderID)
            this.skip(); // eslint-disable-line
          else
            OrderService.getTickets({orderID: orderID}).then(function(response){
              response.should.have.property('count').and.equal('2');
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });

        it('Delete Event', function (done) {
          if (!eventID)
            this.skip(); // eslint-disable-line
          else
            EventsService.events.delete(eventID).then(function(){
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
            });
        });


        it('Create user', function (done) {
          newUserID = null;
          var user = {email: email + playerID + _.uniqueId(), password: 'test', name: 'autotest', companyID: playerID};
          UsersService.save(user).then(function(response){
            response.should.have.property('id');
            newUserID = response.id;
            done();
          }).catch(function (err) {
            done(new MyError(err.data.error_msg || 'Error!' + '    ', '', ''));
          });
        });
        it('Delete user', function (done) {
          if (!newUserID)
            this.skip(); // eslint-disable-line
          else (newUserID)
            UsersService.delete(newUserID).then(function(){
              done();
            }).catch(function (err) {
              done(new MyError(err.data.error_msg + '    ', '', ''));
            });
        });

        it('Out', function (done) {
          Restangular.setDefaultHeaders({ 'Authorization': 'Bearer ' + admin.access_token });
          done();
        });
      });
    });

    // CLEAR -------------------------------------------------------------------

    describe('Clear', function () {
      it('Delete user', function (done) {
        UsersService.delete(userID).should.eventually.be.fulfilled.notify(done);
      });
      it('Delete player', function (done) {
        PlayersService.delete(playerID).should.eventually.be.fulfilled.notify(done);
      });
    });

    // RUN ---------------------------------------------------------------------

    vm.run = function(){
      mocha.run();
    }
	}

})();

(function (angular) {
  'use strict';

  angular.module('tms').service('ModalService', service);

  service.$inject = ['$uibModal'];

  function service($uibModal) {

    this.show = function (templateUrl, controller, prams) {
      return $uibModal.open({
        templateUrl: templateUrl,
        resolve: {
          modalParams: function () {
            return prams
          }
        },
        controller: controller
      }).result
    };

    /**
     * Show alert dialog
     * @param message
     * @param title
     */
    this.alert = function (message, title) {
      return this.show('app/components/templates/modal/alert-modal.html',
        function ($scope, modalParams, $uibModalInstance) {
          $scope.model = modalParams;
          $scope.ok = $uibModalInstance.close.bind($uibModalInstance);
        },
        {message: message, title: title});
    };

    /**
     * Show confirmation dialog
     * @param message
     * @param title
     */
    this.confirm = function (message, title) {
      return this.show('app/components/templates/modal/confirm-modal.html',
        function ($scope, modalParams, $uibModalInstance) {
          $scope.model = modalParams;
          $scope.ok = $uibModalInstance.close.bind($uibModalInstance);
          $scope.cancel = $uibModalInstance.dismiss.bind($uibModalInstance);
        },
        {message: message, title: title});
    };
  }
})(angular);

(function (angular) {
  'use strict';

  angular.module('tms').service('concatIdsAndNamesService', concatIdsAndNamesService);

  function concatIdsAndNamesService() {
    return function(data) {
      return data.map(function (item) {
        return {id: item.id, name: '#' + item.id + ' - ' + item.name};
      });
    }
  }
})(angular);

(function () {
	'use strict';

	angular.module('tms').directive('uiSrefIf', function ($compile, $interpolate) {
		return {
			scope: {
				val: '@uiSrefVal',
				if: '=uiSrefIf'
			},
			link: function ($scope, $element) {
				$element.removeAttr('ui-sref-if');
				$interpolate($element)($scope);

				$scope.$watch('if', function (bool) {
					if (bool) {
						$element.attr('ui-sref', $scope.val);
					} else {
						$element.removeAttr('ui-sref');
						$element.removeAttr('href');
					}
					$interpolate($element)($scope);
				});
			}
		}
	});

})();

(function () {
  'use strict';

  angular.module('tms').directive('stringToNumber', function () {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(value) {
          return '' + value;
        });
        ngModel.$formatters.push(function(value) {
          return parseFloat(value);
        });
      }
    };
  });

})();

(function () {
	'use strict';

	angular.module('tms').directive('showErrors', function () {
		"ngInject";
		return {
			restrict: 'A',
			require: '^form',
			link: function (scope, el, attrs, formCtrl) {
				var inputEl = el[0].querySelector("[name]"),
            inputNgEl = angular.element(inputEl),
            inputName = inputNgEl.attr('name');
				inputNgEl.bind('blur', function () {
					el.toggleClass('has-error', formCtrl[inputName].$invalid);
				});
				scope.$on('show-errors-check-validity', function () {
					el.toggleClass('has-error', formCtrl[inputName].$invalid);
				});
			}
		}
	});

  angular.module('tms').directive('showDdErrors', function ($parse) {
		"ngInject";
		return {
			restrict: 'A',
			link: function ($scope, el, attrs) {
        var inValid = function(val){

          if(_.isArray(val)) {
            return !val.length
          }

          return !(val && val !== '');
        }

        el.bind('click', function () {
          $scope.$watch(attrs.showDdErrors, function(value){
            el.toggleClass('has-error', inValid(value));
          });
				});

        $scope.$on('show-errors-check-validity', function () {
					el.toggleClass('has-error', inValid($parse(attrs.showDdErrors)($scope)));
				});
			}
		}
	});


})();

(function () {
	'use strict';

	angular.module('tms').directive('stateful', function () {
		"ngInject";
		return {
			restrict: 'A',
			link: function ($scope, el) {
        $scope.$watch('vm.loading', function(newVal) {
          var $el = angular.element(el);
          if (newVal)
            $el.addClass('disabled').prepend('<i class="loading glyphicon glyphicon-refresh"></i>');
          else
            $el.removeClass('disabled').find('i.loading').remove();
          // angular.element(el).attr('disabled', newVal);
        });
			}
		}
	});

})();

(function () {
	'use strict';

	angular.module('tms').directive('limitLength', function () {
		return {
      restrict: "A",
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {

        attrs.$set("ngTrim", "false");

        var limitLength = parseInt(attrs.limitLength, 10);

        scope.$watch(attrs.ngModel, function() {
          if (ngModel.$viewValue && ngModel.$viewValue.length > limitLength) {
            ngModel.$setViewValue(ngModel.$viewValue.substring(0, limitLength));
            // caused cursor to jump to the end of line, when limit has been hit
            // ngModel.$render();
          }
        });
      }
		}
	});
})();

(function () {
	'use strict';

	angular.module('tms').directive('keyEnter', function () {
		return {
			restrict: 'A',
			link: function ($scope, el, attrs) {
        angular.element('body').unbind("keydown keypress");
				angular.element('body').bind("keydown keypress", function (event) {
					if (event.which === 13) {
            if (!angular.element('button[type="submit"]').attr('disabled'))
						$scope.$apply(function () {
							$scope.$eval(attrs.keyEnter);
						});
						event.preventDefault();
					}
				});
			}
		};
	});

})();

(function() {
  'use strict';

  /*eslint angular/di: [2,"array"]*/

  angular.module('tms').directive('datetimepicker', [
    '$timeout',
    function($timeout) {
      return {
        restrict: 'EA',
        require: 'ngModel',
        scope: {
          options: '=?',
          min: '=?',
          max: '=?',
          onChange: '&?',
          onClick: '&?',
          onBlur: '&?'
        },
        link: function($scope, $element, $attrs, ngModel) {

          $scope.$watch('options', function(newValue) {
            var dtp = $element.data('DateTimePicker');
            $.map(newValue, function(value, key) {
              dtp[key](value);
            });
          });

          $scope.$watch('min', function(newValue) {
            var dtp = $element.data('DateTimePicker');

            if (newValue && moment(newValue).isValid()) {
              dtp['minDate'](moment(newValue));
            } else if(newValue) {
              dtp['minDate'](newValue);
            }
          });

          $scope.$watch('max', function(newValue) {
            var dtp = $element.data('DateTimePicker');

            if (newValue && moment(newValue).isValid()) {
              dtp['maxDate'](moment(newValue));
            } else if(newValue) {
              dtp['maxDate'](newValue);
            }
          });

          ngModel.$render = function() {
            $element.data('DateTimePicker').date(ngModel.$viewValue);
          };

          $element.on('dp.change', function(e) {
            $timeout(function() {
              $scope.$apply(function() {
                ngModel.$setViewValue(e.date);
              });
              if (angular.isFunction($scope.onChange)) {
                $scope.onChange();
              }
            });
          });

          $element.on('click', function() {
            $timeout(function() {
              if (angular.isFunction($scope.onClick)) {
                $scope.onClick();
              }
            });
          });

          $element.on('dp.hide', function() {
            $timeout(function() {
              if (angular.isFunction($scope.onBlur)) {
                $scope.onBlur();
              }
            });
          });

          $element.datetimepicker($scope.options);
          $timeout(function() {
            if (angular.isDefined(ngModel.$viewValue) && ngModel.$viewValue !== null) {
              if ((ngModel.$viewValue instanceof moment)) {
                ngModel.$setViewValue(moment($scope.date));
              }
              $element.data('DateTimePicker').date(ngModel.$viewValue);
            }
          });
        }
      };
    }
  ]);
})();

/**
 * Checklist-model
 * AngularJS directive for list of checkboxes
 * https://github.com/vitalets/checklist-model
 * License: MIT http://opensource.org/licenses/MIT
 */

  /*eslint angular/di: [2,"array"]*/

angular.module('tms').directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
  // contains
  function contains(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          return true;
        }
      }
    }
    return false;
  }

  // add
  function add(arr, item, comparator) {
    arr = angular.isArray(arr) ? arr : [];
      if(!contains(arr, item, comparator)) {
          arr.push(item);
      }
    return arr;
  }

  // remove
  function remove(arr, item, comparator) {
    if (angular.isArray(arr)) {
      for (var i = arr.length; i--;) {
        if (comparator(arr[i], item)) {
          arr.splice(i, 1);
          break;
        }
      }
    }
    return arr;
  }

  // http://stackoverflow.com/a/19228302/1458162
  function postLinkFn(scope, elem, attrs) {
     // exclude recursion, but still keep the model
    var checklistModel = attrs.checklistModel;
    attrs.$set("checklistModel", null);
    // compile with `ng-model` pointing to `checked`
    $compile(elem)(scope);
    attrs.$set("checklistModel", checklistModel);

    // getter for original model
    var checklistModelGetter = $parse(checklistModel);
    var checklistChange = $parse(attrs.checklistChange);
    var checklistBeforeChange = $parse(attrs.checklistBeforeChange);
    var ngModelGetter = $parse(attrs.ngModel);



    var comparator = angular.equals;

    if (attrs.hasOwnProperty('checklistComparator')){
      if (attrs.checklistComparator[0] == '.') {
        var comparatorExpression = attrs.checklistComparator.substring(1);
        comparator = function (a, b) {
          return a[comparatorExpression] === b[comparatorExpression];
        };

      } else {
        comparator = $parse(attrs.checklistComparator)(scope.$parent);
      }
    }

    // watch UI checked change
    scope.$watch(attrs.ngModel, function(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator));
        return;
      }

      setValueInChecklistModel(getChecklistValue(), newValue);

      if (checklistChange) {
        checklistChange(scope);
      }
    });

    // watches for value change of checklistValue (Credit to @blingerson)
    scope.$watch(getChecklistValue, function(newValue, oldValue) {
      if( newValue != oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true ) {
        var current = checklistModelGetter(scope.$parent);
        checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator));
        checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator));
      }
    });

    function getChecklistValue() {
      return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
    }

    function setValueInChecklistModel(value, checked) {
      var current = checklistModelGetter(scope.$parent);
      if (angular.isFunction(checklistModelGetter.assign)) {
        if (checked === true) {
          checklistModelGetter.assign(scope.$parent, add(current, value, comparator));
        } else {
          checklistModelGetter.assign(scope.$parent, remove(current, value, comparator));
        }
      }

    }

    // declare one function to be used for both $watch functions
    function setChecked(newArr) {
      if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
        setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope));
        return;
      }
      ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator));
    }

    // watch original model change
    // use the faster $watchCollection method if it's available
    if (angular.isFunction(scope.$parent.$watchCollection)) {
        scope.$parent.$watchCollection(checklistModel, setChecked);
    } else {
        scope.$parent.$watch(checklistModel, setChecked, true);
    }
  }

  return {
    restrict: 'A',
    priority: 1000,
    terminal: true,
    scope: true,
    compile: function(tElement, tAttrs) {

      if (!tAttrs.checklistValue && !tAttrs.value) {
        throw 'You should provide `value` or `checklist-value`.';
      }

      // by default ngModel is 'checked', so we set it if not specified
      if (!tAttrs.ngModel) {
        // local scope var storing individual checkbox model
        tAttrs.$set("ngModel", "checked");
      }

      return postLinkFn;
    }
  };
}]);

(function () {
	'use strict';

	angular.module('tms').directive('access', function ($log, AuthService) {
    return {
      restrict: 'A',
      link: function($scope, el, attrs){
        if (attrs.access !== '' && !AuthService.access([attrs.access]))
          el.addClass('hidden');
      }
    };
	});

  angular.module('tms').directive('accessdisable', function ($log, AuthService) {
    return {
      restrict: 'A',
      link: function($scope, el, attrs){
        if (!AuthService.access([attrs.accessdisable]))
          el.addClass('disabled').attr('disabled', 'disabled');
      }
    };
	});

})();

(function () {
    'use strict';

    angular.module('tms').constant('constants', {
        responsibleTypes: {
            user: 'user',
            subdivision: 'subdivision'
        }
    });

})();

(function () {
	'use strict';

	angular.module('tms').constant('ckEditorOptions', {
    allowedContent: true,
    fontSize_sizes : '8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;21/21px;22/22px;24/24px;26/26px;28/28px;36/36px;38/38px;42/42px;46/46px;',
    font_names: 'Arial; Comic San MS; Courier New; Georgia; Lucida Sans Unicode; Tahoma; Times New Roman; Trebuchet MS; Veranda; PF Din Text Cond Pro; HelveticaNeueCyr Roman;',
    contentsCss : '/assets/styles/fonts.css'
  });
 
})();

(function () {
	'use strict';

	angular.module('tms').constant('calendarOptions', {
    locale: 'uk',
    format: 'DD.MM.YYYY'
  });

})();

(function () {
  'use strict';
  angular.module('tms').config(runRoutingSetup);

  function runRoutingSetup($stateProvider) {
    $stateProvider
      .state('print', {
        url: '/print/tickets/:tickets/:access_token/:quotaID/:route',
        title: 'Друк квиткiв',
        controller: 'PrintController as vm',
        templateUrl: 'app/print/print.view.html',
        permissions: ['user'],
        resolve: {
          printType: function () {
            return 'tickets';
          }
        }
      })
      .state('print-quote', {
        url: '/print/quote/:quote/:limit/:access_token',
        title: 'Друк квиткiв',
        controller: 'PrintController as vm',
        templateUrl: 'app/print/print.view.html',
        permissions: ['user'],
        resolve: {
          printType: function () {
            return 'quote';
          }
        }
      });
  }
})();

(function () {
  'use strict';

  angular.module('tms').controller('PrintController', PrintController);

  function PrintController($state, $window, $scope, $stateParams, $timeout, AuthService, Restangular, printType, QuotesService) {

    var vm = this;

    vm.userData = AuthService.init();
    vm.type = (vm.userData) ? vm.userData.printBlankType : 'e_blank';
    vm.ticketsRotationAngle = (vm.userData) ? parseInt(vm.userData.ticketsRotationAngle) : null;
    vm.tickets = [];
    vm.currentDate = new Date();

    if (vm.type === 'standard')
      vm.type = 'a4';

    if (printType === 'tickets' && !$stateParams.tickets)
      return;

    var query = {
      ids: $stateParams.tickets ? $stateParams.tickets.split(',') : [],
      access_token: $stateParams.access_token || null,
      route: $stateParams.route || null
    };

    if ($stateParams.quotaID)
      query.quotaID = $stateParams.quotaID;

    if ($stateParams.quote)
      query.quotaID = $stateParams.quote;

    var url = 'print';
    if ($stateParams.access_token)
      url = url + '?access_token=' + query.access_token;

    printType === 'tickets' ? printTickets() : printQuote();

    var broadcast = function () {};

    $scope.$on('domRendered', function () {
      if (window.callPhantom) { // eslint-disable-line
        window.callPhantom(); // eslint-disable-line
      } else {
        $timeout(function () {
          $window.print();
          $window.close();
        })
      }
    })

    $scope.$on("$destroy", function() {
      if (broadcast) {
        clearTimeout(broadcast);
      }
      document.removeEventListener("DOMSubtreeModified", broadcastDomRendered); // eslint-disable-line
    });


    function printQuote() {
      QuotesService.print($stateParams.quote, $stateParams.limit)
        .then(function (response) {
          vm.tickets = setDefaultTemplateID(response);
          prepare();
        })
        .catch(function () {
          if (window.callPhantom) window.callPhantom(1); // eslint-disable-line
        });
    }

    function setDefaultTemplateID(response) {
      return _.each(response, function (t) {
        if (!t.printTemplateID) {
          t.printTemplateID = 1;
        }
      });
    }

    function printTickets() {
      Restangular.one('tickets').post(url, query)
        .then(function (response) {
          vm.tickets = setDefaultTemplateID(response);
          prepare();
        })
        .catch(function () {
          if (window.callPhantom) window.callPhantom(1); // eslint-disable-line
        });
    }

    function prepare() {
      $timeout(function () {
        _.each(vm.tickets, function (t) {
          t.startdate = (t.startTime) ? moment(t.startTime, 'DD.MM.YYYY HH:mm').toDate() : null;
          t.enddate = (t.endTime) ? moment(t.endTime, 'DD.MM.YYYY HH:mm').toDate() : null;
          t.entrydate = (t.entryTime) ? moment(t.entryTime, 'DD.MM.YYYY HH:mm').toDate() : null;
          t.endExpiryTime = (t.endExpiryTime) ? moment(t.endExpiryTime, 'DD.MM.YYYY HH:mm').toDate() : null;
          t.dateSold = (t.dateSold) ? moment(t.dateSold, 'DD.MM.YYYY HH:mm').toDate() : null;

          angular.element('.' + t.barcode).show().barcode(t.barcode, t.barcodeType, {
            posX: -10,
            barWidth: 2,
            barHeight: 30,
            output: "svg"
          })
        });
      })

      var broadcastDomRendered = function () {
         clearTimeout(broadcast)
         broadcast = $window.setTimeout(function () {
           $scope.$broadcast('domRendered')
         }, 750)
       }

      // fix for barcode show for last ticket
      document.addEventListener("DOMSubtreeModified", broadcastDomRendered); // eslint-disable-line
    }
  }

})();

(function () {
	'use strict';
	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup($stateProvider) {
		$stateProvider.state('main', {
			url: '/',
      title: '',
      controller: 'MainController as vm',
      templateUrl: 'app/main/main.view.html',
      redirectTo: 'main.events',
      resolve: {
        auth: function($q, $log, $state, $timeout, $rootScope, AuthService) {
          if (AuthService.init()) {
            var nav = AuthService.nav();
            if (!_.find(nav, {name: $state.next.name})) {
              $timeout(function() {
                $state.go('403');
              });
              return $q.reject();
            }
            $rootScope.$on("$stateChangeStart", function (event, next) { // eslint-disable-line
              nav = AuthService.nav();
              if ((next.name.indexOf('main.') > -1) && !_.find(nav, {name: next.name})) {
                event.preventDefault();
                $state.go('login');
                return;
              }
            });
            return $q.when();
            //return AuthService.refreshToken();
          }
          // console.log(123)
          $timeout(function() {
            $state.go('login');
          });
          return $q.reject();
        }
      }
		});
	}
})();

(function () {
	'use strict';

	angular.module('tms').controller('MainController', MainController);

	function MainController($log, $state, $scope, AuthService) {
		var vm = this;

    vm.navCollapsed = true;
		vm.userData = AuthService.init();
		vm.menuContent = _.filter(AuthService.nav(), {menu: true});

    var temp = {
      "dev-tms.test-kasa.in.ua": "https://test-kasa.in.ua",
      "tms.net.ua": "https://kasa.in.ua"
    };

    vm.kasalink = temp[document.location.hostname] || 'https://test-kasa.in.ua'; // eslint-disable-line

		vm.logout = function () {
			AuthService.logout();
			$state.go('login');
		}

    vm.navCollapse = function () {
      vm.navCollapsed = false;
    }
	}

})();

/*!
 *  BarCode Coder Library (BCC Library)
 *  BCCL Version 2.0
 *
 *  Porting : jQuery barcode plugin
 *  Version : 2.0.3
 *
 *  Date    : 2013-01-06
 *  Author  : DEMONTE Jean-Baptiste <jbdemonte@gmail.com>
 *            HOUREZ Jonathan
 *
 *  Web site: http://barcode-coder.com/
 *  dual licence :  http://www.cecill.info/licences/Licence_CeCILL_V2-fr.html
 *                  http://www.gnu.org/licenses/gpl.html
 */

 /* eslint-disable */

(function ($) {

  var barcode = {
    settings:{
      barWidth: 1,
      barHeight: 50,
      moduleSize: 5,
      showHRI: false,
      addQuietZone: true,
      marginHRI: 5,
      bgColor: "#FFFFFF",
      color: "#000000",
      fontSize: 10,
      output: "css",
      posX: 0,
      posY: 0
    },
    intval: function(val){
      var type = typeof( val );
      if (type == 'string'){
        val = val.replace(/[^0-9-.]/g, "");
        val = parseInt(val * 1, 10);
        return isNaN(val) || !isFinite(val) ? 0 : val;
      }
      return type == 'number' && isFinite(val) ? Math.floor(val) : 0;
    },
    i25: { // std25 int25
      encoding: ["NNWWN", "WNNNW", "NWNNW", "WWNNN", "NNWNW", "WNWNN", "NWWNN", "NNNWW", "WNNWN","NWNWN"],
      compute: function(code, crc, type){
        if (! crc) {
          if (code.length % 2 != 0) code = '0' + code;
        } else {
          if ( (type == "int25") && (code.length % 2 == 0) ) code = '0' + code;
          var odd = true, v, sum = 0;
          for(var i=code.length-1; i>-1; i--){
            v = barcode.intval(code.charAt(i));
            if (isNaN(v)) return("");
            sum += odd ? 3 * v : v;
            odd = ! odd;
          }
          code += ((10 - sum % 10) % 10).toString();
        }
        return(code);
      },
      getDigit: function(code, crc, type){
        code = this.compute(code, crc, type);
        if (code == "") return("");
        result = "";

        var i, j;
        if (type == "int25") {
          // Interleaved 2 of 5

          // start
          result += "1010";

          // digits + CRC
          var c1, c2;
          for(i=0; i<code.length / 2; i++){
            c1 = code.charAt(2*i);
            c2 = code.charAt(2*i+1);
            for(j=0; j<5; j++){
              result += '1';
              if (this.encoding[c1].charAt(j) == 'W') result += '1';
              result += '0';
              if (this.encoding[c2].charAt(j) == 'W') result += '0';
            }
          }
          // stop
          result += "1101";
        } else if (type == "std25") {
          // Standard 2 of 5 is a numeric-only barcode that has been in use a long time.
          // Unlike Interleaved 2 of 5, all of the information is encoded in the bars; the spaces are fixed width and are used only to separate the bars.
          // The code is self-checking and does not include a checksum.

          // start
          result += "11011010";

          // digits + CRC
          var c;
          for(i=0; i<code.length; i++){
            c = code.charAt(i);
            for(j=0; j<5; j++){
              result += '1';
              if (this.encoding[c].charAt(j) == 'W') result += "11";
              result += '0';
            }
          }
          // stop
          result += "11010110";
        }
        return(result);
      }
    },
    ean: {
      encoding: [ ["0001101", "0100111", "1110010"],
                  ["0011001", "0110011", "1100110"],
                  ["0010011", "0011011", "1101100"],
                  ["0111101", "0100001", "1000010"],
                  ["0100011", "0011101", "1011100"],
                  ["0110001", "0111001", "1001110"],
                  ["0101111", "0000101", "1010000"],
                  ["0111011", "0010001", "1000100"],
                  ["0110111", "0001001", "1001000"],
                  ["0001011", "0010111", "1110100"] ],
      first:  ["000000","001011","001101","001110","010011","011001","011100","010101","010110","011010"],
      getDigit: function(code, type){
        // Check len (12 for ean13, 7 for ean8)
        var len = type == "ean8" ? 7 : 12;
        code = code.substring(0, len);
        if (code.length != len) return("");
        // Check each digit is numeric
        var c;
        for(var i=0; i<code.length; i++){
          c = code.charAt(i);
          if ( (c < '0') || (c > '9') ) return("");
        }
        // get checksum
        code = this.compute(code, type);

        // process analyse
        var result = "101"; // start

        if (type == "ean8"){

          // process left part
          for(var i=0; i<4; i++){
            result += this.encoding[barcode.intval(code.charAt(i))][0];
          }

          // center guard bars
          result += "01010";

          // process right part
          for(var i=4; i<8; i++){
            result += this.encoding[barcode.intval(code.charAt(i))][2];
          }

        } else { // ean13
          // extract first digit and get sequence
          var seq = this.first[ barcode.intval(code.charAt(0)) ];

          // process left part
          for(var i=1; i<7; i++){
            result += this.encoding[barcode.intval(code.charAt(i))][ barcode.intval(seq.charAt(i-1)) ];
          }

          // center guard bars
          result += "01010";

          // process right part
          for(var i=7; i<13; i++){
            result += this.encoding[barcode.intval(code.charAt(i))][ 2 ];
          }
        } // ean13

        result += "101"; // stop
        return(result);
      },
      compute: function (code, type){
        var len = type == "ean13" ? 12 : 7;
        code = code.substring(0, len);
        var sum = 0, odd = true;
        for(i=code.length-1; i>-1; i--){
          sum += (odd ? 3 : 1) * barcode.intval(code.charAt(i));
          odd = ! odd;
        }
        return(code + ((10 - sum % 10) % 10).toString());
      }
    },
    upc: {
      getDigit: function(code){
        if (code.length < 12) {
          code = '0' + code;
        }
        return barcode.ean.getDigit(code, 'ean13');
      },
      compute: function (code){
        if (code.length < 12) {
          code = '0' + code;
        }
        return barcode.ean.compute(code, 'ean13').substr(1);
      }
    },
    msi: {
      encoding:["100100100100", "100100100110", "100100110100", "100100110110",
                "100110100100", "100110100110", "100110110100", "100110110110",
                "110100100100", "110100100110"],
      compute: function(code, crc){
        if (typeof(crc) == "object"){
          if (crc.crc1 == "mod10"){
            code = this.computeMod10(code);
          } else if (crc.crc1 == "mod11"){
            code = this.computeMod11(code);
          }
          if (crc.crc2 == "mod10"){
            code = this.computeMod10(code);
          } else if (crc.crc2 == "mod11"){
            code = this.computeMod11(code);
          }
        } else if (typeof(crc) == "boolean"){
          if (crc) code = this.computeMod10(code);
        }
        return(code);
      },
      computeMod10:function(code){
        var i,
        toPart1 = code.length % 2;
        var n1 = 0, sum = 0;
        for(i=0; i<code.length; i++){
          if (toPart1) {
            n1 = 10 * n1 + barcode.intval(code.charAt(i));
          } else {
            sum += barcode.intval(code.charAt(i));
          }
          toPart1 = ! toPart1;
        }
        var s1 = (2 * n1).toString();
        for(i=0; i<s1.length; i++){
          sum += barcode.intval(s1.charAt(i));
        }
        return(code + ((10 - sum % 10) % 10).toString());
      },
      computeMod11:function(code){
        var sum = 0, weight = 2;
        for(var i=code.length-1; i>=0; i--){
          sum += weight * barcode.intval(code.charAt(i));
          weight = weight == 7 ? 2 : weight + 1;
        }
        return(code + ((11 - sum % 11) % 11).toString());
      },
      getDigit: function(code, crc){
        var table = "0123456789";
        var index = 0;
        var result = "";

        code = this.compute(code, false);

        // start
        result = "110";

        // digits
        for(i=0; i<code.length; i++){
          index = table.indexOf( code.charAt(i) );
          if (index < 0) return("");
          result += this.encoding[ index ];
        }

        // stop
        result += "1001";

        return(result);
      }
    },
    code11: {
      encoding:[  "101011", "1101011", "1001011", "1100101",
                  "1011011", "1101101", "1001101", "1010011",
                  "1101001", "110101", "101101"],
      getDigit: function(code){
        var table = "0123456789-";
        var i, index, result = "", intercharacter = '0'

        // start
        result = "1011001" + intercharacter;

        // digits
        for(i=0; i<code.length; i++){
          index = table.indexOf( code.charAt(i) );
          if (index < 0) return("");
          result += this.encoding[ index ] + intercharacter;
        }

        // checksum
        var weightC    = 0,
        weightSumC = 0,
        weightK    = 1, // start at 1 because the right-most character is "C" checksum
        weightSumK   = 0;
        for(i=code.length-1; i>=0; i--){
          weightC = weightC == 10 ? 1 : weightC + 1;
          weightK = weightK == 10 ? 1 : weightK + 1;

          index = table.indexOf( code.charAt(i) );

          weightSumC += weightC * index;
          weightSumK += weightK * index;
        }

        var c = weightSumC % 11;
        weightSumK += c;
        var k = weightSumK % 11;

        result += this.encoding[c] + intercharacter;

        if (code.length >= 10){
          result += this.encoding[k] + intercharacter;
        }

        // stop
        result  += "1011001";

        return(result);
      }
    },
    code39: {
      encoding:["101001101101", "110100101011", "101100101011", "110110010101",
                "101001101011", "110100110101", "101100110101", "101001011011",
                "110100101101", "101100101101", "110101001011", "101101001011",
                "110110100101", "101011001011", "110101100101", "101101100101",
                "101010011011", "110101001101", "101101001101", "101011001101",
                "110101010011", "101101010011", "110110101001", "101011010011",
                "110101101001", "101101101001", "101010110011", "110101011001",
                "101101011001", "101011011001", "110010101011", "100110101011",
                "110011010101", "100101101011", "110010110101", "100110110101",
                "100101011011", "110010101101", "100110101101", "100100100101",
                "100100101001", "100101001001", "101001001001", "100101101101"],
      getDigit: function(code){
        var table = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%*";
        var i, index, result="", intercharacter='0';

        if (code.indexOf('*') >= 0) return("");

        // Add Start and Stop charactere : *
        code = ("*" + code + "*").toUpperCase();

        for(i=0; i<code.length; i++){
          index = table.indexOf( code.charAt(i) );
          if (index < 0) return("");
          if (i > 0) result += intercharacter;
          result += this.encoding[ index ];
        }
        return(result);
      }
    },
    code93:{
      encoding:["100010100", "101001000", "101000100", "101000010",
                "100101000", "100100100", "100100010", "101010000",
                "100010010", "100001010", "110101000", "110100100",
                "110100010", "110010100", "110010010", "110001010",
                "101101000", "101100100", "101100010", "100110100",
                "100011010", "101011000", "101001100", "101000110",
                "100101100", "100010110", "110110100", "110110010",
                "110101100", "110100110", "110010110", "110011010",
                "101101100", "101100110", "100110110", "100111010",
                "100101110", "111010100", "111010010", "111001010",
                "101101110", "101110110", "110101110", "100100110",
                "111011010", "111010110", "100110010", "101011110"],
      getDigit: function(code, crc){
        var table = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%____*", // _ => ($), (%), (/) et (+)
        c, result = "";

        if (code.indexOf('*') >= 0) return("");

        code = code.toUpperCase();

        // start :  *
        result  += this.encoding[47];

        // digits
        for(i=0; i<code.length; i++){
          c = code.charAt(i);
          index = table.indexOf( c );
          if ( (c == '_') || (index < 0) ) return("");
          result += this.encoding[ index ];
        }

        // checksum
        if (crc){
          var weightC    = 0,
          weightSumC = 0,
          weightK    = 1, // start at 1 because the right-most character is "C" checksum
          weightSumK   = 0;
          for(i=code.length-1; i>=0; i--){
            weightC = weightC == 20 ? 1 : weightC + 1;
            weightK = weightK == 15 ? 1 : weightK + 1;

            index = table.indexOf( code.charAt(i) );

            weightSumC += weightC * index;
            weightSumK += weightK * index;
          }

          var c = weightSumC % 47;
          weightSumK += c;
          var k = weightSumK % 47;

          result += this.encoding[c];
          result += this.encoding[k];
        }

        // stop : *
        result  += this.encoding[47];

        // Terminaison bar
        result  += '1';
        return(result);
      }
    },
    code128: {
      encoding:["11011001100", "11001101100", "11001100110", "10010011000",
                "10010001100", "10001001100", "10011001000", "10011000100",
                "10001100100", "11001001000", "11001000100", "11000100100",
                "10110011100", "10011011100", "10011001110", "10111001100",
                "10011101100", "10011100110", "11001110010", "11001011100",
                "11001001110", "11011100100", "11001110100", "11101101110",
                "11101001100", "11100101100", "11100100110", "11101100100",
                "11100110100", "11100110010", "11011011000", "11011000110",
                "11000110110", "10100011000", "10001011000", "10001000110",
                "10110001000", "10001101000", "10001100010", "11010001000",
                "11000101000", "11000100010", "10110111000", "10110001110",
                "10001101110", "10111011000", "10111000110", "10001110110",
                "11101110110", "11010001110", "11000101110", "11011101000",
                "11011100010", "11011101110", "11101011000", "11101000110",
                "11100010110", "11101101000", "11101100010", "11100011010",
                "11101111010", "11001000010", "11110001010", "10100110000",
                "10100001100", "10010110000", "10010000110", "10000101100",
                "10000100110", "10110010000", "10110000100", "10011010000",
                "10011000010", "10000110100", "10000110010", "11000010010",
                "11001010000", "11110111010", "11000010100", "10001111010",
                "10100111100", "10010111100", "10010011110", "10111100100",
                "10011110100", "10011110010", "11110100100", "11110010100",
                "11110010010", "11011011110", "11011110110", "11110110110",
                "10101111000", "10100011110", "10001011110", "10111101000",
                "10111100010", "11110101000", "11110100010", "10111011110",
                "10111101110", "11101011110", "11110101110", "11010000100",
                "11010010000", "11010011100", "11000111010"],
      getDigit: function(code){
        var tableB = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";
        var result = "";
        var sum = 0;
        var isum = 0;
        var i = 0;
        var j = 0;
        var value = 0;

        // check each characters
        for(i=0; i<code.length; i++){
          if (tableB.indexOf(code.charAt(i)) == -1) return("");
        }

        // check firsts characters : start with C table only if enought numeric
        var tableCActivated = code.length > 1;
        var c = '';
        for(i=0; i<3 && i<code.length; i++){
        c = code.charAt(i);
          tableCActivated &= c >= '0' && c <= '9';
        }

        sum = tableCActivated ? 105 : 104;

        // start : [105] : C table or [104] : B table
        result = this.encoding[ sum ];

        i = 0;
        while( i < code.length ){
          if (! tableCActivated){
            j = 0;
            // check next character to activate C table if interresting
            while ( (i + j < code.length) && (code.charAt(i+j) >= '0') && (code.charAt(i+j) <= '9') ) j++;

            // 6 min everywhere or 4 mini at the end
            tableCActivated = (j > 5) || ((i + j - 1 == code.length) && (j > 3));

            if ( tableCActivated ){
            result += this.encoding[ 99 ]; // C table
            sum += ++isum * 99;
            }
            //         2 min for table C so need table B
          } else if ( (i == code.length) || (code.charAt(i) < '0') || (code.charAt(i) > '9') || (code.charAt(i+1) < '0') || (code.charAt(i+1) > '9') ) {
            tableCActivated = false;
            result += this.encoding[ 100 ]; // B table
            sum += ++isum * 100;
          }

          if ( tableCActivated ) {
            value = barcode.intval(code.charAt(i) + code.charAt(i+1)); // Add two characters (numeric)
            i += 2;
          } else {
            value = tableB.indexOf( code.charAt(i) ); // Add one character
            i += 1;
          }
          result  += this.encoding[ value ];
          sum += ++isum * value;
        }

        // Add CRC
        result  += this.encoding[ sum % 103 ];

        // Stop
        result += this.encoding[106];

        // Termination bar
        result += "11";

        return(result);
      }
    },
    codabar: {
      encoding:["101010011", "101011001", "101001011", "110010101",
                "101101001", "110101001", "100101011", "100101101",
                "100110101", "110100101", "101001101", "101100101",
                "1101011011", "1101101011", "1101101101", "1011011011",
                "1011001001", "1010010011", "1001001011", "1010011001"],
      getDigit: function(code){
        var table = "0123456789-$:/.+";
        var i, index, result="", intercharacter = '0';

        // add start : A->D : arbitrary choose A
        result += this.encoding[16] + intercharacter;

        for(i=0; i<code.length; i++){
          index = table.indexOf( code.charAt(i) );
          if (index < 0) return("");
          result += this.encoding[ index ] + intercharacter;
        }

        // add stop : A->D : arbitrary choose A
        result += this.encoding[16];
        return(result);
      }
    },
    datamatrix: {
      lengthRows:       [ 10, 12, 14, 16, 18, 20, 22, 24, 26,  // 24 squares et 6 rectangular
                          32, 36, 40, 44, 48, 52, 64, 72, 80,  88, 96, 104, 120, 132, 144,
                          8, 8, 12, 12, 16, 16],
      lengthCols:       [ 10, 12, 14, 16, 18, 20, 22, 24, 26,  // Number of columns for the entire datamatrix
                          32, 36, 40, 44, 48, 52, 64, 72, 80, 88, 96, 104, 120, 132, 144,
                          18, 32, 26, 36, 36, 48],
      dataCWCount:      [ 3, 5, 8, 12,  18,  22,  30,  36,  // Number of data codewords for the datamatrix
                          44, 62, 86, 114, 144, 174, 204, 280, 368, 456, 576, 696, 816, 1050,
                          1304, 1558, 5, 10, 16, 22, 32, 49],
      solomonCWCount:   [ 5, 7, 10, 12, 14, 18, 20, 24, 28, // Number of Reed-Solomon codewords for the datamatrix
                          36, 42, 48, 56, 68, 84, 112, 144, 192, 224, 272, 336, 408, 496, 620,
                          7, 11, 14, 18, 24, 28],
      dataRegionRows:   [ 8, 10, 12, 14, 16, 18, 20, 22, // Number of rows per region
                          24, 14, 16, 18, 20, 22, 24, 14, 16, 18, 20, 22, 24, 18, 20, 22,
                          6,  6, 10, 10, 14, 14],
      dataRegionCols:   [ 8, 10, 12, 14, 16, 18, 20, 22, // Number of columns per region
                          24, 14, 16, 18, 20, 22, 24, 14, 16, 18, 20, 22, 24, 18, 20, 22,
                          16, 14, 24, 16, 16, 22],
      regionRows:       [ 1, 1, 1, 1, 1, 1, 1, 1, // Number of regions per row
                          1, 2, 2, 2, 2, 2, 2, 4, 4, 4, 4, 4, 4, 6, 6, 6,
                          1, 1, 1, 1, 1, 1],
      regionCols:       [ 1, 1, 1, 1, 1, 1, 1, 1, // Number of regions per column
                          1, 2, 2, 2, 2, 2, 2, 4, 4, 4, 4, 4, 4, 6, 6, 6,
                          1, 2, 1, 2, 2, 2],
      interleavedBlocks:[ 1, 1, 1, 1, 1, 1, 1, 1, // Number of blocks
                          1, 1, 1, 1, 1, 1, 2, 2, 4, 4, 4, 4, 6, 6, 8, 8,
                          1, 1, 1, 1, 1, 1],
      logTab:           [ -255, 255, 1, 240, 2, 225, 241, 53, 3,  // Table of log for the Galois field
                          38, 226, 133, 242, 43, 54, 210, 4, 195, 39, 114, 227, 106, 134, 28,
                          243, 140, 44, 23, 55, 118, 211, 234, 5, 219, 196, 96, 40, 222, 115,
                          103, 228, 78, 107, 125, 135, 8, 29, 162, 244, 186, 141, 180, 45, 99,
                          24, 49, 56, 13, 119, 153, 212, 199, 235, 91, 6, 76, 220, 217, 197,
                          11, 97, 184, 41, 36, 223, 253, 116, 138, 104, 193, 229, 86, 79, 171,
                          108, 165, 126, 145, 136, 34, 9, 74, 30, 32, 163, 84, 245, 173, 187,
                          204, 142, 81, 181, 190, 46, 88, 100, 159, 25, 231, 50, 207, 57, 147,
                          14, 67, 120, 128, 154, 248, 213, 167, 200, 63, 236, 110, 92, 176, 7,
                          161, 77, 124, 221, 102, 218, 95, 198, 90, 12, 152, 98, 48, 185, 179,
                          42, 209, 37, 132, 224, 52, 254, 239, 117, 233, 139, 22, 105, 27, 194,
                          113, 230, 206, 87, 158, 80, 189, 172, 203, 109, 175, 166, 62, 127,
                          247, 146, 66, 137, 192, 35, 252, 10, 183, 75, 216, 31, 83, 33, 73,
                          164, 144, 85, 170, 246, 65, 174, 61, 188, 202, 205, 157, 143, 169, 82,
                          72, 182, 215, 191, 251, 47, 178, 89, 151, 101, 94, 160, 123, 26, 112,
                          232, 21, 51, 238, 208, 131, 58, 69, 148, 18, 15, 16, 68, 17, 121, 149,
                          129, 19, 155, 59, 249, 70, 214, 250, 168, 71, 201, 156, 64, 60, 237,
                          130, 111, 20, 93, 122, 177, 150],
      aLogTab:          [ 1, 2, 4, 8, 16, 32, 64, 128, 45, 90, // Table of aLog for the Galois field
                          180, 69, 138, 57, 114, 228, 229, 231, 227, 235, 251, 219, 155, 27, 54,
                          108, 216, 157, 23, 46, 92, 184, 93, 186, 89, 178, 73, 146, 9, 18, 36,
                          72, 144, 13, 26, 52, 104, 208, 141, 55, 110, 220, 149, 7, 14, 28, 56,
                          112, 224, 237, 247, 195, 171, 123, 246, 193, 175, 115, 230, 225, 239,
                          243, 203, 187, 91, 182, 65, 130, 41, 82, 164, 101, 202, 185, 95, 190,
                          81, 162, 105, 210, 137, 63, 126, 252, 213, 135, 35, 70, 140, 53, 106,
                          212, 133, 39, 78, 156, 21, 42, 84, 168, 125, 250, 217, 159, 19, 38, 76,
                          152, 29, 58, 116, 232, 253, 215, 131, 43, 86, 172, 117, 234, 249, 223,
                          147, 11, 22, 44, 88, 176, 77, 154, 25, 50, 100, 200, 189, 87, 174, 113,
                          226, 233, 255, 211, 139, 59, 118, 236, 245, 199, 163, 107, 214, 129,
                          47, 94, 188, 85, 170, 121, 242, 201, 191, 83, 166, 97, 194, 169, 127,
                          254, 209, 143, 51, 102, 204, 181, 71, 142, 49, 98, 196, 165, 103, 206,
                          177, 79, 158, 17, 34, 68, 136, 61, 122, 244, 197, 167, 99, 198, 161,
                          111, 222, 145, 15, 30, 60, 120, 240, 205, 183, 67, 134, 33, 66, 132,
                          37, 74, 148, 5, 10, 20, 40, 80, 160, 109, 218, 153, 31, 62, 124, 248,
                          221, 151, 3, 6, 12, 24, 48, 96, 192, 173, 119, 238, 241, 207, 179, 75,
                          150, 1],
      champGaloisMult: function(a, b){  // MULTIPLICATION IN GALOIS FIELD GF(2^8)
        if(!a || !b) return 0;
        return this.aLogTab[(this.logTab[a] + this.logTab[b]) % 255];
      },
      champGaloisDoub: function(a, b){  // THE OPERATION a * 2^b IN GALOIS FIELD GF(2^8)
        if (!a) return 0;
        if (!b) return a;
        return this.aLogTab[(this.logTab[a] + b) % 255];
      },
      champGaloisSum: function(a, b){ // SUM IN GALOIS FIELD GF(2^8)
        return a ^ b;
      },
      selectIndex: function(dataCodeWordsCount, rectangular){ // CHOOSE THE GOOD INDEX FOR TABLES
        if ((dataCodeWordsCount<1 || dataCodeWordsCount>1558) && !rectangular) return -1;
        if ((dataCodeWordsCount<1 || dataCodeWordsCount>49) && rectangular)  return -1;

        var n = 0;
        if ( rectangular ) n = 24;

        while (this.dataCWCount[n] < dataCodeWordsCount) n++;
        return n;
      },
      encodeDataCodeWordsASCII: function(text) {
        var dataCodeWords = new Array();
        var n = 0, i, c;
        for (i=0; i<text.length; i++){
          c = text.charCodeAt(i);
          if (c > 127) {
            dataCodeWords[n] = 235;
            c = c - 127;
            n++;
          } else if ((c>=48 && c<=57) && (i+1<text.length) && (text.charCodeAt(i+1)>=48 && text.charCodeAt(i+1)<=57)) {
            c = ((c - 48) * 10) + ((text.charCodeAt(i+1))-48);
            c += 130;
            i++;
          } else c++;
          dataCodeWords[n] = c;
          n++;
        }
        return dataCodeWords;
      },
      addPadCW: function(tab, from, to){
        if (from >= to) return ;
        tab[from] = 129;
        var r, i;
        for (i=from+1; i<to; i++){
          r = ((149 * (i+1)) % 253) + 1;
          tab[i] = (129 + r) % 254;
        }
      },
      calculSolFactorTable: function(solomonCWCount){ // CALCULATE THE REED SOLOMON FACTORS
        var g = new Array();
        var i, j;

        for (i=0; i<=solomonCWCount; i++) g[i] = 1;

        for(i = 1; i <= solomonCWCount; i++) {
          for(j = i - 1; j >= 0; j--) {
            g[j] = this.champGaloisDoub(g[j], i);
            if(j > 0) g[j] = this.champGaloisSum(g[j], g[j-1]);
          }
        }
        return g;
      },
      addReedSolomonCW: function(nSolomonCW, coeffTab, nDataCW, dataTab, blocks){ // Add the Reed Solomon codewords
        var temp = 0;
        var errorBlocks = nSolomonCW / blocks;
        var correctionCW = new Array();

        var i,j,k;
        for(k = 0; k < blocks; k++) {
          for (i=0; i<errorBlocks; i++) correctionCW[i] = 0;

          for (i=k; i<nDataCW; i=i+blocks){
            temp = this.champGaloisSum(dataTab[i], correctionCW[errorBlocks-1]);
            for (j=errorBlocks-1; j>=0; j--){
              if ( !temp ) {
                correctionCW[j] = 0;
              } else {
                correctionCW[j] = this.champGaloisMult(temp, coeffTab[j]);
              }
              if (j>0) correctionCW[j] = this.champGaloisSum(correctionCW[j-1], correctionCW[j]);
            }
          }
          // Renversement des blocs calcules
          j = nDataCW + k;
          for (i=errorBlocks-1; i>=0; i--){
            dataTab[j] = correctionCW[i];
            j=j+blocks;
          }
        }
        return dataTab;
      },
      getBits: function(entier){ // Transform integer to tab of bits
        var bits = new Array();
        for (var i=0; i<8; i++){
          bits[i] = entier & (128 >> i) ? 1 : 0;
        }
        return bits;
      },
      next: function(etape, totalRows, totalCols, codeWordsBits, datamatrix, assigned){ // Place codewords into the matrix
        var chr = 0; // Place of the 8st bit from the first character to [4][0]
        var row = 4;
        var col = 0;

        do {
          // Check for a special case of corner
          if((row == totalRows) && (col == 0)){
            this.patternShapeSpecial1(datamatrix, assigned, codeWordsBits[chr], totalRows, totalCols);
            chr++;
          } else if((etape<3) && (row == totalRows-2) && (col == 0) && (totalCols%4 != 0)){
            this.patternShapeSpecial2(datamatrix, assigned, codeWordsBits[chr], totalRows, totalCols);
            chr++;
          } else if((row == totalRows-2) && (col == 0) && (totalCols%8 == 4)){
            this.patternShapeSpecial3(datamatrix, assigned, codeWordsBits[chr], totalRows, totalCols);
            chr++;
          }
          else if((row == totalRows+4) && (col == 2) && (totalCols%8 == 0)){
            this.patternShapeSpecial4(datamatrix, assigned, codeWordsBits[chr], totalRows, totalCols);
            chr++;
          }

          // Go up and right in the datamatrix
          do {
            if((row < totalRows) && (col >= 0) && (assigned[row][col]!=1)) {
              this.patternShapeStandard(datamatrix, assigned, codeWordsBits[chr], row, col, totalRows, totalCols);
              chr++;
            }
            row -= 2;
            col += 2;
          } while ((row >= 0) && (col < totalCols));
          row += 1;
          col += 3;

          // Go down and left in the datamatrix
          do {
            if((row >= 0) && (col < totalCols) && (assigned[row][col]!=1)){
              this.patternShapeStandard(datamatrix, assigned, codeWordsBits[chr], row, col, totalRows, totalCols);
              chr++;
            }
            row += 2;
            col -= 2;
          } while ((row < totalRows) && (col >=0));
          row += 3;
          col += 1;
        } while ((row < totalRows) || (col < totalCols));
      },
      patternShapeStandard: function(datamatrix, assigned, bits, row, col, totalRows, totalCols){ // Place bits in the matrix (standard or special case)
        this.placeBitInDatamatrix(datamatrix, assigned, bits[0], row-2, col-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[1], row-2, col-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[2], row-1, col-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[3], row-1, col-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[4], row-1, col, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[5], row, col-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[6], row, col-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[7], row,  col, totalRows, totalCols);
      },
      patternShapeSpecial1: function(datamatrix, assigned, bits, totalRows, totalCols ){
        this.placeBitInDatamatrix(datamatrix, assigned, bits[0], totalRows-1,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[1], totalRows-1,  1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[2], totalRows-1,  2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[3], 0, totalCols-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[4], 0, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[5], 1, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[6], 2, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[7], 3, totalCols-1, totalRows, totalCols);
      },
      patternShapeSpecial2: function(datamatrix, assigned, bits, totalRows, totalCols ){
        this.placeBitInDatamatrix(datamatrix, assigned, bits[0], totalRows-3,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[1], totalRows-2,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[2], totalRows-1,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[3], 0, totalCols-4, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[4], 0, totalCols-3, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[5], 0, totalCols-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[6], 0, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[7], 1, totalCols-1, totalRows, totalCols);
      },
      patternShapeSpecial3: function(datamatrix, assigned, bits, totalRows, totalCols ){
        this.placeBitInDatamatrix(datamatrix, assigned, bits[0], totalRows-3,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[1], totalRows-2,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[2], totalRows-1,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[3], 0, totalCols-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[4], 0, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[5], 1, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[6], 2, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[7], 3, totalCols-1, totalRows, totalCols);
      },
      patternShapeSpecial4: function(datamatrix, assigned, bits, totalRows, totalCols ){
        this.placeBitInDatamatrix(datamatrix, assigned, bits[0], totalRows-1,  0, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[1], totalRows-1, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[2], 0, totalCols-3, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[3], 0, totalCols-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[4], 0, totalCols-1, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[5], 1, totalCols-3, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[6], 1, totalCols-2, totalRows, totalCols);
        this.placeBitInDatamatrix(datamatrix, assigned, bits[7], 1, totalCols-1, totalRows, totalCols);
      },
      placeBitInDatamatrix: function(datamatrix, assigned, bit, row, col, totalRows, totalCols){ // Put a bit into the matrix
        if (row < 0) {
          row += totalRows;
          col += 4 - ((totalRows+4)%8);
        }
        if (col < 0) {
          col += totalCols;
          row += 4 - ((totalCols+4)%8);
        }
        if (assigned[row][col] != 1) {
          datamatrix[row][col] = bit;
          assigned[row][col] = 1;
        }
      },
      addFinderPattern: function(datamatrix, rowsRegion, colsRegion, rowsRegionCW, colsRegionCW){ // Add the finder pattern
        var totalRowsCW = (rowsRegionCW+2) * rowsRegion;
        var totalColsCW = (colsRegionCW+2) * colsRegion;

        var datamatrixTemp = new Array();
        datamatrixTemp[0] = new Array();
        for (var j=0; j<totalColsCW+2; j++){
          datamatrixTemp[0][j] = 0;
        }
        for (var i=0; i<totalRowsCW; i++){
          datamatrixTemp[i+1] = new Array();
          datamatrixTemp[i+1][0] = 0;
          datamatrixTemp[i+1][totalColsCW+1] = 0;
          for (var j=0; j<totalColsCW; j++){
            if (i%(rowsRegionCW+2) == 0){
              if (j%2 == 0){
                datamatrixTemp[i+1][j+1] = 1;
              } else {
                datamatrixTemp[i+1][j+1] = 0;
              }
            } else if (i%(rowsRegionCW+2) == rowsRegionCW+1){
              datamatrixTemp[i+1][j+1] = 1;
            } else if (j%(colsRegionCW+2) == colsRegionCW+1){
              if (i%2 == 0){
                datamatrixTemp[i+1][j+1] = 0;
              } else {
                datamatrixTemp[i+1][j+1] = 1;
              }
            } else if (j%(colsRegionCW+2) == 0){
              datamatrixTemp[i+1][j+1] = 1;
            } else{
              datamatrixTemp[i+1][j+1] = 0;
              datamatrixTemp[i+1][j+1] = datamatrix[i-1-(2*(parseInt(i/(rowsRegionCW+2))))][j-1-(2*(parseInt(j/(colsRegionCW+2))))];
            }
          }
        }
        datamatrixTemp[totalRowsCW+1] = new Array();
        for (var j=0; j<totalColsCW+2; j++){
          datamatrixTemp[totalRowsCW+1][j] = 0;
        }
        return datamatrixTemp;
      },
      getDigit: function(text, rectangular){
        var dataCodeWords = this.encodeDataCodeWordsASCII(text); // Code the text in the ASCII mode
        var dataCWCount = dataCodeWords.length;
        var index = this.selectIndex(dataCWCount, rectangular); // Select the index for the data tables
        var totalDataCWCount = this.dataCWCount[index]; // Number of data CW
        var solomonCWCount = this.solomonCWCount[index]; // Number of Reed Solomon CW
        var totalCWCount = totalDataCWCount + solomonCWCount; // Number of CW
        var rowsTotal = this.lengthRows[index]; // Size of symbol
        var colsTotal = this.lengthCols[index];
        var rowsRegion = this.regionRows[index]; // Number of region
        var colsRegion = this.regionCols[index];
        var rowsRegionCW = this.dataRegionRows[index];
        var colsRegionCW = this.dataRegionCols[index];
        var rowsLengthMatrice = rowsTotal-2*rowsRegion; // Size of matrice data
        var colsLengthMatrice = colsTotal-2*colsRegion;
        var blocks = this.interleavedBlocks[index];  // Number of Reed Solomon blocks
        var errorBlocks = (solomonCWCount / blocks);

        this.addPadCW(dataCodeWords, dataCWCount, totalDataCWCount); // Add codewords pads

        var g = this.calculSolFactorTable(errorBlocks); // Calculate correction coefficients

        this.addReedSolomonCW(solomonCWCount, g, totalDataCWCount, dataCodeWords, blocks); // Add Reed Solomon codewords

        var codeWordsBits = new Array(); // Calculte bits from codewords
        for (var i=0; i<totalCWCount; i++){
          codeWordsBits[i] = this.getBits(dataCodeWords[i]);
        }

        var datamatrix = new Array(); // Put data in the matrix
        var assigned = new Array();

        for (var i=0; i<colsLengthMatrice; i++){
          datamatrix[i] = new Array();
          assigned[i] = new Array();
        }

        // Add the bottom-right corner if needed
        if ( ((rowsLengthMatrice * colsLengthMatrice) % 8) == 4) {
          datamatrix[rowsLengthMatrice-2][colsLengthMatrice-2] = 1;
          datamatrix[rowsLengthMatrice-1][colsLengthMatrice-1] = 1;
          datamatrix[rowsLengthMatrice-1][colsLengthMatrice-2] = 0;
          datamatrix[rowsLengthMatrice-2][colsLengthMatrice-1] = 0;
          assigned[rowsLengthMatrice-2][colsLengthMatrice-2] = 1;
          assigned[rowsLengthMatrice-1][colsLengthMatrice-1] = 1;
          assigned[rowsLengthMatrice-1][colsLengthMatrice-2] = 1;
          assigned[rowsLengthMatrice-2][colsLengthMatrice-1] = 1;
        }

        // Put the codewords into the matrix
        this.next(0,rowsLengthMatrice,colsLengthMatrice, codeWordsBits, datamatrix, assigned);

        // Add the finder pattern
        datamatrix = this.addFinderPattern(datamatrix, rowsRegion, colsRegion, rowsRegionCW, colsRegionCW);

        return datamatrix;
      }
    },
    // little endian convertor
    lec:{
      // convert an int
      cInt: function(value, byteCount){
        var le = '';
        for(var i=0; i<byteCount; i++){
          le += String.fromCharCode(value & 0xFF);
          value = value >> 8;
        }
        return le;
      },
      // return a byte string from rgb values
      cRgb: function(r,g,b){
        return String.fromCharCode(b) + String.fromCharCode(g) + String.fromCharCode(r);
      },
      // return a byte string from a hex string color
      cHexColor: function(hex){
        var v = parseInt('0x' + hex.substr(1));
        var b = v & 0xFF;
        v = v >> 8;
        var g = v & 0xFF;
        var r = v >> 8;
        return(this.cRgb(r,g,b));
      }
    },
    hexToRGB: function(hex){
      var v = parseInt('0x' + hex.substr(1));
      var b = v & 0xFF;
      v = v >> 8;
      var g = v & 0xFF;
      var r = v >> 8;
      return({r:r,g:g,b:b});
    },
    // test if a string is a hexa string color (like #FF0000)
    isHexColor: function (value){
      var r = new RegExp("#[0-91-F]", "gi");
      return  value.match(r);
    },
    // encode data in base64
    base64Encode: function(value) {
      var r = '', c1, c2, c3, b1, b2, b3, b4;
      var k = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var i = 0;
      while (i < value.length) {
        c1 = value.charCodeAt(i++);
        c2 = value.charCodeAt(i++);
        c3 = value.charCodeAt(i++);
        b1 = c1 >> 2;
        b2 = ((c1 & 3) << 4) | (c2 >> 4);
        b3 = ((c2 & 15) << 2) | (c3 >> 6);
        b4 = c3 & 63;
        if (isNaN(c2)) b3 = b4 = 64;
        else if (isNaN(c3)) b4 = 64;
        r += k.charAt(b1) + k.charAt(b2) + k.charAt(b3) + k.charAt(b4);
      }
      return r;
    },
    // convert a bit string to an array of array of bit char
    bitStringTo2DArray: function( digit ){
      var d = []; d[0] = [];
      for(var i=0; i<digit.length; i++) d[0][i] = digit.charAt(i);
      return(d);
    },
    // clear jQuery Target
    resize: function($container, w){
      $container
        .css("padding", "0px")
        .css("overflow", "auto")
        .css("width", w + "px")
        .html("");
        return $container;
    },
    // bmp barcode renderer
    digitToBmpRenderer: function($container, settings, digit, hri, mw, mh){
      var lines = digit.length;
      var columns = digit[0].length;
      var i = 0;
      var c0 = this.isHexColor(settings.bgColor) ? this.lec.cHexColor(settings.bgColor) : this.lec.cRgb(255,255,255);
      var c1 = this.isHexColor(settings.color) ? this.lec.cHexColor(settings.color) : this.lec.cRgb(0,0,0);
      var bar0 = '';
      var bar1 = '';

      // create one bar 0 and 1 of "mw" byte length
      for(i=0; i<mw; i++){
        bar0 += c0;
        bar1 += c1;
      }
      var bars = '';

      var padding = (4 - ((mw * columns * 3) % 4)) % 4; // Padding for 4 byte alignment ("* 3" come from "3 byte to color R, G and B")
      var dataLen = (mw * columns + padding) * mh * lines;

      var pad = '';
      for(i=0; i<padding; i++) pad += '\0';

      // Bitmap header
      var bmp = 'BM' +                            // Magic Number
                this.lec.cInt(54 + dataLen, 4) +  // Size of Bitmap size (header size + data len)
                '\0\0\0\0' +                      // Unused
                this.lec.cInt(54, 4) +            // The offset where the bitmap data (pixels) can be found
                this.lec.cInt(40, 4) +            // The number of bytes in the header (from this point).
                this.lec.cInt(mw * columns, 4) +  // width
                this.lec.cInt(mh * lines, 4) +    // height
                this.lec.cInt(1, 2) +             // Number of color planes being used
                this.lec.cInt(24, 2) +            // The number of bits/pixel
                '\0\0\0\0' +                      // BI_RGB, No compression used
                this.lec.cInt(dataLen, 4) +       // The size of the raw BMP data (after this header)
                this.lec.cInt(2835, 4) +          // The horizontal resolution of the image (pixels/meter)
                this.lec.cInt(2835, 4) +          // The vertical resolution of the image (pixels/meter)
                this.lec.cInt(0, 4) +             // Number of colors in the palette
                this.lec.cInt(0, 4);              // Means all colors are important
      // Bitmap Data
      for(var y=lines-1; y>=0; y--){
        var line = '';
        for (var x=0; x<columns; x++){
          line += digit[y][x] == '0' ? bar0 : bar1;
        }
        line += pad;
        for(var k=0; k<mh; k++){
          bmp += line;
        }
      }
      // set bmp image to the container
      var object = document.createElement('object');
      object.setAttribute('type', 'image/bmp');
      object.setAttribute('data', 'data:image/bmp;base64,'+ this.base64Encode(bmp));
      this.resize($container, mw * columns + padding).append(object);

    },
    // bmp 1D barcode renderer
    digitToBmp: function($container, settings, digit, hri){
      var w = barcode.intval(settings.barWidth);
      var h = barcode.intval(settings.barHeight);
      this.digitToBmpRenderer($container, settings, this.bitStringTo2DArray(digit), hri, w, h);
    },
    // bmp 2D barcode renderer
    digitToBmp2D: function($container, settings, digit, hri){
      var s = barcode.intval(settings.moduleSize);
      this.digitToBmpRenderer($container, settings, digit, hri, s, s);
    },
    // css barcode renderer
    digitToCssRenderer : function($container, settings, digit, hri, mw, mh){
      var lines = digit.length;
      var columns = digit[0].length;
      var content = "";
      var bar0 = "<div style=\"float: left; font-size: 0px; background-color: " + settings.bgColor + "; height: " + mh + "px; width: &Wpx\"></div>";
      var bar1 = "<div style=\"float: left; font-size: 0px; width:0; border-left: &Wpx solid " + settings.color + "; height: " + mh + "px;\"></div>";

      var len, current;
      for(var y=0; y<lines; y++){
        len = 0;
        current = digit[y][0];
        for (var x=0; x<columns; x++){
          if ( current == digit[y][x] ) {
            len++;
          } else {
            content += (current == '0' ? bar0 : bar1).replace("&W", len * mw);
            current = digit[y][x];
            len=1;
          }
        }
        if (len > 0){
          content += (current == '0' ? bar0 : bar1).replace("&W", len * mw);
        }
      }
      if (settings.showHRI){
        content += "<div style=\"clear:both; width: 100%; background-color: " + settings.bgColor + "; color: " + settings.color + "; text-align: center; font-size: " + settings.fontSize + "px; margin-top: " + settings.marginHRI + "px;\">"+hri+"</div>";
      }
      this.resize($container, mw * columns).html(content);
    },
    // css 1D barcode renderer
    digitToCss: function($container, settings, digit, hri){
      var w = barcode.intval(settings.barWidth);
      var h = barcode.intval(settings.barHeight);
      this.digitToCssRenderer($container, settings, this.bitStringTo2DArray(digit), hri, w, h);
    },
    // css 2D barcode renderer
    digitToCss2D: function($container, settings, digit, hri){
      var s = barcode.intval(settings.moduleSize);
      this.digitToCssRenderer($container, settings, digit, hri, s, s);
    },
    // svg barcode renderer
    digitToSvgRenderer: function($container, settings, digit, hri, mw, mh){
      var lines = digit.length;
      var columns = digit[0].length;

      var width = mw * columns;
      var height = mh * lines;
      if (settings.showHRI){
        var fontSize = barcode.intval(settings.fontSize);
        height += barcode.intval(settings.marginHRI) + fontSize;
      }

      // svg header
      var svg = '<div class="object_tik"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + width + '" height="' + height + '">';

      // background
      svg += '<rect width="' +  width + '" height="' + height + '" x="0" y="0" fill="' + settings.bgColor + '" />';

      var bar1 = '<rect width="&W" height="' + mh + '" x="&X" y="&Y" fill="' + settings.color + '" />';

      var len, current;
      for(var y=0; y<lines; y++){
        len = 0;
        current = digit[y][0];
        for (var x=0; x<columns; x++){
          if ( current == digit[y][x] ) {
            len++;
          } else {
            if (current == '1') {
              svg += bar1.replace("&W", len * mw).replace("&X", (x - len) * mw).replace("&Y", y * mh);
            }
            current = digit[y][x];
            len=1;
          }
        }
        if ( (len > 0) && (current == '1') ){
          svg += bar1.replace("&W", len * mw).replace("&X", (columns - len) * mw).replace("&Y", y * mh);
        }
      }

      if (settings.showHRI){
        svg += '<g transform="translate(' + Math.floor(width/2) + ' 0)">';
        svg += '<text y="' + (height - Math.floor(fontSize/2)) + '" text-anchor="middle" style="font-family: Arial; font-size: ' + fontSize + 'px;" fill="' + settings.color + '">' + hri + '</text>';
        svg += '</g>';
      }
      // svg footer
      svg += '</svg></div>'; 

      // create a dom object, flush container and add object to the container
      // var object = document.createElement('object');
      // object.setAttribute('type', 'image/svg+xml');
      // object.setAttribute('data', 'data:image/svg+xml,'+ svg);
      // this.resize($container, width).append(object);
      var object = svg;
      this.resize($container, width).append(object);
    },
    // svg 1D barcode renderer
    digitToSvg: function($container, settings, digit, hri){
      var w = barcode.intval(settings.barWidth);
      var h = barcode.intval(settings.barHeight);
      this.digitToSvgRenderer($container, settings, this.bitStringTo2DArray(digit), hri, w, h);
    },
    // svg 2D barcode renderer
    digitToSvg2D: function($container, settings, digit, hri){
      var s = barcode.intval(settings.moduleSize);
      this.digitToSvgRenderer($container, settings, digit, hri, s, s);
    },

    // canvas barcode renderer
    digitToCanvasRenderer : function($container, settings, digit, hri, xi, yi, mw, mh){
      var canvas = $container.get(0);
      if ( !canvas || !canvas.getContext ) return; // not compatible

      var lines = digit.length;
      var columns = digit[0].length;

      var ctx = canvas.getContext('2d');
      ctx.lineWidth = 1;
      ctx.lineCap = 'butt';
      ctx.fillStyle = settings.bgColor;
      ctx.fillRect (xi, yi, columns * mw, lines * mh);

      ctx.fillStyle = settings.color;

      for(var y=0; y<lines; y++){
        var len = 0;
        var current = digit[y][0];
        for(var x=0; x<columns; x++){
          if (current == digit[y][x]) {
            len++;
          } else {
            if (current == '1'){
              ctx.fillRect (xi + (x - len) * mw, yi + y * mh, mw * len, mh);
            }
            current = digit[y][x];
            len=1;
          }
        }
        if ( (len > 0) && (current == '1') ){
          ctx.fillRect (xi + (columns - len) * mw, yi + y * mh, mw * len, mh);
        }
      }
      if (settings.showHRI){
        var dim = ctx.measureText(hri);
        ctx.fillText(hri, xi + Math.floor((columns * mw - dim.width)/2), yi + lines * mh + settings.fontSize + settings.marginHRI);
      }
    },
    // canvas 1D barcode renderer
    digitToCanvas: function($container, settings, digit, hri){
      var w  = barcode.intval(settings.barWidth);
      var h = barcode.intval(settings.barHeight);
      var x = barcode.intval(settings.posX);
      var y = barcode.intval(settings.posY);
      this.digitToCanvasRenderer($container, settings, this.bitStringTo2DArray(digit), hri, x, y, w, h);
    },
    // canvas 2D barcode renderer
    digitToCanvas2D: function($container, settings, digit, hri){
      var s = barcode.intval(settings.moduleSize);
      var x = barcode.intval(settings.posX);
      var y = barcode.intval(settings.posY);
      this.digitToCanvasRenderer($container, settings, digit, hri, x, y, s, s);
    }
  };

  $.fn.extend({
    barcode: function(datas, type, settings) {
      var digit = "",
          hri   = "",
          code  = "",
          crc   = true,
          rect  = false,
          b2d   = false;

      if (typeof(datas) == "string"){
        code = datas;
      } else if (typeof(datas) == "object"){
        code = typeof(datas.code) == "string" ? datas.code : "";
        crc = typeof(datas.crc) != "undefined" ? datas.crc : true;
        rect = typeof(datas.rect) != "undefined" ? datas.rect : false;
      }
      if (code == "") return(false);

      if (typeof(settings) == "undefined") settings = [];
      for(var name in barcode.settings){
        if (settings[name] == undefined) settings[name] = barcode.settings[name];
      }

      switch(type){
        case "std25":
        case "int25":
          digit = barcode.i25.getDigit(code, crc, type);
          hri = barcode.i25.compute(code, crc, type);
        break;
        case "ean8":
        case "ean13":
          digit = barcode.ean.getDigit(code, type);
          hri = barcode.ean.compute(code, type);
        break;
        case "upc":
          digit = barcode.upc.getDigit(code);
          hri = barcode.upc.compute(code);
        break;
        case "code11":
          digit = barcode.code11.getDigit(code);
          hri = code;
        break;
        case "code39":
          digit = barcode.code39.getDigit(code);
          hri = code;
        break;
        case "code93":
          digit = barcode.code93.getDigit(code, crc);
          hri = code;
        break;
        case "code128":
          digit = barcode.code128.getDigit(code);
          hri = code;
        break;
        case "codabar":
          digit = barcode.codabar.getDigit(code);
          hri = code;
        break;
        case "msi":
          digit = barcode.msi.getDigit(code, crc);
          hri = barcode.msi.compute(code, crc);
        break;
        case "datamatrix":
          digit = barcode.datamatrix.getDigit(code, rect);
          hri = code;
          b2d = true;
        break;
      }
      if (digit.length == 0) return($(this));

      // Quiet Zone
      if ( !b2d && settings.addQuietZone) digit = "0000000000" + digit + "0000000000";

      var $this = $(this);
      var fname = 'digitTo' + settings.output.charAt(0).toUpperCase() + settings.output.substr(1) + (b2d ? '2D' : '');
      if (typeof(barcode[fname]) == 'function') {
        barcode[fname]($this, settings, digit, hri);
      }

      return($this);
    }
  });

}(jQuery));

 /* eslint-disable */

!function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,e,n){Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=10)}([function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(){n(this,t),this.startBin="101",this.endBin="101",this.middleBin="01010",this.Lbinary=["0001101","0011001","0010011","0111101","0100011","0110001","0101111","0111011","0110111","0001011"],this.Gbinary=["0100111","0110011","0011011","0100001","0011101","0111001","0000101","0010001","0001001","0010111"],this.Rbinary=["1110010","1100110","1101100","1000010","1011100","1001110","1010000","1000100","1001000","1110100"]}return t.prototype.encode=function(t,e,n){var r="";n=n||"";for(var i=0;i<t.length;i++)"L"==e[i]?r+=this.Lbinary[t[i]]:"G"==e[i]?r+=this.Gbinary[t[i]]:"R"==e[i]&&(r+=this.Rbinary[t[i]]),i<t.length-1&&(r+=n);return r},t}();e["default"]=r},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){for(var n=0;e>n;n++)t="0"+t;return t}Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(e){n(this,t),this.string=e}return t.prototype.encode=function(){for(var t="110",e=0;e<this.string.length;e++){var n=parseInt(this.string[e]),i=n.toString(2);i=r(i,4-i.length);for(var o=0;o<i.length;o++)t+="0"==i[o]?"100":"110"}return t+="1001",{data:t,text:this.string}},t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]+$/)},t}();e["default"]=i},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.bytes=[];for(var r=0;r<e.length;++r)this.bytes.push(e.charCodeAt(r));this.string=e.substring(1),this.encodings=[740,644,638,176,164,100,224,220,124,608,604,572,436,244,230,484,260,254,650,628,614,764,652,902,868,836,830,892,844,842,752,734,590,304,112,94,416,128,122,672,576,570,464,422,134,496,478,142,910,678,582,768,762,774,880,862,814,896,890,818,914,602,930,328,292,200,158,68,62,424,412,232,218,76,74,554,616,978,556,146,340,212,182,508,268,266,956,940,938,758,782,974,400,310,118,512,506,960,954,502,518,886,966,668,680,692,5379]}return t.prototype.encode=function(){var t,e=this.bytes,n=e.shift()-105;return 103===n?t=this.nextA(e,1):104===n?t=this.nextB(e,1):105===n&&(t=this.nextC(e,1)),{text:this.string.replace(/[^\x20-\x7E]/g,""),data:this.getEncoding(n)+t.result+this.getEncoding((t.checksum+n)%103)+this.getEncoding(106)}},t.prototype.getEncoding=function(t){return this.encodings[t]?(this.encodings[t]+1e3).toString(2):""},t.prototype.valid=function(){return-1!==this.string.search(/^[\x00-\x7F\xC8-\xD3]+$/)},t.prototype.nextA=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;if(t[0]>=200)r=t[0]-105,t.shift(),99===r?n=this.nextC(t,e+1):100===r?n=this.nextB(t,e+1):98===r?(t[0]=t[0]>95?t[0]-96:t[0],n=this.nextA(t,e+1)):n=this.nextA(t,e+1);else{var i=t[0];r=32>i?i+64:i-32,t.shift(),n=this.nextA(t,e+1)}var o=this.getEncoding(r),s=r*e;return{result:o+n.result,checksum:s+n.checksum}},t.prototype.nextB=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;t[0]>=200?(r=t[0]-105,t.shift(),99===r?n=this.nextC(t,e+1):101===r?n=this.nextA(t,e+1):98===r?(t[0]=t[0]<32?t[0]+96:t[0],n=this.nextB(t,e+1)):n=this.nextB(t,e+1)):(r=t[0]-32,t.shift(),n=this.nextB(t,e+1));var i=this.getEncoding(r),o=r*e;return{result:i+n.result,checksum:o+n.checksum}},t.prototype.nextC=function(t,e){if(t.length<=0)return{result:"",checksum:0};var n,r;t[0]>=200?(r=t[0]-105,t.shift(),n=100===r?this.nextB(t,e+1):101===r?this.nextA(t,e+1):this.nextC(t,e+1)):(r=10*(t[0]-48)+t[1]-48,t.shift(),t.shift(),n=this.nextC(t,e+1));var i=this.getEncoding(r),o=r*e;return{result:i+n.result,checksum:o+n.checksum}},t}();e["default"]=r},function(t,e){"use strict";function n(t){for(var e=0,n=0;n<t.length;n++){var r=parseInt(t[n]);e+=(n+t.length)%2===0?r:2*r%10+Math.floor(2*r/10)}return(10-e%10)%10}function r(t){for(var e=0,n=[2,3,4,5,6,7],r=0;r<t.length;r++){var i=parseInt(t[t.length-1-r]);e+=n[r%n.length]*i}return(11-e%11)%11}Object.defineProperty(e,"__esModule",{value:!0}),e.mod10=n,e.mod11=r},function(t,e){"use strict";function n(t,e){var n,r={};for(n in t)t.hasOwnProperty(n)&&(r[n]=t[n]);for(n in e)e.hasOwnProperty(n)&&"undefined"!=typeof e[n]&&(r[n]=e[n]);return r}Object.defineProperty(e,"__esModule",{value:!0}),e["default"]=n},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(16),i=n(15),o=n(22),s=n(25),a=n(24),u=n(30),f=n(31),c=n(23);e["default"]={CODE39:r.CODE39,CODE128:i.CODE128,CODE128A:i.CODE128A,CODE128B:i.CODE128B,CODE128C:i.CODE128C,EAN13:o.EAN13,EAN8:o.EAN8,EAN5:o.EAN5,EAN2:o.EAN2,UPC:o.UPC,ITF14:s.ITF14,ITF:a.ITF,MSI:u.MSI,MSI10:u.MSI10,MSI11:u.MSI11,MSI1010:u.MSI1010,MSI1110:u.MSI1110,pharmacode:f.pharmacode,GenericBarcode:c.GenericBarcode}},function(t,e){"use strict";function n(t){return t.marginTop=t.marginTop||t.margin,t.marginBottom=t.marginBottom||t.margin,t.marginRight=t.marginRight||t.margin,t.marginLeft=t.marginLeft||t.margin,t}Object.defineProperty(e,"__esModule",{value:!0}),e["default"]=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){var n={};for(var r in e)t.hasAttribute("jsbarcode-"+r.toLowerCase())&&(n[r]=t.getAttribute("jsbarcode-"+r.toLowerCase())),t.hasAttribute("data-"+r.toLowerCase())&&(n[r]=t.getAttribute("data-"+r.toLowerCase()));return n.value=t.getAttribute("jsbarcode-value")||t.getAttribute("data-value"),n=(0,s["default"])(n)}Object.defineProperty(e,"__esModule",{value:!0});var o=n(32),s=r(o);e["default"]=i},function(t,e){"use strict";function n(t){function e(t){if(Array.isArray(t))for(var r=0;r<t.length;r++)e(t[r]);else t.text=t.text||"",t.data=t.data||"",n.push(t)}var n=[];return e(t),n}Object.defineProperty(e,"__esModule",{value:!0}),e["default"]=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(33),o=r(i),s=n(34),a=r(s);e["default"]={canvas:o["default"],svg:a["default"]}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){_.prototype[e]=_.prototype[e.toUpperCase()]=_.prototype[e.toLowerCase()]=function(n,r){var i=(0,p["default"])(this._options,r),s=t[e],a=o(n,s,i);return this._encodings.push(a),this}}function o(t,e,n){t=""+t;var r=new e(t,n);if(!r.valid()){if(n.valid===O.valid)throw new Error('"'+t+'" is not a valid input for '+C);n.valid(!1)}var i=r.encode();i=(0,y["default"])(i);for(var o=0;o<i.length;o++)i[o].options=(0,p["default"])(n,i[o].options);return i}function s(){return c["default"].CODE128?"CODE128":Object.keys(c["default"])[0]}function a(t,e,n){var r=l["default"][t.renderer];e=(0,y["default"])(e);for(var i=0;i<e.length;i++)e[i].options=(0,p["default"])(n,e[i].options),(0,b["default"])(e[i].options);(0,b["default"])(n),r(t.element,e,n),t.afterRender&&t.afterRender()}function u(t){if("string"==typeof t){var e=document.querySelectorAll(t);if(0===e.length)throw new Error("No element found");for(var n=[],r=0;r<e.length;r++)n.push(u(e[r]));return n}if(Array.isArray(t)){for(var n=[],r=0;r<t.length;r++)n.push(u(t[r]));return n}if("undefined"!=typeof HTMLCanvasElement&&t instanceof HTMLImageElement){var i=document.createElement("canvas");return{element:i,options:(0,m["default"])(t,O),renderer:"canvas",afterRender:function(){t.setAttribute("src",i.toDataURL())}}}if("undefined"!=typeof SVGElement&&t instanceof SVGElement)return{element:t,options:(0,m["default"])(t,O),renderer:"svg"};if("undefined"!=typeof HTMLCanvasElement&&t instanceof HTMLCanvasElement)return{element:t,options:(0,m["default"])(t,O),renderer:"canvas"};if(t.getContext)return{element:t,renderer:"canvas"};throw new Error("Not supported type to render on.")}var f=n(5),c=r(f),h=n(9),l=r(h),d=n(4),p=r(d),g=n(8),y=r(g),v=n(6),b=r(v),x=n(7),m=r(x),_=function(){},w=function(t,e,n){var r=new _;if("undefined"==typeof t)throw Error("No element to render on was provided.");return r._renderProperties=u(t),r._encodings=[],r._options=O,"undefined"!=typeof e&&(n=n||{},n.format||(n.format=s()),r.options(n),r[n.format](e,n),r.render()),r};w.getModule=function(t){return c["default"][t]};for(var C in c["default"])c["default"].hasOwnProperty(C)&&i(c["default"],C);_.prototype.options=function(t){return this._options=(0,p["default"])(this._options,t),this},_.prototype.blank=function(t){var e="0".repeat(t);return this._encodings.push({data:e}),this},_.prototype.init=function(){Array.isArray(this._renderProperties)||(this._renderProperties=[this._renderProperties]);var t;for(var e in this._renderProperties){t=this._renderProperties[e];var n=(0,p["default"])(this._options,t.options);"auto"==n.format&&(n.format=s());var r=n.value,i=c["default"][n.format.toUpperCase()],u=o(r,i,n);a(t,u,n)}},_.prototype.render=function(){if(Array.isArray(this._renderProperties))for(var t in this._renderProperties)a(this._renderProperties[t],this._encodings,this._options);else a(this._renderProperties,this._encodings,this._options);return this._options.valid(!0),this},"undefined"!=typeof window&&(window.JsBarcode=w),"undefined"!=typeof jQuery&&(jQuery.fn.JsBarcode=function(t,e){var n=[];return jQuery(this).each(function(){n.push(this)}),w(n,t,e)}),t.exports=w;var O={width:2,height:100,format:"auto",displayValue:!0,fontOptions:"",font:"monospace",textAlign:"center",textPosition:"bottom",textMargin:2,fontSize:20,background:"#ffffff",lineColor:"#000000",margin:10,marginTop:void 0,marginBottom:void 0,marginLeft:void 0,marginRight:void 0,valid:function(t){}}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(2),u=r(a),f=function(t){function e(n){return i(this,e),o(this,t.call(this,String.fromCharCode(208)+n))}return s(e,t),e.prototype.valid=function(){return-1!==this.string.search(/^[\x00-\x5F\xC8-\xCF]+$/)},e}(u["default"]);e["default"]=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(2),u=r(a),f=function(t){function e(n){return i(this,e),o(this,t.call(this,String.fromCharCode(209)+n))}return s(e,t),e.prototype.valid=function(){return-1!==this.string.search(/^[\x20-\x7F\xC8-\xCF]+$/)},e}(u["default"]);e["default"]=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(2),u=r(a),f=function(t){function e(n){return i(this,e),o(this,t.call(this,String.fromCharCode(210)+n))}return s(e,t),e.prototype.valid=function(){return-1!==this.string.search(/^(\xCF*[0-9]{2}\xCF*)+$/)},e}(u["default"]);e["default"]=f},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e,n=t.match(/^[\x00-\x5F\xC8-\xCF]*/)[0].length,r=t.match(/^[\x20-\x7F\xC8-\xCF]*/)[0].length,i=t.match(/^(\xCF*[0-9]{2}\xCF*)*/)[0].length;return e=i>=2?String.fromCharCode(210)+c(t):n>r?String.fromCharCode(208)+u(t):String.fromCharCode(209)+f(t),e=e.replace(/[\xCD\xCE]([^])[\xCD\xCE]/,function(t,e){return String.fromCharCode(203)+e})}function u(t){var e=t.match(/^([\x00-\x5F\xC8-\xCF]+?)(([0-9]{2}){2,})([^0-9]|$)/);if(e)return e[1]+String.fromCharCode(204)+c(t.substring(e[1].length));var n=t.match(/^[\x00-\x5F\xC8-\xCF]+/);return n[0].length===t.length?t:n[0]+String.fromCharCode(205)+f(t.substring(n[0].length))}function f(t){var e=t.match(/^([\x20-\x7F\xC8-\xCF]+?)(([0-9]{2}){2,})([^0-9]|$)/);if(e)return e[1]+String.fromCharCode(204)+c(t.substring(e[1].length));var n=t.match(/^[\x20-\x7F\xC8-\xCF]+/);return n[0].length===t.length?t:n[0]+String.fromCharCode(206)+u(t.substring(n[0].length))}function c(t){var e=t.match(/^(\xCF*[0-9]{2}\xCF*)+/)[0],n=e.length;if(n===t.length)return t;t=t.substring(n);var r=t.match(/^[\x00-\x5F\xC8-\xCF]*/)[0].length,i=t.match(/^[\x20-\x7F\xC8-\xCF]*/)[0].length;return r>=i?e+String.fromCharCode(206)+u(t):e+String.fromCharCode(205)+f(t)}Object.defineProperty(e,"__esModule",{value:!0});var h=n(2),l=r(h),d=function(t){function e(n){i(this,e);var r=o(this,t.call(this,n));if(-1!==n.search(/^[\x00-\x7F\xC8-\xD3]+$/))var r=o(this,t.call(this,a(n)));else var r=o(this,t.call(this,n));return o(r)}return s(e,t),e}(l["default"]);e["default"]=d},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.CODE128C=e.CODE128B=e.CODE128A=e.CODE128=void 0;var i=n(14),o=r(i),s=n(11),a=r(s),u=n(12),f=r(u),c=n(13),h=r(c);e.CODE128=o["default"],e.CODE128A=a["default"],e.CODE128B=f["default"],e.CODE128C=h["default"]},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e,r){n(this,t),this.string=e.toUpperCase(),this.mod43Enabled=r.mod43||!1,this.characters=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","-","."," ","$","/","+","%","*"],this.encodings=[20957,29783,23639,30485,20951,29813,23669,20855,29789,23645,29975,23831,30533,22295,30149,24005,21623,29981,23837,22301,30023,23879,30545,22343,30161,24017,21959,30065,23921,22385,29015,18263,29141,17879,29045,18293,17783,29021,18269,17477,17489,17681,20753,35770]}return t.prototype.getEncoding=function(t){return this.getBinary(this.characterValue(t))},t.prototype.getBinary=function(t){return this.encodings[t].toString(2)},t.prototype.getCharacter=function(t){return this.characters[t]},t.prototype.characterValue=function(t){return this.characters.indexOf(t)},t.prototype.encode=function(){for(var t=this.string,e=this.getEncoding("*"),n=0;n<this.string.length;n++)e+=this.getEncoding(this.string[n])+"0";if(this.mod43Enabled){for(var r=0,n=0;n<this.string.length;n++)r+=this.characterValue(this.string[n]);r%=43,e+=this.getBinary(r)+"0",t+=this.getCharacter(r)}return e+=this.getEncoding("*"),{data:e,text:t}},t.prototype.valid=function(){return-1!==this.string.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/)},t}();e.CODE39=r},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),s=r(o),a=function(){function t(e,n){i(this,t),-1!==e.search(/^[0-9]{12}$/)?this.string=e+this.checksum(e):this.string=e,this.displayValue=n.displayValue,this.structure=["LLLLLL","LLGLGG","LLGGLG","LLGGGL","LGLLGG","LGGLLG","LGGGLL","LGLGLG","LGLGGL","LGGLGL"],n.fontSize>10*n.width?this.fontSize=10*n.width:this.fontSize=n.fontSize,this.guardHeight=n.height+this.fontSize/2+n.textMargin,this.lastChar=n.lastChar}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{13}$/)&&this.string[12]==this.checksum(this.string)},t.prototype.encode=function(){var t=new s["default"],e=[],n=this.structure[this.string[0]],r=this.string.substr(1,6),i=this.string.substr(7,6);return this.displayValue&&e.push({data:"000000000000",text:this.string[0],options:{textAlign:"left",fontSize:this.fontSize}}),e.push({data:"101",options:{height:this.guardHeight}}),e.push({data:t.encode(r,n),text:r,options:{fontSize:this.fontSize}}),e.push({data:"01010",options:{height:this.guardHeight}}),e.push({data:t.encode(i,"RRRRRR"),text:i,options:{fontSize:this.fontSize}}),e.push({data:"101",options:{height:this.guardHeight}}),this.lastChar&&this.displayValue&&(e.push({data:"00"}),e.push({data:"00000",text:this.lastChar,options:{fontSize:this.fontSize}})),e},t.prototype.checksum=function(t){var e,n=0;for(e=0;12>e;e+=2)n+=parseInt(t[e]);for(e=1;12>e;e+=2)n+=3*parseInt(t[e]);return(10-n%10)%10},t}();e["default"]=a},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),s=r(o),a=function(){function t(e){i(this,t),this.string=e,this.structure=["LL","LG","GL","GG"]}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{2}$/)},t.prototype.encode=function(){var t=new s["default"],e=this.structure[parseInt(this.string)%4],n="1011";return n+=t.encode(this.string,e,"01"),{data:n,text:this.string}},t}();e["default"]=a},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),s=r(o),a=function(){function t(e){i(this,t),this.string=e,this.structure=["GGLLL","GLGLL","GLLGL","GLLLG","LGGLL","LLGGL","LLLGG","LGLGL","LGLLG","LLGLG"]}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{5}$/)},t.prototype.encode=function(){var t=new s["default"],e=this.checksum(),n="1011";return n+=t.encode(this.string,this.structure[e],"01"),{data:n,text:this.string}},t.prototype.checksum=function(){var t=0;return t+=3*parseInt(this.string[0]),t+=9*parseInt(this.string[1]),t+=3*parseInt(this.string[2]),t+=9*parseInt(this.string[3]),t+=3*parseInt(this.string[4]),t%10},t}();e["default"]=a},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),s=r(o),a=function(){function t(e){i(this,t),-1!==e.search(/^[0-9]{7}$/)?this.string=e+this.checksum(e):this.string=e}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{8}$/)&&this.string[7]==this.checksum(this.string)},t.prototype.encode=function(){var t=new s["default"],e="",n=this.string.substr(0,4),r=this.string.substr(4,4);return e+=t.startBin,e+=t.encode(n,"LLLL"),e+=t.middleBin,e+=t.encode(r,"RRRR"),e+=t.endBin,{data:e,text:this.string}},t.prototype.checksum=function(t){var e,n=0;for(e=0;7>e;e+=2)n+=3*parseInt(t[e]);for(e=1;7>e;e+=2)n+=parseInt(t[e]);return(10-n%10)%10},t}();e["default"]=a},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),s=r(o),a=function(){function t(e,n){i(this,t),-1!==e.search(/^[0-9]{11}$/)?this.string=e+this.checksum(e):this.string=e,this.displayValue=n.displayValue,n.fontSize>10*n.width?this.fontSize=10*n.width:this.fontSize=n.fontSize,this.guardHeight=n.height+this.fontSize/2+n.textMargin}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{12}$/)&&this.string[11]==this.checksum(this.string)},t.prototype.encode=function(){var t=new s["default"],e=[];return this.displayValue&&e.push({data:"00000000",text:this.string[0],options:{textAlign:"left",fontSize:this.fontSize}}),e.push({data:"101"+t.encode(this.string[0],"L"),options:{height:this.guardHeight}}),e.push({data:t.encode(this.string.substr(1,5),"LLLLL"),text:this.string.substr(1,5),options:{fontSize:this.fontSize}}),e.push({data:"01010",options:{height:this.guardHeight}}),e.push({data:t.encode(this.string.substr(6,5),"RRRRR"),text:this.string.substr(6,5),options:{fontSize:this.fontSize}}),e.push({data:t.encode(this.string[11],"R")+"101",options:{height:this.guardHeight}}),this.displayValue&&e.push({data:"00000000",text:this.string[11],options:{textAlign:"right",fontSize:this.fontSize}}),e},t.prototype.checksum=function(t){var e,n=0;for(e=1;11>e;e+=2)n+=parseInt(t[e]);for(e=0;11>e;e+=2)n+=3*parseInt(t[e]);return(10-n%10)%10},t}();e["default"]=a},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.UPC=e.EAN2=e.EAN5=e.EAN8=e.EAN13=void 0;var i=n(17),o=r(i),s=n(20),a=r(s),u=n(19),f=r(u),c=n(18),h=r(c),l=n(21),d=r(l);e.EAN13=o["default"],e.EAN8=a["default"],e.EAN5=f["default"],e.EAN2=h["default"],e.UPC=d["default"]},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.string=e}return t.prototype.encode=function(){return{data:"10101010101010101010101010101010101010101",text:this.string}},t.prototype.valid=function(){return!0},t}();e.GenericBarcode=r},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.string=e,this.binaryRepresentation={0:"00110",1:"10001",2:"01001",3:"11000",4:"00101",5:"10100",6:"01100",7:"00011",8:"10010",9:"01010"}}return t.prototype.valid=function(){return-1!==this.string.search(/^([0-9]{2})+$/)},t.prototype.encode=function(){for(var t="1010",e=0;e<this.string.length;e+=2)t+=this.calculatePair(this.string.substr(e,2));return t+="11101",{data:t,text:this.string}},t.prototype.calculatePair=function(t){for(var e="",n=this.binaryRepresentation[t[0]],r=this.binaryRepresentation[t[1]],i=0;5>i;i++)e+="1"==n[i]?"111":"1",e+="1"==r[i]?"000":"0";return e},t}();e.ITF=r},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.string=e,-1!==e.search(/^[0-9]{13}$/)&&(this.string+=this.checksum(e)),this.binaryRepresentation={0:"00110",1:"10001",2:"01001",3:"11000",4:"00101",5:"10100",6:"01100",7:"00011",8:"10010",9:"01010"}}return t.prototype.valid=function(){return-1!==this.string.search(/^[0-9]{14}$/)&&this.string[13]==this.checksum()},t.prototype.encode=function(){for(var t="1010",e=0;14>e;e+=2)t+=this.calculatePair(this.string.substr(e,2));return t+="11101",{data:t,text:this.string}},t.prototype.calculatePair=function(t){for(var e="",n=this.binaryRepresentation[t[0]],r=this.binaryRepresentation[t[1]],i=0;5>i;i++)e+="1"==n[i]?"111":"1",e+="1"==r[i]?"000":"0";return e},t.prototype.checksum=function(){for(var t=0,e=0;13>e;e++)t+=parseInt(this.string[e])*(3-e%2*2);return 10-t%10},t}();e.ITF14=r},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),f=n(3),c=function(t){function e(n){i(this,e);var r=o(this,t.call(this,n));return r.string+=(0,f.mod10)(r.string),r}return s(e,t),e}(u["default"]);e["default"]=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),f=n(3),c=function(t){function e(n){i(this,e);var r=o(this,t.call(this,n));return r.string+=(0,f.mod10)(r.string),r.string+=(0,f.mod10)(r.string),r}return s(e,t),e}(u["default"]);e["default"]=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),f=n(3),c=function(t){function e(n){i(this,e);var r=o(this,t.call(this,n));return r.string+=(0,f.mod11)(r.string),r}return s(e,t),e}(u["default"]);e["default"]=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function o(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=n(1),u=r(a),f=n(3),c=function(t){function e(n){i(this,e);var r=o(this,t.call(this,n));return r.string+=(0,f.mod11)(r.string),r.string+=(0,f.mod10)(r.string),r}return s(e,t),e}(u["default"]);e["default"]=c},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0}),e.MSI1110=e.MSI1010=e.MSI11=e.MSI10=e.MSI=void 0;var i=n(1),o=r(i),s=n(26),a=r(s),u=n(28),f=r(u),c=n(27),h=r(c),l=n(29),d=r(l);e.MSI=o["default"],e.MSI10=a["default"],e.MSI11=f["default"],e.MSI1010=h["default"],e.MSI1110=d["default"]},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(e){n(this,t),this.number=parseInt(e,10)}return t.prototype.encode=function(){for(var t=this.number,e="";!isNaN(t)&&0!=t;)t%2===0?(e="11100"+e,t=(t-2)/2):(e="100"+e,t=(t-1)/2);return e=e.slice(0,-2),{data:e,text:this.number+""}},t.prototype.valid=function(){return this.number>=3&&this.number<=131070},t}();e.pharmacode=r},function(t,e){"use strict";function n(t){var e=["width","height","textMargin","fontSize","margin","marginTop","marginBottom","marginLeft","marginRight"];for(var n in e)n=e[n],"string"==typeof t[n]&&(t[n]=parseInt(t[n],10));return"string"==typeof t.displayValue&&(t.displayValue="false"!=t.displayValue),t}Object.defineProperty(e,"__esModule",{value:!0}),e["default"]=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e,n){if(!t.getContext)throw new Error("The browser does not support canvas.");o(t,n,e);for(var r=0;r<e.length;r++){var i=(0,h["default"])(n,e[r].options);s(t,i,e[r]),a(t,i,e[r]),u(t,e[r])}f(t)}function o(t,e,n){var r=t.getContext("2d");r.save();for(var i=0,o=0,s=0;s<n.length;s++){var a=(0,h["default"])(a,n[s].options);r.font=a.fontOptions+" "+a.fontSize+"px "+a.font;var u=r.measureText(n[s].text).width,f=n[s].data.length*a.width;n[s].width=Math.ceil(Math.max(u,f));var c=a.height+(a.displayValue&&n[s].text.length>0?a.fontSize:0)+a.textMargin+a.marginTop+a.marginBottom,l=0;a.displayValue&&u>f&&("center"==a.textAlign?l=Math.floor((u-f)/2):"left"==a.textAlign?l=0:"right"==a.textAlign&&(l=Math.floor(u-f))),n[s].barcodePadding=l,c>o&&(o=c),i+=n[s].width}t.width=i+e.marginLeft+e.marginRight,t.height=o,r.clearRect(0,0,t.width,t.height),e.background&&(r.fillStyle=e.background,r.fillRect(0,0,t.width,t.height)),r.translate(e.marginLeft,0)}function s(t,e,n){var r,i,o=t.getContext("2d"),s=n.data;r="top"==e.textPosition?e.marginTop+e.fontSize+e.textMargin:e.marginTop,i=e.height,o.fillStyle=e.lineColor;for(var a=0;a<s.length;a++){var u=a*e.width+n.barcodePadding;"1"===s[a]?o.fillRect(u,r,e.width,e.height):s[a]&&o.fillRect(u,r,e.width,e.height*s[a])}}function a(t,e,n){var r=t.getContext("2d"),i=e.fontOptions+" "+e.fontSize+"px "+e.font;if(e.displayValue){var o,s;s="top"==e.textPosition?e.marginTop+e.fontSize-e.textMargin:e.height+e.textMargin+e.marginTop+e.fontSize,r.font=i,"left"==e.textAlign||n.barcodePadding>0?(o=0,r.textAlign="left"):"right"==e.textAlign?(o=n.width-1,r.textAlign="right"):(o=n.width/2,r.textAlign="center"),r.fillText(n.text,o,s)}}function u(t,e){var n=t.getContext("2d");n.translate(e.width,0)}function f(t){var e=t.getContext("2d");e.restore()}Object.defineProperty(e,"__esModule",{value:!0});var c=n(4),h=r(c);e["default"]=i},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e,n){var r=n.marginLeft;o(t,n,e);for(var i=0;i<e.length;i++){var u=(0,d["default"])(n,e[i].options),h=f(r,u.marginTop,t);c(h,u,e[i]),
s(h,u,e[i]),a(h,u,e[i]),r+=e[i].width}}function o(t,e,n){for(;t.firstChild;)t.removeChild(t.firstChild);for(var r=0,i=0,o=0;o<n.length;o++){var s=(0,d["default"])(s,n[o].options),a=u(n[o].text,t,s),f=n[o].data.length*s.width;n[o].width=Math.ceil(Math.max(a,f));var c=s.height+(s.displayValue&&n[o].text.length>0?s.fontSize:0)+s.textMargin+s.marginTop+s.marginBottom,h=0;s.displayValue&&a>f&&("center"==s.textAlign?h=Math.floor((a-f)/2):"left"==s.textAlign?h=0:"right"==s.textAlign&&(h=Math.floor(a-f))),n[o].barcodePadding=h,c>i&&(i=c),r+=n[o].width}var l=r+e.marginLeft+e.marginRight,g=i;t.setAttribute("width",l+"px"),t.setAttribute("height",g+"px"),t.setAttribute("x","0px"),t.setAttribute("y","0px"),t.setAttribute("viewBox","0 0 "+l+" "+g),t.setAttribute("xmlns",p),t.setAttribute("version","1.1"),t.style.transform="translate(0,0)",e.background&&(t.style.background=e.background)}function s(t,e,n){var r,i,o=n.data;r="top"==e.textPosition?e.fontSize+e.textMargin:0,i=e.height;for(var s=0,a=0;a<o.length;a++){var u=a*e.width+n.barcodePadding;"1"===o[a]?s++:s>0&&(h(u-e.width*s,r,e.width*s,e.height,t),s=0)}s>0&&h(u-e.width*(s-1),r,e.width*s,e.height,t)}function a(t,e,n){var r=document.createElementNS(p,"text");if(e.displayValue){var i,o;r.setAttribute("style","font:"+e.fontOptions+" "+e.fontSize+"px "+e.font),o="top"==e.textPosition?e.fontSize-e.textMargin:e.height+e.textMargin+e.fontSize,"left"==e.textAlign||n.barcodePadding>0?(i=0,r.setAttribute("text-anchor","start")):"right"==e.textAlign?(i=n.width-1,r.setAttribute("text-anchor","end")):(i=n.width/2,r.setAttribute("text-anchor","middle")),r.setAttribute("x",i),r.setAttribute("y",o),r.appendChild(document.createTextNode(n.text)),t.appendChild(r)}}function u(t,e,n){var r=document.createElement("canvas").getContext("2d");r.font=n.fontOptions+" "+n.fontSize+"px "+n.font;var i=r.measureText(t).width;return i}function f(t,e,n){var r=document.createElementNS(p,"g");return r.setAttribute("transform","translate("+t+", "+e+")"),n.appendChild(r),r}function c(t,e,n){t.setAttribute("style","fill:"+e.lineColor+";")}function h(t,e,n,r,i){var o=document.createElementNS(p,"rect");o.setAttribute("x",t),o.setAttribute("y",e),o.setAttribute("width",n),o.setAttribute("height",r),i.appendChild(o)}Object.defineProperty(e,"__esModule",{value:!0});var l=n(4),d=r(l);e["default"]=i;var p="http://www.w3.org/2000/svg"}]);

(function () {
	'use strict';

	angular.module('tms').controller('LoginController', LoginController);

  function LoginController($state, $scope, AuthService) {
    var vm = this;

    vm.error = false;
    vm.user = {
      remember: angular.fromJson(AuthService.remember())
    };

    vm.submit = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (vm.loginform.$invalid) {
        return;
      }
      vm.loading = true;
      AuthService.login(vm.user).then(function () {
        $state.go(AuthService.init().home);
      }).catch(function () {
        vm.error = true;
      }).finally(function(){
        vm.loading = false;
      });
    }
  }

})();

(function () {
	'use strict';

	angular.module('tms').service('AuthService', AuthService);

  function findOne(haystack, arr) {
    return arr.every(function (v) {
      return haystack.indexOf(v) >= 0;
    });
  }

	function AuthService($q, $log, $cookies, $state, $http, $window, Restangular) {
		var self = this,
			now = new Date(),
			exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate()),
			userData = {},
      access = {
        admin: {rules: 9999, home: 'main.events'}, //main.events,
        read_organizer: {rules: 9333, home: 'main.events'},
        // partner: {rules: 9333, home: 'main.events'},
        call_centre: {rules: 8333, home: 'main.events'},
        order_manager: {rules: 301, home: 'main.cashier.order'},
        organizer_manager: {rules: 9333, home: 'main.events'},
        financier: {rules: 9333, home: 'main.events'},
        technical_support: {rules: 8333, home: 'main.events'},
        read_admin: {rules: 9333, home: 'main.events'},
				cashier: {rules: 301, home: 'main.cashier.order'},
        senior_cashier: {rules: 301, home: 'main.cashier.order'},
				content_manager: {rules: 0, home: 'main.help'},
				widget_holder: {rules: 0, home: 'main.statistics.widgets'},
        user: {rules: 0, home: 'login'}
      };

    Restangular.setErrorInterceptor(function(response, deferred, responseHandler) {
      if(response.status === 406) {
        self.refreshToken().then(function(refresh) {
          self.setUser(refresh.plain() || {});
          // Repeat the request and then call the handlers the usual way.
          // $log.log(refresh.access_token, response.config.url)
          response.config.headers = { 'Authorization': 'Bearer ' + refresh.access_token };
          $http(response.config).then(responseHandler, deferred.reject);
        });
        return false;
      }
      return true;
    });

		self.init = function () {
			userData = $cookies.getObject('user');
      if (userData) {
        Restangular.setDefaultHeaders({ 'Authorization': 'Bearer ' + userData.access_token });
        userData.home = access[userData.role].home || '';
      }
			return userData;
		}

		self.setUser = function (newData) {
      // hiding widgets statistics for admins because currently it is not possible to remove
      // widgetsStatistics permission for them on backend
      newData = hideWidgetsStatisticsforAdmin(newData);

      var opt = (userData.remember) ? { expires: exp } : {};
			angular.merge(userData, newData);
			$cookies.putObject('user', userData, opt);
			self.init();
		}

		self.updateMe = function (data) {
			if (data.id !== userData.id)
				return;
			angular.extend(userData, data);
      self.setUser({});
		}

		self.login = function (userAuthData) {
			userData = {remember: userAuthData.remember};
			return Restangular.one('auth').post('signin', userAuthData).then(function (response) {
        self.remember(userAuthData.remember);
        self.setUser(response);
			});
		}

		self.logout = function () {
			return Restangular.one('auth').post('logout', {}).then(function () {
				userData = {};
				$cookies.remove('user');
        $window.location.reload();
			});
		}

    var token = false;
		self.refreshToken = function () {
      var deferred = $q.defer();
      if (!token) {
        token = true;
        return Restangular.one('auth').post('refresh-token', {
          refresh_token: userData.refresh_token
        }).then(function(response){
          token = false;
          deferred.resolve(response);
          return response;
        });
      } else {
        // $log.log(deferred.promise)
        return deferred.promise;
      }
		}

		self.remember = function (val) {
			if (_.isBoolean(val))
				localStorage.setItem('remember', val);
			return localStorage.getItem('remember');
		}

    self.nav = function(){
      if (userData && userData.accessList)
      return _.filter($state.get(), function(o){
        o.permissions = o.permissions || ['none'];
        o.show = findOne(userData.accessList.permissions, o.permissions);
        return o.show;
      });
      else return [];
    }

    self.access = function (permissions) {
      return findOne(userData.accessList.permissions, permissions);
    }

    self.permissions = function() {
      return Restangular.one('access').one('user').one(userData.id+'').get();
    }

    self.permissionsList = function() {
      return Restangular.one('access').one('permissions').get().then(function(response){
        return _.flatten(_.map(response, 'children'));
      });
    }
	}

  function hideWidgetsStatisticsforAdmin(newData) {
    if (newData && newData.accessList && newData.accessList.permissions && newData.accessList.roles &&
      _.includes(newData.accessList.roles, 'admin')
    ) {
      newData.accessList.permissions = _.filter(newData.accessList.permissions, function (permission) {
        return permission !== 'widgetsStatistics';
      });
    }
    return newData;
  }

})();

(function () {
	'use strict';
	angular.module('tms').config(runRoutingSetup);

	function runRoutingSetup($stateProvider) {
		$stateProvider.state('login', {
			url: '/login',
      title: 'Login',
      controller: 'LoginController as vm',
      templateUrl: 'app/auth/login.view.html',
      permissions: ['user']
		});
    $stateProvider.state('403', {
			url: '/403',
      title: '403',
      templateUrl: 'app/auth/403.html',
      permissions: ['user']
		});
	}
})();

(function () {
  'use strict';
  angular.module('tms')
    .run(function (AuthService, $rootScope, $state, $timeout, $window) {

      angular.element('body').on('click', '.dropdown-search', function (e) {
        e.stopPropagation();
      });

      $rootScope.$on("$stateChangeSuccess", function (event, next) { // eslint-disable-line
        $timeout(function () {
          $window.document.title = next.title + ' - TMS';
        });
      });

      $rootScope.$on("$stateChangeStart", function (event, next, params) { // eslint-disable-line
        if (next.redirectTo) {
          event.preventDefault();
          $state.go(next.redirectTo, params); //, {notify: true}
          //unbindStateChangeEvent();
          return;
        }
        
      });
    });
})();

// (function () {
// 	'use strict';
// 	angular.module('tms').config(runRoutingSetup);
//
// 	function runRoutingSetup($stateProvider) {
// 		// $stateProvider.state('home', {
// 		// 	url: '',
//     //   redirectTo: 'main.events'
// 		// });
// 	}
// })();

// (function (angular) {
// 	'use strict';
// 	angular.module('tc')
// 		.constant('SERVICE_URLS', {
// 			login: '/index.php/auth/signin',
// 			logout: '/index.php/auth/logout',
// 			refreshToken: '/index.php/auth/refresh-token',
// 			getUser: '/index.php/user/',
// 			getEvents: '/index.php/events',
// 			getEvent: '/index.php/event',
// 			getCountryList: '/index.php/geo/countries',
// 			updateCityList: '/index.php/geo/cities',
// 			updateLocationList: '/index.php/halls',
// 			updateAreaList: '/index.php/schemes',
// 			eventCreate: '/index.php/event',
// 			eventUpdate: '/index.php/event/',
// 			getUsers: '/index.php/users',
// 			deleteUser: '/index.php/user',
// 			createUser: '/index.php/user',
// 			updateUser: '/index.php/user',
// 			getPlayers: '/index.php/companies',
// 			deletePlayer: '/index.php/company',
// 			getAllCompanies: '/index.php/companies-list',
// 			getProbablePlayerNames: '/index.php/company/officials-list',
// 			getPlayer: '/index.php/company',
// 			getProbablePlayerPositions: '/index.php/user/positions-list',
// 			createPlayer: '/index.php/company',
// 			updatePlayer: '/index.php/company',
// 			listQuotes: '/index.php/quotas',
// 			getQuote: '/index.php/quota',
// 			getTickets: '/index.php/quota/invoice/',
// 			getTickets2: '/index.php/tickets',
// 			zonesList: '/index.php/scheme/zones-list',
// 			quotaXLS: '/index.php/report/quota-xls/',
// 			getoredersXLSurl: '/index.php',
// 			getOrders: '/index.php/orders',
// 			order: '/index.php/order',
// 			searchOrderUrl: '/index.php/orders',
// 			usersList: '/index.php/users-list',
// 			uploadImg: '/index.php/file',
// 			favEvent: '/index.php/event/',
// 			stat: '/index.php/report/event-total/',
// 			sliders: '/index.php/sliders',
// 			slider: '/index.php/slider',
// 			news: '/index.php/news'
// 		})
// 		.constant('uiDatetimePickerConfig', {
// 			dateFormat: 'dd-MM-yyyy HH:mm',
// 			defaultTime: '00:00:00',
// 			showMeridian: false
// 		});
// })(angular);

(function () {
  'use strict';
  angular.module('tms')
    .config(function ($provide, $injector, $urlRouterProvider, RestangularProvider, highchartsNGProvider, toastrConfig, $httpProvider) {

      $provide.decorator('$state', function($delegate, $rootScope) {
        $rootScope.$on('$stateChangeStart', function(event, state, params) { // eslint-disable-line
          $delegate.next = state;
          $delegate.toParams = params;
        });
        return $delegate;
      });

      $provide.decorator('uiSrefDirective', function($delegate, AuthService) {
        var uiSref = $delegate[0],
          link = uiSref.link;
        var nav = AuthService.nav();
        uiSref.compile = function() {
          return function(scope, element, attrs) {
            if (!_.find(nav, {name: attrs.uiSref.split('(')[0]}))
              element.addClass('disabled');
            link.apply(this, arguments);
          };
        };
        return $delegate;
      });

      $urlRouterProvider.otherwise('/');

      RestangularProvider.setBaseUrl('index.php/');
      //RestangularProvider.setBaseUrl('https://dev-tms.test-kasa.in.ua/index.php/');

      // RestangularProvider.setDefaultHttpFields({cache: true});

      highchartsNGProvider.lazyLoad();

      toastrConfig.allowHtml = true;
      toastrConfig.timeOut = 5*60000;
      toastrConfig.positionClass = 'toast-top-right';
      toastrConfig.preventDuplicates = false;
      toastrConfig.progressBar = true;
      toastrConfig.closeButton = true;
      toastrConfig.extendedTimeOut = toastrConfig.timeOut;
      toastrConfig.tapToDismiss = false;

      moment.locale('uk');

      // Error interceptors
      $httpProvider.interceptors.push(['$injector', '$q', function ($injector, $q) {
        var msg = 'Unknown Error';
        return {
          responseError: function (rejection) {
            if (rejection.data && rejection.data.error_msg && _.isObject(rejection.data.error_msg)) {
              msg = '';
              _.each(rejection.data.error_msg, function(v, i){
                msg += i + ' - '+ v[0];
              });
            }
            if (rejection.data && rejection.data.error_msg && _.isString(rejection.data.error_msg)) {
              msg = rejection.data.error_msg;
            }
            //	msg = rejection.data.error_msg;
            switch (rejection.status) {
              case 403:
                $injector.get('toastr').error('Error ' + rejection.status + ': ' + msg);
                break;
              case 401:
                $injector.get('$state').go('login');
                break;
              case 406:
                break;
              case 412:
                break;
              // case 500:
              // $injector.get('$state').reload();
              //	break;
              default:
                $injector.get('toastr').error('Error ' + rejection.status + ': ' + msg);
                break;
            }
            return $q.reject(rejection);
          }
        }
      }]);
    })
})();

angular.module("tms").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/403.html","permission denied");
$templateCache.put("app/auth/login.view.html","<section class=\"kassa-login container-fluid\"><div class=\"row\"><div class=\"col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4\"><h3 class=\"kassa-login-heading text-center\"><img class=\"logo\" src=\"/assets/images/logo-inv.png\"></h3><form name=\"vm.loginform\" ng-submit=\"vm.submit($event)\" class=\"kassa-login-form\" novalidate autocomplete=\"off\"><!-- <input type=\"submit\" class=\"hidden\" id=\"submit\"/> --><div class=\"form-group\" show-errors><input name=\"username\" type=\"text\" class=\"form-control\" ng-model=\"vm.user.username\" required placeholder=\"Логін\"> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" show-errors><input name=\"pass\" type=\"password\" class=\"form-control\" ng-model=\"vm.user.password\" required placeholder=\"Пароль\"> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"login-checkbox\"><label for=\"form-control\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.user.remember\"><i></i>пам’ятати мене</label></label></div><hr><div class=\"error-block text-center\" ng-class=\"{hidden: !vm.error}\"><p class=\"errorMessage\">Невірний логін або пароль!</p></div><div class=\"text-center\"><button type=\"submit\" class=\"btn btn-primary\" stateful>Вхід</button></div></form><footer class=\"kassa-login-footer\"><p>Ticket Management System, © 2016</p></footer></div></div></section>");
$templateCache.put("app/main/main.view.html","<header ng-include=\"\'app/components/navbar/navbar.view.html\'\" class=\"kassa-nav\"></header><section ui-view class=\"main-section fade-in-down-big container-fluid\">asd</section>");
$templateCache.put("app/print/print.view.html","<!-- fix for 1 ticket print --><style>html {\n    min-height: 0;\n  }</style><section class=\"ac stop-print\" ng-if=\"vm.type === \'e_blank\'\" ng-repeat=\"t in vm.tickets\"><div ng-include=\"\'app/print/templates/\' + t.printTemplateID +\'/e_blank.html\'\"></div></section><section class=\"a4\" ng-if=\"vm.type === \'a4\'\" ng-repeat=\"t in vm.tickets\"><div ng-include=\"\'app/print/templates/\' + t.printTemplateID +\'/a4.html\'\"></div></section><section class=\"a5\" ng-if=\"vm.type === \'a5\'\" ng-repeat=\"t in vm.tickets\"><div ng-include=\"\'app/print/templates/\' + t.printTemplateID +\'/a5.html\'\"></div></section><!-- *********************************************************************** -->");
$templateCache.put("app/components/navbar/navbar.view.html","<kassa-navigation><nav class=\"navbar navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header col-md-2\"><button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\"#myNavbar\" ng-click=\"vm.navCollapsed = !vm.navCollapsed\"><span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"{{vm.userData.home}}\"><img class=\"hidden-xs hidden-sm\" src=\"assets/images/logo-inv.png\"> <span class=\"visible-xs-block visible-sm-block\"><b>TMS</b></span></a></div><div class=\"collapse navbar-collapse nav-collapse\" id=\"myNavbar\" uib-collapse=\"vm.navCollapsed\"><ul class=\"nav navbar-nav\"><li uib-dropdown ng-repeat=\"item in vm.menuContent | orderBy: \'position\'\" ui-sref-active=\"active\" ng-if=\"!item.parent\"><a ng-if=\"!item.abstract\" ng-click=\"vm.navCollapsed = true\" ui-sref=\"{{item.name}}\"><span>{{item.title}}</span> </a><a ng-if=\"item.abstract\" uib-dropdown-toggle><span>{{item.title}}</span> <span ng-if=\"!!item.children.length\" class=\"caret\"></span></a><ul ng-if=\"!!item.children.length\" class=\"dropdown-menu\" uib-dropdown-menu><li ng-repeat=\"subitem in item.children\" ng-if=\"subitem.menu && subitem.show\"><a ui-sref=\"{{subitem.name}}\" ng-if=\"subitem.menu\" ng-click=\"vm.navCollapsed = true\"><span>{{subitem.title}}</span></a></li></ul></li></ul><ul class=\"nav navbar-nav navbar-right\"><li><a ng-href=\"{{vm.kasalink}}\" target=\"_blank\"><i class=\"glyphicon glyphicon-share\"></i> kasa.in.ua</a></li><li uib-dropdown><a uib-dropdown-toggle><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-xs hidden-sm\"><b>{{vm.userData.firstName}}</b></span> <span class=\"caret\"></span></a><ul uib-dropdown-menu class=\"text-right\"><li access=\"manageUsers\"><a ui-sref=\"main.configs.user({id: vm.userData.id})\">Профiль</a></li><li><a ng-click=\"vm.logout()\">Вийти</a></li></ul></li></ul></div></div></nav></kassa-navigation>");
$templateCache.put("app/main/api/explorer.html","");
$templateCache.put("app/main/api/tests.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Tests</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.run()\">Запустити</a></span></div></header><div class=\"row\"><section class=\"col-md-12\" style=\"position: relative\"><div id=\"mocha\"></div><div id=\"messages\"></div><div id=\"fixtures\"></div></section></div>");
$templateCache.put("app/main/cashier/cashier.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Каса</span></div></header>");
$templateCache.put("app/main/help/help.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Інструкції</span></div></header><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-striped table-bordered table-responsive\"><tr><td class=\"col-md-8\"><a href=\"assets/pdf/cashier.pdf\" target=\"_blank\" download>Інструкція для касира</a></td><td class=\"col-md-2\">1.26 MB</td><td class=\"col-md-2\">.PDF</td></tr><tr><td class=\"col-md-8\"><a href=\"assets/pdf/quotes.pdf\" target=\"_blank\" download>Квоти. Створення, перегляд і редагування</a></td><td class=\"col-md-2\">933 KB</td><td class=\"col-md-2\">.PDF</td></tr><tr><td class=\"col-md-8\"><a href=\"assets/pdf/manager.pdf\" target=\"_blank\" download>Менеджер замовлень</a></td><td class=\"col-md-2\">883 KB</td><td class=\"col-md-2\">.PDF</td></tr><tr><td class=\"col-md-8\"><a href=\"assets/pdf/events_prices.pdf\" target=\"_blank\" download>Події і розцінка місць</a></td><td class=\"col-md-2\">1.52 MB</td><td class=\"col-md-2\">.PDF</td></tr></table></div></div>");
$templateCache.put("app/main/events/event.edit.html","<header ng-include=\"\'app/main/events/event.header.html\'\"></header><form ng-submit=\"vm.submit($event);\" name=\"vm.createevent\" novalidate autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><uib-tabset active=\"active\"><uib-tab index=\"0\" heading=\"Загальна інформація\"><br><div class=\"event-group-group row\"><div class=\"col-lg-4 form-group\" show-errors><label class=\"star\">Назва</label><input type=\"text\" name=\"name\" class=\"form-control\" placeholder=\"Назва\" ng-model=\"vm.event.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-lg-2 form-group\"><label class=\"star\">Статус події</label><selectlist input-model=\"vm.eventStatusList\" output-model=\"vm.event.status\" hidesearch></selectlist></div><div class=\"col-lg-2 form-group\" show-dd-errors=\"vm.event.type\"><label class=\"star\">Категорiя події</label><selectlist input-model=\"vm.categories\" output-model=\"vm.event.type\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-lg-2 form-group\" show-dd-errors=\"vm.event.genre\"><label class=\"star\">Жанри</label><selectlist input-model=\"vm.genre\" output-model=\"vm.event.genre\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-lg-2 form-group\" show-dd-errors=\"vm.event.organizerID\"><label class=\"star\">Органiзатор</label><selectlist input-method=\"vm.players\" output-model=\"vm.event.organizerID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><!-- <div class=\"col-lg-2 form-group\" show-dd-errors=\"vm.event.artistsID\">\n          <label class=\"star\">Артисти</label>\n          <selectlistartist input-method=\"vm.artists\" output-model=\"vm.event.artistsID\" multiselect required></selectlistartist>\n          <span class=\"help-block\">Обов\'язкове поле</span>\n        </div> --></div><div class=\"row\"><div class=\"col-lg-3\"><h3 style=\"margin-top: -7px\">Місце проведення</h3><div class=\"form-group\" show-dd-errors=\"vm.event.countryID\"><label class=\"star\">Краïна</label><selectlist input-method=\"vm.countryList\" output-model=\"vm.event.countryID\" disabled=\"vm.event.id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" show-dd-errors=\"vm.event.cityID\"><label class=\"star\">Мiсто</label><selectlist input-method=\"vm.cityList\" output-model=\"vm.event.cityID\" disabled=\"vm.event.id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" show-dd-errors=\"vm.event.hallID\"><label class=\"star\">Локацiя</label><selectlist input-method=\"vm.locationList\" output-model=\"vm.event.hallID\" disabled=\"vm.event.id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div ng-if=\"vm.mode !== \'main.new_ext_event\'\"><div class=\"form-group\" show-dd-errors=\"vm.event.hallFileID\"><label class=\"star\">Схема</label><selectlist input-method=\"vm.areaList\" output-model=\"vm.event.hallFileID\" disabled=\"vm.event.id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><p class=\"\" ng-show=\"vm.event.id\"><small>Данi не можливо змiнити тому, що вже iснують квитки на цю подiю</small></p></div><!--        <div class=\"col-lg-7\">--><!--          <div map-lazy-load=\"https://maps.googleapis.com/maps/api/js?v=3.exp\"--><!--               map-lazy-load-params=\"{{vm.googleMapsUrl}}\">--><!--            <ng-map center=\"{{vm.geo}}\" zoom=\"12\" scrollwheel=\"false\">--><!--              <marker position=\"{{vm.geo}}\" title=\"Hello World!\"></marker>--><!--            </ng-map>--><!--          </div>--><!--        </div>--><div class=\"col-lg-2\"><div class=\"form-group\" show-dd-errors=\"vm.event.artistsID\"><label class=\"star\">Артисти</label><selectlistartist input-method=\"vm.artists\" output-model=\"vm.event.artistsID\" multiselect required></selectlistartist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\"><label>Тип відповідального</label><selectlist input-model=\"vm.responsibleTypes\" output-model=\"vm.event.responsibleType\" hidesearch></selectlist></div><div class=\"form-group\" ng-show=\"vm.event.responsibleType === vm.constants.responsibleTypes.user\" show-dd-errors=\"vm.event.responsibleID\"><input type=\"hidden\" ng-if=\"vm.event.responsibleType === vm.constants.responsibleTypes.user\" ng-model=\"vm.event.responsibleID\" required><label class=\"star\">Відповідальний менеджер</label><selectlist input-model=\"vm.subdivisionManagers\" output-model=\"vm.event.responsibleID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" ng-show=\"vm.event.responsibleType === vm.constants.responsibleTypes.subdivision\" show-dd-errors=\"vm.event.responsibleID\"><input type=\"hidden\" ng-if=\"vm.event.responsibleType === vm.constants.responsibleTypes.subdivision\" ng-model=\"vm.event.responsibleID\" required><label class=\"star\">Відповідальний підрозділ</label><selectlist input-model=\"vm.subdivisionList\" output-model=\"vm.event.responsibleID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div></div><hr><div class=\"row\"><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Початок</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.event.dateStart\"><input type=\"text\" name=\"datestart\" class=\"form-control\"> <input type=\"hidden\" name=\"datestart\" ng-model=\"vm.event.dateStart\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Закінчення</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.event.dateEnd\" min=\"vm.event.dateStart\"><input type=\"text\" name=\"dateend\" class=\"form-control\"> <input type=\"hidden\" name=\"dateend\" ng-model=\"vm.event.dateEnd\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Вхід з</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.event.dateEntry\" max=\"vm.event.dateStart\"><input type=\"text\" name=\"datentry\" class=\"form-control\" required> <input type=\"hidden\" name=\"datentry\" ng-model=\"vm.event.dateEntry\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Початок продажів</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.event.dateSalesStart\" max=\"vm.event.dateSalesEnd\"><input type=\"text\" name=\"dateSalesStart\" class=\"form-control\"> <input type=\"hidden\" name=\"dateSalesStart\" ng-model=\"vm.event.dateSalesStart\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Закінчення продажів</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.event.dateSalesEnd\" max=\"vm.event.dateEnd\"><input type=\"text\" name=\"dateSalesEnd\" class=\"form-control\"> <input type=\"hidden\" name=\"dateSalesEnd\" ng-model=\"vm.event.dateSalesEnd\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><!-- <label class=\"col-lg-12\">Афіша</label> --><!-- for first label --><div class=\"col-lg-12\"><!-- <div class=\"form-group col-lg-2\">\n              <button type=\"file\" ngf-select=\"vm.uploadFiles($files, $invalidFiles)\"\n                  ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\"\n                  accept=\"image/*\" ngf-max-size=\"5MB\">Додати файл</button>\n          </div> --><!--  <div class=\"col-lg-10\">\n             <div ng-repeat=\"poster in vm.event.posters\" class=\"col-lg-2 posters\">\n               <img ng-src=\"{{vm.imagesUrl + poster.url}}\" style=\"width: 100%\" class=\" img-thumbnail\"/>\n               <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removePoster(poster)\">\n                 <span aria-hidden=\"true\">&times;</span>\n               </button>\n             </div>\n           </div> --></div><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop\" name=\"desktop\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" ngf-max-size=\"10MB\">Додати файл desktop</button> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.maxWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.minWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><!--  ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" --><div class=\"col-lg-10\"><div ng-repeat=\"poster in vm.event.posters_desktop\" class=\"col-lg-5 posters\"><img ng-src=\"{{vm.imagesUrl + poster.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removePoster_desktop(poster)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop_retina\" name=\"desktop_retina\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1600\" ngf-max-width=\"1600\" ngf-max-size=\"10MB\">Додати файл desktop_retina</button> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.maxWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.minWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.desktop_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"poster in vm.event.posters_desktop_retina\" class=\"col-lg-5 posters\"><img ng-src=\"{{vm.imagesUrl + poster.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removePoster_desktop_retina(poster)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile\" name=\"mobile\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"500\" ngf-max-width=\"500\" ngf-max-size=\"10MB\">Додати файл mobile</button> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.maxWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.minWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"poster in vm.event.posters_mobile\" class=\"col-lg-5 posters\"><img ng-src=\"{{vm.imagesUrl + poster.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removePoster_mobile(poster)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile_retina\" name=\"mobile_retina\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1000\" ngf-max-width=\"1000\" ngf-max-size=\"10MB\">Додати файл mobile_retina</button> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.maxWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.minWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.createevent.mobile_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"poster in vm.event.posters_mobile_retina\" class=\"col-lg-5 posters\"><img ng-src=\"{{vm.imagesUrl + poster.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removePoster_mobile_retina(poster)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!--  <div class=\"event-group-group col-lg-12\">\n           <hr>\n           <h4>Опис</h4>\n           <div class=\"input-group col-lg-12\">\n\n             <div ngf-drop=\"vm.uploadFiles($files, $invalidFiles, true)\" class=\"drop-box\"\n               ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n               ngf-pattern=\"\'image/*\'\">\n               <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"vm.event.description\"></textarea>\n             </div>\n\n            </div>\n          </div> --></div></uib-tab><uib-tab index=\"1\" heading=\"Технічні параметри\"><br><div><div class=\"row\"><div class=\"col-lg-5\"><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.need_sms\"> <i></i>Підтвердження бронювання по СМС</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.forceSales\"> <i></i>Форсувати продажі</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.allowFastPrint\" ng-disabled=\"vm.event.partner_isset === true\"> <i></i>Дозволити продажі без збору данних</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.showEntryTime\"> <i></i>Вiдображатити \"Вхiд з ...\" на квитках</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.ignoreTicketsLifeTime\" ng-disabled=\"vm.event.partner_isset === true\"> <i></i>Заборонити автоскасування замовлень</label></p><p ng-hide=\"!vm.event.apiSource\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.apiSource\"> <i></i>Джерело події</label></p><div class=\"form-group\"><label class=\"star\">Типи квитків</label><div class=\"row\"><div class=\"col-lg-6\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.event.ticketsType\" value=\"all\"><i></i>Всi</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.event.ticketsType\" value=\"physical\"><i></i>Тільки фізичні квитки</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.event.ticketsType\" value=\"electronic\"><i></i>Тільки електронні квитки</label></div></div></div><div class=\"form-group\" show-errors><label class=\"star\">Час очікування оплати замовлення</label><div class=\"row\"><div class=\"col-lg-2\"><input type=\"number\" name=\"ticketsLifeTime\" min=\"0.01\" placeholder=\"0\" class=\"form-control\" ng-model=\"vm.event.ticketsLifeTime\" required></div></div><span class=\"help-block\">Обов\'язкове поле</span></div><div style=\"display: none\"><hr><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.inMainSlider\"> <i></i>Головний слайдер</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.inCitySlider\"> <i></i>Слайдер по місту</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.inMainPage\"> <i></i>Відображати на головній сторінці сайту</label></p></div><hr></div><div class=\"col-lg-6\"><div class=\"row\"><div class=\"col-lg-8\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.displayAllDates\" class=\"ng-valid ng-dirty ng-valid-parse ng-touched ng-not-empty\" style=\"\"> <i></i>Виводити дату початку і дату закінчення події</label></div></div><div class=\"row\"><div class=\"col-lg-8\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.longTime\" class=\"ng-valid ng-dirty ng-valid-parse ng-touched ng-not-empty\" style=\"\"> <i></i>Подія продовжена в часі</label></div></div><div class=\"row\"><div class=\"col-lg-8\"><input id=\"vm.event.expiryTime\" type=\"number\" min=\"0\" placeholder=\"0\" class=\"form-control col-sm-2 ng-valid-number\" ng-disabled=\"!vm.event.longTime\" ng-model=\"vm.event.expiryTime\" style=\"width: 65px\"><label for=\"vm.event.expiryTime\" class=\"i-checks i-checks-sm\">Термін дії квитка (в днях)</label></div></div></div></div><div class=\"row\"><div class=\"col-lg-2\"><label>Валюта</label><selectlist input-method=\"vm.currenciesList\" output-model=\"vm.event.currencyID\" hidesearch></selectlist></div><div class=\"col-lg-4\"><label>Тип штрих-коду</label><div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle>{{vm.event.barcodeType}} <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li><a ng-repeat=\"code in vm.barcodes\" ng-click=\"vm.event.barcodeType = code\">{{code}}</a></li></ul></div></div><div class=\"col-lg-2\" ng-if=\"vm.event.id\"><label>Статичнi коди</label><button type=\"file\" ngf-select=\"vm.setCodes($file, $invalidFiles)\" ngf-pattern=\"\'.csv\'\" class=\"btn btn-success btn-block\" accept=\".csv\" access=\"manageBarcodes\">Встановити</button></div><div class=\"col-lg-2\" ng-if=\"vm.event.id\"><label>Шаблон CSV</label><a class=\"btn btn-default btn-block\" ng-href=\"{{vm.csvExample}}\" download access=\"manageBarcodes\">Завантажити</a></div><div class=\"col-lg-12\"><p><br><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.event.cvsss\"> <i></i>не оновлювати штрих-код</label></p></div><div class=\"col-lg-12\"><hr><div class=\"row\"><div class=\"col-lg-4\"><label>HTML заголовок</label><div class=\"\"><input type=\"text\" value=\"\" ng-model=\"vm.event.htmlCaption\" placeholder=\"HTML заголовок\" class=\"form-control\"></div></div><div class=\"col-lg-6\"><label>URL Alias</label><div class=\"form-group\" show-errors><input type=\"text\" name=\"urlAlias\" value=\"\" ng-model=\"vm.event.urlAlias\" placeholder=\"ULR Alias\" ng-pattern=\"vm.urlAliasPattern\" class=\"form-control\"> <span class=\"help-block\" ng-show=\"vm.createevent.urlAlias.$error.pattern\">ULR Alias не повинен включати спец символи та символи кирилиці.</span></div></div><div class=\"col-lg-2\"><label>&nbsp;</label><div class=\"\"><a class=\"btn btn-primary btn-block\" ng-disabled=\"!vm.event.id\" ng-click=\"vm.genUrlAlias()\">Генерувати URL</a></div></div></div><!--   <div class=\"row\">\n                <div class=\"col-lg-12\">\n                  <br>\n                  <label>META опис  (до 512 символів)</label>\n                  <div class=\"\">\n                    <input type=\"text\" value=\"\" ng-model=\"vm.event.metaDescription\" placeholder=\"META опис\" class=\"form-control\" limit-length=\"512\">\n                  </div>\n                </div>\n                <div class=\"col-lg-12\">\n                  <br>\n                  <label>Ключові слова (до 512 символів)</label>\n                  <div class=\"\">\n                    <input type=\"text\" ng-model=\"vm.event.keywords\" placeholder=\"Ключові слова\" class=\"form-control\" limit-length=\"512\">\n                  </div>\n                </div>\n              </div> --></div></div></div></uib-tab><uib-tab index=\"2\" heading=\"Вигляд квитків\"><br><div class=\"row\"><div class=\"col-md-2\"><label>Тип бланку</label><selectlist input-model=\"vm.blankType\" output-model=\"vm.type\" on-change=\"vm.createPrintView()\"></selectlist></div><div class=\"col-md-2\"><label>Шаблон</label><selectlist input-model=\"vm.printTemplates\" output-model=\"vm.event.printTemplateID\" on-change=\"vm.createPrintView()\"></selectlist></div></div><hr><div class=\"row tickets-tab\"><div class=\"col-md-12\"><div style=\"margin: 0 auto\" ng-include=\"\'app/print/print.view.html\'\"></div></div></div></uib-tab><uib-tab index=\"4\" heading=\"Мультимовність\"><section class=\"row\"><div class=\"col-md-12\"><uib-tabset active=\"\" ng-hide=\"!vm.event.id\"><uib-tab index=\"$index\" ng-repeat=\"event in vm.event.event_lang\"><uib-tab-heading>{{event.lang_name}}</uib-tab-heading><label class=\"star\">Назва - {{event.lang_name}}</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"event.a_name\" placeholder=\"текст\"><br><h4>Опис - {{event.lang_name}}</h4><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"event.description\"></textarea></div><br><label class=\"star\">Мета-титул - {{event.lang_name}}</label><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"event.meta_title\" placeholder=\"текст\"><br><label class=\"star\">Мета опис - {{event.lang_name}}</label><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"event.meta_description\" placeholder=\"текст\"><br><label class=\"star\">Ключові слова - {{event.lang_name}}</label><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"event.keywords\" placeholder=\"текст\"></uib-tab></uib-tabset><uib-tabset active=\"\" ng-hide=\"vm.event.id\"><uib-tab index=\"$index\" ng-repeat=\"event in vm.lang\"><uib-tab-heading>{{event.name}}</uib-tab-heading><label class=\"star\">Назва - {{event.name}}</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"event.a_name\" placeholder=\"текст\"><br><h4>Опис - {{event.name}}</h4><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"event.description\"></textarea></div><br><label class=\"star\">Мета-титул - {{event.name}}</label><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"event.meta_title\" placeholder=\"текст\"><br><label class=\"star\">Мета опис - {{event.name}}</label><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"event.meta_description\" placeholder=\"текст\"><br><label class=\"star\">Ключові слова - {{event.lang_name}}</label><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"event.keywords\" placeholder=\"текст\"></uib-tab></uib-tabset></div></section></uib-tab><uib-tab index=\"5\" heading=\"Серія подій\"><br><section class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-2\"><input type=\"checkbox\" ng-model=\"vm.event.isChild\" ng-true-value=\"true\" ng-false-value=\"false\">Дочірня подія</div><div ng-if=\"vm.event.isChild == true\"><div class=\"col-md-6\"><events-list input-model=\"vm.event\" output-model=\"vm.event.currentParentEvent\"></events-list></div></div></div></section><hr><section class=\"row\"><div style=\"margin-left: 10px\" class=\"col-md-2\"><label>Генерація мультиівентів</label><button type=\"button\" class=\"btn btn-success btn-block\" ng-disabled=\"!vm.event.id || vm.event.isChild === true\" ng-click=\"vm.multiEventModal()\">Генерувати</button></div></section></uib-tab><uib-tab index=\"6\" heading=\"ПРОМО\"><br><section class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><select ng-model=\"vm.event.discount_type\" ng-options=\"value.id as value.name for value in vm.discountTypes\"><option value=\"\"></option></select></div></div></section><br><section class=\"row\" ng-if=\"vm.event.discount_type\"><div class=\"col-md-12\"><section class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-2 form-group\" show-dd-errors=\"vm.event.discount\"><p>Відсоток знижки</p><input type=\"number\" required ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.discount\" style=\"width: 65px\"> <span class=\"help-block\" style=\"right: auto\">Обов\'язкове поле</span></div><div class=\"col-md-2 form-group\" show-dd-errors=\"vm.event.min_tickets\"><p>Min кількість квитків <span tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip-html=\"\'\n                Мінімальна кількість квитків, яка має бути у замовленні, щоб була застосована знижка.\'\" style=\"font-weight: bold\">(?)</span></p><input type=\"number\" name=\"min_tickets\" required ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.min_tickets\" style=\"width: 65px\"> <span class=\"help-block\" style=\"right: auto\">Обов\'язкове поле</span></div><div class=\"col-md-2 form-group\" show-dd-errors=\"vm.event.tickets_count\"><p>Max кількість квитків <span tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip-html=\"\'\n                Максимальна кількість квитків у замовленні, на на які розповсюджується знижка.\'\" style=\"font-weight: bold\">(?)</span></p><input type=\"number\" name=\"tickets_count\" required ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.tickets_count\" style=\"width: 65px\"> <span class=\"help-block\" style=\"right: auto\">Обов\'язкове поле</span></div><div class=\"col-md-3 form-group\"><p>Чи застосовується знижка до min квитків <span tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip-html=\"\'\n                Якщо цей параметр НЕ обрано, то до перших мінімально необхідних квитків (параметр Min кількість квитків) знижка НЕ буде застосована. Наприклад, Min = 3, параметр не обрано і у замовленні 4 квитка, тоді знижка буде застосована, ПОЧИНАЮЧИ з 3-го квитка, тобто всього буде 2 квитка зі знижкою.<br/>\n                Якщо той же приклад, але параметр ОБРАНО, то знижка буде розповсюджуватися на всі 4 квитка.\'\" style=\"font-weight: bold\">(?)</span></p><input type=\"checkbox\" ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.min_tickets_discounting\" ng-true-value=\"true\" ng-false-value=\"false\"></div><div class=\"col-md-3 form-group\" ng-if=\"vm.event.discount_type !== vm.DISCOUNT_TYPE_AUTO\" show-dd-errors=\"vm.event.mask\"><p>Маска <span tooltip-append-to-body=\"true\" tooltip-placement=\"bottom\" uib-tooltip-html=\"\'\n                Маска задається плейсхолдерами, наприклад масці ***-99 будуть відповідати коди fG1-23, oiu-90 тощо<br/>\n                Якщо ввести символ, що відрізняється від 9, a та *, то в промокодах буде використаний саме він.<br/>\n  9: цифри [0-9],<br/>\n  a: літери [A-Za-z],<br/>\n  *: цифри і літери [A-Za-z0-9]\'\" style=\"font-weight: bold\">(?)</span></p><input type=\"text\" required ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.mask\"> <span class=\"help-block\" style=\"right: auto\">Обов\'язкове поле</span></div></div></section><section class=\"row\" style=\"margin-top: 10px\"><div class=\"col-md-12\"><div class=\"col-md-3\"><br><input type=\"checkbox\" ng-disabled=\"!vm.event.discount_type || vm.event.discountExists\" ng-model=\"vm.event.electronic_only\" ng-true-value=\"true\" ng-false-value=\"false\"><label>Тільки електронні квитки</label></div><div class=\"col-md-3 form-group\" ng-if=\"vm.event.discount_type === vm.DISCOUNT_TYPE_PROMOCODE\" show-dd-errors=\"vm.event.promocode_count\"><p>Кількість промокодів</p><input type=\"number\" name=\"promocode_count\" required ng-disabled=\"!vm.event.discount_type || vm.event.generatedPromocode\" ng-model=\"vm.event.promocode_count\" style=\"width: 65px\" max=\"1000\"> <span class=\"help-block\" style=\"right: auto\">{{ vm.createevent.promocode_count.$error.max ? \'Має бути менше 1000\' : \"Обов\'язкове поле\" }}</span></div><div class=\"col-md-3 form-group\" ng-if=\"vm.event.discount_type === vm.DISCOUNT_TYPE_PROMOCODE\" show-dd-errors=\"vm.event.promocode_uses\"><p>Кількість застосувань для кожного промокоду</p><input type=\"number\" required ng-disabled=\"!vm.event.discount_type || vm.event.generatedPromocode\" ng-model=\"vm.event.promocode_uses\" style=\"width: 65px\"> <span class=\"help-block\" style=\"right: auto\">Обов\'язкове поле</span></div><div class=\"col-md-2\" ng-if=\"vm.event.discount_type === vm.DISCOUNT_TYPE_PROMOCODE\"><button class=\"btn btn-block btn-sm\" ng-click=\"vm.generatePromocodes()\" ng-disabled=\"vm.event.generatedPromocode || !vm.event.discount || !vm.event.min_tickets || !vm.event.tickets_count || !vm.event.mask || !vm.event.promocode_count || !vm.event.promocode_uses\" style=\"background: #ddecff\">{{ vm.event.generatedPromocode ? \'Промокоди згенеровані\' : \'Генерувати промокоди\' }}</button> <button class=\"btn btn-block btn-sm\" ng-click=\"vm.loadPromocodes()\" download ng-disabled=\"!vm.event.generatedPromocode\" style=\"background: #f3dcdb\">Завантажити промокоди XLS</button></div></div></section><hr><div class=\"col-md-12\"><p>Тексти/умови/описи</p><uib-tabset active=\"\" ng-disabled=\"!vm.event.discount_type\" ng-hide=\"!vm.event.id\"><uib-tab index=\"$index\" ng-repeat=\"event in vm.event.discount_langs\"><uib-tab-heading>{{event.lang_name}}</uib-tab-heading><label class=\"star\">Текст в описі події</label><input class=\"form-control\" ng-disabled=\"!vm.event.discount_type\" name=\"event_description\" type=\"text\" ng-model=\"event.event_description\" placeholder=\"текст\"><label class=\"star\">Текст в корзині</label><input class=\"form-control\" ng-disabled=\"!vm.event.discount_type\" name=\"checkout_description\" type=\"text\" ng-model=\"event.checkout_description\" placeholder=\"текст\"><label class=\"star\">Текст про помилку</label><input class=\"form-control\" ng-disabled=\"!vm.event.discount_type\" name=\"checkout_error\" type=\"text\" ng-model=\"event.checkout_error\" placeholder=\"текст\"></uib-tab></uib-tabset><uib-tabset active=\"\" ng-if=\"!vm.event.id\"><uib-tab index=\"$index\" ng-repeat=\"event in vm.discount_lang\"><uib-tab-heading>{{event.name}}</uib-tab-heading><label class=\"star\">Текст в описі події</label><input class=\"form-control\" name=\"event_description\" type=\"text\" ng-model=\"event.event_description\" placeholder=\"текст\"><label class=\"star\">Текст в корзині</label><input class=\"form-control\" name=\"checkout_description\" type=\"text\" ng-model=\"event.checkout_description\" placeholder=\"текст\"><label class=\"star\">Текст про помилку</label><input class=\"form-control\" name=\"checkout_error\" type=\"text\" ng-model=\"event.checkout_error\" placeholder=\"текст\"></uib-tab></uib-tabset></div></div></section><!--  <section class=\"row\" ng-if=\"vm.event.discount_type === \'2\'\">\n         <div class=\"col-md-12\">\n\n           <div class=\"col-md-3\">\n             <p>Мінімальна кількість білетів</p>\n             <input type=\"text\" ng-disabled=\"!vm.event.discount_type\" ng-model=\"vm.event.min_tickets\" style=\"width: 65px;\">\n           </div>\n           <div class=\"col-md-3\">\n             <p>Кількість застосованих для кожного промокоду</p>\n             <input type=\"text\" ng-disabled=\"!vm.event.discount_type\" ng-model=\"vm.event.promocode_uses\" style=\"width: 65px;\">\n           </div>\n           <div class=\"col-md-2\">\n             <p>Кількість квитків на які діє знижка</p>\n             <input type=\"text\" ng-disabled=\"!vm.event.discount_type\" ng-model=\"vm.event.tickets_count\"></div>\n           <div class=\"col-md-2\">\n             <p>Маска</p>\n             <input type=\"text\" ng-disabled=\"!vm.event.discount_type\" ng-model=\"vm.event.mask\"></div>\n           <div class=\"col-md-2\">\n             <input type=\"checkbox\" ng-disabled=\"!vm.event.discount_type\" ng-model=\"vm.event.electronic_only\"\n                    ng-true-value=\"true\" ng-false-value=\"false\"><label>Тільки електронні квитки</label>\n\n           </div>\n           <hr>\n           <div class=\"col-md-12\">\n             <p>Тексти/умови/описи</p>\n             <uib-tabset active=\"\" ng-hide=\"!vm.event.id\">\n               <uib-tab index=\"$index\" ng-repeat=\"event in vm.event.discount_langs\">\n                 <uib-tab-heading>{{event.lang_name}}</uib-tab-heading>\n                 <label class=\"star\">Текст в описі події</label>\n                 <input class=\"form-control\" name=\"event_description\" type=\"text\" ng-model=\"event.event_description\"\n                        placeholder=\"текст\"/>\n                 <label class=\"star\">Текст в корзині</label>\n                 <input class=\"form-control\" name=\"checkout_description\" type=\"text\"\n                        ng-model=\"event.checkout_description\" placeholder=\"текст\"/>\n                 <label class=\"star\">Текст про помилку</label>\n                 <input class=\"form-control\" name=\"checkout_error\" type=\"text\" ng-model=\"event.checkout_error\"\n                        placeholder=\"текст\"/>\n               </uib-tab>\n             </uib-tabset>\n\n             <uib-tabset active=\"\" ng-if=\"!vm.event.id\">\n               <uib-tab index=\"$index\" ng-repeat=\"event in vm.discount_lang\">\n                 <uib-tab-heading>{{event.name}}</uib-tab-heading>\n\n                 <label class=\"star\">Текст в описі події</label>\n                 <input class=\"form-control\" name=\"event_description\" type=\"text\" ng-model=\"event.event_description\"\n                        placeholder=\"текст\"/>\n                 <label class=\"star\">Текст в корзині</label>\n                 <input class=\"form-control\" name=\"checkout_description\" type=\"text\"\n                        ng-model=\"event.checkout_description\" placeholder=\"текст\"/>\n                 <label class=\"star\">Текст про помилку</label>\n                 <input class=\"form-control\" name=\"checkout_error\" type=\"text\" ng-model=\"event.checkout_error\"\n                        placeholder=\"текст\"/>\n               </uib-tab>\n             </uib-tabset>\n           </div>\n         </div>\n       </section> --></uib-tab><uib-tab index=\"7\" heading=\"СЗ\"><section class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-12\"><h3>Профілі сервісного збору</h3><p ng-if=\"vm.event.service_charges.length === 0\">Немає результатів</p></div></div></section><section class=\"row\" ng-if=\"vm.event.service_charges.length > 0\"><div class=\"col-md-12\"><div class=\"col-md-9\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID</th><th class=\"action col-md-3\">Назва</th><th class=\"action col-md-1\">Ставка</th><th class=\"action col-md-1\">Тип квитків</th><th class=\"action col-md-1\">Тип оплати</th><th class=\"action col-md-1\">Події</th><th class=\"action col-md-1\">Каси</th></tr></thead><tbody><tr ng-repeat=\"item in vm.event.service_charges\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.rate}} {{item.rate_type === \'percent\' ? \'%\' : \'грн\'}}</td><td>{{item.tickets_type}}</td><td>{{item.payment_type}}</td><td>{{item.events_type}}</td><td>{{item.cashes_type}}</td></tr></tbody></table></div></div></section><br></uib-tab><uib-tab index=\"3\" heading=\"Джерело події\" ng-hide=\"!vm.event.apiSource\"><br><div class=\"event-group-group row\"><div class=\"col-lg-2 form-group\"><label class=\"star\">Провайдер події</label><selectlist input-model=\"vm.eventProviders\" output-model=\"vm.event.eventSource.eventProviderId\" hidesearch></selectlist></div><div class=\"col-lg-2 form-group\"><label class=\"star\">Зовнішній ідентифікатор локації</label><input id=\"vm-event-eventSourceProviderLocationId\" type=\"text\" placeholder=\"\" class=\"form-control col-sm-2 ng-valid-number\" ng-model=\"vm.event.eventSource.remoteLocationId\"></div><div class=\"col-lg-2 form-group\"><label class=\"star\">Зовнішній ідентифікатор події</label><input id=\"vm-event-eventSourceProviderEventId\" type=\"text\" placeholder=\"\" class=\"form-control col-sm-2 ng-valid-number\" ng-model=\"vm.event.eventSource.remoteEventId\"></div></div><hr><table class=\"table table-bordered table-striped\" style=\"width:50%\" ng-hide=\"vm.remoteAreaZones.length === 0\"><tbody><tr><td><b>Зона (зовнішня)</b></td><td><b>Зона (локальна)</b></td></tr><tr ng-repeat=\"(key, value) in vm.remoteAreaZones\" ng-if=\"value.sectorId\"><td>{{value.name}}</td><td><selectlist input-model=\"vm.zonesList\" output-model=\"vm.zonesMaps[key]\" hidesearch></selectlist></td></tr></tbody></table></uib-tab></uib-tabset></form><br><br><br>");
$templateCache.put("app/main/events/event.header.html","<header class=\"headline row\"><div class=\"col-md-12\" ng-if=\"vm.mode===\'main.event.edit\' || vm.mode===\'main.new_ext_event\'\"><span class=\"pull-left hidden-xs\" ng-if=\"!vm.event.id\" access=\"createEvent\">Створення події</span> <span class=\"pull-left hidden-xs\" ng-if=\"vm.event.id\" access=\"updateEvent\">Редагування події</span> <img ng-if=\"vm.event.partner_image.length > 0\" ng-src=\"{{vm.event.partner_image}}\" style=\"width: 50px; position:absolute; right: 20px; top:45px\" class=\"img-thumbnail\"> <span class=\"pull-left visible-xs\">Подiя</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful access=\"updateEvent\">Зберегти</a> <a class=\"btn btn-danger\" ng-if=\"vm.mode===\'main.new_ext_event\'\" ui-sref=\"main.configs.external-events\">Скасувати</a> <a class=\"btn btn-danger\" ng-if=\"vm.mode===\'main.event.edit\'\" ui-sref=\"main.events\">Скасувати</a></span></div><div class=\"col-md-12\" ng-if=\"vm.mode===\'main.event.prices\'\"><span class=\"pull-left\">Конструктор цін</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success hidden-xs\" ng-href=\"{{vm.xls()}}\" download access=\"manageBarcodes\">Статичні коди</a> <span access=\"eventSalesToggle\"><button class=\"btn btn-warning\" ng-show=\"!vm.isrunning\" ng-if=\"vm.event.status !== \'in_sales\'\" ng-click=\"vm.inSales(true)\">Відкрити продажі</button> <button class=\"btn btn-warning\" ng-if=\"vm.event.status === \'in_sales\'\" ng-click=\"vm.inSales(false)\">Закрити продажі</button></span></span></div><div class=\"col-md-12\" ng-if=\"vm.mode===\'main.event.hall\'\"><span class=\"pull-left\">Схема залу</span></div><div class=\"col-md-12\" ng-if=\"vm.mode===\'main.event.statistics\'\"><span class=\"pull-left\">Статистика</span></div></header><ul class=\"nav nav-pills\" ng-if=\"vm.event.id\" ng-class=\"{\'scheme-error\': vm.schemeError()}\"><li role=\"presentation\" ui-sref-active=\"active\"><a href=\"\" ui-sref=\"main.event.edit({id: vm.event.id})\">Паспорт події</a></li><!-- ng-class=\"{\'disabled\': vm.event.partner_image.length > 0}\" --><!-- ng-if=\"!vm.event.partner_image.length>0\" --><li ng-if=\"vm.event.partner_isset === false\" role=\"presentation\" ui-sref-active=\"active\" access=\"hallPrices\"><a href=\"\" ui-sref=\"main.event.prices({id: vm.event.id})\">Конструктор цiн</a></li><li role=\"presentation\" ui-sref-active=\"active\" access=\"hallEditor\"><a href=\"\" ui-sref=\"main.event.hall({id: vm.event.id})\">Схема залу</a></li><li role=\"presentation\" ui-sref-active=\"active\" access=\"manageQuotes\"><a href=\"\" ui-sref=\"main.quotes.edit({id: 0, event: vm.event.id})\">Створити квоту</a></li><li role=\"presentation\" ui-sref-active=\"active\" access=\"hallPrices\"><a href=\"\" ui-sref=\"main.event.statistics({id: vm.event.id})\">Статистика</a></li><li ng-if=\"vm.schemeError()\" class=\"pull-right\"><span class=\"scheme-error\">{{ vm.event.schemeErrorText ? vm.event.schemeErrorText : \'Схема містить помилки!\'}}</span></li><li ng-if=\"vm.schemeError() && vm.event.schemeErrorDetails\" class=\"pull-right\"><a class=\"btn btn-danger\" ng-click=\"vm.showSchemeErrors()\">Info</a></li></ul><br>");
$templateCache.put("app/main/events/event.prices.html","<header ng-include=\"\'app/main/events/event.header.html\'\"></header><div class=\"row\"><!-- <div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\">\n    <label>Місто проведення</label>\n    <selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventIDs.length > 0\"></selectlist>\n  </div>\n  <div class=\"visible-xs-block visible-sm-block divider\">&nbsp;</div> --><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><label>Назва події</label><events-filter output-model=\"vm.event.newid\" init=\"vm.event.id\"></events-filter></div></div><hr><div id=\"kasa-in-ua\"></div>");
$templateCache.put("app/main/events/event.statistics.html","<header ng-include=\"\'app/main/events/event.header.html\'\"></header><div ng-controller=\"StatisticsController as vm\"><div ng-include=\"\'app/main/statistics/statistics.detail.view.html\'\"></div><div></div></div>");
$templateCache.put("app/main/events/events.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список подій</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.event.edit\" access=\"createEvent\">Створити подію</a></span></div></header><div class=\"row\"><div class=\"col-lg-6\"><input placeholder=\"Пошук по назві\" class=\"form-control autosearch\" type=\"text\" maxlength=\"128\" ng-model-options=\"{ debounce: 300 }\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\')\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!vm.filters.name\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"vm.filters.name\" ng-click=\"vm.filters.name = null; vm.filter()\"></i></div><div class=\"col-lg-2 without-arrows\"><input placeholder=\"Пошук по ID\" class=\"form-control autosearch\" type=\"number\" maxlength=\"10\" ng-model-options=\"{ debounce: 300 }\" ng-model=\"vm.filters.id\" ng-change=\"vm.applyFilter(\'id\')\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!vm.filters.id\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"vm.filters.id\" ng-click=\"vm.filters.id = null; vm.filter()\"></i></div><div class=\"col-lg-4 form-group\"><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" on-change=\"vm.applyFilter(\'cityID\')\" placeholder=\"Фільтр по місту події\"></selectlist></div></div><div class=\"row\"><div class=\"col-md-4\"><label style=\"width: 50%\">Фільтр по відповідальному</label><selectlist input-model=\"vm.responsibleTypes\" output-model=\"vm.filters.responsibleType\" hidesearch on-change=\"vm.applyFilter(\'responsibleType\')\" placeholder=\"Тип відповідального\" style=\"width: 50%; display: inline-block\"></selectlist></div><!-- placeholder --><div class=\"col-md-3\" ng-show=\"vm.filters.responsibleType !== vm.constants.responsibleTypes.user && vm.filters.responsibleType !== vm.constants.responsibleTypes.subdivision\"><selectlist disabled=\"true\" placeholder=\"Вибрати відповідального\"></selectlist></div><div class=\"col-md-3\" ng-show=\"vm.filters.responsibleType === vm.constants.responsibleTypes.user\"><selectlist input-model=\"vm.subdivisionManagers\" output-model=\"vm.filters.responsibleIds\" multiselect on-change=\"vm.applyFilter(\'responsibleIds\')\" placeholder=\"Вибрати відповідального\"></selectlist></div><div class=\"col-md-3\" ng-show=\"vm.filters.responsibleType === vm.constants.responsibleTypes.subdivision\"><selectlist input-model=\"vm.subdivisionList\" output-model=\"vm.filters.responsibleIds\" multiselect on-change=\"vm.applyFilter(\'responsibleIds\')\" placeholder=\"Вибрати відповідального\"></selectlist></div><div class=\"col-md-5\"><label style=\"width: 35%\">Фільтр по організатору</label><selectlist input-method=\"vm.players\" output-model=\"vm.filters.organizerID\" on-change=\"vm.applyFilter(\'organizerID\')\" placeholder=\"Вибрати організатора\" style=\"width: 65%; display: inline-block\"></selectlist></div></div><div class=\"row\" style=\"margin-top: 15px\"><div class=\"col-md-7\"><label style=\"width: 32%\">Фільтр за статусом та типом</label><div style=\"width: 68%; display: inline-block\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.mode\" ng-true-value=\"\'favorites\'\" ng-click=\"vm.filterRemember()\"> <i></i>Обрані</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.status\" ng-true-value=\"\'active_statuses\'\" ng-click=\"vm.filterRemember()\"> <i></i>Активні</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.status\" ng-true-value=\"\'new\'\" ng-click=\"vm.filterRemember()\"> <i></i>Проект</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.status\" ng-true-value=\"\'closed_statuses\'\" ng-click=\"vm.filterRemember()\"> <i></i>Завершені</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.status\" ng-true-value=\"\'all_statuses\'\" ng-click=\"vm.filterRemember()\"> <i></i>Усі</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.schemeError\" ng-false-value=\"null\" ng-click=\"vm.filterRemember()\"> <i></i>З помилкою схеми</label></div></div><div class=\"col-md-5\"><label style=\"width: 35%\">Сортування</label><div style=\"width: 65%; display: inline-block\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.orderBy\" value=\"date_create\" ng-click=\"vm.filterRemember()\"> <i></i>По даті створення</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.orderBy\" value=\"date_start\" ng-click=\"vm.filterRemember()\"> <i></i>По даті події</label></div></div></div><hr><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span> <span class=\"col-md-4 col-md-offset-4 text-muted text-right\" ng-if=\"events.collection.length > 1\">Показано: 1 - {{vm.items.length}}</span></header></div><div class=\"\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><div class=\"row\" ng-repeat=\"item in vm.items\" ng-click=\"vm.selectItem(item);\" ng-class=\"{ \'selected-item\': item.active}\"><div class=\"event col-sm-6\"><section class=\"panel\"><div class=\"panel-body\" ng-class=\"{\'scheme-error\': vm.schemeError(item)}\"><img ng-if=\"item.partner_image.length > 0\" ng-src=\"{{item.partner_image}}\" style=\"width: 50px; position:absolute; right: 20px; z-index: 100; top:5px\" class=\"img-thumbnail\"><div class=\"col-sm-3 col-xs-12\"><img class=\"img-responsive\" width=\"100%\" ng-src=\"{{item.posterUrl ? vm.imagesUrl + item.posterUrl : \'assets/images/event-default.jpg\'}}\"></div><div class=\"col-sm-9 col-xs-12\"><div class=\"title\"><div class=\"visible-xs-block divider\"></div><h3 class=\"m-t-none dimgray\">{{item.name}}</h3></div><div class=\"location dimgray\"><strong>{{item.countryName + \', \' + item.cityName}}</strong><br><span>{{item.hallName}}</span><br><small>Зала: {{item.hallFileName}}</small></div><div class=\"date\"><span class=\"m-r dimgray\">{{vm.formatDate(item.dateStart)}}</span></div><br><div class=\"m-t\"><span class=\"label bg-primary m-r\">{{vm.statusCaption(item.status)}}</span> <span class=\"scheme-error\" ng-if=\"vm.schemeError(item)\">Схема містить помилки!</span><br><span style=\"position: relative; top: 5px; background-color: darkslategrey\" class=\"label bg-primary m-r\">ID: {{item.id}}</span> <span class=\"pull-right\" ng-click=\"vm.favorite(item, $event)\"><i class=\"glyphicon glyphicon-heart\" ng-if=\"item.isFavorite\"></i> <i class=\"glyphicon glyphicon-heart-empty\" ng-if=\"!item.isFavorite\"></i></span></div><div class=\"m-t\" access=\"eventsStatistics\"><span class=\"pull-right\" ng-click=\"vm.showQuickStat(item, $event)\" ng-if=\"!item.showQuickStat\" style=\"border: 1px solid; border-radius: 4px; padding: 2px; font-size: 11px\"><i class=\"glyphicon glyphicon-stats\"></i> <span>Швидка статистика</span> </span><span class=\"pull-right\" ng-click=\"vm.showQuickStat(item, $event)\" ng-if=\"item.showQuickStat\" style=\"border: 1px solid;border-radius: 4px; padding: 2px; color: #fff; background: rgb(102, 102, 118); font-size: 11px\"><i class=\"glyphicon glyphicon-stats\"></i> <span>Швидка статистика</span></span></div></div></div></section></div><div class=\"col-sm-6\" ng-if=\"item.showQuickStat\"><div class=\"event-preview kasa-statistic\"><div class=\"row kasa-statistic\"><div class=\"sold-aria\"><div class=\"panel panel-default\"><div class=\"row\"><div class=\"col-md-4\"><h5>ВСЬОГО МІСЦЬ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.totalCount}} шт</span></div></div><div class=\"col-md-4\"><h5>ВСЬОГО З ЦІНОЮ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.pricedCount}} шт</span> <span class=\"h5\">{{item.quickStat.pricedCost}} грн.</span></div></div><div class=\"col-md-4\"><h5>У ПРОДАЖУ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.inSalesCount}} шт</span> <span class=\"h5\">{{item.quickStat.inSalesCost}} грн.</span></div></div></div><div class=\"row\"><br><div class=\"col-md-4 white-tooltip\" uib-tooltip-template=\"\'app/main/statistics/sales.tooltip.view.html\'\" tooltip-placement=\"right\"><h5>ПРОДАНО</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.soldCount}} шт</span> <span class=\"h5\">{{item.quickStat.soldCost}} грн.</span></div></div><div class=\"col-md-4\"><h5>ЗАБРОНЬОВАНО</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.orderedCount}} шт</span> <span class=\"h5\">{{item.quickStat.orderedCost}} грн.</span></div></div><div class=\"col-md-4\"><h5>ПЕРЕДАНО НА РЕАЛІЗАЦІЮ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{item.quickStat.quotedCount}} шт</span> <span class=\"h5\">{{item.quickStat.quotedCost}} грн.</span></div></div></div></div></div></div></div></div><div class=\"col-sm-6\" ng-if=\"item.active\"><div class=\"event-preview\"><section class=\"panel\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4 col-xs-6\"><a class=\"btn btn-block btn-sm\" ng-disabled=\"!vm.hasPermission(\'updateEvent\')\" ui-sref=\"main.event.edit({id: vm.selectedItem.id})\" style=\"background: #dddac4\">Паспорт події</a> <a class=\"btn btn-block btn-sm\" ng-class=\"{\'disabled\': item.partner_isset === true}\" ng-disabled=\"!vm.hasPermission(\'hallPrices\')\" ui-sref=\"main.event.prices({id: vm.selectedItem.id})\" style=\"background: #ddecff\">Конструктор цін</a> <a class=\"btn btn-block btn-sm\" access=\"eventSalesToggle\" ng-show=\"!item.isrunning\" ng-if=\"item.status !== \'in_sales\'\" ng-click=\"vm.inSales(item, true)\" style=\"background: #f3dcdb\">Відкрити продажі</a> <a class=\"btn btn-block btn-sm\" access=\"eventSalesToggle\" ng-if=\"item.status === \'in_sales\'\" ng-click=\"vm.inSales(item, false)\" style=\"background: #f3dcdb\">Закрити продажі</a> <a class=\"btn btn-block btn-sm\" ng-href=\"{{vm.xls(item)}}\" download access=\"manageBarcodes\" style=\"background: #d8e5bc\">Штрихкоди XLS</a><div class=\"visible-xs-block visible-sm-block divider\"></div></div><div class=\"col-md-4 col-xs-6\"><a class=\"btn btn-block btn-sm text-lowercase\" ng-disabled=\"!vm.hasPermission(\'menuEvent\')\" ng-href=\"{{vm.kasalink + \'/\' + \'ua\' + \'/\' + vm.selectedItem.cityNametrans + \'/\' + vm.selectedItem.type + \'/\' + vm.selectedItem.urlAlias}}\" target=\"_blank\" style=\"background: #dddac4\">Попередній перегляд</a> <a class=\"btn btn-block btn-sm\" ng-disabled=\"!vm.hasPermission(\'menuOM\')\" ui-sref=\"main.ordermanager({id: vm.selectedItem.id})\" style=\"background: #ddecff\">Менеджер замовлень</a> <a class=\"btn btn-block btn-sm\" ng-disabled=\"!vm.hasPermission(\'updateEvent\')\" ng-click=\"vm.toggleIndexation(item)\" style=\"background: #f3dcdb\">{{ item.allowIndexation ? \'Заборонити індексацію\' : \'Дозволити індексацію\' }}</a> <a class=\"btn btn-block btn-sm\" ng-disabled=\"!vm.hasPermission(\'menuQuota\')\" ui-sref=\"main.quotes.edit({id: 0, event: vm.selectedItem.id})\" style=\"background: #d8e5bc\">Створити квоту</a><div class=\"visible-xs-block visible-sm-block divider\"></div></div><div class=\"col-md-4 col-xs-6\"><a class=\"btn btn-block btn-sm\" ng-disabled=\"!vm.hasPermission(\'eventsStatistics\')\" ui-sref=\"main.statistics.event({id: vm.selectedItem.id})\" style=\"background: #dddac4\">Статистика</a> <a class=\"btn btn-block btn-sm hidden-xs hidden-sm\" ng-disabled=\"!vm.hasPermission(\'hallEditor\')\" ui-sref=\"main.event.hall({id: vm.selectedItem.id})\" style=\"background: #ddecff\">Схема залу</a> <a class=\"btn btn-block btn-sm disabled\" style=\"background: #f3dcdb\">Контроль продажу</a></div><div class=\"hidden-md hidden-lg col-xs-6\"><a class=\"btn btn-block btn-sm\" ui-sref=\"main.event.hall({id: vm.selectedItem.id})\" style=\"background: #ddecff\">Схема залу</a></div></div></div></section></div></div></div></div></section>");
$templateCache.put("app/main/ordermanager/ordermanager.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Менеджер замовлень</span></div></header><form class=\"ordermanager\" name=\"vm.ordermanager\" class=\"form\" autocomplete=\"off\"><!-- ng-submit=\"vm.find()\" --><div ng-include=\"\'app/main/ordermanager/parts/ks-order-bag.html\'\"></div><!--блок фильтров--><div class=\"row filters\" ng-if=\"!vm.searchorder\"><div class=\"col-md-9\"><div ng-include=\"\'app/main/ordermanager/parts/ks-order-event-f.html\'\"></div><hr><div ng-include=\"\'app/main/ordermanager/parts/ks-order-player-f.html\'\"></div><hr><div ng-include=\"\'app/main/ordermanager/parts/ks-order-payment-f.html\'\"></div><hr><div ng-include=\"\'app/main/ordermanager/parts/ks-order-delivery-f.html\'\"></div><hr><div ng-include=\"\'app/main/ordermanager/parts/ks-order-print-f.html\'\"></div><hr><div ng-include=\"\'app/main/ordermanager/parts/ks-order-status-f.html\'\"></div></div><div class=\"col-md-3\"><div ng-include=\"\'app/main/ordermanager/parts/ks-order-aside.html\'\"></div></div></div><div class=\"row filters searchorder\" ng-if=\"vm.searchorder\" key-enter=\"vm.find()\"><div class=\"col-md-9\" ng-include=\"\'app/main/ordermanager/parts/search.html\'\"></div><div class=\"col-md-3\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Результат запиту</div><div class=\"panel-body\"><p>Замовлень/Квот: {{vm.count || 0}} шт.</p><p>Квиткiв: {{vm.tickets || 0}} шт.</p><p>Вартiсть: {{vm.price || 0}} грн.</p></div><div class=\"panel-footer\" access=\"ticketsXls\"><div class=\"form-group\"><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.xlsUrl}}\" ng-class=\"{\'disabled\': !vm.count}\" download>Завантажити .XLS</a></div><div><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.csvUrl}}\" ng-class=\"{\'disabled\': !vm.count}\" download>Завантажити .CSV</a></div></div></div></div></div><hr><!--блок кнопок--><div class=\"row\"><div class=\"col-md-4\"><button type=\"submit\" stateful class=\"btn btn-success btn-block\" ng-click=\"vm.find()\" key-enter=\"vm.find()\" ng-disabled=\"!vm.filters.eventID.length && vm.companyID !== 1 && !(vm.filters.id.length || vm.filters.clientPhone.length || vm.filters.clientEmail.length || vm.filters.clientName.length || vm.filters.newPostBranchID.length || vm.filters.ticketBarcode.length || (vm.filters.paymentDateFrom && vm.filters.paymentDateTo) || (vm.filters.printDateFrom && vm.filters.printDateTo) || (vm.filters.dateCreateFrom && vm.filters.dateCreateTo))\">Знайти</button></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"vm.clear()\" ng-class=\"{\'disabled\': vm.isFiltersEmpty()}\">Скинути фільтри</button></div><!-- <div class=\"col-md-2\" ng-if=\"vm.searchorder\">\n    <button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"vm.clear()\" ng-class=\"{\'disabled\': vm.isFiltersEmpty()}\">Показати всі</button>\n  </div> --></div><hr><!--блок вывода результатов--><div class=\"order-results row\"><div class=\"col-md-12\" ng-include=\"\'app/main/ordermanager/parts/ks-order-results.html\'\" ng-if=\"vm.orders.length\"></div><div class=\"col-md-12\" ng-if=\"!vm.orders.length && vm.done\"><p>По вказаним фільтрам замовлень не знайдено</p></div></div></form>");
$templateCache.put("app/main/order/order.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\" ng-if=\"vm.order.create\" access=\"createOrder\">Створити замовлення</span> <span class=\"pull-left\" ng-if=\"!vm.order.create\">Редагування замовлення</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-danger\" ng-click=\"vm.back()\" ng-if=\"vm.selectedItem.id\">Скасувати</a></span></div></header><!--блок фильтров--><div ng-include=\"\'app/main/order/order.select.view.html\'\" ng-show=\"!vm.info\"></div><!--блок заказа--><div class=\"event-details\" ng-if=\"vm.selectedItem.id\"><div class=\"row\" ng-if=\"vm.info\"><div class=\"col-md-12\"><h4>Параметри замовлення</h4></div></div><form class=\"form\" name=\"vm.orderupdateform\" novalidate autocomplete=\"off\" ng-show=\"vm.info\"><div ng-if=\"vm.info === \'book\' || vm.info === \'buy\'\" style=\"color: #d9534f\" class=\"text-right\"><span>Увага, залишилось:</span><timer countdown=\"300\" language=\"uk\" interval=\"1000\" finish-callback=\"vm.back()\">{{yearUnit}}</timer></div><input name=\"submit\" type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label star\">Спосіб доставки</label><input type=\"hidden\" ng-model=\"vm.deliveryTypes\" required><selectlist input-model=\"vm.deliveryTypes\" output-model=\"vm.orderu.delivery.type\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\"><label>Tип оплати</label><selectlist input-model=\"vm.paymentTypes\" output-model=\"vm.orderu.payment.type\" disabled=\"true\"></selectlist></div><div class=\"form-group col-md-3\"><label>Статус оплати</label><selectlist input-model=\"vm.paymentStatuses\" output-model=\"vm.orderu.payment.status\" disabled=\"true\"></selectlist></div><div class=\"form-group col-md-1\"><label>№ замовлення</label><p>{{vm.orderID}}</p></div><div class=\"form-group col-md-1\"><label>Загальна сума</label><p><strong>{{ (+vm.order.ticketsPrice + vm.serviceCharge) |number: 2}} грн.</strong></p></div><div class=\"form-group col-md-1\"><label>Сервісний збір</label><p>{{vm.serviceCharge|number: 2}} грн.</p></div></div><div class=\"row\"><div class=\"form-group col-md-3\" show-errors><label class=\"control-label star\">Прізвище</label><input id=\"clientname\" placeholder=\"Прізвище\" name=\"name\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.client.lastName\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\" show-errors><label class=\"control-label star\">Ім’я</label><input placeholder=\"Ім’я\" name=\"lastName\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.client.firstName\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\"><label class=\"control-label\">По-батькові</label><input placeholder=\"По-батькові\" name=\"middleName\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.client.middleName\"></div><div class=\"form-group col-md-3\" show-errors ng-class=\"{\'has-error\': vm.orderupdateform.phone.$invalid && vm.orderupdateform.phone.$touched}\"><label class=\"control-label star\">Телефон</label><input placeholder=\"+380971112233 чи 0971112233\" name=\"phone\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.client.phone\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\" ng-class=\"{\'has-error\': vm.orderupdateform.mail.$error.email}\"><label class=\"control-label\">E-mail</label><input placeholder=\"E-mail\" name=\"mail\" class=\"form-control\" type=\"email\" maxlength=\"128\" ng-model=\"vm.orderu.client.email\"> <span class=\"help-block\">Не вiрний email</span></div><div class=\"col-md-9\"><div class=\"form-group\"><label class=\"control-label\">Коментар</label><input placeholder=\"\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.description\"></div></div><div class=\"form-group col-md-3\" ng-if=\"vm.orderu.delivery.type === \'courier\'\"><label class=\"control-label\">Мiсто</label><multiselect-dropdown items=\"vm.citiesGet\" ng-model=\"vm.orderu.delivery.address.cityID\" options=\"{multiselect: false}\"></multiselect-dropdown></div><div class=\"form-group col-md-9\" show-errors ng-if=\"vm.orderu.delivery.type === \'courier\'\"><label class=\"control-label star\">Адреса</label><input placeholder=\"Адреса\" name=\"address\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"vm.orderu.delivery.address.address\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-6\" show-errors ng-if=\"vm.orderu.delivery.type === \'post_service\'\"><label class=\"control-label star\">Мiсто</label><multiselect-dropdown items=\"vm.citiesGet\" ng-model=\"vm.orderu.delivery.postService.cityID\" options=\"{multiselect: false}\"></multiselect-dropdown><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\" show-errors ng-if=\"vm.orderu.delivery.type === \'post_service\'\"><label class=\"control-label star\">Номер вiддiлення НП</label><input placeholder=\"1\" name=\"postService\" class=\"form-control\" type=\"number\" ng-model=\"vm.orderu.delivery.postService.number\" required> <span class=\"help-block\">Обов\'язкове поле</span></div></div></form><div class=\"row\" ng-if=\"vm.info\"><div class=\"form-group col-md-12\"><button class=\"btn btn-info\" ng-click=\"vm.update()\" stateful ng-if=\"vm.info===\'book\'\">Забронювати</button> <button class=\"btn btn-info\" ng-click=\"vm.print()\" ng-disabled=\"!vm.canPrint || vm.blockPrint\" access=\"printTicket\" ng-hide=\"vm.info === \'book\'\">Надрукувати</button><!-- <a class=\"btn btn-danger pull-right\" ng-click=\"vm.back()\" ng-if=\"vm.selectedItem.id\" >Нове замовлення</a> --></div></div><hr ng-if=\"vm.info\"><div class=\"sub_1 text-danger text-right\" ng-if=\"vm.selectedItem.service_charge != 0\"><strong>Увага! Попередьте клієнта про додаткову сплату сервісного збору</strong></div><uib-tabset active=\"active\"><uib-tab><uib-tab-heading>Схема залу</uib-tab-heading><div id=\"kasa-in-ua\"></div></uib-tab><uib-tab><uib-tab-heading>Інформація про подію</uib-tab-heading><div class=\"event-info container-fluid\"><div class=\"row\"><div class=\"col-lg-2\"><br><img ng-src=\"{{vm.imagesUrl + vm.selectedItem.posterUrl}}\" width=\"100%\"></div><div class=\"details-info col-lg-10\"><h3 class=\"\">{{vm.selectedItem.name}}</h3><div class=\"\">Дата проведення: <strong>{{vm.selectedItem.dateStart}}</strong></div><div class=\"\">Місто: <strong>{{vm.selectedItem.cityName}}</strong></div><div class=\"\">Місце проведення: <strong>{{vm.selectedItem.hallName}}</strong></div><div class=\"\">Адреса: <strong>{{vm.selectedItem.hallName}}</strong></div><div class=\"\">Початок входу: <strong>{{vm.selectedItem.dateEntry}}</strong></div><span class=\"pull-right\" ng-click=\"vm.favorite($event)\"><i class=\"glyphicon glyphicon-heart\" ng-if=\"vm.selectedItem.isFavorite\"></i> <i class=\"glyphicon glyphicon-heart-empty\" ng-if=\"!vm.selectedItem.isFavorite\"></i></span></div></div><div class=\"row\"><hr><div class=\"col-md-12\"><h3>Опис</h3><div class=\"event-description\" ng-bind-html=\"vm.selectedItem.description\"></div><p>&nbsp;</p></div></div></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/main/order/order.select.view.html","<div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"><label>Місто проведення</label><multiselect-dropdown items=\"vm.citiesGet\" ng-model=\"vm.filters.cityID\" options=\"{multiselect: false}\"></multiselect-dropdown></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-5 searchorder\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\" init=\"vm.initEvent\" hideall event-status=\"[\'in_sales\']\"></events-filter></div><div class=\"col-md-1 col-lg-1\"><label>&nbsp;</label><p class=\"form-control-static\"><span class=\"\" ng-click=\"vm.favorite($event)\"><i class=\"glyphicon glyphicon-heart\" ng-if=\"vm.selectedItem.isFavorite\"></i> <i class=\"glyphicon glyphicon-heart-empty\" ng-if=\"!vm.selectedItem.isFavorite\"></i></span></p></div><div class=\"col-md-2 col-lg-2\"><label>&nbsp;</label><button class=\"btn btn-default btn-block\" ng-click=\"vm.showFav=!vm.showFav\">Обрані події</button></div><div class=\"col-md-1 col-lg-1\"><label ng-show=\"vm.orderID\"># id</label><p class=\"form-control-static\">{{vm.orderID}}</p></div></div><hr><div class=\"fav-events\" ng-show=\"vm.showFav\"><poster-carousel><p style=\"padding-top: 20px; padding-left: 25px\">Обрані події:</p><ul class=\"row\"><li class=\"col-md-2\" ng-repeat=\"event in vm.favFvents\" ng-click=\"vm.selectFav(event.id)\"><div class=\"text-center\"><img ng-src=\"{{event.posterUrl ? vm.imagesUrl + event.posterUrl : \'assets/images/event-default.jpg\'}}\"><br><br></div><div class=\"title\"><field-name>{{event.name}}</field-name><field-city>{{event.cityName}}</field-city><field-date-start>{{event.dateStart}}</field-date-start></div></li></ul></poster-carousel></div>");
$templateCache.put("app/main/partners/partners.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Редагування партнера</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.partners\">Скасувати</a></span></div></header><div class=\"row\"><div class=\"col-md-12\">партнери edit</div></div><section class=\"row\"><form name=\"vm.partnerform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Системна назва партнера</label><input class=\"form-control\" name=\"systemName\" type=\"text\" ng-model=\"vm.item.systemName\" required placeholder=\"Системна назва партнера\"></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Url alias</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" required placeholder=\"Url alias\"></div></div><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Token</label><input class=\"form-control\" name=\"token\" type=\"text\" ng-model=\"vm.item.token\" required placeholder=\"Token\"></div></div><hr></form></section>");
$templateCache.put("app/main/partners/partners.event.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Партнери</span></div></header><div class=\"row\"><div class=\"col-md-12\">партнери event edit</div></div>");
$templateCache.put("app/main/partners/partners.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.partners.partners.event.edit\" ng-if=\"!vm.edit\">Додати партнера</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.partners\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.names\" ng-change=\"vm.applyFilter(\'names\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID</th><th>Системна назва партнера</th><th class=\"action col-md-1\">Іконка</th><th class=\"action col-md-3\">Url Alias</th><th class=\"action col-md-3\">Token</th><th class=\"action col-md-1\">Edit</th></tr></thead><tbody><tr ng-repeat=\"n in vm.items | orderBy:\'+id\'\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.name}}</td><td><img ng-src=\"{{n.image}}\" style=\"width: 50px\" class=\"img-thumbnail\"></td><td>{{n.base_url}}</td><td><div style=\"overflow: auto\">{{n.token}}</div></td><td><button class=\"btn btn-default btn-xs\" ui-sref=\"main.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"false\"></span></button> <button class=\"btn btn-default btn-xs\" ui-sref=\"main.view({ id:n.id })\"><span class=\"glyphicon glyphicon-eye-open\" aria-hidden=\"false\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/partners/partners.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.item.name}}</span></div></header><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.itemsLength}}</span></header></div></section><hr><div class=\"list-view row\" ng-if=\"vm.itemsLength > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.itemsLength\">Елементи 1—{{vm.itemsLength}} із {{vm.itemsLength}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.itemsLength\">Елементи 0 із {{vm.itemsLength}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID партнера</th><th class=\"action col-md-1\">ID в системі</th><th class=\"action col-md-3\">Назва</th><th class=\"action col-md-3\">Постер</th><th class=\"action col-md-3\">Локація</th><th class=\"action col-md-2\">Дата та час початку</th><th class=\"action col-md-2\">Дата та час кінця</th><th class=\"action col-md-4\">Інфо | Статус | Дія</th></tr></thead><tbody><tr ng-repeat=\"(key, n) in vm.item.items\" ng-style=\"n.systemId && {\'background-color\':\'lightgreen\'}\"><td>{{key}}</td><td>{{n.systemId}}</td><td>{{n.title}}</td><td><img ng-src=\"{{n.image}}\" style=\"width: 50%\" class=\"img-thumbnail\"></td><td>{{n.cityName}}<br>{{n.cityAddress}}<br>{{n.venueTitle}}</td><td>{{n.dataStart}}</td><td>{{n.dataEnd}}</td><td><a class=\"btn btn-info\" ng-click=\"vm.info({\n          partnerEventId: key,\n          partnerEventName: n.title,\n          partnerHallId: n.hallId,\n          partnerHallName: n.hallName,\n          partnerLocation: {\n            cityName: n.cityName,\n            cityAddress: n.cityAddress,\n            venueTitle: n.venueTitle\n            }\n          })\" stateful style=\"background-color: lightblue; border-radius: 5px; box-shadow: inset 0 2px 1px rgba(0,0,0,.075)\">Інфо</a> <a class=\"btn btn-success dropdown-toggle\" ng-if=\"!n.systemId\" ng-click=\"vm.add({ partnerEventId:key, items:n })\" stateful>Додати</a> <a class=\"btn btn-danger dropdown-toggle\" ng-if=\"n.systemId\" ng-click=\"vm.del({ partnerEventId:key, id:n.id, systemId:n.systemId })\" stateful>Зняти з продажу</a> <a class=\"btn btn-warning dropdown-toggle\" ng-click=\"vm.viewArea({ partnerEventId: key, partnerHallId: n.hallId })\" stateful>Зони</a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/quotes/quotes.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-primary\" ng-click=\"vm.goToView(vm.quotecreate)\" ng-if=\"vm.quote.id\">Перегляд</a> <a class=\"btn btn-success\" ui-sref=\"main.quotes.list\" ng-if=\"vm.savedsuccess\">Ok</a> <a class=\"btn btn-danger\" ng-click=\"vm.goback()\" ng-if=\"!vm.savedsuccess\">Не зберiгати</a></span></div></header><form class=\"form\" name=\"vm.quotecreate\" novalidate autocomplete=\"off\"><div class=\"row\"><div class=\"col-md-12\"><h4>Параметри квоти</h4></div><div class=\"form-group col-md-3\" show-errors><label class=\"control-label star\" for=\"name\">Назва</label><input placeholder=\"Назва\" class=\"form-control\" name=\"name\" id=\"name\" type=\"text\" maxlength=\"128\" ng-model=\"vm.quote.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-1\" ng-if=\"vm.quote.id\"><label class=\"control-label\" ng-if=\"vm.quote.id\">ID</label><div><p class=\"form-control-static\">{{vm.quote.id}}</p></div></div><div class=\"form-group col-md-4\" show-dd-errors=\"vm.quote.eventID\"><label>Подiя</label><events-filter output-model=\"vm.quote.eventID\" ng-if=\"!vm.quote.id\" init=\"vm.quote.eventID\"></events-filter><input type=\"hidden\" ng-model=\"vm.quote.eventID\" required><div ng-if=\"vm.quote.id\"><p class=\"form-control-static ellipsis\">{{vm.quote.eventName}}</p></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-2\"><label class=\"control-label\" for=\"Quote_name\" ng-show=\"vm.quote.id\">Дата</label><div ng-show=\"vm.quote.id\"><p class=\"form-control-static\">{{vm.quote.dateCreate}}</p></div></div><div class=\"form-group col-md-1\"></div><div class=\"form-group col-md-1\" ng-if=\"!vm.quote.id\"></div><div class=\"form-group col-md-1 text-right\"><label class=\"control-label\" for=\"Quote_name\">Статус</label><p class=\"form-control-static\"><span class=\"label label-danger\" ng-if=\"vm.quote.status === \'new\'\">Чернетка</span> <span class=\"label label-success\" ng-if=\"vm.quote.status === \'active\'\">Активна</span> <span class=\"label label-warning\" ng-if=\"vm.quote.status === \'returned\'\">Повернута</span> <span class=\"label label-danger\" ng-if=\"vm.quote.status === \'canceled\'\">Вiдмiнена</span></p></div></div><div class=\"row\"><div class=\"form-group col-md-2\" show-dd-errors=\"vm.quote.type\"><label class=\"control-label star\">Тип</label><input type=\"hidden\" ng-model=\"vm.quote.type\" required><selectlist input-model=\"vm.types\" output-model=\"vm.quote.type\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><div class=\"col-lg-6\"><div class=\"row\"><div class=\"form-group col-lg-6\" show-dd-errors=\"vm.quote.providerID\"><label class=\"control-label star\">Постачальник</label><input type=\"hidden\" ng-model=\"vm.quote.providerID\" required><selectlist input-method=\"vm.companies\" output-model=\"vm.quote.providerID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-6\" show-dd-errors=\"vm.quote.partnerID\"><label>Одержувач</label><!-- <input type=\"hidden\" ng-model=\"vm.quote.partnerID\" required/> --><selectlist input-method=\"vm.companies\" output-model=\"vm.quote.partnerID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><select class=\"form-control\" placeholder=\"Percent\" ng-model=\"vm.quote.partnerFeeType\"><option value=\"percent\" selected=\"selected\">% від продажу</option><option value=\"fee\">винагорода за продаж</option></select></div><div class=\"col-md-4\"><p class=\"form-control-static text-right\">Комісійні контрагента:</p></div><div class=\"col-md-2\"><input class=\"form-control\" type=\"number\" min=\"0\" value=\"0\" ng-model=\"vm.quote.partnerFee\"></div></div><div class=\"row\"><div class=\"col-md-6\"><button class=\"btn btn-success btn-block\" ng-if=\"!vm.savedsuccess\" ng-click=\"vm.save()\" ng-disabled=\"!vm.quotecreate.$dirty\" stateful>Зберегти параметри</button></div></div></div><div class=\"col-lg-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"Quote_comment\">Коментар</label><div class=\"dropdown-group\"><textarea placeholder=\"Коментар\" class=\"form-control\" name=\"description\" id=\"description\" rows=\"6\" ng-model=\"quote.description\"></textarea></div></div></div></div></form><hr><div class=\"fade-in\" ng-show=\"vm.hideInfo\"><h4>Редагування квоти</h4><div id=\"kasa-in-ua\" class=\"row\"></div></div>");
$templateCache.put("app/main/quotes/quotes.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список квот</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.quotes.new\">Створити квоту</a></span></div></header><div class=\"row filters\"><div class=\"col-md-1\"><label>#</label><input type=\"number\" placeholder=\"0\" class=\"form-control\" ng-model=\"vm.filters.id\"></div><div class=\"col-md-2\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventID\"></selectlist></div><div class=\"col-md-4\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\"></events-filter></div><div class=\"col-md-2\"><label>Ряд та мicце</label><div class=\"row\"><div class=\"col-md-5\"><input type=\"number\" placeholder=\"0\" class=\"form-control\" ng-model=\"vm.filters.rowNumber\"></div><div class=\"col-md-5\"><input type=\"number\" placeholder=\"0\" class=\"form-control\" ng-model=\"vm.filters.placeNumber\"></div></div></div><div class=\"col-md-2\"><label>Контрагенти</label><selectlist input-method=\"vm.playersGet\" output-model=\"vm.filters.partnerID\"></selectlist></div><div class=\"col-md-1\"><label class=\"col-md-12\">&nbsp;</label><label class=\"i-checks i-checks-sm pull-right\" style=\"margin-top: 12px\"><input type=\"checkbox\" ng-model=\"vm.filters.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'\'\"> <i></i>Активні</label></div></div><hr><div class=\"\"><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 < vm.count)\">Елементи 1-{{vm.items.length}} із {{vm.count}}</div><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 >= vm.count)\">Елементи 1-{{vm.count}} із {{vm.count}}</div></div><div class=\"tabler\"><table class=\"table table-striped table-bordered table-responsive col-md-12\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead><tr><th class=\"col-md-half\">№</th><th class=\"col-md-3half\" ng-click=\"vm.sort(\'name\')\">Назва</th><th class=\"col-md-3half\" ng-click=\"vm.sort(\'eventName\')\">Подiя</th><th class=\"col-md-3half\" ng-click=\"vm.sort(\'partnerName\')\">Створив</th><th class=\"col-md-3half\" ng-click=\"vm.sort(\'partnerName\')\">Гравець</th><th class=\"col-md-1 text-center\" ng-click=\"vm.sort(\'ticketsCost\')\">Цiна</th><th class=\"col-md-half text-center\" ng-click=\"vm.sort(\'ticketsCount\')\">Кiл-ть</th><th class=\"text-center\" ng-click=\"vm.sort(\'dateCreate\')\">Дата</th><th class=\"col-md-1 text-center\" ng-click=\"vm.sort(\'status\')\">Статус / Тип</th><th class=\"col-md-1\"></th></tr></thead><tbody><tr ng-repeat=\"quote in vm.items\" ng-show=\"!quote.deleted\"><td>{{quote.id}}</td><td><div class=\"ellipsis\">{{quote.name}}</div></td><td><div class=\"ellipsis\">{{quote.eventName}}</div></td><td><small><div class=\"ellipsis1\">{{quote.creatorInfo}}</div></small></td><td>{{quote.partnerName}}</td><td class=\"text-center\">{{quote.ticketsCost}} грн.</td><td class=\"text-center\">{{quote.ticketsCount}}</td><td class=\"text-center\">{{vm.formatDate(quote.dateCreate)}}</td><td class=\"text-center\"><span class=\"label label-danger\" ng-if=\"quote.status === \'new\'\">Чернетка</span> <span class=\"label label-success\" ng-if=\"quote.status === \'active\'\">Активна</span> <span class=\"label label-warning\" ng-if=\"quote.status === \'returned\'\">Повернута</span> <span class=\"label label-danger\" ng-if=\"quote.status === \'canceled\'\">Вiдмiнена</span> <span class=\"label label-warning\" ng-if=\"quote.status === \'transfer_to_order\'\">Переведена</span> <span class=\"label label-warning\" ng-if=\"quote.status === \'transfer_to_order\'\">в замовлення</span> <span class=\"label label-default\" ng-if=\"quote.type === \'quota\'\">Фiзична</span> <span class=\"label label-default\" ng-if=\"quote.type === \'e_quota\'\">Електронна</span> <span class=\"label label-default\" ng-if=\"quote.type === \'single_space\'\">ЄБП</span></td><td class=\"\"><div class=\"button-column\"><a class=\"btn btn-default btn-xs\" ui-sref=\"main.quotes.view({id: quote.id})\"><span class=\"glyphicon glyphicon-eye-open\"></span> </a><a class=\"btn btn-default btn-xs\" ui-sref=\"main.quotes.edit({id: quote.id})\"><span class=\"glyphicon glyphicon-pencil\"></span> </a><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.getXLSurl(quote.id)}}\" download access=\"quotaXls\">Накладна </a><!-- <button type=\"button\" class=\"btn btn-default btn-xs\" disabled>\n              Закрити\n            </button> --> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.print(quote)\" ng-if=\"quote.status === \'active\' && quote.type === \'quota\'\"><span class=\"glyphicon glyphicon glyphicon-print\"></span></button> <button class=\"btn btn-default btn-xs\" access=\"quotaDelete\" ng-click=\"vm.delete(quote)\" ng-if=\"quote.status === \'canceled\' || quote.status === \'new\'\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.printToZip(quote)\" access=\"printTicket\" ng-if=\"quote.status === \'active\'  && quote.type === \'quota\'\">Друк в файл</button></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/quotes/quotes.view.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left here\">{{vm.titleView}} </span><span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.quotes.edit({id: vm.quote.id, back: \'view\'})\">Редагувати</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Назва</label><p>{{vm.quote.name}}</p></div><div class=\"col-md-1\"><label>ID</label><p>{{vm.quote.id}}</p></div><div class=\"col-md-2\"><label>Статус</label><p><span class=\"label label-danger\" ng-if=\"vm.quote.status === \'new\'\">Чернетка</span> <span class=\"label label-success\" ng-if=\"vm.quote.status === \'active\'\">Активна</span> <span class=\"label label-warning\" ng-if=\"vm.quote.status === \'returned\'\">Повернута</span> <span class=\"label label-danger\" ng-if=\"vm.quote.status === \'canceled\'\">Вiдмiнена</span> <span class=\"label label-warning\" ng-if=\"vm.quote.status === \'transfer_to_order\'\">Переведена в замовлення</span></p></div><div class=\"col-md-3\"><label>Постачальник</label><p>{{vm.quote.providerName}}</p></div><div class=\"col-md-3\"><label>Отримувач</label><p>{{vm.quote.partnerName}}</p></div></div><div class=\"row\"><div class=\"col-md-3\"><label>Хто створив</label><p>{{vm.quote.creatorInfo}}</p></div><div class=\"col-md-3\"><label>Дата створення</label><p>{{vm.quote.dateCreate | date}}</p></div><div class=\"col-md-3\"><label>Хто роздрукував</label><p>{{vm.quote.printerName}}</p></div><div class=\"col-md-3\"><label>Дата друку</label><p>{{vm.quote.datePrint | date}}</p></div></div><hr><div class=\"row\"><div class=\"col-md-4\"><label>Розмір квоти</label><p>{{vm.quote.ticketsCost}}</p></div><div class=\"col-md-4\"><label>Очікувана винагорода</label><p>{{vm.expectedTotalFee || 0}}</p></div><div class=\"col-md-4\"><label ng-if=\"vm.quote.partnerFeeType ===\'fee\'\">Фактична винагорода</label><label ng-if=\"vm.quote.partnerFeeType !==\'fee\'\">Відсоток з проданих</label><p>{{vm.realTotalFee || 0}}</p></div></div><hr><div class=\"row\"><div class=\"col-md-12\"><!--<button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"vm.createorder()\" ng-disabled=\"vm.quote.freeTicketsCount < 1\" access=\"convertQuota\">Створити замовлення</button> --> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.close()\" disabled=\"disabled\">Закрити</button><!-- <button type=\"button\" class=\"btn btn-success btn-xs\" disabled>Вилучити місця</button>\n    <button type=\"button\" class=\"btn btn-success btn-xs\" disabled>Передати квоту</button> --> <button type=\"button\" class=\"btn btn-success btn-xs\" ui-sref=\"main.quotes.edit({id: vm.quote.id, agentedit: true})\">Продажі к/а</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"vm.print()\" access=\"printTicket\" ng-if=\"vm.quote.status === \'active\' && vm.quote.type === \'quota\'\">Друк</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"vm.printToZip(vm.quote)\" access=\"printTicket\" ng-if=\"vm.quote.status === \'active\' && vm.quote.type === \'quota\'\">Друк в файл</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"vm.setInvite()\" access=\"setOrderTypeInvite\" ng-if=\"vm.quote.status === \'active\'\">Встановити запрошення</button></div></div><hr><div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-true-value=\"\'sold\'\" ng-model=\"vm.ticketsStatus[0]\">Продані</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-true-value=\"\'not_sold\'\" ng-model=\"vm.ticketsStatus[1]\">Непродані</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-true-value=\"\'returned\'\" ng-model=\"vm.ticketsStatus[2]\">Повернуті</label><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-true-value=\"\'transmitted\'\" ng-model=\"vm.ticketsStatus[3]\">Передані</label><div class=\"pull-right\" access=\"invoiceQuota\"><a ng-href=\"{{vm.xlsUrl}}\" type=\"button\" class=\"btn btn-success btn-xs\" download>Завантажити накладну</a></div></div><div class=\"panel-body panel-body-table\"><table class=\"table table-striped table-condensed\"><thead><tr><th></th><th>Ціна</th><th>Кількість</th><th>Cумма</th></tr></thead><tbody><tr ng-repeat=\"ticket in vm.tickets\"><td>{{ticket.placesString}} {{ticket.ticketsStatus}}</td><td>{{ticket.price}}</td><td>{{ticket.count}}</td><td>{{ticket.cost}}</td></tr><tr class=\"info font-bold\"><td>Всього:</td><td></td><td>{{vm.totalTickets.count}}</td><td>{{vm.totalTickets.cost}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/responsible/responsible.events.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Аналітика продажів</span></div></header><div class=\"row\"><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за назвою\"></div><div class=\"col-md-9\" style=\"padding-top: 5px\"><label class=\"i-checks\" ng-if=\"vm.viewAll\"><input type=\"checkbox\" ng-model=\"vm.filters.filterAll\" ng-change=\"vm.applyFilter(\'filterAll\');\"> <i></i>Усі події</label><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"vm.filters.filterUser\" ng-change=\"vm.applyFilter(\'filterUser\');\"> <i></i>Мої події</label><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"vm.filters.filterSubdivision\" ng-change=\"vm.applyFilter(\'filterSubdivision\');\"> <i></i>Мого підрозділу</label></div></div><div class=\"list-view row\" infinite-scroll=\"vm.load();\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\" ng-if=\"!!vm.items.length\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Подій не знайдено</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th class=\"col-md-3\">Назва</th><th class=\"col-md-2\">Дата</th><th class=\"col-md-1\">Місто</th><th class=\"col-md-3\">Відповідальний</th><th class=\"col-md-1 text-center\">Оцінка</th><th class=\"col-md-1 text-center\">Дії</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.date}}</td><td>{{item.city}}</td><td>{{item.responsible}}</td><td class=\"text-center\"><span class=\"label label-danger\" ng-if=\"item.rate <= vm.ratingLimits.bottom\">Погано</span> <span class=\"label label-warning\" ng-if=\"item.rate > vm.ratingLimits.bottom && item.rate < vm.ratingLimits.top\">Не дуже добре</span> <span class=\"label label-success\" ng-if=\"item.rate >= vm.ratingLimits.top\">Добре</span></td><td><div class=\"button-column text-center\"><a type=\"button\" ui-sref=\"main.event.edit({ id: item.id })\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-eye-open\" aria-hidden=\"true\"></span></a></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/statistics/clients.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Звіт по клієнтам</span></div></header><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" name=\"onlyBuyers\" ng-model=\"vm.filters.onlyBuyers\" ng-value=\"true\"><i></i>Клієнти що придбали квитки</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" name=\"onlyBuyers\" ng-model=\"vm.filters.onlyBuyers\" ng-value=\"false\"><i></i>Клієнти що придбали/забронювали квитки</label></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.allEvents\" checklist-value=\"\'true\'\"> <i></i>Фомрувати по всіх подіях</label></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><a class=\"btn btn-success btn-block\" ng-href=\"{{vm.clientsReportLink}}\" download>Сформувати звіт</a></div></div>");
$templateCache.put("app/main/statistics/dev-clients.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Dev - Звіт</span></div></header><!--Фильтр поиска--><div class=\"row filters\"><div style=\"float:left; width:50%\"><div class=\"col-md-3\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\"></selectlist></div><div class=\"col-md-6\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" init=\"vm.initEvent\" city=\"vm.filters.cityID\"></events-filter></div><div class=\"col-md-3\"><label>Касир</label><selectlist input-method=\"vm.moneyRecipient\" output-model=\"vm.filters.moneyRecipientID\"></selectlist></div><div class=\"col-md-3 pull-right\"><label>&nbsp;</label><button class=\"btn btn-success btn-block\" ng-disabled=\"!(vm.dataIsLoaded)\" ng-click=\"vm.getXls()\">Export XLS</button></div><div class=\"col-md-3 pull-right\"><label>&nbsp;</label><button class=\"btn btn-success btn-block\" stateful ng-disabled=\"!(vm.filters.eventID.length)\" ng-click=\"vm.getStat()\" key-enter=\"vm.getStat()\">Знайти</button></div></div><div style=\"float:left; width:50%\"><label class=\"i-checks i-checks-sm\" style=\"display:-webkit-box\"><input type=\"checkbox\" ng-model=\"vm.ticketFilter.paidbycc\" ng-checked=\"vm.ticketFilter.paidbycc\"> <i></i>Відобразити квитки оплачені платіжною картою (окірм електронних)</label><label class=\"i-checks i-checks-sm\" style=\"display:-webkit-box\"><input type=\"checkbox\" ng-model=\"vm.ticketFilter.eticket\" ng-checked=\"vm.ticketFilter.eticket\"> <i></i>Відобразити електронні квитки</label><label class=\"i-checks i-checks-sm\" style=\"display:-webkit-box\"><input type=\"checkbox\" ng-model=\"vm.byinvite\" ng-checked=\"vm.byinvite\"> <i></i>Відобразити запрошення</label><label class=\"i-checks i-checks-sm\" style=\"display:-webkit-box\"><input type=\"checkbox\" ng-model=\"vm.ticketFilter.byquota\" ng-checked=\"vm.ticketFilter.byquota\"> <i></i>Відобразити продані через квоту квитки</label></div></div><hr><div ng-show=\"vm.dataIsLoaded\"><table class=\"table table-bordered table-striped\" style=\"width:50%\"><tbody><tr><td colspan=\"3\"><h4>Загальна інфоормація</h4></td></tr><tr><td><b>Разом</b></td><td><b>{{vm.reportGrandHeaderTicketsTotal| number : 0 }}</b></td><td><b>{{vm.reportGrandHeaderTotal| number : 2 }}</b></td></tr><tr><td><b>Вартість квтитка</b></td><td><b>Кількість квитків</b></td><td><b>На суму</b></td></tr><tr ng-hide=\"vm.reportGrandHeader.length\"><td colspan=\"3\">Дані відсутні</td></tr><tr ng-repeat=\"reportGrandHeadeRow in vm.reportGrandHeader\"><td>{{reportGrandHeadeRow.ticket_cost | number : 2 }}</td><td>{{reportGrandHeadeRow.tickets_count}}</td><td>{{reportGrandHeadeRow.ticket_sum | number : 2 }}</td></tr><tr ng-show=\"vm.byinvite\"><td colspan=\"3\"><b>Запрошення</b></td></tr><tr ng-show=\"vm.byinvite\"><td><b>Разом</b></td><td>{{vm.reportBodyLevel2_1GrandTotal.tickets_count}}</td><td>{{vm.reportBodyLevel2_1GrandTotal.ticket_cost_total | number : 2 }}</td></tr></tbody></table><table class=\"table table-bordered table-striped\"><thead><tr><td colspan=\"5\"><h4>Продажі по акаунтам</h4></td></tr></thead><tbody><tr><td><b>Акаунт</b></td><td><b>Зона</b></td><td><b>Ціна квитка</b></td><td><b>Кількість проданих квитків</b></td><td><b>Продано квитків на суму</b></td></tr><tr ng-hide=\"vm.reportBodyLevel1[0].length\"><td colspan=\"5\">Дані відсутні</td></tr><tbody ng-repeat=\"reportBodyLevel1Row in vm.reportBodyLevel1[0]\"><tr ng-show=\"reportBodyLevel1Row.reportBodyLevel2.length || vm.byinvite && reportBodyLevel1Row.reportBodyLevel2_1.length\"><td colspan=\"5\"><b>{{reportBodyLevel1Row.user_email }} {{reportBodyLevel1Row.user_first_name}} {{reportBodyRow.user_last_name}} (#{{reportBodyLevel1Row.ticket_seller_id}})</b></td></tr><tr ng-show=\"(reportBodyLevel1Row.reportBodyLevel2.length > 1)\"><td colspan=\"3\"><b>Разом</b></td><td><b>{{vm.getReportBodyLevel2Total(reportBodyLevel1Row.ticket_seller_id).tickets_count | number : 0}}</b></td><td><b>{{vm.getReportBodyLevel2Total(reportBodyLevel1Row.ticket_seller_id).ticket_cost_total | number : 2}}</b></td></tr><tr ng-repeat=\"reportBodyLevel2Row in reportBodyLevel1Row.reportBodyLevel2\"><td>&nbsp;</td><td>{{reportBodyLevel2Row.area_zone_name}}</td><td>{{reportBodyLevel2Row.ticket_cost}}</td><td>{{reportBodyLevel2Row.tickets_count}}</td><td>{{reportBodyLevel2Row.ticket_cost_total | number : 2 }}</td></tr><tr ng-show=\"vm.byinvite && reportBodyLevel1Row.reportBodyLevel2_1.length\"><td colspan=\"5\"><b>Запрошення</b></td></tr><tr ng-show=\"vm.byinvite && {{( reportBodyLevel1Row.reportBodyLevel2_1.length > 1)}}\"><td colspan=\"3\"><b>Разом</b></td><td><b>{{vm.getReportBodyLevel2_1Total(reportBodyLevel1Row.ticket_seller_id).tickets_count | number : 0}}</b></td><td><b>{{vm.getReportBodyLevel2_1Total(reportBodyLevel1Row.ticket_seller_id).ticket_cost_total | number : 2}}</b></td></tr><tr ng-show=\"vm.byinvite\" ng-repeat=\"reportBodyLevel2_1Row in reportBodyLevel1Row.reportBodyLevel2_1\"><td>&nbsp;</td><td>{{reportBodyLevel2_1Row.area_zone_name}}</td><td>{{reportBodyLevel2_1Row.ticket_cost}}</td><td>{{reportBodyLevel2_1Row.tickets_count}}</td><td>{{reportBodyLevel2_1Row.ticket_cost_total | number : 2 }}</td></tr></tbody></tbody></table><table class=\"table table-bordered table-striped\"><thead><tr><td colspan=\"5\"><h4>Продажі через квоту</h4></td></tr></thead><tbody><tr><td><b>Акаунт</b></td><td><b>Зона</b></td><td><b>Ціна квитка</b></td><td><b>Кількість проданих квитків</b></td><td><b>Продано квитків на суму</b></td></tr><tr ng-hide=\"vm.reportBodyLevel1[1].length\"><td colspan=\"5\">Дані відсутні</td></tr><tbody><tbody ng-repeat=\"reportBodyLevel1Row in vm.reportBodyLevel1[1]\"><tr><td ng-show=\"reportBodyLevel1Row.reportBodyLevel2.length || vm.byinvite && reportBodyLevel1Row.reportBodyLevel2_1.length\" colspan=\"5\"><b>{{reportBodyLevel1Row.user_email }} {{reportBodyLevel1Row.user_first_name}} {{reportBodyRow.user_last_name}} (#{{reportBodyLevel1Row.ticket_seller_id}})</b></td></tr><tr ng-show=\"{{(reportBodyLevel1Row.reportBodyLevel2.length > 1)}}\"><td colspan=\"3\"><b>Разом</b></td><td><b>{{vm.getReportBodyLevel2Total(reportBodyLevel1Row.ticket_seller_id).tickets_count | number : 0}}</b></td><td><b>{{vm.getReportBodyLevel2Total(reportBodyLevel1Row.ticket_seller_id).ticket_cost_total | number : 2}}</b></td></tr><tr ng-repeat=\"reportBodyLevel2Row in reportBodyLevel1Row.reportBodyLevel2\"><td>&nbsp;</td><td>{{reportBodyLevel2Row.area_zone_name}}</td><td>{{reportBodyLevel2Row.ticket_cost}}</td><td>{{reportBodyLevel2Row.tickets_count}}</td><td>{{reportBodyLevel2Row.ticket_cost_total | number : 2 }}</td></tr><tr ng-show=\"reportBodyLevel1Row.reportBodyLevel2_1.length && vm.byinvite\"><td colspan=\"5\"><b>Запрошення</b></td></tr><tr ng-show=\"vm.byinvite && {{(reportBodyLevel1Row.reportBodyLevel2_1.length > 1)}}\"><td colspan=\"3\"><b>Разом</b></td><td><b>{{vm.getReportBodyLevel2_1Total(reportBodyLevel1Row.ticket_seller_id).tickets_count | number : 0}}</b></td><td><b>{{vm.getReportBodyLevel2_1Total(reportBodyLevel1Row.ticket_seller_id).ticket_cost_total | number : 2}}</b></td></tr><tr ng-show=\"vm.byinvite\" ng-repeat=\"reportBodyLevel2_1Row in reportBodyLevel1Row.reportBodyLevel2_1\"><td>&nbsp;</td><td>{{reportBodyLevel2_1Row.area_zone_name}}</td><td>{{reportBodyLevel2_1Row.ticket_cost}}</td><td>{{reportBodyLevel2_1Row.tickets_count}}</td><td>{{reportBodyLevel2_1Row.ticket_cost_total | number : 2 }}</td></tr></tbody></tbody></tbody></table></div>");
$templateCache.put("app/main/statistics/full.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Розширена статистика</span></div></header><!--Фильтр поиска и даты--><div class=\"row filters\"><div class=\"col-md-2\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventID\"></selectlist></div><div class=\"col-md-6\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" init=\"vm.initEvent\" city=\"vm.filters.cityID\"></events-filter></div><!--\n\n  <div class=\"col-md-2\">\n    <label>&nbsp;</label>\n    <button class=\"btn btn-success btn-block\" stateful ng-class=\"{disabled: !vm.filters.eventID}\" ng-click=\"vm.getStat()\">Знайти</button>\n  </div> --></div><hr><div class=\"row kasa-statistic\" ng-if=\"vm.filters.eventID\"><!--Область продаж--><div class=\"col-md-4 sold-aria\"><div class=\"panel panel-default\"><ul class=\"list-group\"><li ng-repeat=\"item in vm.menuItems\" ng-click=\"vm.select(item)\" class=\"list-group-item\"><a href=\"\" class=\"{{ item === vm.selectedMenuItem ? \'active\' : \'\' }}\">{{item.title}}</a></li></ul></div></div><!--Область динамики. График--><div ng-include=\"vm.selectedMenuItem.templateUrl\"></div>");
$templateCache.put("app/main/statistics/sales.tooltip.view.html","<table class=\"table table-bordered table-style-1\" ng-if=\"vm.response.sales || item.quickStat.sales\"><thead><tr><th rowspan=\"2\">Ціна</th><th colspan=\"2\">Продано</th></tr><tr><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat-end ng-repeat=\"item in (vm.response.sales || item.quickStat.sales) | orderBy: \'price\'\"><td>{{item.price}}</td><td>{{item.soldCount}}</td><td>{{item.soldCost.toFixed(2)}}</td></tr></tbody></table>");
$templateCache.put("app/main/statistics/statistics.detail.view.html","<!--Фильтр поиска и даты--><div class=\"row filters\"><div class=\"col-md-2\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventID\"></selectlist></div><div class=\"col-md-4\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" init=\"vm.initEvent\" city=\"vm.filters.cityID\" multiselect></events-filter></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-xs-12\"><label>Період оплати</label></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateFrom\" max=\"vm.filters.paymentDateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateTo\" min=\"vm.filters.paymentDateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div><div class=\"col-md-2\"><label>&nbsp;</label><button class=\"btn btn-success btn-block\" stateful ng-disabled=\"!(vm.filters.eventID.length || (vm.filters.paymentDateFrom && vm.filters.paymentDateTo))\" ng-click=\"vm.getStat()\" key-enter=\"vm.getStat()\">Знайти</button></div></div><hr><div class=\"row kasa-statistic\" ng-if=\"vm.response\"><!--Область продаж--><div class=\"col-md-4 sold-aria\"><div class=\"panel panel-default\"><br><div class=\"row\"><div class=\"col-md-12\" ng-if=\"vm.response\"><div uib-tooltip-template=\"\'app/main/statistics/sales.tooltip.view.html\'\" tooltip-placement=\"right\" class=\"white-tooltip\"><h4>ПРОДАНО</h4><div class=\"quantity-sold\"><span class=\"h1\">{{vm.response.soldCount}} шт</span> <span class=\"h5\">({{vm.percent(vm.response.soldCount)}}%)</span><br><span class=\"h4\">{{vm.response.soldCost}} грн.</span></div><div class=\"pull-right\" ng-if=\"vm.userData.role === \'admin\'\" style=\"margin-right: 20px; text-align: center\"><h5 style=\"margin: 0\">Сервісний збір</h5><span class=\"h5\" style=\"margin: 0\">{{vm.response.soldServiceCharge}} грн.</span></div></div></div><div ng-hide=\"!vm.response.soldProductCount\" style=\"border:1px solid red; color:red; position: absolute; right: 30px\"><h4>Акція</h4><div class=\"quantity-sold\"><span class=\"h1\">{{vm.response.soldProductCount}} шт</span><br><span class=\"h4\">{{vm.response.soldProductCost}} грн.</span></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><h5>ВСЬОГО З ЦІНОЮ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.pricedCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.pricedCount)}}%)</span><br><span class=\"h5\">{{vm.response.pricedCost}} грн.</span></div></div><div class=\"col-md-6\"><h5>ЗАПРОШЕННЯ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.inviteCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.inviteCount)}}%)</span><br><span class=\"h5\">{{vm.response.inviteCost}} грн.</span></div></div></div><div class=\"row\"><br><div class=\"col-md-6\"><h5>У ПРОДАЖУ<br>&nbsp;</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.inSalesCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.inSalesCount)}}%)</span><br><span class=\"h5\">{{vm.response.inSalesCost}} грн.</span></div></div><div class=\"col-md-6\"><h5>ПЕРЕДАНО НА РЕАЛІЗАЦІЮ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.quotedCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.quotedCount)}}%)</span><br><span class=\"h5\">{{vm.response.quotedCost}} грн.</span></div></div></div><div class=\"row\"><br><div class=\"col-md-6\"><h5>ЗАБРОНЬОВАНО<br>(не оплачено)</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.orderedCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.orderedCount)}}%)</span><br><span class=\"h5\">{{vm.response.orderedCost}} грн.</span></div></div><div class=\"col-md-6\"><h5>ЗАКРИТО З ПРОДАЖУ<br>&nbsp;</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.notInSalesCount}} шт</span> <span class=\"h6\">({{vm.percent(vm.response.notInSalesCount)}}%)</span><br><span class=\"h5\">{{vm.response.notInSalesCost}} грн.</span></div></div></div><div class=\"row\"><br><div class=\"col-md-6\"><h5>НЕ ЗАДІЯНО</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.freeCount}} шт</span></div></div><div class=\"col-md-6\"><h5>ПРИХОВАНІ НА СХЕМІ</h5><div class=\"quantity-sold\"><span class=\"h2\">{{vm.response.hiddenCount}} шт</span><br><span class=\"h5\">{{vm.response.hiddenCost}} грн.</span></div></div></div><br></div></div><!--Область динамики. График--><div class=\"col-md-8 dynamic-aria\"><div class=\"panel panel-default\"><br><div><highchart id=\"statistic-chart\" config=\"vm.chartConfig\"></highchart></div></div></div></div><!--Таблица вывода 1--><div class=\"row kasa-statistic\" ng-if=\"vm.response\"><div class=\"col-xs-12\"><hr><h3><span>Загальні продажі контрагентів</span><div class=\"form-group pull-right\"><a class=\"btn btn-success btn-block\" ng-href=\"{{vm.contractorsXlsUrl}}\" download=\"\">Звіт .XLS</a></div></h3><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Контрагент</th><th>Продано</th><th>Бронь</th><th>Передано на реалізацію</th><th>Запрошення</th><th>Сума (продано)</th><th>Частка валу</th></tr><tr class=\"tr-1\"><td>шт</td><td>шт</td><td>шт</td><td>шт</td><td>грн</td><td>%</td></tr></thead><tbody><tr ng-repeat=\"c in vm.response.contractors\"><td>{{c.name}}</td><td class=\"td-b\">{{c.soldCount}}</td><td class=\"td-b\">{{c.reserveCount}}</td><td class=\"td-b\">{{c.inQuotaCount}}</td><td class=\"td-b\">{{c.inviteCount}}</td><td class=\"td-b\">{{c.soldCost}}</td><td class=\"td-c\">{{vm.percent(c.soldCount)}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td>{{vm.response.contractorsSoldCount}}</td><td>{{vm.response.contractorsReserveCount}}</td><td>{{vm.response.contractorsInQuotaCount}}</td><td>{{vm.response.contractorsInviteCount}}</td><td>{{vm.response.contractorsSoldCost}}</td><td>{{vm.response.soldPercent}}</td></tr></tfoot></table><hr><h3><span>Загальні продажі по API</span></h3><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Контрагент (Гравець)</th><th>Продано</th><th>Бронь</th><th>Сума (продано)</th></tr><tr class=\"tr-1\"><td>шт</td><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat=\"c in vm.response.apicontractors\"><td>{{c.name}}</td><td class=\"td-b\">{{c.soldCount}}</td><td class=\"td-b\">{{c.reserveCount}}</td><td class=\"td-b\">{{c.soldCost}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td>{{vm.response.apicontractorsSoldCount}}</td><td>{{vm.response.apicontractorsReserveCount}}</td><td>{{vm.response.apicontractorsSoldCost}}</td></tr></tfoot></table><hr><h3><span>Загальні продажі контрагентів в розрізі подій</span></h3><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Подія</th><th rowspan=\"2\">Контрагент</th><th>Продано</th><th>Бронь</th><th>Передано на реалізацію</th><th>Запрошення</th><th>Сума (продано)</th><th>Частка валу</th></tr><tr class=\"tr-1\"><td>шт</td><td>шт</td><td>шт</td><td>шт</td><td>грн</td><td>%</td></tr></thead><tbody><tr ng-repeat=\"c in vm.response.eventsContractors\"><td>{{c.event}}</td><td>{{c.contractor}}</td><td class=\"td-b\">{{c.soldCount}}</td><td class=\"td-b\">{{c.reserveCount}}</td><td class=\"td-b\">{{c.inQuotaCount}}</td><td class=\"td-b\">{{c.inviteCount}}</td><td class=\"td-b\">{{c.soldCost}}</td><td class=\"td-c\">{{vm.percent(c.soldCount)}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td></td><td>{{vm.response.contractorsSoldCount}}</td><td>{{vm.response.contractorsReserveCount}}</td><td>{{vm.response.contractorsInQuotaCount}}</td><td>{{vm.response.contractorsInviteCount}}</td><td>{{vm.response.contractorsSoldCost}}</td><td>{{vm.response.soldPercent}}</td></tr></tfoot></table><hr><div ng-repeat=\"event in vm.response.zones\"><h3><span>В розрізі секторів - {{event.event}}</span></h3><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\"></th><th rowspan=\"2\">Ціна</th><th colspan=\"2\">Продано</th><th colspan=\"2\">Разом продано</th><th colspan=\"2\">Бронь</th><th colspan=\"2\">Разом (продано+бронь)</th><th rowspan=\"2\">Запрошення, шт</th></tr><tr class=\"tr-1\"><td>шт</td><td>грн</td><td>шт</td><td>грн</td><td>шт</td><td>грн</td><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat-start=\"z in event.zones\"><td rowspan=\"{{z.prices.length}}\">{{z.name}}</td><td class=\"td-a\">{{z.prices[0].price}}</td><td class=\"td-b\">{{z.prices[0].soldCount}}</td><td class=\"td-b\">{{z.prices[0].soldCost}}</td><td class=\"td-b\" rowspan=\"{{z.prices.length}}\">{{z.soldCount}}</td><td class=\"td-b\" rowspan=\"{{z.prices.length}}\">{{z.soldCost}}</td><td class=\"td-c\">{{z.prices[0].reservedCount}}</td><td class=\"td-c\">{{z.prices[0].reservedCost}}</td><td class=\"td-b\" rowspan=\"{{z.prices.length}}\">{{z.soldCount + z.reservedCount}}</td><td class=\"td-b\" rowspan=\"{{z.prices.length}}\">{{z.soldCost + z.reservedCost}}</td><td class=\"td-d\" rowspan=\"{{z.prices.length}}\">{{z.inviteCount}}</td></tr><tr ng-repeat-end ng-repeat=\"p in z.prices.slice(1)\"><td class=\"td-a\">{{p.price}}</td><td class=\"td-b\">{{p.soldCount}}</td><td class=\"td-b\">{{p.soldCost}}</td><td class=\"td-c\">{{p.reservedCount}}</td><td class=\"td-c\">{{p.reservedCost}}</td></tr></tbody><!-- TODO when ready --><!-- <tfoot>\n          <tr class=\"tr-2\">\n            <td>ВСЬОГО</td>\n            <td>-</td>\n            <td>{{event.soldCount}}</td>\n            <td>{{event.soldCost}}</td>\n            <td>{{event.soldCount}}</td>\n            <td>{{event.soldCost}}</td>\n            <td>{{event.orderedCount}}</td>\n            <td>{{event.orderedCost}}</td>\n            <td>{{event.soldCount + event.orderedCount}}</td>\n            <td>{{event.soldCost + event.orderedCost}}</td>\n            <td>{{event.inviteCount}}</td>\n          </tr>\n        </tfoot> --></table><hr></div><h3>Продажі через віджети</h3><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Подія</th><th rowspan=\"2\">Віджет</th><th colspan=\"2\">Оплачено через віджет</th><th colspan=\"2\">Оформлено через віджет</th></tr><tr class=\"tr-1\"><td>шт</td><td>грн</td><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat=\"w in vm.response.widgets\"><td>{{w.eventName}}</td><td>{{w.name}}</td><td class=\"td-b\">{{w.soldCount}}</td><td class=\"td-b\">{{w.soldCost}}</td><td class=\"td-b\">{{w.reservedCount}}</td><td class=\"td-b\">{{w.reservedCost}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td colspan=\"2\">ВСЬОГО</td><td>{{vm.response.widgetsSoldCount}}</td><td>{{vm.response.widgetsSoldCost}}</td><td>{{vm.response.widgetsReservedCount}}</td><td>{{vm.response.widgetsReservedCost}}</td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/statistics/statistics.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Статистика</span></div></header><div ng-include=\"\'app/main/statistics/statistics.detail.view.html\'\"></div>");
$templateCache.put("app/main/statistics/widgets.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Продажі через віджет</span></div></header><div class=\"row kasa-statistic\" ng-if=\"vm.response\"><div class=\"col-xs-12\"><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Назва</th><th colspan=\"2\">Оплачено через віджет</th><th colspan=\"2\">Оформлено через віджет</th><th colspan=\"2\">Неоплачені броні</th></tr><tr class=\"tr-1\"><td>шт</td><td>грн</td><td>шт</td><td>грн</td><td>шт</td><td>грн</td></tr></thead><tbody><tbody ng-repeat=\"event in vm.response.events\"><tr><td colspan=\"7\"><b>{{event.eventName}}</b></td></tr><tr ng-repeat=\"widget in vm.response.widgets | filter : {eventId : event.eventId } \"><td>{{widget.name}}</td><td class=\"td-b\">{{widget.soldCount}}</td><td class=\"td-b\">{{widget.soldCost}}</td><td class=\"td-b\">{{widget.reservedCount}}</td><td class=\"td-b\">{{widget.reservedCost}}</td><td class=\"td-b\">{{widget.reservedNotPaidCount}}</td><td class=\"td-b\">{{widget.reservedNotPaidCost}}</td></tr></tbody></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td>{{vm.response.widgetsSoldCount}}</td><td>{{vm.response.widgetsSoldCost}}</td><td>{{vm.response.widgetsReservedCount}}</td><td>{{vm.response.widgetsReservedCost}}</td><td>{{vm.response.widgetsReservedNotPaidCount}}</td><td>{{vm.response.widgetsReservedNotPaidCost}}</td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/service-charge/service-charge.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Редагування сервісного збору</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.service-charge\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.form\" novalidate autocomplete=\"off\" class=\"container-fluid\"><div class=\"col-md-12 form-group\"><div class=\"row\"><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Тип ставки</label><select class=\"form-control\" name=\"rate_type\" ng-model=\"vm.serviceCharge.rate_type\" ng-options=\"key as value for (key, value) in vm.rateTypes\" required></select><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-1 form-group\" show-errors><label class=\"star\">Ставка</label><input class=\"form-control\" type=\"text\" name=\"rate\" ng-model=\"vm.serviceCharge.rate\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Тип квитків</label><select class=\"form-control\" name=\"tickets_type\" ng-model=\"vm.serviceCharge.tickets_type\" ng-options=\"key as value for (key, value) in vm.ticketsTypes\" required></select><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Тип оплати</label><select class=\"form-control\" name=\"payment_type\" ng-model=\"vm.serviceCharge.payment_type\" ng-options=\"key as value for (key, value) in vm.paymentTypes\" required></select><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-3 form-group\"><label>Назва (для внутрішнього використання)</label><input class=\"form-control\" type=\"text\" ng-model=\"vm.serviceCharge.name\"></div><div class=\"col-md-2 form-group\"><label>Активний</label><div><input type=\"checkbox\" ng-model=\"vm.serviceCharge.active\"></div></div></div><div class=\"row\"><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Тип вибору подій</label><select class=\"form-control\" name=\"events_type\" ng-model=\"vm.serviceCharge.events_type\" ng-options=\"key as value for (key, value) in vm.eventsTypes\" required></select><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-4 form-group\"></div><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Тип вибору кас</label><select class=\"form-control\" name=\"cashes_type\" ng-model=\"vm.serviceCharge.cashes_type\" ng-options=\"key as value for (key, value) in vm.cashesTypes\" required></select><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"col-md-6 form-group\"><label>Події</label><selectlistevent input-model=\"vm.events\" output-model=\"vm.serviceCharge.events\" disabled=\"vm.serviceCharge.events_type === \'all\'\" multiselect></selectlistevent></div><div class=\"col-md-6 form-group\"><label>Каси</label><selectlist input-model=\"vm.cashes\" output-model=\"vm.serviceCharge.cashes\" disabled=\"vm.serviceCharge.cashes_type === \'all\'\" multiselect></selectlist></div></div></div></form></section><!--<section class=\"row\" ng-if=\"vm.serviceCharge.id\">--><!--  <hr>--><!--  <div class=\"col-md-12\">--><!--    <span class=\"pull-right title-btns\">--><!--      <a class=\"btn btn-danger\" ng-click=\"vm.delete()\">Видалити</a>--><!--    </span>--><!--  </div>--> <!--</section>-->");
$templateCache.put("app/main/service-charge/service-charge.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Профілі сервісного збору</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.service-charge-edit\">Додати сервісний збір</a></span></div></header><div class=\"list-view row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID</th><th class=\"action col-md-3\">Назва</th><th class=\"action col-md-1\">Ставка</th><th class=\"action col-md-1\">Тип квитків</th><th class=\"action col-md-1\">Тип оплати</th><th class=\"action col-md-1\">Події</th><th class=\"action col-md-1\">Каси</th><th class=\"action col-md-1\">Активний</th><th class=\"action col-md-2\">Редагувати</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items | orderBy:\'+id\'\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.rate}} {{item.rate_type === \'percent\' ? \'%\' : \'грн\'}}</td><td>{{item.tickets_type}}</td><td>{{item.payment_type}}</td><td>{{item.events_count}}</td><td>{{item.cashes_count}}</td><td>{{item.active ? \'Так\' : \'Ні\'}}</td><td><button class=\"btn btn-default btn-xs\" ui-sref=\"main.service-charge-edit({ id:item.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"false\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/directives/artistslist/artists.list.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-repeat=\"(i, artist) in active\" class=\"artist-block\" ng-class=\"{multiselect: (multiselect && artistsCount > 1)}\"><span class=\"artist-block-name\">{{artist.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"remove(i, $artist)\"></i> </span><span ng-if=\"artistsCount === 0\">Всі артисти</span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-click=\"\" ng-if=\"!hidesearch\"><input type=\"text\" ng-model=\"searchObj.artistsSearch\" class=\"autosearch\" placeholder=\"Пошук новини\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchObj.artistsSearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchObj.artistsSearch\" ng-click=\"clear($artist)\"></i></li><hr ng-if=\"!hidesearch && !hideall\"><li ng-if=\"!hideall\"><a href=\"\" ng-click=\"set()\">Всі артисти {{artistSearch}}</a></li><hr><li ng-repeat=\"artist in artists\"><a href=\"\" ng-click=\"set(artist)\" ng-class=\"{selected: artist.selected}\"><b>{{artist.name}}</b></a></li></ul></div>");
$templateCache.put("app/components/directives/choicelist/choice.list.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-repeat=\"(i, choic) in active\" class=\"choic-block\" ng-class=\"{multiselect: (multiselect && choiceCount > 1)}\"><span class=\"choic-block-name\">{{choic.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"remove(i, $choic)\"></i> </span><span ng-if=\"choiceCount === 0\">Всі артисти</span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-click=\"\" ng-if=\"!hidesearch\"><input type=\"text\" ng-model=\"searchObj.choiceSearch\" class=\"autosearch\" placeholder=\"Пошук новини\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchObj.choiceSearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchObj.choiceSearch\" ng-click=\"clear($choic)\"></i></li><hr ng-if=\"!hidesearch && !hideall\"><li ng-if=\"!hideall\"><a href=\"\" ng-click=\"set()\">Всі артисти {{choicSearch}}</a></li><hr><li ng-repeat=\"choic in choice\"><a href=\"\" ng-click=\"set(choic)\" ng-class=\"{selected: choic.selected}\"><b>{{choic.name}}</b></a></li></ul></div>");
$templateCache.put("app/components/directives/choiceplacelist/choiceplace.list.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-repeat=\"(i, choicplace) in active\" class=\"choic-block\" ng-class=\"{multiselect: (multiselect && choiceplaceCount > 1)}\"><span class=\"choic-block-name\">{{choicplace.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"remove(i, $choicplace)\"></i> </span><span ng-if=\"choiceplaceCount === 0\">Всі місця</span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-click=\"\" ng-if=\"!hidesearch\"><input type=\"text\" ng-model=\"searchObj.choicplaceSearch\" class=\"autosearch\" placeholder=\"Пошук місця\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchObj.choicplaceSearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchObj.choicplaceSearch\" ng-click=\"clear($choicplace)\"></i></li><hr ng-if=\"!hidesearch && !hideall\"><li ng-if=\"!hideall\"><a href=\"\" ng-click=\"set()\">Всі місця {{choicplaceSearch}}</a></li><hr><li ng-repeat=\"choicplace in choiceplace\"><a href=\"\" ng-click=\"set(choicplace)\" ng-class=\"{selected: choicplace.selected}\"><b>{{choicplace.name}}</b></a></li></ul></div>");
$templateCache.put("app/components/directives/cities/cities.filter.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\">{{cityName || \'Вибрати місто\'}} <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\"><input type=\"text\" ng-model=\"citySearch\" class=\"autosearch\" placeholder=\"Пошук міста\" ng-change=\"search()\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!citySearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"citySearch\" ng-click=\"citySearch = null; search($event)\"></i></li><hr><li><a href=\"\" ng-click=\"cityName = null; cityID = null\">Всі міста</a></li><hr><li ng-repeat=\"item in cities\"><a ng-click=\"set(item.id, item.name)\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/eventslist/events.list.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-repeat=\"(i, event) in active\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && eventsCount > 1)}\"><span class=\"event-block-name\">{{event.name}} <small>{{event.cityName}} - {{event.dateStart}}</small></span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"remove(i, $event)\"></i> </span><span ng-if=\"eventsCount === 0\">Всі події</span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-click=\"\" ng-if=\"!hidesearch\"><input type=\"text\" ng-model=\"searchObj.eventSearch\" class=\"autosearch\" placeholder=\"Пошук події\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchObj.eventSearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchObj.eventSearch\" ng-click=\"clear($event)\"></i></li><hr ng-if=\"!hidesearch && !hideall\"><li ng-if=\"!hideall\"><a href=\"\" ng-click=\"set()\">Всі події {{eventSearch}}</a></li><hr><li ng-repeat=\"event in events\"><a href=\"\" ng-click=\"set(event)\" ng-class=\"{selected: event.selected}\"><b>{{event.name}}</b><p><small>{{event.cityName}} - {{event.dateStart}}</small></p></a></li></ul></div>");
$templateCache.put("app/components/directives/events/events.filter.html","<div class=\"pull-right events-i-checks\" ng-if=\"!hidestate\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"searchObj.eventStatus\" checklist-value=\"\'new\'\"> <i></i>Новi</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"searchObj.eventStatus\" checklist-value=\"\'in_sales\'\"> <i></i>В продажi</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"searchObj.eventStatus\" checklist-value=\"\'out_of_sales\'\"> <i></i>Завершенi</label></div><div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-repeat=\"(i, event) in active\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && eventsCount > 1)}\"><span ng-if=\"event.longTime === true && event.displayAllDates !== true\" class=\"event-block-name\">{{event.name}} <small>{{event.cityName}}</small></span> <span ng-if=\"event.longTime !== true && event.displayAllDates !== true\" class=\"event-block-name\">{{event.name}} <small>{{event.cityName}} - {{event.dateStart}}</small></span> <span ng-if=\"event.longTime !== true && event.displayAllDates === true\" class=\"event-block-name\">{{event.name}} <small>{{event.cityName}} - {{event.dateStart}} - {{event.dateEnd}}</small></span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"remove(i, $event)\"></i> </span><span ng-if=\"eventsCount === 0\">Всі події</span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-click=\"\" ng-if=\"!hidesearch\"><input type=\"text\" ng-model=\"searchObj.eventSearch\" class=\"autosearch\" placeholder=\"Пошук події\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchObj.eventSearch\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchObj.eventSearch\" ng-click=\"clear($event)\"></i></li><hr ng-if=\"!hidesearch && !hideall\"><li ng-if=\"!hideall\"><a href=\"\" ng-click=\"set()\">Всі події {{eventSearch}}</a></li><hr><li ng-repeat=\"event in events\"><a href=\"\" ng-click=\"set(event)\" ng-class=\"{selected: event.selected}\"><b>{{event.name}}</b><p><small ng-if=\"event.longTime !== true && event.displayAllDates !== true\">{{event.cityName}} - {{event.dateStart}}</small> <small ng-if=\"event.longTime === true && event.displayAllDates !== true\">{{event.cityName}} </small><small ng-if=\"event.longTime !== true && event.displayAllDates === true\">{{event.cityName}} - {{event.dateStart}} - {{event.dateEnd}}</small></p></a></li></ul></div>");
$templateCache.put("app/components/directives/multiselectDropdown/multiselectDropdown.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\" style=\"margin-right: 25px\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"select(item); $event.stopPropogation();\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-if=\"cfg.search\"><input type=\"text\" ng-model=\"q\" ng-change=\"search(q)\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"><!--<i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i>--> <i class=\"glyphicon glyphicon-remove\" ng-show=\"q\" ng-click=\"q = null; filter()\"></i></li><hr ng-if=\"cfg.selectAll && cfg.multiselect\"><li ng-if=\"cfg.selectAll && cfg.multiselect\"><a href=\"\" ng-click=\"selectAll()\">Всі</a></li><hr><li ng-repeat=\"item in list\" access=\"{{item.access}}\"><a ng-click=\"select(item)\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/select-list/select-list.html","<div class=\"dropdown-select\" uib-dropdown on-toggle=\"isOpen=!isOpen\"><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">{{placeholder}}</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu ng-show=\"isOpen\" ng-if=\"initialized\"><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/select-list-area/select-listarea.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/select-list-artist/select-listartist.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-if=\"selected.length > 0\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"></span> <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.names}}</a></li></ul><!-- <b ng-if=\"selected.length > 0\">Вибрані артисти:</b>   --><div ng-repeat=\"item in selected = (list | filter:{selected: true})\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"btn btn-default btn-xs\"><b class=\"event-block-name\">{{item.names}} </b></span><i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i></div></div><!-- <b ng-if=\"selected.length > 0\">Вибрані артисти:</b>   --> <!--  <div ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\">\n      \n       <div class=\"col-md-2\">        \n          {{item.names}} \n          <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i>      \n      </div>\n\n    </div>  -->");
$templateCache.put("app/components/directives/select-list-event/select-list-event.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"selectedView !== \'inline\' || !selected.length\">Вибрати</span> <span ng-if=\"selectedView === \'inline\'\" ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\"><b>{{item.name}}</b><p><small>{{item.cityName}} - {{item.dateStart}}</small></p></a></li></ul></div><div ng-if=\"selectedView !== \'inline\'\"><b ng-if=\"selected.length > 0\">Вибрані події:</b><!-- <div  type=\"button\" ng-disabled=\"disabled || !list.length\"> --> <button ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"btn btn-default btn-xs\"><b class=\"event-block-name\">{{item.name}}</b><p><small>{{item.cityName}} - {{item.dateStart}}</small></p></span><i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i></button><!-- </div> --></div>");
$templateCache.put("app/components/directives/select-list-choice/select-listchoice.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/select-list-region/select-listregion.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/directives/select-list-place/select-listplace.html","<div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle ng-disabled=\"disabled || !list.length\"><span ng-if=\"!selected.length\">Вибрати</span> <span ng-repeat=\"item in selected = (list | filter:{selected: true})\" class=\"event-block\" ng-class=\"{multiselect: (multiselect && selected.length > 1)}\"><span class=\"event-block-name\">{{item.name}}</span> <i class=\"glyphicon glyphicon-remove-sign\" ng-click=\"set(item.id, $event); setDirty()\"></i> </span><span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li class=\"dropdown-search\" ng-show=\"!hidesearch\"><input type=\"text\" ng-model=\"searchString\" class=\"autosearch\" placeholder=\"Пошук\" autocomplete=\"off\"> <i class=\"glyphicon glyphicon-search\" ng-if=\"!searchString\"></i> <i class=\"glyphicon glyphicon-remove\" ng-if=\"searchString\" ng-click=\"clearSearch($event)\"></i></li><hr ng-if=\"!hidesearch\"><li><a href=\"\" ng-click=\"clear(); setDirty();\">Всі</a></li><hr><li ng-repeat=\"item in list | filter:searchString\" access=\"{{item.access}}\"><a ng-click=\"touched = true; set(item.id); setDirty();\" ng-class=\"{selected: item.selected}\">{{item.name}}</a></li></ul></div>");
$templateCache.put("app/components/templates/modal/alert-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{::model.title}}</h3></div><div class=\"modal-body\"><p ng-bind-html=\"model.message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Ok</button></div>");
$templateCache.put("app/components/templates/modal/confirm-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{::model.title}}</h3></div><div class=\"modal-body\"><p ng-bind-html=\"model.message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Ok</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/cashier/statistics/cashier.statistics.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Статистика</span></div></header><form class=\"form content-fluid\" novalidate autocomplete=\"off\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-4\"><label>Місто проведення</label><selectlist input-model=\"vm.cities\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventIDs.length > 0\"></selectlist></div><div class=\"col-xs-12 col-sm-6 col-md-8 col-lg-8\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\" multiselect></events-filter></div><div class=\"col-md-12\"><div ng-show=\"vm.showCashInfo\"><hr><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"block m-b-lg\">Каси</label><selectlist input-model=\"vm.players\" output-model=\"vm.filters.cashID\" multiselect></selectlist></div></div><div class=\"col-xs-6\"><div class=\"form-group\"><label class=\"block m-b-lg\">Касири</label><selectlist disabled=\"\" input-model=\"vm.users\" output-model=\"vm.filters.cashierID\" multiselect></selectlist></div></div></div></div><hr><div class=\"filter-cont\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-6\"><label>Період створення</label><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateCreateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateCreateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"col-xs-6\"><label>Період оплати</label><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"col-xs-6\"><br><label>Період друку</label><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.datePrintFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.datePrintTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div></div></div><hr><div class=\"filter-cont\"><div class=\"row\"><div class=\"col-xs-12 col-md-12 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Статус квитка</label><br><div class=\"col-md-12\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.ticketStatus\" ng-true-value=\"\'active\'\"><i></i>Активний</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.filters.ticketStatus\" ng-true-value=\"\'returned\'\"><i></i>Скасований</label></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Типи замовлень</label><br><div class=\"col-md-12\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" value=\"\"><i></i>Всi</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" value=\"orders\"><i></i>Замовлення</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" value=\"quotas\"><i></i>Квоти</label></div></div></div></div></div></div></div></div></div><div class=\"col-md-3\"><label>&nbsp;</label><h4>Які квитки враховувати :</h4><span><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.orderStatus\" checklist-value=\"\'created_by_cashier\'\"> <i></i>Оформлено касиром</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.orderStatus\" checklist-value=\"\'pickup\'\"> <i></i>Самовивіз з каси</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.orderStatus\" checklist-value=\"\'no_money\'\"> <i></i>Касир НЕ отримуваав кошти</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.orderStatus\" checklist-value=\"\'invite\'\"> <i></i>Запрошення</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.orderStatus\" checklist-value=\"\'delivery\'\"> <i></i>Доставка</label></p></span><hr><!-- ng-disabled=\"!vm.filters.eventID.length && !vm.filters.cashierID.length\" --> <button class=\"btn btn-success btn-block\" ng-click=\"vm.load()\" key-enter=\"vm.load()\" ng-disabled=\"!vm.filters.eventID.length && !vm.filters.cashID.length && !vm.filters.cashierID.length && !vm.filters.dateCreateFrom && !vm.filters.dateCreateTo && !vm.filters.datePrintFrom && !vm.filters.datePrintTo && !vm.filters.paymentDateFrom && !vm.filters.paymentDateTo\" stateful>Показати</button><br><div class=\"panel panel-default\" ng-show=\"vm.total\"><div class=\"panel-heading\">Результат</div><div class=\"panel-body\"><span>Оформлено: <span class=\"font-bold\">{{vm.total.soldCount}}шт / {{vm.total.soldCost}}грн / {{vm.total.soldPercent}}%</span></span><br><span>Самомвивіз: <span class=\"font-bold\">{{vm.total.pickupCount}}шт / {{vm.total.pickupCost}}грн / {{vm.total.pickupPercent}}%</span></span><br><span>Не отримав гроші: <span class=\"font-bold\">{{vm.total.noMoneyCount}}шт / {{vm.total.noMoneyCost}}грн / {{vm.total.noMoneyPercent}}%</span></span><br><span>Запрошення: <span class=\"font-bold\">{{vm.total.inviteCount}}шт / {{vm.total.totalCount ? (vm.total.inviteCount / vm.total.totalCount * 100).toFixed() : 0}}% </span></span><br><span>Разом: <span class=\"font-bold\">{{vm.total.totalCountWithNoMoney}} шт / {{vm.total.totalCostWithNoMoney}} грн / {{vm.total.totalPercentWithNoMoney}}%</span></span><br><span>Сервісний збір: <span class=\"font-bold\">{{vm.total.serviceCharge}} грн</span></span></div></div></div></div></form><hr><h5 ng-show=\"vm.results.length < 1\">Результатiв не знайдено</h5><table class=\"table table-bordered table-striped table-condensed table-statistic\" ng-show=\"vm.results.length > 0\"><thead><tr><th rowspan=\"3\" class=\"col-md-2\">Подія/касир</th><th colspan=\"{{vm.showStatus(\'created_by_cashier\')*3+vm.showStatus(\'pickup\')*3}}\" ng-show=\"vm.showStatus(\'created_by_cashier\') || vm.showStatus(\'pickup\')\">Касир отримав кошти</th><th colspan=\"3\" ng-show=\"vm.showStatus(\'no_money\')\" rowspan=\"2\">Касир не отримував кошти</th><th colspan=\"6\" ng-show=\"vm.showStatus(\'delivery\')\">Доставка</th><th rowspan=\"2\" ng-show=\"vm.showStatus(\'invite\')\">Запрошення</th><th colspan=\"4\" rowspan=\"2\">Разом (без запрошень)</th><th rowspan=\"2\" ng-show=\"vm.isAdmin\">Сервісний збір</th></tr><tr><th colspan=\"3\" ng-show=\"vm.showStatus(\'created_by_cashier\')\">оформлено касиром (прямий продаж)</th><th colspan=\"3\" ng-show=\"vm.showStatus(\'pickup\')\">самовивіз з каси</th><th colspan=\"3\" ng-show=\"vm.showStatus(\'delivery\')\">готівка</th><th colspan=\"3\" ng-show=\"vm.showStatus(\'delivery\')\">платіжна система</th></tr><tr><th ng-show=\"vm.showStatus(\'created_by_cashier\')\">шт</th><th ng-show=\"vm.showStatus(\'created_by_cashier\')\">на суму, грн</th><th ng-show=\"vm.showStatus(\'created_by_cashier\')\">%</th><th ng-show=\"vm.showStatus(\'pickup\')\">шт</th><th ng-show=\"vm.showStatus(\'pickup\')\">на суму, грн</th><th ng-show=\"vm.showStatus(\'pickup\')\">%</th><th ng-show=\"vm.showStatus(\'no_money\')\">шт</th><th ng-show=\"vm.showStatus(\'no_money\')\">на суму, грн</th><th ng-show=\"vm.showStatus(\'no_money\')\">%</th><th ng-show=\"vm.showStatus(\'delivery\')\">шт</th><th ng-show=\"vm.showStatus(\'delivery\')\">на суму, грн</th><th ng-show=\"vm.showStatus(\'delivery\')\">%</th><th ng-show=\"vm.showStatus(\'delivery\')\">шт</th><th ng-show=\"vm.showStatus(\'delivery\')\">на суму, грн</th><th ng-show=\"vm.showStatus(\'delivery\')\">%</th><th ng-show=\"vm.showStatus(\'invite\')\">шт</th><th>шт</th><th>на суму, грн</th><th>%</th><th>до інкасації</th><th ng-show=\"vm.isAdmin\">на суму, грн</th></tr></thead><tbody ng-repeat=\"e in vm.results\"><tr class=\"info\"><td colspan=\"{{5 + vm.showStatus(\'created_by_cashier\') * 3 + vm.showStatus(\'pickup\')*3\n        + vm.showStatus(\'no_money\')*3 + vm.showStatus(\'invite\')*1 + vm.showStatus(\'delivery\') * 6}}\">{{e.name}}</td></tr><tr class=\"info-\" ng-repeat=\"c in e.cashiers\"><td><div class=\"ellipsis\">{{c.name}}</div></td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{c.soldCount}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{c.soldCost}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{c.soldPercent}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{c.pickupCount}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{c.pickupCost}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{c.pickupPercent}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{c.noMoneyCount}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{c.noMoneyCost}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{c.noMoneyPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCashCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCashCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCashPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCardCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCardCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{c.deliveryCardPercent}}</td><td ng-show=\"vm.showStatus(\'invite\')\">{{c.inviteCount}}</td><td>{{c.totalCount}}</td><td>{{c.totalCost}}</td><td>{{c.totalPercent}}</td><td>{{c.totalToCollection}}</td><td ng-show=\"vm.isAdmin\">{{c.serviceCharge}}</td></tr><tr class=\"info-\" style=\"background-color: rgba(81, 163, 81, 0.47)\"><td>Всього по події:</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{e.total.soldCount}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{e.total.soldCost}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{e.total.soldPercent}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{e.total.pickupCount}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{e.total.pickupCost}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{e.total.pickupPercent}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{e.total.noMoneyCount}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{e.total.noMoneyCost}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{e.total.noMoneyPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCashCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCashCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCashPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCardCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCardCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{e.total.deliveryCardPercent}}</td><td ng-show=\"vm.showStatus(\'invite\')\">{{e.total.inviteCount}}</td><td>{{e.total.totalCount}}</td><td>{{e.total.totalCost}}</td><td>{{e.total.totalPercent}}</td><td>{{e.total.totalToCollection}}</td><td ng-show=\"vm.isAdmin\">{{e.total.serviceCharge}}</td></tr></tbody><tfoot><tr class=\"font-bold\" style=\"background-color: #f0ad4e\"><td>Всього по звіту:</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{vm.total.soldCount}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{vm.total.soldCost}}</td><td ng-show=\"vm.showStatus(\'created_by_cashier\')\">{{vm.total.soldPercent}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{vm.total.pickupCount}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{vm.total.pickupCost}}</td><td ng-show=\"vm.showStatus(\'pickup\')\">{{vm.total.pickupPercent}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{vm.total.noMoneyCount}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{vm.total.noMoneyCost}}</td><td ng-show=\"vm.showStatus(\'no_money\')\">{{vm.total.noMoneyPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCashCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCashCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCashPercent}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCardCount}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCardCost}}</td><td ng-show=\"vm.showStatus(\'delivery\')\">{{vm.total.deliveryCardPercent}}</td><td ng-show=\"vm.showStatus(\'invite\')\">{{vm.total.inviteCount}}</td><td>{{vm.total.totalCount}}</td><td>{{vm.total.totalCost}}</td><td>{{vm.total.totalPercent}}</td><td>{{vm.total.totalToCollection}}</td><td ng-show=\"vm.isAdmin\">{{vm.total.serviceCharge}}</td></tr></tfoot></table>");
$templateCache.put("app/main/configs/city-list/city-list.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\" ng-if=\"!vm.mode\">Додати місто</span> <span class=\"title\" ng-if=\"vm.mode\">Редагувати місто</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.city-list\">Скасувати</a></span></div></header><section class=\"\"><form name=\"vm.citycreate\" novalidate autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><div class=\"row\"><div class=\"form-group col-lg-12\" show-errors><label class=\"star\">Назва</label><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.city.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"form-group col-lg-12\" show-dd-errors=\"vm.city.isActiveS\"><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.city.isActiveS\" required><label class=\"star\">Активність</label><selectlist input-model=\"vm.cityStatuses\" output-model=\"vm.city.isActiveS\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"form-group col-lg-12\" show-dd-errors=\"vm.city.regionID\"><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.city.regionID\" required><label class=\"star\">Локація</label><selectlist input-model=\"vm.cityAreas\" output-model=\"vm.city.areaID\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"form-group col-lg-12\" show-dd-errors=\"vm.city.regionID\"><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.city.regionID\" required><label class=\"star\">Регіон</label><selectlist input-model=\"vm.cityRegions\" output-model=\"vm.city.regionID\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div></form></section>");
$templateCache.put("app/main/configs/city-list/city-list.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список міст</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.city\">Додати місто</a></span></div></header><div class=\"row\"><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за назвою\"></div></div><hr><div class=\"row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">За заданими параметрами не знайдено жодного міста</div></div><div class=\"row\" infinite-scroll=\"vm.load();\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\" ng-if=\"!!vm.items.length\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th class=\"col-md-5\">Назва</th><th class=\"col-md-1\">Регіон</th><th class=\"col-md-1\">Локація</th><th class=\"col-md-1\">Активність</th><th class=\"col-md-1\">&nbsp;</th></tr></thead><tr ng-repeat=\"item in vm.items\" ng-if=\"!item.deleted\"><td class=\"redtext\">{{item.id}}</td><td>{{item.name}}</td><td>{{item.regionName}}</td><td>{{item.areaName}}</td><td><span class=\"label label-success\" ng-if=\"item.isActive === true\">Так</span> <span class=\"label label-primary\" ng-if=\"item.isActive === false\">Ні</span></td><td class=\"col-md-2\"><div class=\"button-column\"><a type=\"button\" ui-sref=\"main.configs.city({ id: item.id })\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a></div></td></tr></table></div></div>");
$templateCache.put("app/main/configs/event-permissions/player.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Доступ гравця до подій</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.players\">Скасувати</a></span></div></header><div ng-include=\"\'app/main/configs/event-permissions/parts/form.html\'\"></div><div ng-include=\"\'app/main/configs/event-permissions/parts/filters.html\'\"></div><hr><div class=\"list-view row\" ng-if=\"vm.events.length > 0\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th>Назва</th><th class=\"col-md-3\">Дата події</th><th class=\"col-md-2\">Місто</th><th class=\"col-md-2\">Доступ</th></tr></thead><tr ng-repeat=\"event in vm.events\"><td>{{event.id}}</td><td>{{event.name}}</td><td class=\"col-md-3\">{{event.date}}</td><td class=\"col-md-2\">{{event.city}}</td><td class=\"col-md-2\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"event.access\" ng-true-value=\"\'allowed\'\" ng-false-value=\"\'not_allowed\'\"><i></i>Доступний</label></td></tr></table></div></div>");
$templateCache.put("app/main/configs/event-permissions/user.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Доступ користувача до подій</span> <span class=\"pull-right title-btns\"><button class=\"btn btn-warning\" ng-click=\"vm.resetAccess()\">Надати доступ по гравцю</button> <a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.users\">Скасувати</a></span></div></header><div ng-include=\"\'app/main/configs/event-permissions/parts/form.html\'\"></div><div ng-include=\"\'app/main/configs/event-permissions/parts/filters.html\'\"></div><hr><div class=\"list-view row\" ng-if=\"vm.events.length > 0\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th>Назва</th><th class=\"col-md-3\">Дата події</th><th class=\"col-md-2\">Місто</th><th class=\"col-md-2\">Доступ</th></tr></thead><tr ng-repeat=\"event in vm.events\"><td>{{event.id}}</td><td>{{event.name}}</td><td class=\"col-md-3\">{{event.date}}</td><td class=\"col-md-2\">{{event.city}}</td><td class=\"col-md-2\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"event.access\" value=\"not_allowed\"><i></i>Недоступно</label><br><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"event.access\" value=\"allowed\"><i></i>Доступно</label><br><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"event.access\" value=\"only\"><i></i>Виключно</label></td></tr></table></div></div>");
$templateCache.put("app/main/configs/event/event.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список event</span></div></header><section class=\"row\"><div id=\"kasa-in-ua\"></div></section>");
$templateCache.put("app/main/configs/export-db/view.html","<!-- TODO remove when not needed --><header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Експорт бази</span></div></header><label>Вибір за подією</label><div class=\"row\"><div class=\"form-group col-md-5\"><selectlistevent input-model=\"vm.event\" output-model=\"vm.item.currentEvent\" multiselect></selectlistevent></div><div class=\"form-group col-md-3\" show-dd-errors=\"vm.item.currentEvent\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" download>Експорт в XLS</a></div></div><label>Вибір за містом</label><div class=\"row\"><div class=\"form-group col-md-5\"><selectlist input-method=\"vm.cityList\" output-model=\"vm.item.cityID\" multiselect></selectlist></div><div class=\"form-group col-md-3\" show-dd-errors=\"vm.item.cityID\"><a class=\"btn btn-success\" ng-click=\"vm.saveCity()\" download>Експорт в XLS</a></div></div>");
$templateCache.put("app/main/configs/locations/locations.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список локацiй</span></div></header><section class=\"row\"><div id=\"kasa-in-ua\"></div></section>");
$templateCache.put("app/main/configs/external-events/events.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список зовнішних подій</span></div></header><div class=\"row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">За заданими параметрами не знайдено жодної події</div></div><div class=\"row\" infinite-scroll=\"vm.load();\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\" ng-if=\"!!vm.items.length\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-2\">Партнер</th><th class=\"col-md-3\">Назва події</th><th class=\"col-md-1\">Місто</th><th class=\"col-md-2\">Локація</th><th class=\"col-md-2\">Постер</th><th class=\"col-md-2\"></th></tr></thead><tr ng-repeat=\"item in vm.items\"><td>{{item.eventSource.eventProviderName}}</td><td>{{item.name}}</td><td>{{item.eventSource.displaySiteCityName}}</td><td>{{item.eventSource.remoteSiteName}}</td><td><img width=\"100px\" src=\"{{item.extposter}}\"></td><td><div class=\"button-column\"><a class=\"btn btn-block btn-sm ng-scope\" ng-if=\"item.localStatus === \'is_not_loaded\'\" ui-sref=\"main.new_ext_event({ event: vm.stringify(item) })\" style=\"background: rgb(143, 219, 242)\">Додати до списку активних подій</a> <a class=\"btn btn-block btn-sm ng-scope\" ng-if=\"item.localStatus !== \'is_not_loaded\' && item.localStatus === \'in_sales\'\" ng-click=\"vm.inSales(item, false)\" style=\"background: rgb(243, 220, 219)\">Закрити продажі</a> <a class=\"btn btn-block btn-sm ng-scope\" ng-if=\"item.localStatus !== \'is_not_loaded\' && item.localStatus !== \'in_sales\'\" ng-click=\"vm.inSales(item, true)\" style=\"background: rgb(219, 243, 225)\">Відкрити продажі</a></div></td></tr></table></div></div>");
$templateCache.put("app/main/configs/map/map.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Каса</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.cashier.edit\" ng-if=\"!vm.edit\">Створити</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.cashier\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.mapform\" novalidate autocomplete=\"off\" class=\"col-md-12\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Назва</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"vm.item.name\" required placeholder=\"Назва\"></div><div class=\"col-md-1 form-group\"><label>Сортування</label><input class=\"form-control\" name=\"priority\" type=\"text\" ng-model=\"vm.item.priority\" placeholder=\"0\"></div><div class=\"col-md-3 form-group\"></div><div class=\"col-md-2 form-group\"><label>Статус</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label></p></div><div class=\"col-md-1 form-group\"><label class=\"\">ID</label><p class=\"form-control-static\">{{vm.item.id}}</p></div></div><div class=\"row\"><div class=\"col-md-3\"><selectlist input-method=\"vm.players\" output-model=\"vm.item.companyID\"></selectlist></div><div class=\"col-md-3\"><selectlist input-method=\"vm.users\" output-model=\"vm.item.cashiers\" multiselect></selectlist></div></div><hr><div class=\"row\"><div class=\"col-md-3 form-group\"><label class=\"star\">Мiсто</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.item.address.cityID\" search-string=\"vm.citySearch\"></selectlist></div><div class=\"col-md-2 form-group\"><label class=\"star\">Iндекс</label><input class=\"form-control\" name=\"zipCode\" type=\"text\" ng-model=\"vm.item.address.zipCode\" required placeholder=\"Iндекс\"></div><div class=\"col-md-5 form-group\"><label class=\"star\">Адреса</label><input class=\"form-control\" name=\"address\" type=\"text\" ng-model=\"vm.item.address.address\" required placeholder=\"Адреса\"></div><div class=\"col-md-1 form-group\"><label class=\"\">Координати</label><input class=\"form-control\" name=\"latitude\" type=\"text\" ng-model=\"vm.item.address.latitude\" placeholder=\"\"></div><div class=\"col-md-1 form-group\"><label class=\"\">&nbsp;</label><input class=\"form-control\" name=\"latitude\" type=\"text\" ng-model=\"vm.item.address.longitude\" placeholder=\"\"></div></div><hr><div class=\"row\"><div class=\"col-md-7 form-group\"><label class=\"\">Текст</label><input class=\"form-control\" name=\"description\" type=\"text\" ng-model=\"vm.item.description.text\" placeholder=\"\"></div></div><div class=\"row\"><div class=\"col-md-7 form-group\"><label class=\"\">Робочi години</label><input class=\"form-control\" name=\"description\" type=\"text\" ng-model=\"vm.item.description.workTime\" placeholder=\"\"></div></div><div class=\"row\"><div class=\"col-md-7 form-group\"><label class=\"\">Додатково</label><input class=\"form-control\" name=\"description\" type=\"text\" ng-model=\"vm.item.description.notification\" placeholder=\"\"></div></div></form></section>");
$templateCache.put("app/main/configs/map/map.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список кас</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.cashier.edit\" ng-if=\"!vm.edit\">Створити</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.cashier\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><div class=\"col-md-2\"><label>Місто</label><input type=\"text\" ng-model=\"search.city\" class=\"form-control\"></div><div class=\"col-md-4\"><label>Назва</label><input type=\"text\" ng-model=\"search.name\" class=\"form-control\"></div><div class=\"col-md-4\"><label>Адреса</label><input type=\"text\" ng-model=\"search.address\" class=\"form-control\"></div><div class=\"col-md-2\">&nbsp;</div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><hr><div class=\"summary pull-right\" ng-if=\"vm.cashes.length > 0\">Елементи 1 - {{vm.cashes.length}}</div></div><div class=\"tabler col-md-12\"><table class=\"table table-responsive table-bordered table-striped table-condensed\"><thead><tr><th width=\"50px\">ID</th><th class=\"col-md-3\">Назва</th><!-- <th class=\"col-md-1\">Iндекс</th> --><th class=\"col-md-2\">Мiсто</th><th class=\"col-md-4\">Адреса</th><th></th><th class=\"action col-md-1\"></th></tr></thead><tbody><tr ng-repeat=\"n in vm.cashes | filter:search\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.name}}</td><!-- <td>{{n.zipCode}}</td> --><td>{{n.city}}</td><td>{{n.address}}</td><td>{{n.latitude}}, {{n.longitude}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.configs.cashier.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></td></tr></tbody></table></div></section>");
$templateCache.put("app/main/configs/mail/mail.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Статистика email</span></div></header><div class=\"row\"><div class=\"col-md-2\"><label>E-mail</label><input type=\"email\" ng-model=\"vm.filters.email\" class=\"form-control\"></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-xs-12\"><label>Період створення</label></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateSendFrom\" max=\"vm.filters.dateSendTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateSendTo\" min=\"vm.filters.dateSendFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"col-md-2\"><label>Статус</label><selectlist input-model=\"vm.statuses\" output-model=\"vm.filters.sended\" hidesearch></selectlist></div><div class=\"col-md-2\"><label># замовлення</label><input type=\"text\" ng-model=\"vm.filters.orderID\" class=\"form-control\"></div></div><hr><div class=\"\"><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 < vm.count)\">Елементи 1-{{vm.items.length}} із {{vm.count}}</div><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 >= vm.count)\">Елементи 1-{{vm.count}} із {{vm.count}}</div></div><div class=\"row\"><div class=\"tabler col-md-12\"><table class=\"table table-responsive table-bordered table-striped table-condensed\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead><tr><th width=\"50px\">ID</th><th class=\"\">email</th><th class=\"col-md-2\">Дата</th><th class=\"col-md-2\">Статус</th><th class=\"col-md-2\"># замовлення</th></tr></thead><tbody><tr ng-repeat=\"n in vm.items\"><th style=\"width: 50px\">{{n.id}}<td class=\"\">{{n.email}}</td><td class=\"col-md-2\">{{n.date}}</td><td class=\"col-md-2\">{{n.sended ? \'Відправлено\' : \'Не відправлено\'}}</td><td class=\"col-md-2\">{{n.orderID}}</td></th></tr></tbody></table></div></div>");
$templateCache.put("app/main/configs/news/news.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список news</span></div></header><section class=\"row\"><div id=\"kasa-in-ua\"></div></section>");
$templateCache.put("app/main/configs/permissions/edit.html","");
$templateCache.put("app/main/configs/permissions/list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Доступи</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.saveRole()\" ng-if=\"vm.state === \'roles\' && vm.role\">Зберегти</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful access=\"manageRbac\">Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.users\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"contant\" ng-if=\"vm.state === \'user\'\"><h3>{{vm.userData.roles}}</h3><div ng-repeat=\"g in vm.groups\"><h3>{{g.name}}</h3><div class=\"row border-bottom-default\" ng-repeat=\"p in g.items\"><div class=\"col-md-3\">{{p}}</div><div class=\"col-md-8\">{{vm.getInfo(p)}}</div><div class=\"col-md-1\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.userData\" checklist-value=\"p\" accessdisable=\"manageRbac\"> <i></i></label></div></div></div><br><br><br></section><section ng-if=\"vm.state === \'roles\'\"><div class=\"row\"><div class=\"col-md-3\"><selectlist input-model=\"vm.rolesList\" output-model=\"vm.roleID\" hidesearch></selectlist></div></div><hr><div ng-repeat=\"g in vm.groups\" ng-show=\"vm.roleID\"><h3>{{g.name}}</h3><div class=\"row border-bottom-default\" ng-repeat=\"p in g.items\"><div class=\"col-md-3\">{{p}}</div><div class=\"col-md-8\">{{vm.getInfo(p)}}</div><div class=\"col-md-1\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.selectedUserPermitions[p]\" accessdisable=\"manageRbac\"> <i></i></label></div></div></div><br><br><br></section>");
$templateCache.put("app/main/configs/place/place.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список місця</span></div></header><section class=\"row\"><div id=\"kasa-in-ua\"></div></section>");
$templateCache.put("app/main/configs/players/players.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\" ng-if=\"!vm.mode\">Створити гравця</span> <span class=\"title\" ng-if=\"vm.mode\">Редагувати гравця</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.players\">Скасувати</a></span></div></header><section class=\"\"><form name=\"vm.playercreate\" novalidate autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><div class=\"row\"><div class=\"form-group col-lg-6\" show-errors><label class=\"star\">Назва</label><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.player.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-3\" show-dd-errors=\"vm.player.type\"><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.player.type\" required><label class=\"star\">Тип</label><selectlist input-model=\"vm.playerRoles\" output-model=\"vm.player.type\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><div class=\"form-group col-lg-6\" show-errors><label class=\"star\">Юридична назва</label><input type=\"text\" name=\"legalname\" class=\"col-lg-6 col-xs-12 form-control\" ng-model=\"vm.player.legalName\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-errors><label class=\"star\">Ідентифікаційний код / ЄДРПОУ</label><input class=\"form-control\" pattern=\"[0-9]{6,12}\" name=\"edrpou\" ng-model=\"vm.player.edrpou\" type=\"text\" min=\"0\" max=\"99999999\" required> <span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"form-group col-lg-6\" show-errors><label class=\"star\">Юридичні реквізити</label><textarea name=\"requisites\" class=\"form-control\" rows=\"3\" ng-model=\"vm.player.requisites\" required></textarea><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\"><label>Контактні данi</label><textarea name=\"contact\" class=\"form-control\" rows=\"3\" ng-model=\"vm.player.contact\"></textarea></div></div><hr><div class=\"row\"><div class=\"form-group col-lg-12\" show-errors><label>Опис</label><textarea class=\"form-control\" name=\"description\" rows=\"6\" ng-model=\"vm.player.description\">\n      </div>\n    </div>\n\n  </form>\n</section>");
$templateCache.put("app/main/configs/players/players.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список гравцiв</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.player\">Створити гравця</a></span></div></header><div class=\"row\"><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за назвою\"></div><div class=\"col-lg-4\"><div class=\"dropdown-select\" uib-dropdown><button class=\"btn btn-default btn-block\" type=\"button\" uib-dropdown-toggle>{{ vm.filters.typeCaption || \'Фільтр по ролях\' }} <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li><a ng-click=\"vm.filters.type = \'\'; vm.filters.typeCaption = \'\'; vm.applyFilter();\">Всi</a></li><hr><li ng-repeat=\"(id, item) in vm.roles\"><a ng-click=\"vm.filters.type = id; vm.filters.typeCaption = item; vm.applyFilter();\">{{item}}</a></li></ul></div></div></div><hr><div class=\"row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">За заданими параметрами не знайдено жодного гравця</div></div><div class=\"row\" infinite-scroll=\"vm.load();\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\" ng-if=\"!!vm.items.length\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th class=\"col-md-3\">Назва</th><th class=\"col-md-1\">Тип</th><th class=\"col-md-5\">Опис</th><th class=\"col-md-2\">&nbsp;</th></tr></thead><tr ng-repeat=\"item in vm.items\" ng-if=\"!item.deleted\"><td>{{item.id}}</td><td>{{item.name}}</td><td><span class=\"label label-primary\" ng-if=\"item.type === \'cash\'\">Каса</span> <span class=\"label label-success\" ng-if=\"item.type === \'individual\'\">Індивідуальний</span> <span class=\"label label-danger\" ng-if=\"item.type === \'ticket_agency\'\">Білетна агенція</span> <span class=\"label label-info\" ng-if=\"item.type === \'organizer\'\">Організатор</span></td><td><div ng-bind-html=\"item.description\"></div></td><td class=\"col-md-2\"><div class=\"button-column\" ng-if=\"item.type !== \'system_client\'\"><a type=\"button\" ui-sref=\"main.configs.player({ id: item.id })\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span> </a><a ui-sref=\"main.configs.event.permissions.player({ id: item.id })\" class=\"btn btn-default btn-sm\">Доступ до подій </a><button type=\"button\" class=\"btn btn-default btn-sm\" aria-label=\"Left Align\" ng-click=\"vm.delete(item)\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></div></td></tr></table></div></div>");
$templateCache.put("app/main/configs/problem-tickets/view.html","<!-- TODO remove when not needed --><header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Звіт по проблемним квиткам</span></div></header><!-- <div class=\"col-md-4\">\n  <div class=\"panel-footer\">\n    <div class=\"form-group\">\n      <a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.barcodesDuplicatesXlsUrl}}\" download>Дублікати штрихкодів .XLS</a>\n    </div>\n  </div>\n</div> --><div class=\"col-md-4\"><div class=\"panel-footer\"><div class=\"form-group\"><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.salesDuplicatesXlsUrl}}\" download>Дублікати продажу .XLS</a></div></div></div><div class=\"col-md-4\"><div class=\"panel-footer\"><div class=\"form-group\"><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.oldSystemBarcodesXlsUrl}}\" download>Штрихкоди старої системи .XLS</a></div></div></div>");
$templateCache.put("app/main/configs/return/return.list.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Статистика по поверненим квиткам</span></div></header><div class=\"\"><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 < vm.count)\">Елементи 1-{{vm.items.length}} із {{vm.count}}</div><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 >= vm.count)\">Елементи 1-{{vm.count}} із {{vm.count}}</div></div><div class=\"row\"><div class=\"tabler col-md-12\"><table class=\"table table-responsive table-bordered table-striped table-condensed\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead><tr><th rowspan=\"2\" class=\"col-md-1\"># замовлення</th><th rowspan=\"2\">Подія</th><th rowspan=\"2\">Код</th><th colspan=\"4\">Клієнт</th><th colspan=\"3\">Користувач</th><th rowspan=\"2\">Дата повернення</th></tr><tr><th>email</th><td>Ім\'я</td><td>Прізвище</td><td>Телефон</td><th>email</th><td>Ім\'я</td><td>Прізвище</td></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td class=\"col-md-1\">{{item.orderID}}</td><td>{{item.eventName}}</td><td>{{item.barcode}}</td><td style=\"overflow-wrap: normal; overflow-wrap: break-word\">{{item.clientEmail}}</td><td>{{item.clientFirstName}}</td><td>{{item.clientLastName}}</td><td>{{item.clientPhone}}</td><td style=\"overflow-wrap: normal; overflow-wrap: break-word\">{{item.returnUserEmail}}</td><td>{{item.returnUserFirstName}}</td><td>{{item.returnUserLastName}}</td><td>{{item.returnDate}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/configs/subdivisions/subdivisions.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\" ng-if=\"!vm.mode\">Створити підрозділ</span> <span class=\"title\" ng-if=\"vm.mode\">Редагувати підрозділ</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.subdivisions\">Скасувати</a></span></div></header><section class=\"\"><form name=\"vm.form\" autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><div class=\"row\"><div class=\"form-group col-lg-6\" show-errors><label class=\"star\">Назва</label><input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.subdivision.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-dd-errors=\"vm.subdivision.manager_user_id\"><input type=\"hidden\" ng-model=\"vm.subdivision.manager_user_id\" required><label class=\"star\">Керівник підрозділу</label><selectlist input-model=\"vm.users\" output-model=\"vm.subdivision.manager_user_id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"form-group col-lg-6\" show-errors><label class=\"star\">Адреса</label><input type=\"text\" name=\"address\" class=\"form-control\" ng-model=\"vm.subdivision.address\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-4\" show-dd-errors=\"vm.subdivision.city_id\"><input type=\"hidden\" ng-model=\"vm.subdivision.city_id\" required><label class=\"star\">Місто</label><selectlist input-model=\"vm.cities\" output-model=\"vm.subdivision.city_id\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div></form></section><!--<section class=\"row\" ng-if=\"vm.subdivision.id\">--><!--  <hr>--><!--  <div class=\"col-md-12\">--><!--    <span class=\"pull-right title-btns\">--><!--      <a class=\"btn btn-danger\" ng-click=\"vm.delete()\">Видалити</a>--><!--    </span>--><!--  </div>--> <!--</section>-->");
$templateCache.put("app/main/configs/subdivisions/subdivisions.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список підрозділів</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.subdivision\">Створити підрозділ</a></span></div></header><div class=\"row\"><div class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.id\" ng-change=\"vm.applyFilter(\'id\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Знайти за ID\"></div><div class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за назвою\"></div><div class=\"col-md-2\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.city\" ng-change=\"vm.applyFilter(\'city\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за містом\"></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.address\" ng-change=\"vm.applyFilter(\'address\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за адресою\"></div><div class=\"col-md-3\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.filters.manager\" ng-change=\"vm.applyFilter(\'manager\');\" ng-model-options=\"{ debounce: 300 }\" placeholder=\"Фільтр за керівником\"></div></div><hr><div class=\"row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">За заданими параметрами не знайдено жодного підрозділу</div></div><div class=\"row\" infinite-scroll=\"vm.load();\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\" ng-if=\"!!vm.items.length\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th class=\"col-md-2\">Назва</th><th class=\"col-md-2\">Місто</th><th class=\"col-md-3\">Адреса</th><th class=\"col-md-3\">Керівник підрозділу</th><th class=\"col-md-1 text-center\">Дії</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-if=\"!item.deleted\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.cityName}}</td><td>{{item.address}}</td><td>{{item.managerName}}</td><td><div class=\"button-column text-center\"><a type=\"button\" ui-sref=\"main.configs.subdivision({ id: item.id })\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/configs/users/users.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\" ng-if=\"!vm.mode\">Створити користувача</span> <span class=\"title\" ng-if=\"vm.mode\">Редагувати користувача</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-warning\" style=\"margin-right: 20px\" ng-if=\"vm.user.id\" ng-click=\"vm.changeUser()\">Авторізація</a> <a class=\"btn btn-warning\" style=\"margin-right: 20px\" ng-if=\"vm.user.id\" ng-click=\"vm.changePassword()\">Змінити пароль</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.users\">Скасувати</a></span></div></header><form ng-submit=\"vm.submitForm($event)\" name=\"vm.usercreate\" novalidate autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors ng-if=\"!vm.user.id\"><label class=\"star\">Логін (e-mail)</label><input type=\"email\" name=\"uemail\" ng-model=\"vm.user.email\" class=\"form-control\" required autocomplete=\"new-email\"> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-4 form-group\" ng-if=\"vm.user.id\"><label>Логін (e-mail)</label><p class=\"form-control-static\">{{vm.user.email}}</p></div><div class=\"col-md-3\" ng-if=\"!vm.user.id\"><div class=\"form-group\" show-errors><label class=\"star\">Пароль</label><input type=\"password\" name=\"upassword\" ng-model=\"vm.user.password\" class=\"form-control\" required autocomplete=\"new-password\"> <span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"col-md-3\" ng-if=\"vm.user.id\"><div class=\"form-group\"><label>Дата рестрацiï</label><p class=\"form-control-static\">{{vm.user.dateRegister}}</p></div></div><div class=\"col-md-3 form-group\" show-dd-errors=\"vm.user.printType\"><label>Спосіб друку</label><div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle>{{vm.user.printType || \'Не вибрано\'}} <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li ng-repeat=\"dt in vm.printTypes\"><a ng-click=\"vm.user.printBlankType = dt.id; vm.user.printType = dt.name\">{{dt.name}}</a></li></ul></div></div><div class=\"col-md-2 form-group\"><label>Перевернути бланк</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.user.ticketsRotation\" ng-true-value=\"180\"> <i></i>Перевернути на 180°</label></p></div></div><div class=\"row\"><div class=\"col-md-4 form-group\"><label>Токен API</label><p class=\"form-control-static\" style=\"word-wrap: break-word;  word-break: break-all\">{{vm.decodeToken(vm.user.access_token)}}</p></div><div class=\"col-sm-2 form-group\" show-errors><label class=\"star\">Дата закінчення токена</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.user.dateTokenExpired\"><input type=\"text\" name=\"date\" class=\"form-control\"> <input type=\"hidden\" name=\"date\" ng-model=\"vm.user.dateTokenExpired\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"form-group col-md-1\"></div><div class=\"form-group col-md-4\" ng-show=\"vm.cashierRoles.includes(vm.user.role)\"><label>Каса</label><selectlist input-model=\"vm.cashList\" output-model=\"vm.user.cashID\"></selectlist></div><!-- <div class=\"col-md-3\">\n      <div class=\"form-group\">\n        <label>Дата закінчення токена</label>\n        <p class=\"form-control-static\">\n          {{vm.user.dateTokenExpired}}\n        </p>\n      </div>\n    </div> --></div><hr><div class=\"row\"><div class=\"form-group col-lg-3\" show-dd-errors=\"vm.user.companyID\"><label class=\"star\">Компанія</label><input type=\"hidden\" ng-model=\"vm.user.companyID\" required><selectlist input-model=\"vm.companyList\" output-model=\"vm.user.companyID\" search-string=\"vm.companySearch\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-3\"><label>Підрозділ</label><selectlist input-model=\"vm.subdivisionList\" output-model=\"vm.user.subdivisionID\"></selectlist></div><div class=\"form-group col-lg-3\" show-dd-errors=\"vm.user.statusCaption\"><label class=\"star\">Статус</label><input type=\"hidden\" ng-model=\"vm.user.statusCaption\" required><div class=\"dropdown-select\" uib-dropdown><button type=\"button\" class=\"btn btn-default btn-block\" uib-dropdown-toggle>{{ vm.user.statusCaption || \'Статус користувача\'}} <span class=\"caret pull-right\"></span></button><ul uib-dropdown-menu><li ng-repeat=\"(i, status) in vm.statusList\" ng-click=\"vm.user.status=i; vm.user.statusCaption=status\"><a>{{status}}</a></li></ul></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-lg-3\" show-dd-errors=\"vm.user.role\"><label class=\"star\">Роль</label><input type=\"hidden\" ng-model=\"vm.user.role\" required><selectlist input-model=\"vm.rolesList\" output-model=\"vm.user.role\" hidesearch></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><div class=\"col-lg-3 form-group\" show-errors><label class=\"star\">Ім\'я</label><input type=\"text\" name=\"firstName\" ng-model=\"vm.user.firstName\" class=\"form-control\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-lg-3 form-group\" show-errors><label class=\"star\">Прізвище</label><input type=\"text\" name=\"lastName\" ng-model=\"vm.user.lastName\" class=\"form-control\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-lg-3 form-group\"><label class=\"\">Телефон</label><input type=\"tel\" name=\"phone\" ng-model=\"vm.user.phone\" class=\"form-control\"></div><div class=\"col-lg-3 form-group\" show-errors><label>Псевдонім у Telegram</label><input type=\"text\" placeholder=\"@username\" name=\"telegramPseudo\" ng-model=\"vm.user.telegramPseudo\" class=\"form-control\"></div></div><hr><div class=\"row\"><div class=\"col-lg-12 form-group\"><label>Коментар</label><textarea ng-model=\"vm.user.info\" class=\"form-control\" rows=\"3\"></textarea></div></div></form>");
$templateCache.put("app/main/configs/users/users.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Список користувачiв</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.user\" access=\"manageUsers\">Створити користувача</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Email</label><input type=\"text\" ng-model=\"vm.filters.email\" ng-change=\"vm.applyFilter(\'email\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div><div class=\"col-md-3\"><label>П.І.Б.</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div><div class=\"col-md-3\"><label>Телефон</label><input type=\"text\" ng-model=\"vm.filters.phone\" ng-change=\"vm.applyFilter(\'phone\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><br><div class=\"row\"><div class=\"col-md-3\"><label>Ролі</label><selectlist input-model=\"vm.rolesList\" output-model=\"vm.filters.role\" hidesearch on-change=\"vm.applyFilter()\"></selectlist></div><div class=\"col-md-3\"><label>Дата реєстрації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._dateRegisterFrom\" on-blur=\"vm.applyDateFilter()\"><input type=\"text\" class=\"form-control\" placeholder=\"Початкова дата\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-md-3\"><label>&nbsp;</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._dateRegisterTo\" on-blur=\"vm.applyDateFilter()\"><input type=\"text\" class=\"form-control\" placeholder=\"Кiнцева дата\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th>ID гравця</th><th class=\"col-md-2\">Email</th><th class=\"col-md-3\">П.І.Б.</th><th>Телефон</th><th class=\"col-md-2\">Ролі</th><!-- <th>Токен API</th>           --><th>Дата реєстрації</th><th>Токен діє до</th><th class=\"col-md-2\">&nbsp;</th></tr></thead><tr ng-repeat=\"user in vm.items\" ng-if=\"!user.deleted\"><td>{{user.id}}</td><td>{{user.companyID}}</td><td class=\"col-md-2\">{{user.email}}</td><td class=\"col-md-3\">{{user.name}}</td><td>{{user.phone}}</td><td>{{vm.getRole(user.role)}}</td><!-- <td style=\"word-wrap: break-word;  word-break: break-all\">{{vm.decodeToken(user.access_token)}}</td>             --><td>{{vm.formatDate(user.dateRegister)}}</td><td>{{vm.formatDate(user.dateTokenExpired)}}</td><td class=\"col-md-2\"><div class=\"button-column\"><a ui-sref=\"main.configs.user({ id: user.id })\" class=\"btn btn-default btn-sm\" access=\"manageUsers\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span> </a><a ui-sref=\"main.configs.permissions.user({ id: user.id })\" class=\"btn btn-default btn-sm\" access=\"manageRbac\">Доступ </a><a ui-sref=\"main.configs.event.permissions.user({ id: user.id })\" class=\"btn btn-default btn-sm\" access=\"manageRbac\">Події </a><button class=\"btn btn-default btn-sm\" ng-click=\"vm.delete(user)\" ng-if=\"user.role !== \'admin\'\" access=\"manageUsers\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></div></td></tr></table></div></div>");
$templateCache.put("app/main/configs/widgets/widgets.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Віджет</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.configs.widgets\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.widgetForm\" novalidate autocomplete=\"off\" class=\"col-md-12\"><div class=\"form-group col-md-6\" show-errors><label class=\"control-label star\" for=\"widgetName\">Назва віджета</label><input placeholder=\"Назва\" class=\"form-control\" name=\"widgetName\" id=\"widgetName\" type=\"text\" ng-model=\"vm.widget.name\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-3 form-group\" show-dd-errors=\"vm.widget.type\"><label class=\"control-label star\">Тип</label><selectlist input-model=\"vm.widgetTypes\" output-model=\"vm.widget.type\" disabled=\"vm.widget.id\"></selectlist><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.widget.type\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-3 form-group\"><p class=\"form-control-static\"><br><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.widget.isActive\"> <i></i>Активний</label></p></div><div class=\"col-md-6 form-group\" show-dd-errors=\"vm.widget.companyID\"><label class=\"control-label star\">Гравець</label><selectlist input-method=\"vm.getPlayers\" output-model=\"vm.widget.companyID\"></selectlist><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.widget.companyID\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-6 form-group\" show-dd-errors=\"vm.widget.userID\"><label class=\"control-label star\">Користувач</label><selectlist input-method=\"vm.getPlayerUser\" output-model=\"vm.widget.userID\"></selectlist><input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.widget.userID\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-12 form-group\"><label class=\"control-label star\">Період дії віджету</label><div class=\"row\"><div class=\"col-md-6 dropdown-group form-group\" show-dd-errors=\"vm.widget.dateStart\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.widget.dateStart\" max=\"vm.widget.dateEnd\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <input type=\"hidden\" name=\"name\" class=\"form-control\" ng-model=\"vm.widget.dateStart\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.widget.dateEnd\" min=\"vm.widget.dateStart\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"form-group col-md-6\" show-errors><label class=\"control-label star\" for=\"siteUrl\">Домен віджета</label><input placeholder=\"Домен\" class=\"form-control\" name=\"siteUrl\" id=\"siteUrl\" type=\"text\" ng-model=\"vm.widget.siteUrl\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-md-6\"><!--  should be disabled for edit --><label class=\"control-label\" for=\"uid\">Ключ доступу (від 45 символів)</label><input placeholder=\"Ключ\" class=\"form-control\" name=\"uid\" id=\"uid\" type=\"text\" ng-model=\"vm.widget.uid\" ng-disabled=\"vm.widget.id\"></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" for=\"code\">Код віджета</label><div class=\"dropdown-group\"><textarea placeholder=\"Код\" class=\"form-control\" name=\"code\" id=\"code\" rows=\"6\" ng-model=\"vm.widget.code\"></textarea></div></div></div><form></form></form></section>");
$templateCache.put("app/main/configs/widgets/widgets.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Віджети партнерів</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.configs.widget\" access=\"manageWidgets\">Створити віджет</a></span></div></header><div class=\"row filters\"><div class=\"col-md-4\"><selectlist input-method=\"vm.getPlayers\" output-model=\"vm.filters.companyID\"></selectlist></div></div><hr><div><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 < vm.count)\">Елементи 1-{{vm.items.length}} із {{vm.count}}</div><div class=\"summary pull-right text-right\" ng-if=\"(vm.offset+1 >= vm.count)\">Елементи 1-{{vm.count}} із {{vm.count}}</div></div><div class=\"tabler\"><table class=\"table table-striped table-bordered table-responsive col-md-12\"><thead><tr><th class=\"col-md-half\">ID</th><th class=\"col-md-3half\">Назва</th><th class=\"col-md-3half\">Гравець</th><th class=\"col-md-half text-center\">Тип</th><th class=\"col-md-1 text-center\">Дата від</th><th class=\"col-md-1 text-center\">Дата по</th><th class=\"col-md-1 text-center\">Активність</th><th class=\"col-md-half\"></th></tr></thead><tbody><tr ng-repeat=\"widget in vm.items\" ng-show=\"!widget.deleted\"><td>{{widget.id}}</td><td>{{widget.name}}</td><td>{{widget.companyName}}</td><td class=\"text-center\"><span ng-if=\"widget.type === \'hall\'\">Зал</span> <span ng-if=\"widget.type === \'button\'\">Кнопка</span></td><td class=\"text-center\">{{widget.dateStart}}</td><td class=\"text-center\">{{widget.dateEnd}}</td><td class=\"text-center\"><span class=\"label label-danger\" ng-if=\"!widget.isActive\">Чернетка</span> <span class=\"label label-success\" ng-if=\"widget.isActive\">Активний</span></td><td class=\"\"><div class=\"button-column\"><a class=\"btn btn-default btn-xs\" access=\"manageWidgets\" ui-sref=\"main.configs.widget({id: widget.id})\"><span class=\"glyphicon glyphicon-pencil\"></span> </a><button class=\"btn btn-default btn-xs\" access=\"manageWidgets\" disabled=\"disabled\" ng-click=\"vm.delete(widget)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></div></td></tr></tbody></table></div>");
$templateCache.put("app/main/encashment/manager/encashment.manager.add.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\">Додати інкасацію</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.saveEncashment()\">Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.encashment.manager\">Скасувати</a></span></div></header><form ng-submit=\"vm.submit($event)\" name=\"vm.encashmentform\" novalidate autocomplete=\"off\"><input type=\"submit\" class=\"hidden\" id=\"submit\"><div class=\"row\"><div class=\"col-sm-6 form-group\" show-dd-errors=\"vm.encashment.cashID\"><label class=\"star\">Каса</label><selectlist input-method=\"vm.cashesList\" output-model=\"vm.encashment.cashID\"></selectlist><input type=\"hidden\" name=\"cashID\" ng-model=\"vm.encashment.cashID\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-sm-6 form-group\"><label>Касир</label><selectlist input-method=\"vm.cashiersList\" output-model=\"vm.encashment.cashierID\"></selectlist></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label>Місто проведення</label><selectlist input-method=\"vm.cityList\" output-model=\"vm.encashment.cityID\"></selectlist></div><div class=\"col-sm-6 form-group\"><label>Подія</label><events-filter output-model=\"vm.encashment.eventID\" city=\"vm.encashment.cityID\" disabled=\"!vm.encashment.cashID\"></events-filter></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\" show-errors><label class=\"star\">Сума інкасації</label><input type=\"number\" name=\"sum\" ng-model=\"vm.encashment.sum\" class=\"form-control\" min=\"0\" max=\"{{vm.currentDebt}}\" ng-min=\"0\" ng-max=\"vm.currentDebt\" required> <span class=\"help-block\" ng-if=\"!vm.encashmentform.sum.$error.max\">Обов\'язкове поле</span> <span class=\"help-block\" ng-if=\"vm.encashmentform.sum.$error.max\">Сума інкасації більша за борг</span></div><div class=\"col-sm-6 form-group\" show-errors><label class=\"star\">Дата інкасації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.encashment.date\" max=\"vm.encashment.date\"><input type=\"text\" name=\"date\" class=\"form-control\"> <input type=\"hidden\" name=\"date\" ng-model=\"vm.encashment.date\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"row\"><div class=\"col-sm-12 form-group\"><label>Опис</label><textarea ng-model=\"vm.encashment.description\" class=\"form-control\" rows=\"3\"></textarea></div></div></form><div ng-if=\"vm.items.length\"><hr><div class=\"row encashment-result\"><div class=\"encashment-item\"><h4>Загальний борг: <b>{{vm.currentDebt || 0}} грн</b></h4></div><div class=\"encashment-item\"><h4>Кількість продаж: <b>{{vm.salesCount || 0}}</b></h4></div><div class=\"encashment-item\"><h4>Сума продажів: <b>{{vm.salesSum || 0}} грн.</b></h4></div></div><br><div class=\"tabler\"><table class=\"table table-striped table-bordered table-responsive col-md-12\"><thead><tr><th class=\"col-md-half\">№</th><th class=\"col-md-3half\">Каса</th><th class=\"col-md-3half\">Касир</th><th class=\"col-md-3half\">Подія</th><th class=\"col-md-3half\">Iнкасатор</th><th class=\"col-md-1\">Сума інкасації</th><th class=\"col-md-3half\">Борг</th><th class=\"col-md-3half\">Опис</th><th class=\"col-md-1\">Дата інкасації</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td><div class=\"ellipsis\">{{item.cashName}}</div></td><td><div class=\"ellipsis\">{{item.cashierName}}</div></td><td><div class=\"ellipsis\">{{item.eventName}}</div></td><td><div class=\"ellipsis\">{{item.collectorName}}</div></td><td>{{item.sum || 0}} грн.</td><td>{{item.debt || 0}} грн.</td><td><div class=\"ellipsis\">{{item.description}}</div></td><td>{{item.date}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/encashment/manager/encashment.manager.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\">Список інкасацій</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.encashment.manager-add\">Провести інкасацію</a></span></div></header><section class=\"encashment\"><div class=\"row\"><div class=\"col-sm-3\"><label>Каса</label><selectlist input-method=\"vm.cashesList\" output-model=\"vm.filters.cashID\"></selectlist></div><div class=\"col-sm-3\"><label>Касир</label><selectlist input-method=\"vm.cashiersList\" output-model=\"vm.filters.cashierID\"></selectlist></div><div class=\"col-sm-3 dropdown-group\"><label>Початок інкасації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateFrom\"><input type=\"text\" class=\"form-control\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-sm-3 dropdown-group\"><label>Закінчення інкасації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateTo\"><input type=\"text\" class=\"form-control\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div><br><div class=\"row\"><div class=\"col-sm-4\"><label>Місто проведення</label><selectlist input-method=\"vm.cityList\" output-model=\"vm.filters.cityID\"></selectlist></div><div class=\"col-sm-6\"><label>Подія</label><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\"></events-filter></div><div class=\"col-sm-2 button-container-top-fix\"><div class=\"row\"><div class=\"col-sm-6\"><button type=\"submit\" stateful class=\"btn btn-success btn-block\" ng-click=\"vm.find()\" key-enter=\"vm.find()\">Знайти</button></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn btn-default btn-block ellipsis\" style=\"max-width: 100%\" ng-click=\"vm.clear()\">Скинути фільтри</button></div></div></div></div><hr><div ng-if=\"!!vm.items.length\"><div class=\"row encashment-result\"><div class=\"encashment-item\"><h4>Загальна сума: <b>{{vm.totalSum || 0}} грн.</b></h4></div><div class=\"encashment-item\"><h4>Загальний борг: <b>{{vm.totalDebt || 0}} грн.</b></h4></div><div class=\"encashment-item\" access=\"encashmentsXls\"><a class=\"btn btn-default\" ng-href=\"{{vm.xlsUrl}}\" download>Cформувати xls</a></div></div><div class=\"tabler\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><table class=\"table table-striped table-bordered table-responsive col-md-12\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead><tr><th class=\"col-md-half\">№</th><th class=\"col-md-3half\">Каса</th><th class=\"col-md-3half\">Касир</th><th class=\"col-md-3half\">Подія</th><th class=\"col-md-3half\">Iнкасатор</th><th class=\"col-md-1\">Сума інкасації</th><th class=\"col-md-3half\">Борг</th><th class=\"col-md-3half\">Опис</th><th class=\"col-md-1\">Дата інкасації</th><!--th class=\"col-md-half\">Звіт</th--></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td><div class=\"ellipsis\">{{item.cash}}</div></td><td><div class=\"ellipsis\">{{item.cashier}}</div></td><td><div class=\"ellipsis\">{{item.event}}</div></td><td><div class=\"ellipsis\">{{item.collector}}</div></td><td>{{item.sum || 0}} грн.</td><td>{{item.debt || 0}} грн.</td><td><div class=\"ellipsis\">{{item.description}}</div></td><td>{{item.date}}</td><!--td class=\"col-md-2\">\n            <div class=\"button-column\">\n              <a class=\"btn btn-default btn-sm\" ng-click=\"vm.report(item)\">\n                <span class=\"glyphicon glyphicon-list-alt\" aria-hidden=\"true\"></span>\n              </a>\n            </div>\n          </td--></tr></tbody></table></div></div></section>");
$templateCache.put("app/main/encashment/percent/encashment.percent.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\" ng-if=\"vm.type == \'cash\'\">Відсоток каси</span> <span class=\"title\" ng-if=\"vm.type == \'cashier\'\">Відсоток касира</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.saveEncashment()\">Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.encashment.percents\">Скасувати</a></span></div></header><section class=\"encashment\"><h4>Загальні відсотки винагороди</h4><div class=\"row\"><div class=\"col-sm-2\"><label>Прямий продаж <span uib-tooltip-html=\"\'Касир створив замовлення\' + \'<br>\' + \'Касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></label><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" string-to-number ng-model=\"vm.salePercent\" class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></div><div class=\"col-sm-2\"><label>Самовивіз з каси <span uib-tooltip-html=\"\'Хтось створив замовлення\' + \'<br>\' + \'Касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></label><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" string-to-number ng-model=\"vm.pickupPercent\" class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></div><div class=\"col-sm-2\"><label>Друк оплачених <span uib-tooltip-html=\"\'Не важливо хто створив замовлення\' + \'<br>\' + \'НЕ касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></label><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" string-to-number ng-model=\"vm.printPercent\" class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></div></div><hr><h4>Відсотки винагороди по подіях</h4><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><label>Назва події</label><events-filter output-model=\"vm.eventID\" city=\"vm.cityID\"></events-filter></div><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6 button-container-top-fix\"><a class=\"btn btn-success\" ng-click=\"vm.addEvent()\" ng-disabled=\"!vm.eventID\">Додати</a></div></div><hr><div class=\"tabler\"><table class=\"table table-striped table-bordered table-responsive col-md-12\"><thead><tr><th class=\"col-md-1half\">Подiя</th><th class=\"col-md-3half\">Прямий продаж</th><th class=\"col-md-3half\">Самовивіз з каси</th><th class=\"col-md-3half\">Друк оплачених</th><th class=\"col-md-1\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"item in vm.events\"><td><b>{{item.name}}</b><p><small>{{item.cityName}} - {{item.dateStart}}</small></p></td><td class=\"col-sm-1\"><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" ng-model=\"item.salePercent\" string-to-number class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></td><td class=\"col-sm-1\"><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" ng-model=\"item.pickupPercent\" string-to-number class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></td><td class=\"col-sm-1\"><div class=\"input-group\"><input type=\"number\" value=\"0\" min=\"0\" max=\"99\" ng-min=\"0\" ng-max=\"99\" ng-model=\"item.printPercent\" string-to-number class=\"form-control\" placeholder=\"0\"><div class=\"input-group-addon\">%</div></div></td><td class=\"col-md-1\"><div class=\"button-column\"><a class=\"btn btn-default btn-sm\" ng-click=\"vm.deleteEvent(item)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></a></div></td></tr></tbody></table></div></section>");
$templateCache.put("app/main/encashment/percent/encashment.percent.list.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Відсоток</span></div></header><section class=\"encashment\"><div ng-show=\"vm.isFilter\"><h4>Фільтр</h4><div class=\"row\"><div class=\"col-sm-4\"><label>Країна</label><selectlist input-method=\"vm.countryList\" output-model=\"vm.countryID\"></selectlist></div><div class=\"col-sm-4\"><label>Місто</label><selectlist input-method=\"vm.cityList\" output-model=\"vm.cityID\"></selectlist></div></div><hr></div><div class=\"row\"><div class=\"col-sm-4\"><label>Каса</label><selectlist input-method=\"vm.cashesList\" output-model=\"vm.cashID\"></selectlist></div><div class=\"col-sm-2\"><label class=\"col-md-12\">&nbsp;</label><label class=\"i-checks i-checks-sm\" style=\"margin-top: 12px\"><input type=\"checkbox\" ng-model=\"vm.isFilter\"> <i></i>Фільтр</label></div></div><hr><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!!vm.items.length\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-2\">Назва</th><th class=\"col-md-1\">Тип</th><th class=\"col-md-2\">Прямий продаж <span uib-tooltip-html=\"\'Касир створив замовлення\' + \'<br>\' + \'Касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></th><th class=\"col-md-2\">Самовивіз з каси <span uib-tooltip-html=\"\'Хтось створив замовлення\' + \'<br>\' + \'Касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></th><th class=\"col-md-2\">Самовивіз з каси <span uib-tooltip-html=\"\'Не важливо хто створив замовлення\' + \'<br>\' + \'НЕ касир прийняв оплату\' + \'<br>\' + \'Касир роздрукував квитки\'\" tooltip-append-to-body=\"true\" tooltip-placement=\"right-top\" class=\"glyphicon glyphicon-question-sign\"></span></th><th class=\"col-md-2\">Відсотки по подіях</th><th class=\"col-md-2\">&nbsp;</th></tr></thead><tr ng-repeat=\"item in vm.items\"><td>{{item.name}}</td><td><span class=\"label label-primary\" ng-if=\"item.isCash\">Каса</span> <span class=\"label label-success\" ng-if=\"!item.isCash\">Касир</span></td><td>{{item.salePercent || 0}} %</td><td>{{item.pickupPercent || 0}} %</td><td>{{item.printPercent || 0}} %</td><td><span class=\"glyphicon glyphicon-ok\" ng-if=\"item.hasEventsPercents\"></span></td><td class=\"col-md-2\"><div class=\"button-column\"><a ui-sref=\"main.encashment.percent-cash({ id: item.id })\" ng-if=\"item.isCash\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span> </a><a ui-sref=\"main.encashment.percent-cashier({ id: item.id })\" ng-if=\"!item.isCash\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></a></div></td></tr></table></div></section>");
$templateCache.put("app/main/events/modal/modal.scheme-error.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Виявлено помилки</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-md-12\" style=\"white-space: pre-line; overflow-y: scroll; max-height: 60vh\">{{ schemeErrorDetails }}</div></div></div>");
$templateCache.put("app/main/events/modal/multievent-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Вкажіть параметри:</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4\" style=\"display: flex\"><input id=\"vm.event.multieventCount\" type=\"number\" min=\"1\" max=\"10\" placeholder=\"1\" class=\"col-sm-2 form-control ng-valid-number\" ng-model=\"multiEventCount\" style=\"width: 65px\"><label for=\"vm.event.multieventCount\" class=\"i-checks i-checks-sm\">Кількість потрібних дочірніх івентів</label></div><div class=\"col-md-8\"><label class=\"text-center i-checks i-checks-sm\">Дата початку події:</label><div class=\"form-group col-md-12\"><div style=\"margin-bottom: 5px\" class=\"input-group datepicker\" ng-repeat=\"n in duplicateItem()\" datetimepicker options=\"{ locale: \'uk\' }\" ng-model=\"newDateStart\"><input type=\"text\" name=\"somedatestart-{{ $index }}\" class=\"form-control\"> <input type=\"hidden\" name=\"somedatestart-{{ $index }}\" ng-model=\"newDateStart\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">ОК</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/ordermanager/modal/ks-confirm-print-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Підтвердити дію</h3></div><div class=\"modal-body\"><p class=\"modal-message\" ng-bind-html=\"message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">Друк</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/ordermanager/modal/ks-confirm-refund-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Підтвердити дію</h3></div><div class=\"modal-body\"><p class=\"modal-message\" ng-bind-html=\"message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-danger\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">Скасувати замовлення</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Не скасовувати</button></div>");
$templateCache.put("app/main/ordermanager/modal/ks-confirm-system-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Системне сповіщення</h3></div><div class=\"modal-body\"><p class=\"modal-message\" ng-bind-html=\"message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">Ок</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/ordermanager/modal/ks-email-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Редагування email</h3></div><div class=\"modal-body\"><p>Будь-ласка, введіть email</p><input type=\"email\" ng-model=\"vm.email\" class=\"form-control\"></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.ok()\" ng-disabled=\"!vm.email\">Ok</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel()\">Відміна</button></div>");
$templateCache.put("app/main/ordermanager/modal/ks-order-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Редагування квитків</h3></div><div class=\"modal-body\"><uib-tabset active=\"active\"><uib-tab index=\"0\" heading=\"Загальна інформація\"><h5 class=\"text-center\">Увага! Зміни буде внесено до усіх обраних квитків!</h5><!-- <hr>\n      <h5 class=\"text-right\">Параметри квиткiв</h5> --><div class=\"row\"><div class=\"form-group col-md-6\"><label>Спосіб доставки</label><selectlist input-model=\"deliveryTypes\" output-model=\"tickets.delivery.type\" hidesearch></selectlist></div><div class=\"form-group col-md-6\"><label>Статус доставки</label><selectlist input-model=\"deliveryStatuses\" output-model=\"tickets.delivery.status\" hidesearch></selectlist></div><div class=\"form-group col-md-6\"><label>Спосіб оплати</label><selectlist input-model=\"paymentTypes\" output-model=\"tickets.payment.type\" hidesearch></selectlist></div><div class=\"form-group col-md-6\"><label>Статус оплати</label><selectlist input-model=\"paymentStatuses\" output-model=\"tickets.payment.status\" hidesearch></selectlist></div><div class=\"form-group col-md-6\"><label>Статус друку</label><selectlist input-model=\"printStatuses\" output-model=\"tickets.printStatus\" hidesearch></selectlist></div><div class=\"form-group col-md-6\"><label>Активність</label><selectlist input-model=\"statuses\" output-model=\"tickets.status\" hidesearch></selectlist></div></div><div class=\"row\"><!-- <div class=\"form-group col-md-7\">\n          <label class=\"control-label\">Контактні дані вiдвiдувача</label>\n          <input placeholder=\"Прізвище, Ім’я, По-батькові\" name=\"name\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"edit.client.name\"/>\n        </div>\n        <div class=\"form-group col-md-5\">\n          <label class=\"control-label\">Телефон</label>\n          <input placeholder=\"Телефон\" name=\"phone\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"edit.client.phone\"/>\n        </div>\n        <div class=\"col-lg-12\">\n          <div class=\"form-group\">\n            <label class=\"control-label\">Коментар</label>\n            <input placeholder=\"\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"edit.description\">\n          </div>\n        </div> --><div class=\"form-group col-md-3\" ng-if=\"tickets.delivery.type == \'courier\'\"><label class=\"control-label\">Мiсто</label><selectlist input-method=\"citiesGet\" output-model=\"tickets.delivery.address.cityID\"></selectlist></div><div class=\"form-group col-md-9\" ng-if=\"tickets.delivery.type == \'courier\'\"><label class=\"control-label\">Адреса</label><input placeholder=\"Адреса\" name=\"address\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"tickets.delivery.address.address\"></div><div class=\"form-group col-md-3\" ng-if=\"tickets.delivery.type === \'post_service\'\"><label class=\"control-label\">Мiсто</label><selectlist input-method=\"citiesGet\" output-model=\"tickets.delivery.postService.cityID\"></selectlist></div><div class=\"form-group col-md-6\" ng-if=\"tickets.delivery.type === \'post_service\'\"><label class=\"control-label\">Адреса</label><input placeholder=\"Адреса\" name=\"address\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"tickets.delivery.postService.address\"></div><div class=\"form-group col-md-3\" ng-if=\"tickets.delivery.type === \'post_service\'\"><label class=\"control-label\">Номер вiддiлення НП</label><input placeholder=\"1\" name=\"postService\" class=\"form-control\" type=\"number\" ng-model=\"tickets.delivery.postService.number\"></div><div class=\"form-group col-md-12\"><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"tickets.sendStatusMail\" ng-true-value=\"false\" ng-false-value=\"true\"> <i></i>Не відправляти лист про зміну статуса</label></p><p><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"tickets.ignoreTicketsLifeTime\"> <i></i>Заборонити автоскасування замовлення</label></p></div></div></uib-tab><uib-tab index=\"1\" heading=\"Редагування квиткiв\"><br><div style=\"max-height: 50vh; overflow-y: auto; overflow-x: hidden\"><div class=\"row\" ng-repeat=\"t in items\"><div><div class=\"col-md-6\"><p class=\"form-control-static ellipsis\"><b>{{t.eventName}}</b></p></div><div class=\"col-md-3\"><p class=\"form-control-static ellipsis\"><b>{{t.zoneNumber}}</b></p></div><div class=\"col-md-3\"><p class=\"form-control-static\"><b><span ng-if=\"t.rowNumber\">ряд: {{t.rowNumber}},</span> <span ng-if=\"t.rowNumber\">мiсце: {{t.placeNumber}}</span> &nbsp;</b></p></div><div class=\"col-md-3\"><label>Квиток / Замовлення</label><p class=\"form-control-static\"><small>{{t.id}} / {{t.orderID}}</small></p></div><div class=\"form-group col-md-3\" ng-if=\"t.paymentStatus !== \'invite\'\"><label>Вартість</label><div class=\"input-group\"><input type=\"text\" min=\"0\" ng-model=\"t.price\" class=\"form-control\" ng-disabled=\"cantPrint()\"><div class=\"input-group-addon\">грн</div></div></div><div class=\"form-group col-md-3\"><label>Знижка</label><div class=\"input-group\"><input type=\"text\" min=\"0\" max=\"100\" ng-min=\"0\" ng-max=\"99\" ng-model=\"t.discount\" class=\"form-control\" ng-disabled=\"cantPrint()\"><div class=\"input-group-addon\">%</div></div></div><div class=\"form-group col-md-3\"><label>Ціна</label><p class=\"form-control-static\">{{t.price - t.price*t.discount/100}} грн.</p></div><div class=\"form-group col-md-12\"><input placeholder=\"Прізвище, Ім’я, По-батькові\" name=\"receiverName\" class=\"form-control\" type=\"text\" maxlength=\"128\" ng-model=\"t.visitor.firstName\"><hr></div></div></div></div></uib-tab></uib-tabset></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Закрити</button></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-aside.html","<div class=\"form-group\"><div class=\"row\"><label>&nbsp;</label></div><div class=\"row\" show-errors><!-- show-dd-errors=\"vm.filters.id\" --><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-list\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"text\" name=\"fId\" ng-pattern=\"vm.fIdPattern\" class=\"form-control\" placeholder=\"Номер замовлення\" ng-model=\"vm.filters.id\"> <span style=\"color:Red\" ng-show=\"vm.ordermanager.fId.$error.pattern\">Тільки цифри</span></div></div><div class=\"row\"><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-earphone\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"+380971112233 чи 0971112233\" ng-model=\"vm.filters.clientPhone\"></div></div><div class=\"row\"><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-envelope\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"email\" class=\"form-control\" placeholder=\"E-mail власника\" ng-model=\"vm.filters.clientEmail\"></div></div><div class=\"row\"><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-user\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Прізвище та ім\'я власника\" ng-model=\"vm.filters.clientName\"></div></div><div class=\"row\"><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-gift\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"ТТН\" ng-model=\"vm.filters.newPostBranchID\"></div></div><!-- <div class=\"row\">\n        <div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-tag\" aria-hidden=\"true\"></span></div>\n        <div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Теги\" disabled></div>\n    </div> --><div class=\"row\"><div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-barcode\" aria-hidden=\"true\"></span></div><div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Штpих-код квитка\" ng-model=\"vm.filters.ticketBarcode\"></div></div><!-- <div class=\"row\">\n        <div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-map-marker\" aria-hidden=\"true\"></span></div>\n        <div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Країна\" disabled></div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-map-marker\" aria-hidden=\"true\"></span></div>\n        <div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Область\" disabled></div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-1 col-md-1\"><span class=\"glyphicon glyphicon-map-marker\" aria-hidden=\"true\"></span></div>\n        <div class=\"col-xs-10 col-md-10\"><input type=\"text\" class=\"form-control\" placeholder=\"Місто\"  ng-model=\"vm.filters.eventCityID\"></div>\n    </div> --></div><!-- <hr>\n\n<div class=\"row\">\n    <div class=\"col-md-12\">\n      <button type=\"button\" class=\"btn btn-default btn-block\" disabled>Завантажити профіль</button>\n    </div>\n</div> --><hr><div class=\"panel panel-default\"><div class=\"panel-heading\">Результат запиту</div><div class=\"panel-body\"><p>Замовлень/Квот: {{vm.count || 0}} шт.</p><p>Квиткiв: {{vm.tickets || 0}} шт.</p><p>Вартiсть: {{vm.price || 0}} грн.</p></div><div class=\"panel-footer\" access=\"ticketsXls\"><div class=\"form-group\"><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.xlsUrl}}\" ng-class=\"{\'disabled\': !vm.count}\" download>Завантажити .XLS</a></div><div><a class=\"btn btn-default btn-xs\" ng-href=\"{{vm.csvUrl}}\" ng-class=\"{\'disabled\': !vm.count}\" download>Завантажити .CSV</a></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-bag.html","<aside class=\"order-bag\" ng-class=\"{showbag: vm.showbag}\"><div class=\"order-bag-body\"><div class=\"order-bag-header\" ng-click=\"vm.showbag = !vm.showbag\"><i class=\"glyphicon glyphicon-shopping-cart\"></i> &nbsp;Кошик</div><div class=\"order-bag-text\"><p>Квитків: {{vm.bagLength}}</p><p>На суму: {{vm.bagSuma}} грн</p><!-- в\n      <p class=\"sub_1 text-danger\" ng-if=\"order.tickets[0].service_charge > 0 \">\n      {{+(vm.bagSuma/100*order.tickets[0].service_charge-0) + +(vm.bagSuma-0)|number}}</p> --></div><hr><section ng-if=\"vm.bag.tickets.length > 0\"><p><button class=\"btn btn-primary btn-block\" ng-click=\"vm.printBag()\" stateful access=\"printTicket\">Надрукувати</button> <button class=\"btn btn-primary btn-block\" ng-click=\"vm.editBag(vm.bag, vm.orders)\" access=\"updateTicket\">Редагувати</button> <button class=\"btn btn-primary btn-block\" ng-disabled=\"vm.isSetInviteBtnDisabled()\" ng-click=\"vm.setInvite()\" stateful access=\"setOrderTypeInvite\">Встановити запрошення</button><!-- <a ng-if=\"vm.bag.type === \'quota\'\" class=\"btn btn-primary btn-block\" ui-sref=\"main.quotes.edit({id: vm.bag.id})\" access=\"manageQuotes\">Редагувати</a> --></p><hr><button class=\"btn btn-primary btn-block\" ng-disabled=\"vm.isSendMailBtnDisabled()\" ng-click=\"vm.sendMail()\">Надіслати е-квиток</button> <button class=\"btn btn-primary btn-block\" ng-disabled=\"vm.isSendPayLinkMailBtnDisabled()\" ng-click=\"vm.sendPaymentLink()\">Надіслати лінк на оплату</button><!-- <button class=\"btn btn-primary btn-block\" ng-click=\"vm.sendTicketNotPay()\">Скасований-НЕ ОПЛАЧЕНИЙ</button> --><!-- <button class=\"btn btn-primary btn-block\" ng-click=\"vm.sendTicketPay()\">Надіслати скасований-оплачений</button> --> <button class=\"btn btn-primary btn-block\" ng-click=\"vm.printToZip()\" access=\"cancelOrder\" ng-disabled=\"vm.hasReturnedTickets()\">Друк в файл</button><hr><button class=\"btn btn-warning btn-block\" ng-click=\"vm.returnTickets()\" stateful access=\"returnTicket\">Скасувати</button><hr><button class=\"btn btn-danger btn-block\" ng-click=\"vm.clearBag()\">Очистити</button><p></p></section><section ng-if=\"vm.bag.tickets.length < 1\" style=\"opacity: 0.5\"><p class=\"text-center\">Кошик порожнiй</p><p class=\"text-center\"><i class=\"glyphicon glyphicon-warning-sign\" style=\"font-size: 24px; color: orange\"></i></p></section></div></aside>");
$templateCache.put("app/main/ordermanager/parts/ks-order-delivery-f.html","<div class=\"section row\"><div class=\"hidden-xs col-md-1\"><i class=\"glyphicon glyphicon-send mo-icon\"></i></div><div class=\"col-xs-12 col-md-11 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Спосіб доставки</label></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryType\" checklist-value=\"\'pickup\'\"><i></i>Самовивіз</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryType\" checklist-value=\"\'post_service\'\"><i></i>Нова пошта з відділення</label><!-- <label class=\"i-checks i-checks-sm  col-md-6\">\n              <input type=\"checkbox\" checklist-model=\"vm.filters.deliveryType\" checklist-value=\"\'post\'\"><i></i>Пошта\n            </label> --><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryType\" checklist-value=\"\'courier\'\"><i></i>Кур\'єром по місту</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryType\" checklist-value=\"\'internet\'\"><i></i>Електронний квиток</label></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Статус доставки</label></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryStatus\" checklist-value=\"\'future\'\"><i></i>Не відправлявся</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryStatus\" checklist-value=\"\'current\'\"><i></i>Надіслано клієнту</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryStatus\" checklist-value=\"\'past\'\"><i></i>Отримано клієнтом</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.deliveryStatus\" checklist-value=\"\'canceled\'\"><i></i>Повернено від клієнта</label><!-- <label class=\"i-checks i-checks-sm col-md-6\">\n              <input type=\"checkbox\" checklist-model=\"vm.filters.deliveryStatus\" checklist-value=\"\'failed\'\"><i></i>Відправлено на e-mail\n            </label> --></div></div></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-event-f.html","<div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventIDs.length > 0\"></selectlist></div><div class=\"visible-xs-block visible-sm-block divider\">&nbsp;</div><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><label>Назва події</label><!-- event-status=\"vm.eventStatus\" event-search=\"vm.eventSearch\" --><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\" hideall=\"vm.companyID !== 1\" init=\"vm.initEvent\" multiselect reset=\"vm.eventReset\"></events-filter></div><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>Сектор залу</label><selectlist input-method=\"vm.zones\" output-model=\"vm.filters.zoneID\" disabled=\"!vm.zones\" multiselect></selectlist></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-payment-f.html","<div class=\"user-section row\"><div class=\"col-md-1 hidden-xs\"><i class=\"glyphicon glyphicon-piggy-bank mo-icon\"></i></div><div class=\"col-xs-12 col-md-11 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-4\">Прийняв оплату</label></div><div class=\"row\"><div class=\"col-md-6\"><selectlist input-method=\"vm.players\" output-model=\"vm.filters.moneyRecipientCompanyID\"></selectlist></div><div class=\"col-md-6\"><selectlist input-method=\"vm.moneyRecipient\" output-model=\"vm.filters.moneyRecipientID\" multiselect></selectlist></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-6\">Період оплати</label></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateFrom\" max=\"vm.filters.paymentDateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.paymentDateTo\" min=\"vm.filters.paymentDateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"col-xs-12 col-md-12\"><br><div class=\"row\"><span class=\"col-xs-12 col-md-6\" style=\"margin-top: -2px\"><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'credit_card\'\"> <i></i>Платіжна система</label><!-- <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'credit_card\'\"><i></i>credit_card</label> --><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'cash\'\"> <i></i>Готівкою</label><!-- <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'cash_on_delivery\'\"><i></i>cash_on_delivery</label>\n              <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'cashless\'\"><i></i>cashless</label>\n              <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentType\" checklist-value=\"\'bank_transfer\'\"><i></i>bank_transfer</label> --> </span><span class=\"col-xs-12 col-md-6\" style=\"margin-top: -2px\"><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentStatus\" checklist-value=\"\'paid\'\"> <i></i>Оплачено</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentStatus\" checklist-value=\"\'not_paid\'\"> <i></i>Неоплачено</label><label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentStatus\" checklist-value=\"\'invite\'\"> <i></i>Запрошення</label><!-- <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentStatus\" checklist-value=\"\'canceled\'\"><i></i>Отменено</label>\n              <label class=\"i-checks i-checks-sm col-md-6\"><input type=\"checkbox\" checklist-model=\"vm.filters.paymentStatus\" checklist-value=\"\'failed\'\"><i></i>Не удалось</label> --></span></div></div><div class=\"col-xs-12 col-md-12\"><br><div class=\"row\"><div class=\"col-md-2 dropdown-group\"><label class=\"\">Цiна з</label><input type=\"number\" class=\"form-control\" ng-model=\"vm.filters.priceFrom\" placeholder=\"0\"></div><div class=\"col-md-2 dropdown-group\"><label class=\"\">Цiна по</label><input type=\"number\" class=\"form-control\" ng-model=\"vm.filters.priceTo\" placeholder=\"0\"></div></div></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-player-f.html","<div class=\"user-section row\"><div class=\"col-md-1 hidden-xs\"><i class=\"glyphicon glyphicon-user mo-icon\"></i></div><div class=\"col-xs-12 col-md-11 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-4\">Хто створив</label><span class=\"col-md-8\" style=\"margin-top: -2px\" ng-init=\"all\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.creatorType\" ng-value=\"all\" value=\"\"><i></i>Всi</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.creatorType\" value=\"cashiers\"><i></i>Касири</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.creatorType\" value=\"clients\"><i></i>Клієнти</label></span></div><div class=\"row\"><div class=\"dropdown-group col-md-6\"><selectlist input-method=\"vm.players\" disabled=\"vm.filters.creatorType != \'cashiers\'\" output-model=\"vm.filters.creatorCompanyID\"></selectlist></div><div class=\"dropdown-group col-md-6\"><selectlist input-method=\"vm.creatorCompany\" disabled=\"vm.filters.creatorType != \'cashiers\'\" output-model=\"vm.filters.creatorID\" multiselect></selectlist></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-6\">Період створення</label></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateCreateFrom\" max=\"vm.filters.dateCreateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.dateCreateTo\" min=\"vm.filters.dateCreateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-print-f.html","<div class=\"user-section row\"><div class=\"hidden-xs col-md-1\"><i class=\"glyphicon glyphicon-print mo-icon\"></i></div><div class=\"col-xs-12 col-md-11 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-6\">Хто роздрукував</label></div><div class=\"row\"><div class=\"dropdown-group col-md-6\"><selectlist input-method=\"vm.players\" output-model=\"vm.filters.printerCompanyID\"></selectlist></div><div class=\"dropdown-group col-md-6\"><selectlist input-method=\"vm.printerCompany\" output-model=\"vm.filters.printerID\" multiselect></selectlist></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-6\">Період друку</label></div><div class=\"row\"><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.printDateFrom\" max=\"vm.filters.paymentDateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початок\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-md-6 dropdown-group\"><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters.printDateTo\" min=\"vm.filters.printDateFrom\"><input type=\"text\" class=\"form-control\" placeholder=\"Закінчення\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div></div></div><div class=\"col-xs-12 col-md-12\"><br><div class=\"row\"><span class=\"col-md-6\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'e_blank\'\"><i></i>Бланк</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'a4\'\"><i></i>А4</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'a5\'\"><i></i>А5</label></span><span class=\"col-md-6\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketPrintStatus\" checklist-value=\"\'printed\'\"><i></i>Роздруковані</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketPrintStatus\" checklist-value=\"\'not_printed\'\"><i></i>Нероздруковані</label></span></div></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/ks-order-results.html","<section infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"4\" infinite-scroll-disabled=\"vm.disableScroll\"><div ng-repeat=\"order in vm.orders\" class=\"panel panel-default results\"><div class=\"panel-heading clearfix results-heading\" ng-click=\"vm.getTickets(order)\" ng-class=\"{hastickets: (order.ticketsCount > 0), quota: (order.type === \'quota\')}\"><div class=\"col-md-1\"><label class=\"i-checks i-checks-sm\" ng-click=\"$event.stopPropagation()\" ng-class=\"{disabled: !order.tickets}\" ng-if=\"order.type ===\'order\'\"><input type=\"checkbox\" ng-disabled=\"!order.totalTicketsCount\" ng-model=\"order.selected\" ng-change=\"vm.select(order)\"><i></i> #{{order.id}}</label><small>{{order.dateCreate}}</small></div><div class=\"col-md-3 ellipsis\"><b>{{order.events}}</b><br><span ng-if=\"order.ticketLifeTime\" class=\"redtext\">Автоскасування: {{ order.ticketLifeTime }}</span><br><div ng-hide=\"!(order.product.id > 0)\" class=\"packet-proposal\">{{order.product.name}} Ціна {{order.product.price | number:2}} грн. Сума замовлення {{vm.getOrderTotal(order) | number:2}} грн.</div></div><div ng-if=\"order.partner_image.length > 0\" class=\"col-md-1\"><small>Партнер</small><br><img ng-src=\"{{order.partner_image}}\" style=\"width: 50px;z-index: 100\" class=\"img-thumbnail\"></div><div class=\"col-md-1\"><small>Кiлькiсть</small><br>{{order.ticketsCount}} шт. <span ng-if=\"order.ticketsCount !== order.totalTicketsCount\">({{order.totalTicketsCount}})</span></div><div class=\"col-md-1\"><small>Сума</small><br>{{order.totalTicketsCost || order.ticketsCost}} грн. <span ng-if=\"order.ticketsCost !== order.totalTicketsCost\">({{order.ticketsCost}})</span><!--  <div class=\"sub_1 text-danger\" ng-if=\"order.service_charge > 0\">\n      Cеврісний збір. Вартість: <strong>{{+(order.ticketsCost/100*order.service_charge-0) + +(order.ticketsCost-0)|number}}</strong> грн.\n      </div> --><!-- {{order.events.service_charge}}ааааа --><div class=\"sub_1 text-danger\" ng-if=\"order.serviceCharge > 0\">Серв. збір {{order.serviceCharge}} грн.</div><div class=\"sub_1 text-warning\" ng-if=\"order.combopay.payed_count > 0\">Оплачено {{order.combopay.payed_amount}}&nbsp;грн. ({{order.combopay.payed_count}} із {{order.combopay.total_count}})</div></div><div class=\"col-md-3\"><small ng-if=\"order.type === \'quota\'\"><a ui-sref=\"main.quotes.edit({id: order.id})\" ng-click=\"$event.stopPropagation()\">Редагувати</a><br><a ng-click=\"vm.printQuote($event, order)\">Друк</a>&nbsp;&nbsp;&nbsp;<a ng-click=\"vm.printQuoteToZip($event, order)\">Друк в файл</a></small><div ng-if=\"order.type === \'order\'\"><div ng-if=\"order.client\">{{order.client.name}}<span ng-if=\"order.client.name && order.client.phone\"> | </span>{{order.client.phone}} <span ng-if=\"(order.client.name || order.client.phone) && order.client.email\">| </span>{{order.client.email}}</div><div ng-if=\"order.deliveryComment || order.description\"><small>Коментар:</small> {{order.deliveryComment || order.description}}</div><div ng-if=\"order.deliveryType\"><small>Тип доставки:</small> <span ng-switch=\"order.deliveryType\"><span ng-switch-when=\"pickup\">Самовивіз</span> <span ng-switch-when=\"post_service\">Нова пошта</span> <span ng-switch-when=\"courier\">Кур\'єром</span> <span ng-switch-when=\"internet\">Е-квиток</span></span></div><div ng-if=\"order.deliveryStatus\"><small>Статус доставки:</small> <span ng-switch=\"order.deliveryStatus\"><span ng-switch-when=\"future\">Не відправлявся</span> <span ng-switch-when=\"current\">Надіслано клієнту</span> <span ng-switch-when=\"past\">Отримано клієнтом</span> <span ng-switch-when=\"canceled\">Повернено від клієнта</span></span></div><div ng-if=\"order.deliveryCity || order.deliveryAddress\"><small>Адреса доставки:</small> {{[order.deliveryRegion, order.deliveryCity, order.deliveryAddress].join(\' \')}} <small ng-if=\"order.deliveryBranchNumber\">НП: №</small>{{order.deliveryBranchNumber}}</div><div ng-if=\"order.printers\"><small>Хто роздрукував:</small> {{order.printers}}</div></div></div><div class=\"col-md-2 text-right\"><!-- <small>Статус</small> --> <small access=\"storyTicket\" ng-if=\"order.type ===\'order\'\"><a href=\"\" ng-click=\"vm.orderDdetails($event, order)\">Детальніше</a></small> <b><small ng-if=\"order.type === \'order\'\">Замовлення</small> <small ng-if=\"order.type === \'quota\'\">Квота</small> </b><!--<br>      --><!-- <label ng-if=\"order.status === \'new\'\" class=\"label label-info\">створено</label>\n      <label ng-if=\"order.status === \'current\'\" class=\"label label-primary\">в процессi</label>\n      <label ng-if=\"order.status === \'past\'\" class=\"label label-success\">виконано</label>\n      <label ng-if=\"order.status === \'archived\'\" class=\"label label-default\">архiв</label>\n      <label ng-if=\"order.status === \'return\'\" class=\"label label-warning\">повернення</label>\n      <label ng-if=\"order.status === \'canceled\'\" class=\"label label-warning\">скасований</label>\n      <label ng-if=\"order.status === \'failed\'\" class=\"label label-danger\">помилка</label> --></div></div><div class=\"table1 container-fluid results-tickets fade-in\" ng-if=\"order.showTickets\"><div ng-repeat=\"t in order.tickets\" class=\"row\"><div class=\"col-md-2\"><label class=\"i-checks i-checks-sm\" ng-if=\"order.type ===\'order\'\"><input type=\"checkbox\" ng-disabled=\"order.partnerApi\" ng-model=\"t.selected\" ng-change=\"vm.select(order, t)\"><i></i> #{{t.id}}</label></div><div class=\"col-md-4\"><div><p ng-show=\"t.eventName\">{{t.eventName}}</p><p ng-show=\"t.zoneNumber\"><small><span>Сектор: {{t.zoneNumber}}, </span><span ng-show=\"t.rowNumber\">Ряд: {{t.rowNumber}}, </span><span ng-show=\"t.placeNumber\">Мiсце: {{t.placeNumber}}</span></small></p><!--<p ng-show=\"t.deliveryInfo\">--><!--<small>--><!--<span>Коментар для доставки: {{t.deliveryInfo}}</span>--><!--</small>--><!--</p>--></div><!-- <div class=\"sub_1 text-danger\" ng-if=\"t.service_charge !== \'0\'\">Увага! севрісний збір.\n           <strong>{{t.price/100*t.service_charge}}</strong> грн.\n        </div> --></div><div class=\"col-md-1\"><span ng-if=\"t.discountPrice\">{{+t.discountPrice + +t.service_charge}} ({{t.price}})</span> <span ng-if=\"!t.discountPrice\">{{+t.price + +t.service_charge}}</span></div><div class=\"col-md-1\"><small access=\"storyTicket\"><a href=\"\" ng-click=\"vm.history(t, order)\">Iсторiя</a></small><br><small access=\"storyTicket\"><a href=\"\" ng-click=\"vm.details(t, order)\">Детальніше</a></small></div><div class=\"col-md-2\"><div><label ng-if=\"t.printStatus === \'not_printed\'\" class=\"label label-warning\">Не роздрукований</label><label ng-if=\"t.printStatus === \'printed\'\" class=\"label label-info\">Роздрукований</label></div><div><label ng-if=\"t.paymentStatus === null || t.paymentStatus === \'not_paid\'\" class=\"label label-danger\">Не оплачено</label><label ng-if=\"t.paymentStatus === \'paid\'\" class=\"label label-success\">Оплачено</label><label ng-if=\"t.paymentStatus === \'canceled\'\" class=\"label label-danger\">Скасовано</label><label ng-if=\"t.paymentStatus === \'invite\'\" class=\"label label-danger\">Запрошення</label>&nbsp; <span ng-if=\"t.paymentStatus !== \'invite\'\"><label ng-if=\"t.paymentType === \'credit_card\'\" class=\"label label-primary\">Платіжна система</label><label ng-if=\"t.paymentType === \'cash\'\" class=\"label label-primary\">Готівкою</label><label ng-if=\"t.paymentType === \'cash_on_delivery\'\" class=\"label label-primary\">Готівкою</label></span></div><div><label ng-if=\"t.deliveryType === \'pickup\'\" class=\"label label-default\">Самовивіз</label><label ng-if=\"t.deliveryType === \'post_service\'\" class=\"label label-warning\">Нова пошта</label><label ng-if=\"t.deliveryType === \'courier\'\" class=\"label label-default\">Кур\'єром</label><label ng-if=\"t.deliveryType === \'internet\'\" class=\"label label-info\">Е-квиток</label>&nbsp;<label ng-if=\"t.deliveryStatus === \'future\'\" class=\"label label-default\">Не відправлявся</label><label ng-if=\"t.deliveryStatus === \'current\'\" class=\"label label-info\">Надіслано клієнту</label><label ng-if=\"t.deliveryStatus === \'past\'\" class=\"label label-primary\">Отримано клієнтом</label><label ng-if=\"t.deliveryStatus === \'canceled\'\" class=\"label label-danger\">Повернено від клієнта</label></div></div><div class=\"col-md-1\">{{t.barcode}}</div><div class=\"col-md-1 text-right\"><label ng-if=\"t.status === \'sold\' || t.status === \'in_partner_sales\'\" class=\"label label-success\">Активний</label><label ng-if=\"t.status === \'returned\' && t.paymentStatus === \'paid\'\" class=\"label label-danger\">Повернутий</label><label ng-if=\"t.paymentStatus === \'not_paid\' && t.status === \'returned\'\" class=\"label label-danger\">Скасований</label><label ng-if=\"t.paymentStatus === null && t.status === \'returned\'\" class=\"label label-danger\">Скасований</label><label ng-if=\"t.status === \'reserved\'\" class=\"label label-info\">Заброньований</label></div></div><hr ng-if=\"order.loadmore\"><button class=\"btn btn-primary btn-xs\" ng-if=\"order.loadmore\" ng-click=\"vm.getTickets(order, true)\" stateful>вiдобразити ще</button> <button class=\"btn btn-primary btn-xs\" ng-if=\"order.loadmore\" ng-click=\"order.loadmore = order.ticketsCount; vm.getTickets(order, true)\" stateful>вiдобразити все</button></div></div></section>");
$templateCache.put("app/main/ordermanager/parts/ks-order-status-f.html","<!--СТАТУС--><div class=\"section-status row\"><div class=\"hidden-xs col-md-1\"><i class=\"glyphicon glyphicon-cog mo-icon\"></i></div><div class=\"col-xs-12 col-md-11 container\"><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Статус квитка</label><br><div class=\"col-md-12\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'active\'\"><i></i>Активний</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'returned\'\"><i></i>Скасований</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'printed_returned\'\"><i></i>Повернуті</label></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"row\"><label class=\"col-md-12\">Типи замовлень</label><br><div class=\"col-md-12\"><span ng-init=\"vm.filters.searchType=\'orders\'\"><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" value=\"\"><i></i>Всi</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" ng-value=\"\'orders\'\"><i></i>Замовлення</label><label class=\"i-checks i-checks-sm\"><input type=\"radio\" ng-model=\"vm.filters.searchType\" value=\"quotas\"><i></i>Квоти</label></span></div></div></div></div></div>");
$templateCache.put("app/main/ordermanager/parts/modal.details.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Детальная інформація про квиток</h3></div><div class=\"modal-body modal-body__history\"><div class=\"col\"><p>Подія</p><p>Сектор</p><p>Ряд</p><p>Місце</p><p>Ціна</p><p>Активність</p><p>Формат</p><p>Власник</p><p>Дата створення</p><p>Створив</p><p>Гравець, що створив</p><p>Платформа створення</p><p>Гравець автора друку</p><p>Автор друку</p><p>Статус друку</p><p>Дата друку</p></div><div class=\"col\"><p>{{ticket.eventName}}</p><p>{{ticket.zoneNumber || \'-\'}}</p><p>{{ticket.rowNumber || \'-\'}}</p><p>{{ticket.placeNumber || \'-\'}}</p><p>{{ticket.price}}</p><p>{{actions[ticket.status]}}</p><p>{{info(\'blankType\', ticket.blankType)}}</p><p>{{history.clientName}}</p><p>{{history.date}}</p><p>{{history.actorName}}</p><p>kasa.in.ua</p><p>-</p><p>{{history.printerCompanyName}}</p><p>{{history.printerName}}</p><p>{{info(\'printStatus\', ticket.printStatus)}}</p><p>{{history.datePrint}}</p></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("app/main/ordermanager/parts/modal.history.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Iсторiя квитків</h3></div><div class=\"modal-body modal-body__history\"><div class=\"col\"><p>#</p><p>Дiя</p><p>Дата/Час</p><p>Користувач</p><p>Ціна</p><p>Дата друку</p><p>Дата оплати</p><p>Ім’я власника</p><p>Email власника</p><p>Статус</p><p>Статус оплати</p><p>Статус доставки</p><p>Гравець що роздрукував</p><p>Користувач що роздрукував</p><p>Гравець що отримав кошти</p><p>Користувач що отримав кошти</p><p>Тип доставки</p><p>Тип квитка</p></div><div class=\"col\" ng-repeat=\"i in history\"><p><small>#{{i.id}}</small></p><p><b>{{actions[i.action]}}</b></p><p>{{i.date}}</p><p><b>{{i.actorName}}</b></p><p>{{i.price}}</p><p>{{i.datePrint}}</p><p>{{i.datePaid}}</p><p>{{i.clientName}}</p><p>{{i.clientEmail}}</p><p>{{info(\'status\', i.status)}}</p><p>{{info(\'paymentStatus\', i.paymentStatus)}}</p><p>{{info(\'deliveryStatus\', i.deliveryStatus)}}</p><p>{{i.printerCompanyName}}</p><p>{{i.printerName}}</p><p>{{i.moneyRecipientCompanyName}}</p><p>{{i.moneyRecipientName}}</p><p>{{info(\'deliveryType\', i.deliveryType)}}</p><p>{{info(\'blankType\', i.blankType)}}</p></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">OK</button></div>");
$templateCache.put("app/main/ordermanager/parts/modal.order.edit.details.html","<div class=\"modal-header\"><h3 class=\"modal-title\">#{{order.id}} - Редагування замовлення</h3></div><div class=\"modal-body modal-body__history\" style=\"overflow-y: auto\"><form class=\"form\" name=\"orderupdateform\" novalidate autocomplete=\"off\"><div class=\"form-group\" show-errors ng-class=\"{\'has-error\': orderupdateform.lastName.$invalid && orderupdateform.$submitted}\"><label class=\"control-label star\">Прізвище</label><input class=\"form-control\" type=\"text\" name=\"lastName\" ng-model=\"order.client.lastName\" maxlength=\"128\" placeholder=\"Прізвище\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" show-errors ng-class=\"{\'has-error\': orderupdateform.firstName.$invalid && orderupdateform.$submitted}\"><label class=\"control-label star\">Ім\'я</label><input class=\"form-control\" type=\"text\" name=\"firstName\" ng-model=\"order.client.firstName\" maxlength=\"128\" placeholder=\"Ім’я\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\"><label class=\"control-label\">По-батькові</label><input placeholder=\"По-батькові\" name=\"middleName\" class=\"form-control\" type=\"text\" maxlength=\"128\" placeholder=\"По-батькові\" ng-model=\"order.client.middleName\"></div><div class=\"form-group\"><label class=\"control-label\">E-mail</label><input class=\"form-control\" type=\"email\" name=\"email\" maxlength=\"128\" ng-model=\"order.client.email\" placeholder=\"E-mail\"></div><div class=\"form-group\" show-errors ng-class=\"{\'has-error\': orderupdateform.phone.$invalid && orderupdateform.$submitted}\"><label class=\"control-label star\">Телефон</label><input class=\"form-control\" type=\"text\" ng-model=\"order.client.phone\" placeholder=\"+380971112233 чи 0971112233\"> <span class=\"help-block\">Обов\'язкове поле, формат (000) 000-00-00</span></div><div class=\"form-group\"><label class=\"control-label\">Адреса</label><input class=\"form-control\" type=\"text\" ng-model=\"order.delivery.deliveryAddress\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\">Відділення Нової Пошти</label><input class=\"form-control\" type=\"text\" ng-model=\"order.delivery.deliveryPostNumber\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\">Місто</label><input class=\"form-control\" type=\"text\" ng-model=\"order.delivery.deliveryCity\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\">Коментар</label><input class=\"form-control\" type=\"text\" ng-model=\"order.description\" maxlength=\"128\"> <span class=\"help-block\">Обов\'язкове поле</span></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok(); orderupdateform.$setSubmitted();\">Зберегти</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"close()\">Відміна</button></div>");
$templateCache.put("app/main/ordermanager/parts/search.html","<!-- <form class=\"form\" ng-submit=\"vm.find()\"  autocomplete=\"off\"> --><div class=\"form-group col-md-3\"><div><label>Номер замовлення</label></div><div show-errors><input type=\"text\" name=\"sId\" ng-pattern=\"vm.fIdPattern\" class=\"form-control\" placeholder=\"Номер замовлення\" ng-model=\"vm.filters.id\"> <span style=\"color:Red\" ng-show=\"vm.ordermanager.sId.$error.pattern\">Тільки цифри</span></div></div><div class=\"form-group col-md-3\"><div><label>Телефон власника</label></div><div><input type=\"text\" class=\"form-control\" placeholder=\"+380971112233 чи 0971112233\" ng-model=\"vm.filters.clientPhone\"></div></div><div class=\"form-group col-md-3\"><div><label>Прізвище, ім\'я власника</label></div><div><input type=\"text\" class=\"form-control\" placeholder=\"Прізвище, ім\'я власника\" ng-model=\"vm.filters.clientName\"></div></div><div class=\"form-group col-md-3\"><div><label>E-mail адреса</label></div><div><input type=\"email\" class=\"form-control\" placeholder=\"E-mail адреса\" ng-model=\"vm.filters.clientEmail\"></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>Місто проведення</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventIDs.length > 0\"></selectlist></div><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" city=\"vm.filters.cityID\" hideall=\"vm.companyID !== 1\" init=\"vm.initEvent\" multiselect reset=\"vm.eventReset\"></events-filter></div><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>Сектор залу</label><selectlist input-method=\"vm.zones\" output-model=\"vm.filters.zoneID\" disabled=\"!vm.zones\"></selectlist></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-4\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketPrintStatus\" checklist-value=\"\'printed\'\"><i></i>Роздруковані</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketPrintStatus\" checklist-value=\"\'not_printed\'\"><i></i>Нероздруковані</label></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-12\"><label>Статус квитка:</label>&nbsp;&nbsp;&nbsp;<label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'active\'\"><i></i>Активний</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'returned\'\"><i></i>Скасований</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketStatus\" checklist-value=\"\'printed_returned\'\"><i></i>Повернуті</label></div></div></div><!-- <div class=\"col-md-6\">\n      <label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'e_blank\'\"><i></i>Бланк</label>\n      <label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'a4\'\"><i></i>А4</label>\n      <label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" checklist-model=\"vm.filters.ticketBlankType\" checklist-value=\"\'a5\'\"><i></i>А5</label>\n    </div> --> <!-- </form> -->");
$templateCache.put("app/main/partners/modal/modal.dialog.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Увага! Ви несете персональну відповідальність за подальші дії</h3></div><div class=\"modal-body\"><p>Дані співставлення знайдені в івенті №{{eventId}}</p><p>Таблиця співставлень буде очищена, івент буде скасований</p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Погоджуюсь</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/partners/modal/modal.info-area.html","<div class=\"modal-header\"><h4>{{baseInfo.partnerEventName}}</h4><h5>Івент № {{baseInfo.partnerEventId}}</h5></div><div class=\"modal-body\"><div class=\"row match-area\"><div class=\"form-group col-md-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-4\">id холлу</th><th>Назва партнерського холлу</th><th>Локація</th></tr></thead><tbody><tr><td>{{baseInfo.partnerHallId}}</td><td>{{baseInfo.partnerHallName}}</td><td>{{baseInfo.partnerLocation.cityName}}<br>{{baseInfo.partnerLocation.cityAddress}}<br>{{baseInfo.partnerLocation.venueTitle}}</td></tr></tbody></table></div></div><div class=\"row\" style=\"max-height: 35vh; overflow-y: auto; overflow-x: hidden\"><div class=\"form-group col-md-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1 text-center\">№<br>п/п</th><th class=\"col-md-3\">id зони</th><th>Назва партнерської зони</th></tr></thead><tbody><tr ng-repeat=\"(key, partnerZone) in infoPartnerZones\"><td class=\"text-center\">{{$index + 1}}</td><td>{{key}}</td><td>{{partnerZone}}</td></tr></tbody></table></div></div></div><div class=\"modal-footer pb-5\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"close()\">Закрити</button></div>");
$templateCache.put("app/main/partners/modal/modal.responsible.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Додати відповідального</h3></div><div class=\"modal-body\"><form><div class=\"row\"><div class=\"col-md-4 form-group\"><label>Тип відповідального</label><selectlist input-model=\"responsibleTypes\" output-model=\"responsibleType\" hidesearch></selectlist></div><div class=\"col-md-6 form-group\" ng-show=\"responsibleType === constants.responsibleTypes.user\" show-dd-errors=\"responsibleID\"><input type=\"hidden\" ng-if=\"responsibleType === constants.responsibleTypes.user\" ng-model=\"responsibleID\" required><label class=\"star\">Відповідальний менеджер</label><selectlist input-model=\"subdivisionManagers\" output-model=\"responsibleID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-md-6 form-group\" ng-show=\"responsibleType === constants.responsibleTypes.subdivision\" show-dd-errors=\"responsibleID\"><input type=\"hidden\" ng-if=\"responsibleType === constants.responsibleTypes.subdivision\" ng-model=\"responsibleID\" required><label class=\"star\">Відповідальний підрозділ</label><selectlist input-model=\"subdivisionList\" output-model=\"responsibleID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-success pull-left\" type=\"button\" ng-click=\"ok()\" ng-disabled=\"!responsibleID\">Додати</button> <button class=\"btn btn-warning pull-left\" type=\"button\" ng-click=\"skip()\">Пропустити</button> <button class=\"btn btn-danger\" type=\"button\" ng-click=\"close()\">Відміна</button></div>");
$templateCache.put("app/main/partners/modal/modal.view-area.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Редагування локації та зон</h3></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"warning\"><div class=\"form-group col-md-12\">{{warning}}</div></div><div class=\"row match-area\" ng-show=\"!warning\"><div class=\"form-group col-md-3\">{{partnerHallName}}</div><div class=\"form-group col-md-5\"><selectlist input-model=\"areas\" output-model=\"formData.areaId\" disabled=\"eventId\"></selectlist></div><div class=\"form-group col-md-4\"><selectlist input-model=\"areaFiles\" output-model=\"formData.areaFileId\" disabled=\"eventId\"></selectlist></div></div><br><div class=\"row\" ng-show=\"!warning && showZones && formData.areaFileId === initAreaFileId\" style=\"max-height: 50vh; overflow-y: auto; overflow-x: hidden\"><div class=\"form-group col-md-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th>Партнерська зона</th><th class=\"action col-md-6\">Наша зона</th><th class=\"col-md-2\">Активність зони</th></tr></thead><tbody><tr ng-repeat=\"partnerZone in formData.partnerZones | orderBy:\'+id\'\" ng-style=\"missingApiZones.includes(partnerZone.partnerZoneId) && {\'border\' : \'2px dashed lightcoral\'}\"><td>{{partnerZone.name}}</td><td><selectlist input-model=\"partnerZone.zones\" output-model=\"partnerZone.zoneId\" disabled=\"partnerZone.initZoneId !== null && eventId\"></selectlist></td><td><input type=\"checkbox\" ng-model=\"partnerZone.zoneActive\"></td></tr></tbody></table></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger pull-left\" type=\"button\" ng-click=\"clear()\" ng-disabled=\"!allowEdit\">Очистити співставлення</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{newZonesEnabled && eventId ? \'Додати нові зони\' : \'OK\'}}</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"close()\">Закрити</button></div>");
$templateCache.put("app/main/quotes/modal/ks-confirm-print-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Підтвердити дію</h3></div><div class=\"modal-body\"><p class=\"modal-message\" ng-bind-html=\"message\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">OK</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/quotes/modal/ks-confirm-without-save-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Підтвердити дію</h3></div><div class=\"modal-body\"><p>Є не збережені дані. Продовжити без збереження?</p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-show=\"button.ok\" ng-click=\"ok()\">ОК</button> <button class=\"btn btn-warning\" type=\"button\" ng-show=\"button.cancel\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/quotes/modal/quotes.print.html","<div class=\"modal-header\"><h3 class=\"modal-title\" ng-if=\"!setInvite\">Друк{{printToFile ? \' в файл\' : \'\'}}</h3><h3 class=\"modal-title\" ng-if=\"setInvite\">Встановити запрошення</h3></div><div class=\"modal-body\"><div class=\"form-group\" ng-show=\"!showfull\"><label class=\"control-label\">Кiлькiсть квиткiв</label><div><p class=\"form-control-static\">{{limit}} шт.</p><!-- <input class=\"form-control\" type=\"number\" ng-model=\"limit\" ng-max=\"max\" max=\"{{max}}\" min=\"0\" /> --></div></div><label ng-if=\"showfull && tickets\" class=\"i-checks i-checks-sm\" ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" ng-model=\"checklist.selectAll\" ng-change=\"toggleSelectAll()\" ng-click=\"$event.stopPropagation()\"><i></i> Всі</label><div ng-if=\"showfull\" style=\"max-height: 60vh; overflow-y: auto; position: relative\"><table class=\"table table-striped quota-tickets-table\" ng-if=\"tickets\"><thead><tr><th ng-click=\"sortBy(\'id\')\">№</th><th ng-click=\"sortBy(\'zoneNumber\')\">Сектор</th><th ng-click=\"sortBy(\'rowNumber\')\">Ряд</th><th ng-click=\"sortBy(\'placeNumber\')\">Мiсце</th><th ng-click=\"sortBy(\'price\')\">Цiна</th><th ng-click=\"sortBy(\'barcode\')\">Код</th><th ng-click=\"sortBy(\'datePrint\')\">Дата друку</th><th ng-click=\"sortBy(\'printStatus\')\">Роздруковано</th><th ng-click=\"sortBy(\'status\')\">Продано к/а</th><th ng-if=\"setInvite\" ng-click=\"sortBy(\'paymentStatus\')\">Запрошення</th></tr></thead><tr ng-repeat=\"t in tickets | orderBy: sort\"><td><label class=\"i-checks i-checks-sm\" ng-click=\"$event.stopPropagation()\"><input type=\"checkbox\" checklist-model=\"checklist.selected\" checklist-value=\"t\"><i></i> #{{t.id}}</label></td><td>{{t.zoneNumber}}</td><td>{{t.rowNumber}}</td><td>{{t.placeNumber}}</td><td>{{t.price}}</td><td>{{t.barcode}}</td><td>{{t.datePrint}}</td><td><span ng-show=\"t.printStatus === \'printed\'\">Так</span> <span ng-show=\"t.printStatus === \'not_printed\'\">Ні</span></td><td><span ng-show=\"t.status === \'in_partner_sales\'\">Так</span> <span ng-show=\"t.status !== \'in_partner_sales\'\">Ні</span></td><td ng-if=\"setInvite\"><span ng-show=\"t.paymentStatus === \'invite\'\">Так</span> <span ng-show=\"t.paymentStatus !== \'invite\'\">Ні</span></td></tr></table><p ng-if=\"!tickets\">Завантаження...</p></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"full()\" ng-if=\"!showfull\">Вибрати бiлети</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"printSelected()\" ng-if=\"showfull\" ng-disabled=\"!setInvite && checklist.selected.length < 1\">{{setInvite ? \'OK\' : \'Друк\'}}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\" ng-if=\"!showfull\" ng-disabled=\"!limit || limit < 1 || limit > max\">Друк</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"close()\">Назад</button></div>");
$templateCache.put("app/main/statistics/tables/by-contractors.html","<div class=\"col-md-8\"><div class=\"panel panel-default\"><h4 class=\"text-center\">По контрагентах на подію</h4><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1 row\"><th class=\"col-md-4\">Гравець</th><th class=\"col-md-2\">Продано, шт</th><th class=\"col-md-2\">Бронь, шт</th><th class=\"col-md-2\">Запрошення, шт</th><th class=\"col-md-2\">Сума(бронь + продано), грн</th><th class=\"col-md-2\">Частка валу, %</th></tr></thead><tbody><tr ng-repeat=\"item in vm.response.contractors\" class=\"row\"><td>{{item.name}}</td><td class=\"td-a\">{{item.soldCount}}</td><td class=\"td-a\">{{item.reservedCount}}</td><td class=\"td-a\">{{item.inviteCount}}</td><td class=\"td-b\">{{item.reservedAndSoldCost}}</td><td class=\"td-c\">{{item.percent}}</td></tr></tbody><tfoot><tr class=\"tr-2 row\"><td>Разом:</td><td>{{vm.response.soldCount}}</td><td>{{vm.response.reservedCount}}</td><td>{{vm.response.inviteCount}}</td><td>{{vm.response.reservedAndSoldCost}}</td><td class=\"td-c\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/statistics/tables/kg-10.html","<div class=\"col-md-8\"><div class=\"panel panel-default\"><h4 class=\"text-center\">КГ-10 на подію</h4><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Гравець</th><th colspan=\"2\">Видано</th><th colspan=\"2\">Реалізовано</th><th colspan=\"2\">Повернуто</th></tr><tr class=\"tr-1\"><td>шт</td><td>грн</td><td>шт</td><td>грн</td><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat=\"item in vm.response.partners\"><td>{{item.name}}</td><td class=\"td-a\">{{item.totalCount}}</td><td class=\"td-a\">{{item.totalCost}}</td><td class=\"td-b\">{{item.soldCount}}</td><td class=\"td-b\">{{item.soldCost}}</td><td class=\"td-a\">{{item.returnedCount}}</td><td class=\"td-a\">{{item.returnedCost}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td>{{vm.response.totalCount}}</td><td>{{vm.response.totalCost}}</td><td>{{vm.response.soldCount}}</td><td>{{vm.response.soldCost}}</td><td>{{vm.response.returnedCount}}</td><td>{{vm.response.returnedCost}}</td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/statistics/tables/kg-9.html","<div class=\"col-md-8\"><div class=\"panel panel-default\"><h4 class=\"text-center\">КГ-9 на подію</h4><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1\"><th rowspan=\"2\">Ціна</th><th colspan=\"2\">Усього до реалізації за абонементами</th><th colspan=\"2\">Реалізовано за абонементами</th><th colspan=\"2\">Не реалізовано за абонементами</th></tr><tr class=\"tr-1\"><td>шт</td><td>грн</td><td>шт</td><td>грн</td><td>шт</td><td>грн</td></tr></thead><tbody><tr ng-repeat=\"item in vm.response.prices\"><td>{{item.price}}</td><td class=\"td-a\">{{item.totalCount}}</td><td class=\"td-a\">{{item.totalCost}}</td><td class=\"td-b\">{{item.soldCount}}</td><td class=\"td-b\">{{item.soldCost}}</td><td class=\"td-a\">{{item.notSoldCount}}</td><td class=\"td-a\">{{item.notSoldCost}}</td></tr></tbody><tfoot><tr class=\"tr-2\"><td>ВСЬОГО</td><td>{{vm.response.totalCount}}</td><td>{{vm.response.totalCost}}</td><td>{{vm.response.soldCount}}</td><td>{{vm.response.soldCost}}</td><td>{{vm.response.notSoldCount}}</td><td>{{vm.response.notSoldCost}}</td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/statistics/tables/payment-and-delivery-types.html","<div class=\"col-md-8\"><div class=\"panel panel-default\"><h4 class=\"text-center\">Способи оплати та доставки на подію</h4><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1 row\"><th class=\"col-md-4\">Доставка</th><th class=\"col-md-2\">Готівка, шт</th><th class=\"col-md-2\">Готівка, грн</th><th class=\"col-md-2\">Банківська карта, шт</th><th class=\"col-md-2\">Банківська карта, грн</th><th class=\"col-md-2\">Всього по рядку, шт</th><th class=\"col-md-2\">Всього по рядку, грн</th></tr></thead><tbody><tr ng-repeat=\"item in vm.response.deliveries\" class=\"row\"><td>{{item.name}}</td><td class=\"td-a\">{{item.cashCount}}</td><td class=\"td-b\">{{item.cashCost}}</td><td class=\"td-a\">{{item.bankCardCount}}</td><td class=\"td-b\">{{item.bankCardCost}}</td><td class=\"td-c\">{{item.totalCount}}</td><td class=\"td-c\">{{item.totalCost}}</td></tr></tbody><tfoot><tr class=\"tr-2 row\"><td>Разом:</td><td>{{vm.response.cashCount}}</td><td>{{vm.response.cashCost}}</td><td>{{vm.response.bankCardCount}}</td><td>{{vm.response.bankCardCost}}</td><td class=\"td-c\">{{vm.response.totalCount}}</td><td class=\"td-c\">{{vm.response.totalCost}}</td></tr></tfoot></table></div></div>");
$templateCache.put("app/main/statistics/tables/remains-of-tickets.html","<div class=\"col-md-8\"><div class=\"panel panel-default\"><h4 class=\"text-center\">Залишки квитків на подію</h4><table class=\"table table-bordered table-style-1\"><thead><tr class=\"tr-1 row\"><th class=\"col-md-4\">Зона (сектор)</th><th class=\"col-md-1\">Ряд</th><th class=\"col-md-2\">Мiсця</th><th class=\"col-md-2\">Кiл-ть, шт</th><th class=\"col-md-1\">Цiна, грн</th><th class=\"col-md-2\">Сума, грн</th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.response.zones\" class=\"row\"><td ng-class=\"{fullrow: item.rows.length > 0}\" ng-if=\"!item.full\" ng-click=\"item.full=!item.full\">{{item.name}}</td><td class=\"td-a\" ng-if=\"!item.full\">-</td><td class=\"td-b\" ng-if=\"!item.full\">-</td><td class=\"td-b\" ng-if=\"!item.full\">{{item.count}}</td><td class=\"td-b\" ng-if=\"!item.full\">{{item.prices.length == 1 ? item.prices[0].price : \'-\'}}</td><td class=\"td-c\" ng-if=\"!item.full\">{{item.cost}}</td><td class=\"fullrow\" rowspan=\"{{item.rows.length}}\" ng-if=\"item.full\" ng-click=\"item.full=!item.full\">{{item.name}}</td><td class=\"td-a\" ng-if=\"item.full\">{{item.rows[0].number || \'-\'}}</td><td class=\"td-b\" ng-if=\"item.full\">{{item.rows[0].places || \'-\'}}</td><td class=\"td-b\" ng-if=\"item.full\">{{item.rows[0].count || item.count}}</td><td class=\"td-b\" ng-if=\"item.full\">{{!item.rows.length ? item.prices[0].price : item.rows[0].price}}</td><td class=\"td-c\" ng-if=\"item.full\">{{item.rows[0].cost || item.cost}}</td></tr><tr ng-repeat-end ng-repeat=\"p in item.rows.slice(1)\" ng-if=\"item.full\"><td></td><td class=\"td-a\">{{p.number}}</td><td class=\"td-b\">{{p.places}}</td><td class=\"td-b\">{{p.count}}</td><td class=\"td-b\">{{p.price}}</td><td class=\"td-c\">{{p.cost}}</td></tr></tbody><tfoot><tr class=\"tr-2 row\"><td>Разом:</td><td></td><td></td><td>{{vm.response.freeCount}}</td><td></td><td class=\"td-c\">{{vm.response.freeCost}}</td></tr></tfoot></table></div><div class=\"panel panel-default\"><table class=\"table table-bordered table-striped\"><tr><td>всього розцінено:</td><td><b>{{vm.response.totalCount}}</b></td><td>на суму:</td><td><b>{{vm.response.totalCost}}</b></td></tr><tr><td>всього задіяно:</td><td><b>{{vm.response.usedCount}}</b></td><td>на суму:</td><td><b>{{vm.response.usedCost}}</b></td></tr><tr><td>всього вільно:</td><td><b>{{vm.response.freeCount}}</b></td><td>на суму:</td><td><b>{{vm.response.freeCost}}</b></td></tr></table></div></div>");
$templateCache.put("app/main/service-charge/modal/modal.delete.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Увага!</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-md-12\">Ви підтверджуєте видалення сервісного збору?</div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary pull-left\" type=\"button\" ng-click=\"ok()\">Так</button> <button class=\"btn btn-warning pull-right\" type=\"button\" ng-click=\"close()\">Ні</button></div>");
$templateCache.put("app/main/site/artists/artists.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}} - {{vm.item.names}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.artists.edit\" ng-if=\"!vm.edit\">Добавити артиста</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.artists\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.artistsform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-3 form-group\" show-errors><label class=\"star\">Системна назва артиста</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.names\" placeholder=\"Введіть назву\"></div><div class=\"col-md-3 form-group\" show-errors><!-- <label class=\"star\">Url alias</label>\n            <input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" placeholder=\"ULR Alias\"/> --><label>URL Alias</label><div class=\"form-group\" show-errors><input type=\"text\" name=\"urlAlias\" value=\"\" ng-model=\"vm.item.urlAlias\" placeholder=\"Введіть URL\" ng-pattern=\"vm.urlAliasPattern\" class=\"form-control\"> <span class=\"help-block\" ng-show=\"vm.artistsform.urlAlias.$error.pattern\">ULR Alias не повинен включати спец символи та символи кирилиці.</span></div></div><div class=\"col-lg-2\"><label>&nbsp;</label><div class=\"\"><a class=\"btn btn-primary btn-block\" ng-disabled=\"!vm.item.id\" ng-click=\"vm.genUrlAlias()\">Генерувати URL</a></div></div><div class=\"col-md-2 form-group\" show-errors><label>SoundCloud</label><input class=\"form-control\" type=\"text\" ng-model=\"vm.item.playlist\" placeholder=\"Номер плейлісту\"></div><div class=\"col-sm-2 form-group\" show-errors><label class=\"star\">Дата публікації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.item.dateArt\"><input type=\"text\" name=\"date\" class=\"form-control\"> <input type=\"hidden\" name=\"date\" ng-model=\"vm.item.dateArt\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><p class=\"text-center\"><strong>Текстові описи та СЕО параметри</strong></p><uib-tabset active=\"active\"><uib-tab index=\"$index\" ng-repeat=\"item in vm.item.artists_lang\"><uib-tab-heading>{{item.lang_name}}</uib-tab-heading><label class=\"star\">Назва артиста</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"item.a_name\" placeholder=\"Введіть назву\"><br><h4>Текстовий опис артиста</h4><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\"></textarea></div><p>Текстовий опис підбірки короткий (250 символів для превью)</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.short_description\" ng-maxlength=\"255\"></textarea><span style=\"color:Red\" ng-show=\"vm.artistsform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.short_description.length}}</span></div><!-- <uib-tabset active=\"active\">\n  <uib-tab  index=\"$index\" ng-repeat=\"item in vm.item.artists_lang_description\"  >      \n            <p>Текстовий опис підбірки короткий (250 символів для превью)</p>                 \n        <div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\"\n          ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n          ngf-pattern=\"\'image/*\'\">\n          <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\" ng-maxlength=\"255\"></textarea>\n          <span style=\"color:Red\" ng-show=\"vm.artistsform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.description.length}}</span>                              \n          </div>          \n  </uib-tab>\n</uib-tabset> --><div class=\"row\"><div class=\"col-md-2\"><p>META-title</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"item.meta_title\" placeholder=\"Введіть назву\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Description</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"item.meta_description\" placeholder=\"Введіть опис\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Keywords</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"item.keywords\" placeholder=\"Введіть ключові слова\"></div></div></uib-tab></uib-tabset><hr><p class=\"text-center\"><strong>Контент підбірки</strong></p><div class=\"row\"><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop\" name=\"desktop\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" ngf-max-size=\"10MB\">Додати файл desktop</button> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.maxWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.minWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"artists in vm.item.artists_desktop\" class=\"col-lg-5 artists\"><img ng-src=\"{{vm.imagesUrl + artists.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArtists_desktop(artists)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop_retina\" name=\"desktop_retina\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1600\" ngf-max-width=\"1600\" ngf-max-size=\"10MB\">Додати файл desktop_retina</button> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.maxWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.minWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.desktop_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"artists in vm.item.artists_desktop_retina\" class=\"col-lg-5 artists\"><img ng-src=\"{{vm.imagesUrl + artists.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArtists_desktop_retina(artists)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile\" name=\"mobile\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"500\" ngf-max-width=\"500\" ngf-max-size=\"10MB\">Додати файл mobile</button> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.maxWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.minWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"artists in vm.item.artists_mobile\" class=\"col-lg-5 artists\"><img ng-src=\"{{vm.imagesUrl + artists.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArtists_mobile(artists)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile_retina\" name=\"mobile_retina\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1000\" ngf-max-width=\"1000\" ngf-max-size=\"10MB\">Додати файл mobile_retina</button> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.maxWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.minWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.artistsform.mobile_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"artists in vm.item.artists_mobile_retina\" class=\"col-lg-5 artists\"><img ng-src=\"{{vm.imagesUrl + artists.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArtists_mobile_retina(artists)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div></div></form></section>");
$templateCache.put("app/main/site/artists/artists.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.artists.edit\" ng-if=\"!vm.edit\">Добавити артиста</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.artists\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.names\" ng-change=\"vm.applyFilter(\'names\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID</th><th>Системна назва артиста</th><th class=\"action col-md-2\">Url Alias</th></tr></thead><tbody><tr ng-repeat=\"n in vm.items\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.names}}</td><td>{{n.urlAlias}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.artists.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/site/area/area.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}} - {{vm.item.name}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.area\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.areaform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">URL Alias</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" placeholder=\"Введіть URL\"></div><div class=\"col-md-2 form-group\"><label>ТОП міста</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.cityTop\"> <i></i>Активний</label></p></div><div class=\"col-md-2 form-group\"><label>ТОП країни</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.countryTop\"> <i></i>Активний</label></p></div></div><hr><p class=\"text-center\"><strong>Текстові описи та СЕО параметри</strong></p><!--  <uib-tabset active=\"active\">\n  <uib-tab  index=\"$index\" ng-repeat=\"item in vm.item.area_lang_description\"  >\n    <uib-tab-heading>{{item.lang_name}}</uib-tab-heading>    \n            <h4>Загальний опис - {{item.lang_name}}</h4>\n          <div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\"\n          ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n          ngf-pattern=\"\'image/*\'\">\n          <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\" ng-maxlength=\"255\"></textarea>\n          <span style=\"color:Red\" ng-show=\"vm.areaform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.description.length}}</span>\n          </div>          \n  </uib-tab>\n</uib-tabset>\n<hr/> --><uib-tabset active=\"active\"><uib-tab index=\"$index\" ng-repeat=\"item in vm.item.area_lang\"><uib-tab-heading>{{item.lang_name}}</uib-tab-heading><label class=\"star\">Назва локації</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"item.a_name\" placeholder=\"Введіть назву\"><br><h4>Текстовий опис локації</h4><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\"></textarea></div><p>Текстовий опис підбірки короткий (250 символів для превью)</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.short_description\" ng-maxlength=\"255\"></textarea><span style=\"color:Red\" ng-show=\"vm.areaform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.short_description.length}}</span></div><!-- \n<uib-tabset active=\"active\">\n  <uib-tab  index=\"$index\" ng-repeat=\"item in vm.item.area_lang_description\"  >     \n          <p>Текстовий опис підбірки короткий (250 символів для превью)</p>\n          <div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\"\n          ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n          ngf-pattern=\"\'image/*\'\">\n          <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\" ng-maxlength=\"255\"></textarea>\n          <span style=\"color:Red\" ng-show=\"vm.areaform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.description.length}}</span>\n          </div>          \n  </uib-tab>\n</uib-tabset> --><div class=\"row\"><div class=\"col-md-2\"><p>META-title</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"item.meta_title\" placeholder=\"Введіть назву\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Description</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"item.meta_description\" placeholder=\"Введіть опис\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Keywords</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"item.keywords\" placeholder=\"Введіть ключові слова\"></div></div></uib-tab></uib-tabset><hr><p class=\"text-center\"><strong>Контент підбірки</strong></p><div class=\"row\"><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop\" name=\"desktop\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" ngf-max-size=\"10MB\">Додати файл desktop</button> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.maxWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.minWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"area in vm.item.area_desktop\" class=\"col-lg-5 area\"><img ng-src=\"{{vm.imagesUrl + area.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArea_desktop(area)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop_retina\" name=\"desktop_retina\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1600\" ngf-max-width=\"1600\" ngf-max-size=\"10MB\">Додати файл desktop_retina</button> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.maxWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.minWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.desktop_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"area in vm.item.area_desktop_retina\" class=\"col-lg-5 area\"><img ng-src=\"{{vm.imagesUrl + area.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArea_desktop_retina(area)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile\" name=\"mobile\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"500\" ngf-max-width=\"500\" ngf-max-size=\"10MB\">Додати файл mobile</button> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.maxWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.minWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"area in vm.item.area_mobile\" class=\"col-lg-5 area\"><img ng-src=\"{{vm.imagesUrl + area.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArea_mobile(area)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile_retina\" name=\"mobile_retina\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1000\" ngf-max-width=\"1000\" ngf-max-size=\"10MB\">Додати файл mobile_retina</button> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.maxWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.minWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.areaform.mobile_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"area in vm.item.area_mobile_retina\" class=\"col-lg-5 area\"><img ng-src=\"{{vm.imagesUrl + area.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeArea_mobile_retina(area)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div></div></form></section>");
$templateCache.put("app/main/site/area/area.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span></div></header><div class=\"row\"><!-- <div class=\"col-lg-5\">\n    <input placeholder=\"Пошук по назвi\" class=\"form-control autosearch\" type=\"text\" maxlength=\"128\"\n            ng-model-options=\"{ debounce: 300 }\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\')\">\n    <i class=\"glyphicon glyphicon-search\" ng-if=\"!vm.filters.name\"></i>\n    <i class=\"glyphicon glyphicon-remove\" ng-if=\"vm.filters.name\" ng-click=\"vm.filters.name = null; vm.filter()\"></i>\n  </div> --><div class=\"col-lg-3\"><label>Місто</label><selectlist input-method=\"vm.citiesGet\" output-model=\"vm.filters.cityID\" on-change=\"vm.applyFilter(\'cityID\')\"></selectlist></div><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div><!-- <div class=\"col-md-3\">\n    <label>Пошук по телефону</label>\n    <input type=\"text\" ng-model=\"vm.filters.phone\" ng-change=\"vm.applyFilter(\'phone\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\">\n  </div>  --><!--  <div class=\"col-md-3\">\n    <label>Пошук по типу</label>   \n    <selectlist input-model=\"vm.typeList\" output-model=\"vm.filters.type\" hidesearch on-change=\"vm.applyFilter()\"></selectlist>\n  </div>  --><!-- <div class=\"col-md-3\">    \n   <label>Пошук по даті</label>\n    <div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._dateCreate\" on-blur=\"vm.applyDateFilter()\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"Дата створення\" />\n      <span class=\"input-group-addon\">\n        <span class=\"glyphicon glyphicon-calendar\"></span>\n      </span>\n    </div>\n\n  </div> --></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div><!-- <div class=\"\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\">\n      <div class=\"row\" ng-repeat=\"area in vm.items\" >\n        <div class=\"area col-sm-5\">\n          <section class=\"panel\">\n            <div class=\"panel-body\">\n              <div class=\"col-sm-11 col-xs-3\">\n                <div class=\"title\">\n                  <p class=\"m-t-none dimgray\">{{area.name}}</p>\n                  <p class=\"m-t-none dimgray\">Дата створення: {{area.date_create}}</p>\n                </div>              \n              </div>\n              <div class=\"col-sm-1 col-xs-1\">\n                <button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.area.edit({ id:area.id })\">\n                  <span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>\n                </button>\n              </div>                                       \n            </div>\n      </div>   \n    </div>\n    </div> --></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th>ID</th><th>ID address</th><th>Місто</th><th class=\"action col-md-2\">Системна назва</th><th class=\"action col-md-2\">Url Alias</th><th class=\"action col-md-1\">Тип</th><th class=\"action col-md-1\">Телефон</th><th class=\"action col-md-2\">Опис</th><th class=\"action col-md-1\">Топ</th><th class=\"action col-md-1\">Дата створення</th></tr></thead><tr ng-repeat=\"n in vm.items\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.address_id}}</td><td style=\"word-wrap: break-word\">{{n.cityName}}</td><td style=\"word-wrap: break-word\">{{n.name}}</td><td style=\"word-wrap: break-word\">{{n.urlAlias}}</td><td>{{n.type}}</td><td>{{n.phone}}</td><td>{{n.description}}</td><td>{{n.top}}</td><td>{{n.date_create}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.area.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button></td></tr></table></div></div><!-- </section> -->");
$templateCache.put("app/main/site/choice/choice.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.choice.edit\" ng-if=\"!vm.edit\">Добавити підбірку</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.choice\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.choiceform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Системна назва підбірки</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"vm.item.name\" required placeholder=\"Введіть назву\"></div><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">URL Alias</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" required placeholder=\"Введіть URL\"></div><div class=\"col-md-1 form-group\"><label>Статус</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label></p></div><div class=\"col-md-1 form-group\"><label>Фон</label><div><select ng-model=\"vm.item.background\"><option value=\"white\">Бiлий</option><option value=\"black\">Чорний</option></select></div></div><!-- <div class=\"col-md-1 form-group\">\n        \n        <p class=\"form-control-static\">\n          <label class=\"i-checks i-checks-sm\">\n           \n            <i></i>Активний            \n          </label>\n        </p>\n      </div>  --></div><hr><p class=\"text-center\"><strong>Текстові описи та СЕО параметри</strong></p><!--   <uib-tabset active=\"active\">\n  <uib-tab  index=\"$index\" ng-repeat=\"item in vm.item.choice_lang_description\"  >\n    <uib-tab-heading>{{item.lang_name}}</uib-tab-heading>    \n            <h4>Короткий опис - {{item.lang_name}}</h4>\n          <div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\"\n          ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n          ngf-pattern=\"\'image/*\'\">\n          <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\" ng-maxlength=\"255\"></textarea>\n          <span style=\"color:Red\" ng-show=\"vm.choiceform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.description.length}}</span>\n          </div>          \n  </uib-tab>\n</uib-tabset> --><!-- <hr/> --><uib-tabset active=\"active\"><uib-tab index=\"$index\" ng-repeat=\"item in vm.item.choice_lang\"><uib-tab-heading>{{item.lang_name}}</uib-tab-heading><p>Назва підбірки</p><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"item.a_name\" placeholder=\"Введіть назву\"><br><p>Текстовий опис підбірки</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\"></textarea></div><p>Текстовий опис підбірки короткий (250 символів для превью)</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.short_description\" ng-maxlength=\"255\"></textarea><span style=\"color:Red\" ng-show=\"vm.choiceform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.short_description.length}}</span></div><!--  <uib-tabset active=\"active\">\n  <uib-tab  index=\"$index\" ng-repeat=\"item in vm.item.choice_lang_description\"  >\n          <p>Текстовий опис підбірки короткий (250 символів для превью)</p>\n          <div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\"\n          ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\"\n          ngf-pattern=\"\'image/*\'\">\n          <textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\" ng-maxlength=\"255\"></textarea>\n          <span style=\"color:Red\" ng-show=\"vm.choiceform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{item.description.length}}</span>\n          </div>          \n  </uib-tab>\n  </uib-tabset>  --><div class=\"row\"><div class=\"col-md-2\"><p>META-title</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"item.meta_title\" placeholder=\"Введіть назву\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Description</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"item.meta_description\" placeholder=\"Введіть опис\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Keywords</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"item.keywords\" placeholder=\"Введіть ключові слова\"></div></div></uib-tab></uib-tabset><hr><p class=\"text-center\"><strong>Контент підбірки</strong></p><div class=\"row\"><div class=\"col-md-2\"><p>Регіони відображення:</p></div><div ng-show=\"vm.item.all_ukraine == \'not_active\'\"><div class=\"col-md-6\"><selectlistregion input-model=\"vm.georegion\" output-model=\"vm.item.currentRegion\" multiselect></selectlistregion></div></div><div class=\"col-md-3\"><input type=\"checkbox\" ng-model=\"vm.item.all_ukraine\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> Відображати підбірку для всієї країни</div></div><div class=\"row\"><div class=\"col-md-2\"><p>Події що включено в підбірку:</p></div><div class=\"col-md-10\"><selectlistevent input-model=\"vm.event\" output-model=\"vm.item.currentEvent\" multiselect></selectlistevent></div></div><div class=\"row\"><div class=\"col-md-3\"><p>Зони сайту, де відображається підбірка:</p></div><div class=\"col-md-9\"><selectlistplace input-model=\"vm.choiceplace\" output-model=\"vm.item.currentChoicePivot\" multiselect></selectlistplace></div></div><hr><div class=\"row\"><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Зображення desktop</button></div><div class=\"col-lg-10\"><div ng-repeat=\"choice in vm.item.choice_desktop\" class=\"col-lg-5 choice\"><img ng-src=\"{{vm.imagesUrl + choice.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeChoice_desktop(choice)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Зображення desktop_retina</button></div><div class=\"col-lg-10\"><div ng-repeat=\"choice in vm.item.choice_desktop_retina\" class=\"col-lg-5 choice\"><img ng-src=\"{{vm.imagesUrl + choice.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeChoice_desktop_retina(choice)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Зображення mobile</button></div><div class=\"col-lg-10\"><div ng-repeat=\"choice in vm.item.choice_mobile\" class=\"col-lg-5 choice\"><img ng-src=\"{{vm.imagesUrl + choice.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeChoice_mobile(choice)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Зображення mobile_retina</button></div><div class=\"col-lg-10\"><div ng-repeat=\"choice in vm.item.choice_mobile_retina\" class=\"col-lg-5 choice\"><img ng-src=\"{{vm.imagesUrl + choice.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removechoice_mobile_retina(choice)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div></div></form></section>");
$templateCache.put("app/main/site/choice/choice.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.choice.edit\" ng-if=\"!vm.edit\">Добавити підбірку</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.choice\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><!-- <div class=\"col-lg-5\">\n    <input placeholder=\"Пошук по назвi\" class=\"form-control autosearch\" type=\"text\" maxlength=\"128\"\n            ng-model-options=\"{ debounce: 300 }\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\')\">\n    <i class=\"glyphicon glyphicon-search\" ng-if=\"!vm.filters.name\"></i>\n    <i class=\"glyphicon glyphicon-remove\" ng-if=\"vm.filters.name\" ng-click=\"vm.filters.name = null; vm.filter()\"></i>\n  </div> --><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div><!-- <div class=\"\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\">\n      <div class=\"row\" ng-repeat=\"choice in vm.items\" >\n        <div class=\"choice col-sm-5\">\n          <section class=\"panel\">\n            <div class=\"panel-body\">\n              <div class=\"col-sm-11 col-xs-3\">\n                <div class=\"title\">\n                  <p class=\"m-t-none dimgray\">{{choice.name}}</p>                  \n                </div>              \n              </div>\n              <div class=\"col-sm-1 col-xs-1\">\n                <button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.choice.edit({ id:choice.id })\">\n                  <span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>\n                </button>\n              </div>                                       \n            </div>\n      </div>   \n    </div>\n    </div> --></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering\">ID</th><th class=\"event-name\">Системна назва підбірки</th><th>Url Alias</th><th class=\"action col-md-1\">Активність</th></tr></thead><tbody><tr ng-repeat=\"n in vm.items\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.name}}</td><td>{{n.urlAlias}}</td><td>{{n.status}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.choice.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button><!--   <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\">\n              <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>\n            </button> --></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/site/choiceplace/choiceplace.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.choiceplace.edit\" ng-if=\"!vm.edit\">Добавити місця</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.choiceplace\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.choiceplaceform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Назва</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"vm.item.name\" required placeholder=\"Назва\"></div><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Slug</label><input class=\"form-control\" name=\"slug\" type=\"text\" ng-model=\"vm.item.slug\" required placeholder=\"slug\"></div></div><hr><div class=\"row\"><div class=\"form-group col-md-5\"><label>Події вiдображенних турів</label><events-list input-model=\"vm.event\" output-model=\"vm.item.currentEvent\" multiselect></events-list></div></div><hr></form></section>");
$templateCache.put("app/main/site/choiceplace/choiceplace.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.choiceplace.edit\" ng-if=\"!vm.edit\">Добавити місце</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.choiceplace\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div><div class=\"\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><div class=\"row\" ng-repeat=\"choiceplace in vm.items\"><div class=\"tour col-sm-5\"><section class=\"panel\"><div class=\"panel-body\"><div class=\"col-sm-11 col-xs-3\"><div class=\"title\"><p class=\"m-t-none dimgray\">{{choiceplace.name}}</p></div></div><div class=\"col-sm-1 col-xs-1\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.choiceplace.edit({ id:choiceplace.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button></div></div></section></div></div></div></section><hr><section class=\"row\" ui-view><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"list-summary pull-right\" ng-if=\"vm.choiceplace.length > 0\">Елементи 1 - {{vm.choiceplace.length}}</div></div><div class=\"tabler col-md-12\"><table class=\"table table-responsive table-bordered table-striped table-condensed\"><thead><tr><th class=\"numbering\">ID</th><th class=\"event-name\">Назва</th><th>slug</th></tr></thead><tbody><tr ng-repeat=\"n in vm.choiceplace\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.name}}</td><td>{{n.slug}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.choiceplace.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></td></tr></tbody></table></div></section>");
$templateCache.put("app/main/site/pixel/pixel.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\">FB Pixel</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\">Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.fb-pixel\">Скасувати</a></span></div></header><section class=\"pixel\"><form ng-submit=\"vm.submit($event)\" name=\"vm.pixelform\" novalidate autocomplete=\"off\"><div class=\"row\"><div class=\"col-sm-6 form-group\" show-errors><label class=\"star\">Назва</label><input type=\"text\" name=\"name\" ng-model=\"vm.pixel.name\" class=\"form-control\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"col-sm-2\"><label class=\"col-md-12\">&nbsp;</label><label class=\"i-checks i-checks-sm\" style=\"margin-top: 12px\"><input type=\"checkbox\" ng-model=\"vm.pixel.status\" name=\"status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\"><label>Місто проведення</label><selectlist input-method=\"vm.cityList\" output-model=\"vm.cityID\"></selectlist></div><div class=\"col-sm-6 form-group\"><label class=\"star\">Подія</label><events-filter output-model=\"vm.pixel.events\" city=\"vm.cityID\" multiselect></events-filter></div></div><div class=\"row\"><div class=\"col-sm-12 form-group\" show-errors><label class=\"star\">Код</label><textarea ng-model=\"vm.pixel.code\" name=\"code\" class=\"form-control\" rows=\"10\" required></textarea><span class=\"help-block\">Обов\'язкове поле</span></div></div></form></section>");
$templateCache.put("app/main/site/pixel/pixel.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"title\">FB Pixel</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.fb-pixel.edit\">Додати FB Pixel</a></span></div></header><section class=\"pixel\"><div class=\"tabler\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><table class=\"table table-striped table-bordered table-responsive col-md-12\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead><tr><th class=\"col-md-1\">№</th><th class=\"col-md-8\" ng-click=\"vm.sort(\'name\')\">Назва</th><th class=\"col-md-1\" ng-click=\"vm.sort(\'dateAdd\')\">Дата</th><th class=\"col-md-1\" ng-click=\"vm.sort(\'status\')\">Активно</th><th class=\"col-md-1\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td><div class=\"ellipsis\">{{item.name}}</div></td><td>{{item.dateAdd}}</td><td><span class=\"glyphicon glyphicon-ok\" ng-if=\"item.status == \'active\'\"></span></td><td class=\"col-md-2\"><div class=\"button-column\"><a ui-sref=\"main.site.fb-pixel.edit({ id: item.id })\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span> </a><a class=\"btn btn-default btn-sm\" ng-click=\"vm.delete(item)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></a></div></td></tr></tbody></table></div></section>");
$templateCache.put("app/main/site/geocitylang/geocitylang.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.geocitylang\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.geocitylangform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"vm.item.geo_city_lang\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"event-name col-md-1\">Код мови</th><th class=\"event-name col-md-10\">Назва міста</th></tr></thead><tr ng-repeat=\"item in vm.item.geo_city_lang\"><td>{{item.lang_name}}</td><td class=\"text-left\"><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"item.a_name\" placeholder=\"Назва міста\"></td></tr></table></div></div></form></section>");
$templateCache.put("app/main/site/geocitylang/geocitylang.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><!-- <a class=\"btn btn-success\" ui-sref=\"main.site.geocitylang.edit\" ng-if=\"!vm.edit\">Добавити місто</a> --> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.geocitylang\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering col-md-1\">ID</th><th class=\"event-name col-md-10\">Назва міста</th><th class=\"action col-md-1\">Редагувати</th></tr></thead><tr ng-repeat=\"n in vm.items\" ng-if=\"!n.deleted\"><td>{{n.id}}</td><td>{{n.name}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.geocitylang.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button></td></tr></table></div></div>");
$templateCache.put("app/main/site/news/news.edit.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}} - {{vm.item.name}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.news.edit\" ng-if=\"!vm.edit\">Створити новину</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.news\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.newsform\" novalidate autocomplete=\"off\" class=\"col-md-12\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Загальна назва</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"vm.item.name\" required placeholder=\"Назва\"></div><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Url alias</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" required placeholder=\"alias\"></div><div class=\"col-md-1 form-group\"><label>Статус</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label></p></div><div class=\"col-md-1 form-group\"><label>Картинка</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.block_type\" ng-true-value=\"\'picture\'\" ng-false-value=\"\'not_picture\'\"> <i></i>Показувати</label></p></div><div class=\"col-sm-2 form-group\" show-errors><label class=\"star\">Дата публікації</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.item.datePublish\"><input type=\"text\" name=\"date\" class=\"form-control\"> <input type=\"hidden\" name=\"date\" ng-model=\"vm.item.datePublish\" required> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div><span class=\"help-block\">Обов\'язкове поле</span></div></div><hr><div class=\"row\"><div class=\"form-group col-md-5\"><label>Рекомендовані артисти</label><selectlistartist input-model=\"vm.artists\" output-model=\"vm.item.currentArtist\" multiselect></selectlistartist></div></div><!-- currentRecomendation --><hr><div class=\"row\"><div class=\"form-group col-md-5\"><label>Рекомендовані події</label><events-list input-model=\"vm.event\" output-model=\"vm.item.currentEvent\" multiselect></events-list></div></div><hr><div class=\"row\"><div class=\"form-group col-md-5\"><label>Рекомендовані локації</label><selectlistarea input-model=\"vm.area\" output-model=\"vm.item.currentArea\" multiselect></selectlistarea></div></div><hr><uib-tabset active=\"active\"><uib-tab index=\"$index\" ng-repeat=\"item in vm.item.news_lang\"><uib-tab-heading>{{item.lang_name}}</uib-tab-heading><label class=\"star\">Назва - {{item.lang_name}}</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"item.a_name\" placeholder=\"текс\"><br><h4>Опис - {{item.lang_name}}</h4><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"item.description\"></textarea></div><br><label class=\"star\">Мета-титул - {{item.lang_name}}</label><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"item.meta_title\" placeholder=\"текс\"><br><label class=\"star\">Мета опис - {{item.lang_name}}</label><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"item.meta_description\" placeholder=\"текс\"><br><label class=\"star\">Ключові слова - {{item.lang_name}}</label><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"item.keywords\" placeholder=\"текс\"></uib-tab></uib-tabset><hr><div class=\"row\"><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Додати файл desktop</button></div><div class=\"col-lg-10\"><div ng-repeat=\"news in vm.item.news_desktop\" class=\"col-lg-5 news\"><img ng-src=\"{{vm.imagesUrl + news.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeNews_desktop(news)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Додати файл desktop_retina</button></div><div class=\"col-lg-10\"><div ng-repeat=\"news in vm.item.news_desktop_retina\" class=\"col-lg-5 news\"><img ng-src=\"{{vm.imagesUrl + news.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeNews_desktop_retina(news)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Додати файл mobile</button></div><div class=\"col-lg-10\"><div ng-repeat=\"news in vm.item.news_mobile\" class=\"col-lg-5 news\"><img ng-src=\"{{vm.imagesUrl + news.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeNews_mobile(news)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'image/*\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-size=\"5MB\">Додати файл mobile_retina</button></div><div class=\"col-lg-10\"><div ng-repeat=\"news in vm.item.news_mobile_retina\" class=\"col-lg-5 news\"><img ng-src=\"{{vm.imagesUrl + news.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeNews_mobile_retina(news)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div></div></form></section>");
$templateCache.put("app/main/site/news/news.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.news.edit\" ng-if=\"!vm.edit\">Створити новину</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.news\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><!-- <div class=\"col-lg-5\">\n    <input placeholder=\"Пошук по назвi\" class=\"form-control autosearch\" type=\"text\" maxlength=\"128\"\n            ng-model-options=\"{ debounce: 300 }\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\')\">\n    <i class=\"glyphicon glyphicon-search\" ng-if=\"!vm.filters.name\"></i>\n    <i class=\"glyphicon glyphicon-remove\" ng-if=\"vm.filters.name\" ng-click=\"vm.filters.name = null; vm.filter()\"></i>\n  </div> --><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div><!-- <div class=\"col-md-3\">\n    <label>Пошук по даті публікації</label>\n    <div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._datePublish\" on-blur=\"vm.applyDateFilter()\">\n      <input type=\"text\" class=\"form-control\" placeholder=\"Дата\" />\n      <span class=\"input-group-addon\">\n        <span class=\"glyphicon glyphicon-calendar\"></span>\n      </span>\n    </div>\n  </div> --></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div><!--  <div class=\"\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\">\n      <div class=\"row\" ng-repeat=\"news in vm.items\" >\n        <div class=\"news col-sm-5\">\n          <section class=\"panel\">\n            <div class=\"panel-body\">\n              <div class=\"col-sm-11 col-xs-3\">\n                <div class=\"title\">\n                  <p class=\"m-t-none dimgray\">{{news.name}}</p>                  \n                </div>              \n              </div>\n              <div class=\"col-sm-1 col-xs-1\">\n                <button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.news.edit({ id:news.id })\">\n                  <span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>\n                </button>\n              </div>                                       \n            </div>\n      </div>   \n    </div>\n    </div> --></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><td class=\"col-md-1\"></td><th class=\"numbering\">ID</th><th class=\"event-name\">Загальна назва</th><th>Url Alias</th><th class=\"action col-md-1\">Активність</th><th class=\"action col-md-1\">Картинка</th><th class=\"action col-md-1\">Дата публікації</th><th class=\"action col-md-1\">Редагувати</th></tr></thead><tr ng-repeat=\"n in vm.items\" ng-if=\"!n.deleted\"><td class=\"col-md-1\"><img ng-src=\"{{vm.imagesUrl + n.imageUrl}}\" width=\"100%\"></td><td>{{n.id}}</td><td>{{n.name}}</td><td>{{n.urlAlias}}</td><td>{{n.status}}</td><td>{{n.block_type}}</td><td>{{n.datePublish}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.news.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button><!-- <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\">\n              <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>\n            </button> --></td></tr></table></div></div><!-- <section class=\"row\" ui-view>\n\n <div class=\" list-view row\" ng-if=\"vm.items.length > 0\">\n  <div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">\n    Елементи 1—{{vm.items.length}} із {{vm.count}}\n  </div>\n  <div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">\n    Елементи 0 із {{vm.count}}\n  </div>\n  <div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\">\n    <table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\"\n            infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\">\n      <thead class=\"table-header\" >\n        <tr>\n          <td class=\"col-md-1\"></td>\n          <th class=\"numbering\">ID</th>\n          <th class=\"event-name\">Назва</th>\n          <th>Url Alias</th>\n          <th class=\"action col-md-1\">Активність</th>\n           <th class=\"action col-md-1\">Картинка</th>\n          <th class=\"action col-md-1\">Дата публікації</th>\n          <th class=\"action col-md-1\"></th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"n in vm.news\" ng-if=\"!n.deleted\">\n          <td class=\"col-md-1\"><img ng-src=\"{{vm.imagesUrl + n.imageUrl}}\" width=\"100%\"/></td>\n          <td>{{n.id}}</td>\n          <td>{{n.name}}</td>\n          <td>{{n.urlAlias}}</td>\n          <td>{{n.status}}</td>\n          <td>{{n.block_type}}</td>\n          <td>{{n.datePublish}}</td>\n          <td class=\"text-right\">\n            <button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.news.edit({ id:n.id })\">\n              <span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span>\n            </button>\n            <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\">\n              <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>\n            </button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</section> -->");
$templateCache.put("app/main/site/recommendations/recommendations.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Рекомендовані події</span></div></header><div class=\"row\"><form name=\"vm.form\" autocomplete=\"off\"><div class=\"col-md-6\"><label style=\"width: 17%\">Додати подію:</label><selectlistevent input-model=\"vm.events\" output-model=\"vm.addedEvents\" selected-view=\"inline\" multiselect style=\"width: 60%; display: inline-block\"></selectlistevent><a class=\"btn btn-success\" ng-click=\"vm.save()\" style=\"width: 15%; margin-left: 3%; margin-top: -2px\">Додати</a></div></form></div><div class=\"list-view row\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Подій не знайдено</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\"><thead class=\"table-header\"><tr><th class=\"col-md-1\">ID</th><th class=\"col-md-4\">Назва</th><th class=\"col-md-2\">Дата</th><th class=\"col-md-2\">Місто</th><th class=\"col-md-2 text-center\">Статус</th><th class=\"col-md-1 text-center\">Дії</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items | orderBy:\'-id\'\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.date}}</td><td>{{item.city}}</td><td class=\"text-center\"><span class=\"label label-danger\" ng-if=\"item.marked\">{{item.status}}</span> <span ng-if=\"!item.marked\">{{item.status}}</span></td><td><div class=\"button-column text-center\"><button type=\"button\" class=\"btn btn-default btn-sm\" aria-label=\"Left Align\" ng-click=\"vm.delete(item)\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/site/tour/tour.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.tour.edit\" ng-if=\"!vm.edit\">Добавити тур</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.tour\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\"><form name=\"vm.tourform\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div class=\"col-md-5 form-group\" show-errors><label class=\"star\">Системна назва туру</label><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"vm.item.name\" required placeholder=\"Назва\"></div><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Url alias</label><input class=\"form-control\" name=\"urlAlias\" type=\"text\" ng-model=\"vm.item.urlAlias\" required placeholder=\"alias\"></div><div class=\"col-md-1 form-group\"><label>Статус</label><p class=\"form-control-static\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label></p></div></div><hr><p class=\"text-center\"><strong>Текстові описи та СЕО параметри</strong></p><uib-tabset active=\"active\" ng-hide=\"vm.item.id\"><uib-tab index=\"$index\" ng-repeat=\"tour in vm.lang\"><uib-tab-heading>{{tour.name}}</uib-tab-heading><p>Назва підбірки</p><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"tour.a_name\" placeholder=\"Введіть назву\"><br><p>Текстовий опис підбірки</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"tour.description\"></textarea></div><p>Текстовий опис підбірки короткий (250 символів для превью)</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"tour.short_description\" ng-maxlength=\"255\"></textarea><span style=\"color:Red\" ng-show=\"vm.choiceform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{tour.short_description.length}}</span></div><div class=\"row\"><div class=\"col-md-2\"><p>META-title</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"tour.meta_title\" placeholder=\"Введіть назву\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Description</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"tour.meta_description\" placeholder=\"Введіть опис\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Keywords</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"tour.keywords\" placeholder=\"Введіть ключові слова\"></div></div></uib-tab></uib-tabset><uib-tabset active=\"active\" ng-hide=\"!vm.item.id\"><uib-tab index=\"$index\" ng-repeat=\"tour in vm.item.tour_lang\"><uib-tab-heading>{{tour.lang_name}}</uib-tab-heading><p>Назва підбірки</p><input class=\"form-control\" name=\"name\" type=\"text\" ng-model=\"tour.a_name\" placeholder=\"Введіть назву\"><br><p>Текстовий опис підбірки</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"tour.description\"></textarea></div><p>Текстовий опис підбірки короткий (250 символів для превью)</p><div ngf-drop=\"vm.uploadFile($file, true)\" class=\"drop-box\" ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'image/*\'\"><textarea ckeditor=\"vm.ckEditorOptions\" ng-model=\"tour.short_description\" ng-maxlength=\"255\"></textarea><span style=\"color:Red\" ng-show=\"vm.choiceform.$error.maxlength\">Максимум 255 символів. Кількість символів: {{tour.short_description.length}}</span></div><div class=\"row\"><div class=\"col-md-2\"><p>META-title</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_title\" type=\"text\" ng-model=\"tour.meta_title\" placeholder=\"Введіть назву\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Description</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"meta_description\" type=\"text\" ng-model=\"tour.meta_description\" placeholder=\"Введіть опис\"></div></div><div class=\"row\"><div class=\"col-md-2\"><p>META-Keywords</p></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"keywords\" type=\"text\" ng-model=\"tour.keywords\" placeholder=\"Введіть ключові слова\"></div></div></uib-tab></uib-tabset><hr><p class=\"text-center\"><strong>Контент підбірки</strong></p><div class=\"row\"><div class=\"col-md-2\"><p>Події вiдображенних турів:</p></div><div class=\"col-md-10\"><selectlistevent input-model=\"vm.event\" output-model=\"vm.item.currentEvent\" multiselect></selectlistevent></div></div><br><div class=\"row\"><!-- for desktop --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop\" name=\"desktop\" ngf-select=\"vm.uploadFilesDesk($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" ngf-max-size=\"10MB\">Додати файл desktop</button> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.maxWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.minWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"tours in vm.item.tours_desktop\" class=\"col-lg-5 tours\"><img ng-src=\"{{vm.imagesUrl + tours.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeTours_desktop(tours)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for desktop_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFiledesktop_retina\" name=\"desktop_retina\" ngf-select=\"vm.uploadFilesDeskret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1600\" ngf-max-width=\"1600\" ngf-max-size=\"10MB\">Додати файл desktop_retina</button> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.maxWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.minWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.desktop_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"tours in vm.item.tours_desktop_retina\" class=\"col-lg-5 tours\"><img ng-src=\"{{vm.imagesUrl + tours.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeTours_desktop_retina(tours)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile\" name=\"mobile\" ngf-select=\"vm.uploadFilesMob($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"500\" ngf-max-width=\"500\" ngf-max-size=\"10MB\">Додати файл mobile</button> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.maxWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.minWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"tours in vm.item.tours_mobile\" class=\"col-lg-5 tours\"><img ng-src=\"{{vm.imagesUrl + tours.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeTours_mobile(tours)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><!-- for mobile_retina --><div class=\"col-lg-12\"><div class=\"form-group col-lg-2\"><button type=\"file\" ng-model=\"picFilemobile_retina\" name=\"mobile_retina\" ngf-select=\"vm.uploadFilesMobret($files, $invalidFiles)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1000\" ngf-max-width=\"1000\" ngf-max-size=\"10MB\">Додати файл mobile_retina</button> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.maxWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.minWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.tourform.mobile_retina.$error.pattern\">Афіша не відповідає формату(jpg, jpeg, png)</span></div><div class=\"col-lg-10\"><div ng-repeat=\"tours in vm.item.tours_mobile_retina\" class=\"col-lg-5 tours\"><img ng-src=\"{{vm.imagesUrl + tours.url}}\" style=\"width: 100%\" class=\"img-thumbnail\"> <button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.removeTours_mobile_retina(tours)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><hr></div></form></section>");
$templateCache.put("app/main/site/tour/tour.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">{{vm.title}}</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.tour.edit\" ng-if=\"!vm.edit\">Добавити тур</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.tour\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><div class=\"row\"><div class=\"col-md-3\"><label>Пошук по назвi</label><input type=\"text\" ng-model=\"vm.filters.name\" ng-change=\"vm.applyFilter(\'name\');\" class=\"form-control\" ng-model-options=\"{ debounce: 300 }\"></div></div><section class=\"event-list\"><div class=\"row\"><header class=\"header-view col-md-6\"><span class=\"\">Знайдено: {{vm.count}}</span></header></div></section><hr><div class=\"list-view row\" ng-if=\"vm.items.length > 0\"><div class=\"summary text-right col-md-12\" ng-if=\"!!vm.items.length\">Елементи 1—{{vm.items.length}} із {{vm.count}}</div><div class=\"summary text-right col-md-12\" ng-if=\"!vm.items.length\">Елементи 0 із {{vm.count}}</div><div class=\"tabler col-xs-12 col-sm-12 col-md-12 col-lg-12\"><table class=\"table table-striped table-bordered\" infinite-scroll=\"vm.load()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"vm.disableScroll\"><thead class=\"table-header\"><tr><th class=\"numbering\">ID</th><th class=\"event-name\">Системна назва туру</th><th>Url Alias</th><th class=\"action col-md-1\">Активність</th></tr></thead><tr ng-repeat=\"n in vm.items\"><td>{{n.id}}</td><td>{{n.name}}</td><td>{{n.urlAlias}}</td><td>{{n.status}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.tour.edit({ id:n.id })\"><span class=\"glyphicon glyphicon-pencil\" aria-hidden=\"true\"></span></button><!-- <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(n)\">\n              <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>\n            </button> --></td></tr></table></div></div><!-- </section> -->");
$templateCache.put("app/main/site/slides/slides.edit.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Слайди</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"site.news-new\" ng-if=\"!vm.edit\">Створити слайд</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.slides\" ng-if=\"vm.edit\">Cкасувати</a></span></div></header><section class=\"row\"><form name=\"vm.slide\" novalidate autocomplete=\"off\" class=\"container-fluid\"><input type=\"submit\" class=\"hidden\"><div class=\"row\"><div ng-if=\"vm.item.tourID\"><div class=\"form-group col-md-4\"><label>Подiя</label>{{vm.item.eventID}}<events-filter output-model=\"vm.item.eventID\" init=\"vm.item.eventID\"></events-filter><span class=\"help-block\">Обов\'язкове поле</span></div></div><div ng-if=\"!vm.item.tourID\"><div class=\"form-group col-md-4\" show-dd-errors=\"vm.item.eventID\"><label class=\"star\">Подiя</label>{{vm.item.eventID}}<events-filter output-model=\"vm.item.eventID\" init=\"vm.item.eventID\"></events-filter><span class=\"help-block\">Обов\'язкове поле</span></div></div><div class=\"col-md-2 form-group\" show-errors><label>Колiр фону <span class=\"color-bg\" ng-style=\"{\'background-color\': vm.item.backgroundColor}\"></span></label><input name=\"backgroundColor\" class=\"form-control\" colorpicker type=\"text\" ng-model=\"vm.item.backgroundColor\" required placeholder=\"Колiр фону\"></div><div class=\"col-md-2 form-group\" show-errors><label>Колiр тексту <span class=\"color-bg\" ng-style=\"{\'background-color\': vm.item.fontColor}\"></span></label><input name=\"fontColor\" class=\"form-control\" colorpicker type=\"text\" ng-model=\"vm.item.fontColor\" required placeholder=\"Колiр тексту\"></div><div class=\"col-md-3 form-group\"><label>Статус</label><p class=\"form-control-static\" style=\"border: 0\"><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.status\" ng-true-value=\"\'active\'\" ng-false-value=\"\'not_active\'\"> <i></i>Активний</label><label class=\"i-checks i-checks-sm\"><input type=\"checkbox\" ng-model=\"vm.item.inMainPage\"> <i></i>На головнiй</label></p></div><div class=\"col-md-1 form-group\"><label class=\"\">ID</label><p class=\"form-control-static\">{{vm.item.id}}</p></div></div><div class=\"row\"><div ng-if=\"!vm.item.eventID\"><div class=\"form-group col-md-4\" show-dd-errors=\"vm.item.tourID\"><label class=\"star\">Тури</label><selectlist input-method=\"vm.getTours\" output-model=\"vm.item.tourID\"></selectlist><span class=\"help-block\">Обов\'язкове поле</span></div></div><div ng-if=\"vm.item.eventID\"><div class=\"form-group col-md-4\"><label>Тури</label><selectlist input-method=\"vm.getTours\" output-model=\"vm.item.tourID\"></selectlist></div></div></div><hr><div class=\"row\"><div class=\"form-group col-md-4\"><label>Місто вiдображення слайду</label><selectlist input-model=\"vm.cities\" output-model=\"vm.item.currentCities\" multiselect></selectlist></div></div><hr><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Слайд</label><input class=\"hidden\" ng-model=\"vm.item.bigSlideUrl\" required name=\"bigSlideUrl\"><div class=\"\"><!--  <button type=\"file\" ngf-select=\"vm.uploadFile($file,false,false)\" ngf-pattern=\"\'image/*\'\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">Додати файл</button> --> <button type=\"file\" ng-model=\"picFilebigSlideUrl\" name=\"bigSlideUrl\" ngf-select=\"vm.uploadFile($file,false,false)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"800\" ngf-max-width=\"800\" ngf-max-size=\"10MB\">Додати файл</button> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.maxWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.minWidth\">ширина = 800px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrl.$error.pattern\">Слайд не відповідає формату(jpg, jpeg, png)</span></div><div ng-if=\"vm.item.bigSlideUrl\"><br><img ng-src=\"{{vm.imagesUrl + vm.item.bigSlideUrl}}\" style=\"mix-width: 100%\" class=\"img-thumbnail\"></div></div><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Малий слайд</label><input class=\"hidden\" ng-model=\"vm.item.smallSlideUrl\" required name=\"smallSlideUrl\"><div class=\"\"><!-- <button type=\"file\" ngf-select=\"vm.uploadFile($file, true, false)\" ngf-pattern=\"\'image/*\'\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">Додати файл</button> --> <button type=\"file\" ng-model=\"picFilesmallSlideUrl\" name=\"smallSlideUrl\" ngf-select=\"vm.uploadFile($file, true, false)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"500\" ngf-min-height=\"500\" ngf-min-width=\"500\" ngf-max-width=\"500\" ngf-max-size=\"10MB\">Додати файл</button> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.maxHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.maxWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.minHeight\">висота = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.minWidth\">ширина = 500px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrl.$error.pattern\">Слайд не відповідає формату(jpg, jpeg, png)</span></div><div ng-if=\"vm.item.smallSlideUrl\"><br><img ng-src=\"{{vm.imagesUrl + vm.item.smallSlideUrl}}\" style=\"mix-width: 100%\" class=\"img-thumbnail\"></div></div></div><div class=\"row\"><div class=\"col-md-4 form-group\" show-errors><label class=\"star\">Слайд Retina</label><input class=\"hidden\" ng-model=\"vm.item.bigSlideUrlRetina\" required name=\"bigSlideUrlRetina\"><div class=\"\"><!-- <button type=\"file\" ngf-select=\"vm.uploadFile($file,false, true)\" ngf-pattern=\"\'image/*\'\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">Додати файл</button> --> <button type=\"file\" ng-model=\"picFilebigSlideUrlRetina\" name=\"bigSlideUrlRetina\" ngf-select=\"vm.uploadFile($file,false, true)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1600\" ngf-max-width=\"1600\" ngf-max-size=\"10MB\">Додати файл</button> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.maxWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.minWidth\">ширина = 1600px</span> <span style=\"color:Red\" ng-show=\"vm.slide.bigSlideUrlRetina.$error.pattern\">Слайд не відповідає формату(jpg, jpeg, png)</span></div><div ng-if=\"vm.item.bigSlideUrlRetina\"><br><img ng-src=\"{{vm.imagesUrl + vm.item.bigSlideUrlRetina}}\" style=\"mix-width: 100%\" class=\"img-thumbnail\"></div></div><div class=\"col-md-2 form-group\" show-errors><label class=\"star\">Малий слайд Retina</label><input class=\"hidden\" ng-model=\"vm.item.smallSlideUrlRetina\" required name=\"smallSlideUrlRetina\"><div class=\"\"><!-- <button type=\"file\" ngf-select=\"vm.uploadFile($file, true, true)\" ngf-pattern=\"\'image/*\'\" class=\"btn btn-success btn-block\" accept=\"image/*\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\">Додати файл</button> --> <button type=\"file\" ng-model=\"picFilesmallSlideUrlRetina\" name=\"smallSlideUrlRetina\" ngf-select=\"vm.uploadFile($file, true, true)\" ngf-pattern=\"\'.jpg,.jpeg,.png\'\" multiple=\"multiple\" class=\"btn btn-success btn-block\" accept=\"image/jpeg,image/jpg,image/png\" ngf-max-height=\"1000\" ngf-min-height=\"1000\" ngf-min-width=\"1000\" ngf-max-width=\"1000\" ngf-max-size=\"10MB\">Додати файл</button> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.maxSize\">не більше 10Мб</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.maxHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.maxWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.minHeight\">висота = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.minWidth\">ширина = 1000px</span> <span style=\"color:Red\" ng-show=\"vm.slide.smallSlideUrlRetina.$error.pattern\">Слайд не відповідає формату(jpg, jpeg, png)</span></div><div ng-if=\"vm.item.smallSlideUrlRetina\"><br><img ng-src=\"{{vm.imagesUrl + vm.item.smallSlideUrlRetina}}\" style=\"mix-width: 100%\" class=\"img-thumbnail\"></div></div></div></form></section>");
$templateCache.put("app/main/site/slides/slides.view.html","<header class=\"headline row\"><div class=\"col-md-12\"><span class=\"pull-left\">Слайди</span> <span class=\"pull-right title-btns\"><a class=\"btn btn-success\" ui-sref=\"main.site.slides.edit\" ng-if=\"!vm.edit\">Створити слайд</a> <a class=\"btn btn-success\" ng-click=\"vm.save()\" ng-if=\"vm.edit\" stateful>Зберегти</a> <a class=\"btn btn-danger\" ui-sref=\"main.site.slides\" ng-if=\"vm.edit\">Скасувати</a></span></div></header><section class=\"row\" ui-view><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"list-summary pull-right\" ng-if=\"vm.slides.length > 0\">Елементи 1 - {{vm.slides.length}}</div></div><div class=\"tabler col-md-12\"><table class=\"table table-bordered table-striped table-condensed\"><thead><tr><th class=\"numbering\" class=\"col-md-1\">ID</th><th>Малий слайд</th><th class=\"event-name\">Подія / Тур</th><th>Колір фону</th><th>Колір тексту</th><th class=\"action\" class=\"col-md-1\"></th></tr></thead><tbody><tr ng-repeat=\"slide in vm.slides\" ng-if=\"!slide.deleted\"><td>{{slide.id}}</td><td><img width=\"30%\" ng-src=\"{{vm.imagesUrl + slide.smallSlideUrl}}\"></td><td><span ng-if=\"!slide.tourName\">{{slide.eventName}}</span> <span ng-if=\"!slide.eventName\">{{slide.tourName}}</span> <span ng-if=\"slide.eventName && slide.tourName\">{{slide.tourName}} / {{slide.tourName}}</span></td><td><span class=\"color-bg\" style=\"background-color: {{slide.backgroundColor}}\"></span> {{slide.backgroundColor}}</td><td><span class=\"color-bg\" style=\"background-color: {{slide.fontColor}}\"></span> {{slide.fontColor}}</td><td class=\"text-right\"><button class=\"btn btn-default btn-xs\" ui-sref=\"main.site.slides.edit({id: slide.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button><!--  <button class=\"btn btn-default btn-xs\" ng-click=\"vm.delete(slide)\">\n              <span class=\"glyphicon glyphicon-trash\" aria-hidden=\"true\"></span>\n            </button> --></td></tr></tbody></table></div></section>");
$templateCache.put("app/print/templates/1/a4.html","<div class=\"ticket_layout\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"block_2\"><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/images/logo-white.png\" alt=\"\"></div><div class=\"sub_2\"><p>+38 097 0000 754</p><p>+38 093 0000 754</p><p>+38 066 0000 754</p><span>* Тарифікація згідно з тарифами даних операторів</span></div><div class=\"clear\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><p>{{t.event}}</p><span>{{t.area}}</span> <span>{{t.city}}, {{t.address}}</span> <span>#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</span></div><div class=\"sub_2\"><p><span>Покупець: </span>{{t.client}}</p><p><span>Дата: </span>{{t.startdate | date:\'dd.MM.yyyy\'}}</p><p><span>Початок: </span>{{t.startdate | date:\'HH:mm\'}}</p><p ng-if=\"t.entrydate\"><span>Вхiд з: </span>{{t.entrydate | date:\'HH:mm\'}}</p><p ng-if=\"t.paymentStatus !== \'invite\'\"><span>Ціна: </span>{{t.price}} грн.</p><p ng-if=\"t.paymentStatus === \'invite\'\"><span>Ціна: </span>Запрошення</p><p></p><p ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\">Сервісний збір: <span>{{t.service_charge|number: 2}} грн</span></p><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}<p></p><p><span ng-if=\"t.row\">Ряд: </span>{{t.row}}</p><p><span ng-if=\"t.number\">Мiсце: </span>{{t.number}}</p></div><div class=\"clear\"></div></div><div class=\"block_4\"><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/images/logo-white.png\" alt=\"\"></div><div class=\"sub_2\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"clear\"></div></div><div class=\"block_5\"><div class=\"sub_1\"><p><strong>Увага!!! Квиток потрібно роздрукувати!</strong></p><p>Придбаний за технологією “електронний квиток” бланк містить в собі унікальний штрих-код, в якому зашифрована назва обраної Вами події, дата, час та місце в залі. Закодована на електронному квитку інформація та її автентичність перевіряється сканером штрих-кодів. Після успішної перевірки по даному квитку може бути дозволений вхід. Один квиток дає право відвідати захід лише одній особі. Система не пропускає повторів або використання одного і того ж штрих-коду двічі.</p><p>Власник квитка несе повну відповідальність за збереження квитка протягом усього заходу. Код квитка є унікальним, тому не показуйте його стороннім людям та в жодному разі не копіюйте квиток! Якщо ж з Вашої вини квиток було скопійовано (інформація стала доступною третім особам), то це розцінюється, як фізична втрата квитка. В результаті хтось інший може пройти за Вашим квитком.</p><p>За фактом успішної оплати, квиток (або квитки) має бути роздрукований на принтері, та збережений користувачем.</p><p>Увага! Не перегинайте квиток у місці розміщення коду для коректного зчитування сканером при вході на подію. Поле, де вкзаний штрих-код, має бути чітким, не затертим, без пошкоджень всього коду, або його частини. У випадку невиконання вище перелічених застережень, прохід на подію не гарантується.</p><p class=\"center\">Квитки поверненню чи обміну не підлягають.</p></div></div></div>");
$templateCache.put("app/print/templates/1/a5.html","<div class=\"ticket_layout_wrapper\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"ticket_layout\"><div class=\"block_1 rotate-90\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</div></div><div class=\"block_2 rotate-90\"><div class=\"sub_1\">{{t.event}}</div><div class=\"sub_2\"><p>{{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></p><p>Замовлено: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div><div class=\"sub_3\"></div></div><div class=\"block_3 rotate-270\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\"><p>{{t.event}} / {{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span> <span>/ #{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</span></p></div></div><div class=\"block_4\"><strong>{{t.event}}</strong></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_3\"><p>Замовлення № {{t.orderID}}</p><p>Надруковано: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div></div><div class=\"block_6\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'dd.MM.yyyy\'}}</strong></div></div><div class=\"block_7\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'HH:mm\'}}</strong></div></div><div class=\"block_8\"><div class=\"sub_1\" ng-if=\"t.paymentStatus !== \'invite\'\"><strong>{{t.price}}</strong> грн.</div><div class=\"sub_1\" ng-if=\"t.paymentStatus === \'invite\'\"><strong>Запрошення</strong></div></div><div class=\"sub_1\" ng-if=\"t.service_charge !== \'0\'\">Сервісний збір: <strong>{{t.service_charge}}</strong> грн.</div><div class=\"block_8-5\" ng-if=\"t.entrydate\"><p>Вхiд з: <span style=\"\">{{t.entrydate | date:\'HH:mm\'}}</span></p></div><div class=\"block_9\"><div class=\"sub_1\"><p><strong>{{t.area}}</strong></p><p>{{t.city}}, {{t.address}}</p></div></div><div class=\"block_10\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span><strong>{{t.zone}}</strong></div></div><div class=\"block_11\"><div class=\"sub_1\" ng-if=\"t.row\">Ряд: <strong>{{t.row}}</strong></div></div><div class=\"block_12\"><div class=\"sub_1\" ng-if=\"t.number\">Мiсце: <strong>{{t.number}}</strong></div></div></div></div>");
$templateCache.put("app/print/templates/1/e_blank.html","<div class=\"ticket_layout ticket_a4\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\"><div class=\"sub_1\">{{t.area}}</div><div class=\"sub_2\">{{t.city}}, {{t.address}}</div><div class=\"sub_3\">{{t.event}}</div></div><div class=\"block_2\"><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_1\">Дата покупки: {{t.dateSold | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_1\">Дата:<span>{{t.startdate | date:\'dd.MM.yyyy\'}}</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_1\">Дата:<div class=\"all_dates\"><span style=\"margin-left: 0\">{{t.startdate | date:\'dd.MM.yyyy\'}} - {{t.enddate | date:\'dd.MM.yyyy\'}}</span></div></div><div ng-if=\"t.longTime === true\" class=\"sub_3\">Термін дії: {{ t.endExpiryTime | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_3\">Початок: <span>{{t.startdate | date:\'HH:mm\'}}</span></div><div class=\"sub_3\" ng-if=\"t.entrydate\">Вхiд з: <span style=\"margin-left: 23px\">{{t.entrydate | date:\'HH:mm\'}}</span></div><div class=\"sub_4\">Ціна: <span ng-if=\"t.paymentStatus !== \'invite\'\">{{t.price}} грн</span> <span ng-if=\"t.paymentStatus === \'invite\'\">Запрошення</span></div><div class=\"sub_4\" ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\">Сервісний збір: <span>{{t.service_charge | number: 2}} грн</span></div><div class=\"sub_4\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</div><div class=\"sub_2\" ng-if=\"t.row\">Ряд: <span>{{t.row}}</span></div><div class=\"sub_3\" ng-if=\"t.number\">Мiсце: <span>{{t.number}}</span></div></div><div class=\"block_4\"><div class=\"sub_2\">{{t.barcode}}</div><!-- <div class=\"sub_1\"> --><div class=\"{{t.barcode}} barcode\"></div><!-- </div> --><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">{{t.event}}</div><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_4\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_6\"><div class=\"sub_1\">{{t.event}}</div><div ng-if=\"t.longTime === true\" class=\"sub_2\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_3\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div><div class=\"sub_5\"><div class=\"{{t.barcode}} barcode\"></div></div></div></div>");
$templateCache.put("app/print/templates/2/a4.html","<section class=\"a4\"><link rel=\"stylesheet\" href=\"assets/2/images/print.css\"><div class=\"ticket_layout\"><div class=\"top_layout\"><img src=\"assets/2/images/top.png\" style=\"width:778px\" alt=\"\"></div><div class=\"block_2\"><div class=\"sub_3\"><div style=\"margin-left: 30px\" class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/2/images/logo-grey.png\" alt=\"\"></div><div class=\"sub_2\"><p>+38 097 0000 754</p><p>+38 093 0000 754</p><p>+38 066 0000 754</p><span>* Тарифікація згідно з тарифами даних операторів</span></div><div class=\"clear\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><p>{{t.event}}</p><span>{{t.area}}</span> <span>{{t.city}}, {{t.adress}}</span> <span>#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</span></div><div class=\"sub_2\"><p><span>Покупець: </span>{{t.client}}</p><p><span>Дата: </span>{{t.startdate | date:\'dd.MM.yyyy\'}}</p><p><span>Початок: </span>{{t.startdate | date:\'HH:mm\'}}</p><p><span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: </span>{{t.price}}</p><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: </span>Запрошення<p></p><p></p><p ng-if=\"t.service_charge !== \'0\'\">Сервісний збір: <span>{{t.service_charge}} грн</span></p><p><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</p><p><span ng-if=\"t.row\">Ряд: </span>{{t.row}}</p><p><span ng-if=\"t.number\">Мiсце: </span>{{t.number}}</p><div class=\"images_holder\" style=\"margin-right: 25px\"><img class=\"zorya_a4\" src=\"assets/2/images/zorya.png\" alt=\"\" style=\"margin-left: 0; margin-right: 15px\"> <img class=\"herta_a4\" src=\"assets/2/images/athletic.png\" alt=\"\" style=\"width: 165px\"></div></div><div class=\"clear\"></div></div><div class=\"block_4\"><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/2/images/logo-grey.png\" alt=\"\"></div><div class=\"sub_2\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"clear\"></div></div><div class=\"block_5\"><div class=\"sub_1\"><p><strong>Увага!!! Квиток потрібно роздрукувати!</strong></p><p>Придбаний за технологією “електронний квиток” бланк містить в собі унікальний штрих-код, в якому зашифрована назва обраної Вами події, дата, час та місце в залі. Закодована на електронному квитку інформація та її автентичність перевіряється сканером штрих-кодів. Після успішної перевірки по даному квитку може бути дозволений вхід. Один квиток дає право відвідати захід лише одній особі. Система не пропускає повторів або використання одного і того ж штрих-коду двічі.</p><p>Власник квитка несе повну відповідальність за збереження квитка протягом усього заходу. Код квитка є унікальним, тому не показуйте його стороннім людям та в жодному разі не копіюйте квиток! Якщо ж з Вашої вини квиток було скопійовано (інформація стала доступною третім особам), то це розцінюється, як фізична втрата квитка. В результаті хтось інший може пройти за Вашим квитком.</p><p>За фактом успішної оплати, квиток (або квитки) має бути роздрукований на принтері, та збережений користувачем.</p><p>Увага! Не перегинайте квиток у місці розміщення коду для коректного зчитування сканером при вході на подію. Поле, де вкзаний штрих-код, має бути чітким, не затертим, без пошкоджень всього коду, або його частини. У випадку невиконання вище перелічених застережень, прохід на подію не гарантується.</p><p class=\"center\">Квитки поверненню чи обміну не підлягають.</p></div></div></div></section><style>/* START STYLES FOR ZORYA - HERTA*/\n\nbody .a4 .ticket_layout .block_3 .sub_2 p {\n  margin-bottom: 1px!important;\n  font-size: 13px!important;\n}\n\n.ac .ticket_layout .block_1 ul {\n  position: absolute;\n  display: flex;\n  align-items: baseline;\n  list-style: none;\n  justify-content: space-between;\n  padding: 0;\n  top: -45px;\n  left: 147px;\n  margin: 0;\n}\n\n.ac .ticket_layout .block_1 ul li img {\n  width: 62px;\n}\n\n.ac .ticket_layout .block_1 ul li img.fedex {\n\n}\n\n.ac .ticket_layout .block_1 ul li img.hankook {\n  height: 20px;\n  width: 31px;\n}\n\n.ac .ticket_layout .block_1 ul li img.unicredit {\n  height: 10px;\n  width: 49px;\n}\n\n.ac .ticket_layout .block_1 ul li img.enterprise {\n  display: inline-block;\n  height: 29px;\n  margin-top: 4px;\n  margin-bottom: -8px;\n  width: 45px;\n}\n\n.ac .ticket_layout .block_1 ul li img.amstel {\n  width: 46px;\n  margin-bottom: -5px;\n  height: 24px;\n  margin-left: -2px;\n}\n\n.ac .ticket_layout .block_1 ul li img.adidas {\n  width: 30px;\n}\n\n.ac .ticket_layout .block_1 .sub_1 {\n  position: relative;\n}\n\n.ac .ticket_layout .block_1 .sub_1 .europe {\n  content: url(\'../images/europe.png\');\n  position: absolute;\n  width: 39px;\n  top: -18px;\n  left: 131px;\n}\n\n.ac .ticket_layout .block_1 .sub_1 .lviv {\n  content: url(\'../images/lviv.png\');\n  position: absolute;\n  width: 42px;\n  right: 128px;\n  top: -7px;\n}\n\n.ac .ticket_layout .block_3 {\n  position: relative;\n}\n\n.ac .ticket_layout .block_3 .zorya {\n    position: absolute;\n    width: 39px;\n    top: -18px;\n    left: 127px;\n}\n\n.ac .ticket_layout .block_3 .herta {\n  position: absolute;\n    width: 40px;\n    top: -4px;\n    left: 172px;\n}\n\n.ac .ticket_layout .block_3 {\n  top: 296px;\n}\n\n.top_layout {\n  background: url(../images/top.png);\n  background-size: contain;\n  height: 149px;\n  background-repeat: no-repeat;\n}\n\n.a4 .ticket_layout .block_2 .sub_2 {\n  width: 21%;\n  float: right;\n  text-align: right;\n  color: #a1a1a1;\n  font-size: 13px;\n  margin-right: 30px;\n}\n\n.a4 .ticket_layout .block_2 .sub_1 {\n  width: 20%;\n  float: left;\n  text-align: center;\n  margin-left: 429px;\n}\n\n.a4 .ticket_layout .block_2 .sub_1 img {\n  width: 100%;\n}\n\n\n.a4 .images_holder {\n  float: right;\n  margin-right: 70px;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.a4 .images_holder .zorya_a4 {\n  margin-left: 25px;\n  margin-right: 45px;\n}\n\n.a4 .ticket_layout .block_3 .sub_3 img {\n  width: 88%;\n  margin-top: 166px;\n  margin-left: 58px;\n}\n\n.ac .ticket_layout .block_2 {\n  top: 338px;\n}\n\nbody .a4 .ticket_layout .block_4 {\n      padding-bottom: 10px!important;\n    margin-top: 20px!important;\n}\n\nbody .a4 .ticket_layout .block_5 {\n  margin-top: 15px!important;\n}\n\nbody .a4 .ticket_layout .block_5 .sub_1 p {\n  margin-bottom: 5px!important;\n  line-height: 13px!important;\n  font-size: 12px!important;\n}\n\n\n/*END STYLES FOR ZORYA - HERTA*/</style>");
$templateCache.put("app/print/templates/2/a5.html","<div class=\"ticket_layout_wrapper\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"ticket_layout\"><div class=\"block_1 rotate-90\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</div></div><div class=\"block_2 rotate-90\"><div class=\"sub_1\">{{t.event}}</div><div class=\"sub_2\"><p>{{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></p><p>Замовлено: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div><div class=\"sub_3\"></div></div><div class=\"block_3 rotate-270\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\"><p>{{t.event}} / {{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span> <span>/ #{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</span></p></div></div><div class=\"block_4\"><strong>{{t.event}}</strong></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_3\"><p>Замовлення № {{t.orderID}}</p><p>Надруковано: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div></div><div class=\"block_6\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'dd.MM.yyyy\'}}</strong></div></div><div class=\"block_7\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'HH:mm\'}}</strong></div></div><div class=\"block_8\"><div class=\"sub_1\" ng-if=\"t.paymentStatus !== \'invite\'\"><strong>{{t.price}}</strong> грн.</div><div class=\"sub_1\" ng-if=\"t.paymentStatus === \'invite\'\"><strong>Запрошення</strong></div></div><div class=\"block_8-5\" ng-if=\"t.entrydate\"><p>Вхiд з: <span style=\"\">{{t.entrydate | date:\'HH:mm\'}}</span></p></div><div class=\"block_9\"><div class=\"sub_1\"><p><strong>{{t.area}}</strong></p><p>{{t.city}}, {{t.address}}</p></div></div><div class=\"block_10\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span><strong>{{t.zone}}</strong></div></div><div class=\"block_11\"><div class=\"sub_1\" ng-if=\"t.row\">Ряд: <strong>{{t.row}}</strong></div></div><div class=\"block_12\"><div class=\"sub_1\" ng-if=\"t.number\">Мiсце: <strong>{{t.number}}</strong></div></div></div></div>");
$templateCache.put("app/print/templates/2/e_blank.html","<link rel=\"stylesheet\" href=\"assets/2/images/print.css\"><div class=\"ticket_layout ticket_a4\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\" style=\"left: -103px\"><ul><li><img class=\"fedex\" src=\"assets/2/images/fedex-mono.png\" alt=\"\"></li><li><img class=\"hankook\" src=\"assets/2/images/hankook-mono.png\" alt=\"\"></li><li><img class=\"unicredit\" src=\"assets/2/images/unicredit-mono.png\" alt=\"\"></li><li><img class=\"enterprise\" src=\"assets/2/images/enterprise-mono.png\" alt=\"\"></li><li><img class=\"amstel\" src=\"assets/2/images/amstel-mono.png\" alt=\"\"></li><li><img class=\"adidas\" src=\"assets/2/images/adidas-mono.png\" alt=\"\"></li></ul><div class=\"sub_1\"><img class=\"europe\" src=\"assets/2/images/league-mono.png\" alt=\"\"> {{t.area}}<img src=\"assets/2/images/lviv-mono.png\" class=\"lviv\" alt=\"\"></div><div class=\"sub_2\">{{t.city}}, {{t.address}}</div><div class=\"sub_3\">{{t.event}}</div></div><div class=\"block_2\"><div class=\"sub_1\">Дата: <span>{{t.startdate | date:\'dd.MM.yyyy\'}}</span></div><div class=\"sub_3\">Початок: <span>{{t.startdate | date:\'HH:mm\'}}</span></div><div class=\"sub_3\" ng-if=\"t.entrydate\">Вхiд з: <span style=\"margin-left: 23px\">{{t.entrydate | date:\'HH:mm\'}}</span></div><div class=\"sub_4\">Ціна: <span ng-if=\"t.paymentStatus !== \'invite\'\">{{t.price}} грн</span> <span ng-if=\"t.paymentStatus === \'invite\'\">Запрошення</span></div></div><div class=\"block_3\"><img src=\"assets/2/images/zorya-mono.png\" class=\"zorya\" alt=\"\"><div><img src=\"assets/2/images/athletic-mono.png\" class=\"herta\" alt=\"\"></div><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</div><div class=\"sub_2\" ng-if=\"t.row\">Ряд: <span>{{t.row}}</span></div><div class=\"sub_3\" ng-if=\"t.number\">Мiсце: <span>{{t.number}}</span></div></div><div class=\"block_4\"><div class=\"sub_2\">{{t.barcode}}</div><!-- <div class=\"sub_1\"> --><div class=\"{{t.barcode}} barcode\"></div><!-- </div> --><div class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">{{t.event}}</div><div class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_4\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_6\"><div class=\"sub_1\">{{t.event}}</div><div class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_3\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div><div class=\"sub_5\"><div class=\"{{t.barcode}} barcode\"></div></div></div></div><style>/* START STYLES FOR ZORYA - HERTA*/\r\n\r\n.ac .ticket_layout .block_1 ul {\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: baseline;\r\n  list-style: none;\r\n  justify-content: space-between;\r\n  padding: 0;\r\n  left: 147px;\r\n  top: -43px;\r\n  margin: 0;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img {\r\n  width: 42px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.fedex {\r\n\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.hankook {\r\n  height: 20px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.unicredit {\r\n  width: 49px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.enterprise {\r\n  display: inline-block;\r\n  margin-top: 4px;\r\n  margin-bottom: -8px;\r\n  width: 45px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.amstel {\r\n  width: 46px;\r\n  margin-bottom: -5px;\r\n  margin-left: -2px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 ul li img.adidas {\r\n  width: 30px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 .sub_1 {\r\n  position: relative;\r\n}\r\n\r\n.ac .ticket_layout .block_1 .sub_1 .europe {\r\n  content: url(\'../images/europe.png\');\r\n  position: absolute;\r\n  width: 39px;\r\n  top: -16px;\r\n  left: 131px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 .sub_1 .lviv {\r\n  content: url(\'../images/lviv.png\');\r\n  position: absolute;\r\n  width: 42px;\r\n  right: 128px;\r\n  top: -5px;\r\n}\r\n\r\n.ac .ticket_layout .block_3 {\r\n  position: relative;\r\n}\r\n\r\n.ac .ticket_layout .block_3 .zorya {\r\n    position: absolute;\r\n    width: 39px;\r\n    top: -18px;\r\n    left: 123px;\r\n}\r\n\r\n.ac .ticket_layout .block_3 .herta {\r\n  position: absolute;\r\n  width: 48px;\r\n  top: -10px;\r\n  left: 173px;\r\n}\r\n.ac .ticket_layout .block_3 .oak-mono {\r\n  position: absolute;\r\n  width: 22px;\r\n  top: -16px;\r\n  left: 167px;\r\n}\r\n.ac .ticket_layout .block_3 .herta-mono {\r\n  position: absolute;\r\n  width: 22px;\r\n  top: -13px;\r\n  left: 190px;\r\n}\r\n\r\n.ac .ticket_layout .block_3 {\r\n  top: 296px;\r\n}\r\n\r\n.top_layout {\r\n  background: url(../images/top.png);\r\n  background-size: contain;\r\n  height: 149px;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.a4 .ticket_layout .block_2 .sub_2 {\r\n  width: 21%;\r\n  float: right;\r\n  text-align: right;\r\n  color: #a1a1a1;\r\n  font-size: 13px;\r\n  margin-right: 30px;\r\n}\r\n\r\n.a4 .ticket_layout .block_2 .sub_1 {\r\n  width: 20%;\r\n  float: left;\r\n  text-align: center;\r\n  margin-left: 429px;\r\n}\r\n\r\n.a4 .ticket_layout .block_2 .sub_1 img {\r\n  width: 100%;\r\n}\r\n\r\n\r\n.a4 .images_holder {\r\n      float: right;\r\n    margin-right: 70px;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.a4 .images_holder .zorya_a4 {\r\n  margin-left: 25px;\r\n  margin-right: 45px;\r\n}\r\n\r\n.a4 .ticket_layout .block_3 .sub_3 img {\r\n  width: 88%;\r\n  margin-top: 166px;\r\n  margin-left: 58px;\r\n}\r\n\r\n.ac .ticket_layout .block_2 {\r\n  top: 343px;\r\n  left: -183px;\r\n}\r\n\r\nbody .ac .ticket_layout .block_2 .sub_1 span {\r\n  margin-left: 3px;\r\n}\r\n\r\n.ac .ticket_layout .block_1 {\r\n  top: 200px;\r\n}\r\n\r\n.ac .ticket_layout .block_2 {\r\n    top: 324px;\r\n    left: -183px;\r\n}\r\n\r\n.ac .ticket_layout .block_3 {\r\n    top: 280px;\r\n}\r\n.ac .ticket_layout .block_5 {\r\n  margin-top: -60px;\r\n}\r\n\r\n/*END STYLES FOR ZORYA - HERTA*/</style>");
$templateCache.put("app/print/templates/3/a4.html","<div class=\"ticket_layout\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"block_2\"><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/images/logo-white.png\" alt=\"\"></div><div class=\"sub_2\"><p>+38 097 0000 754</p><p>+38 093 0000 754</p><p>+38 066 0000 754</p><span>* Тарифікація згідно з тарифами даних операторів</span></div><div class=\"clear\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><p>{{t.event}}</p><span>{{t.area}}</span> <span>{{t.city}}, {{t.address}}</span> <span>#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</span></div><div class=\"sub_2\"><p><span>Покупець: </span>{{t.client}}</p><p><span>Дата: </span>{{t.startdate | date:\'dd.MM.yyyy\'}}</p><p><span>Початок: </span>{{t.startdate | date:\'HH:mm\'}}</p><p ng-if=\"t.entrydate\"><span>Вхiд з: </span>{{t.entrydate | date:\'HH:mm\'}}</p><p ng-if=\"t.paymentStatus !== \'invite\'\"><span>Ціна: </span>{{t.price}} грн.</p><p ng-if=\"t.paymentStatus === \'invite\'\"><span>Ціна: </span>Запрошення</p><p></p><p ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\">Сервісний збір: <span>{{t.service_charge|number: 2}} грн</span></p><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}<p></p><p><span ng-if=\"t.row\">Ряд: </span>{{t.row}}</p><p><span ng-if=\"t.number\">Мiсце: </span>{{t.number}}</p></div><div class=\"clear\"></div></div><div class=\"block_4\"><div class=\"sub_1\"><img class=\"logo-print\" src=\"assets/images/logo-white.png\" alt=\"\"></div><div class=\"sub_2\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"clear\"></div></div><div class=\"block_5\"><div class=\"sub_1\"><p><strong>Увага!!! Квиток потрібно роздрукувати!</strong></p><p>Придбаний за технологією “електронний квиток” бланк містить в собі унікальний штрих-код, в якому зашифрована назва обраної Вами події, дата, час та місце в залі. Закодована на електронному квитку інформація та її автентичність перевіряється сканером штрих-кодів. Після успішної перевірки по даному квитку може бути дозволений вхід. Один квиток дає право відвідати захід лише одній особі. Система не пропускає повторів або використання одного і того ж штрих-коду двічі.</p><p>Власник квитка несе повну відповідальність за збереження квитка протягом усього заходу. Код квитка є унікальним, тому не показуйте його стороннім людям та в жодному разі не копіюйте квиток! Якщо ж з Вашої вини квиток було скопійовано (інформація стала доступною третім особам), то це розцінюється, як фізична втрата квитка. В результаті хтось інший може пройти за Вашим квитком.</p><p>За фактом успішної оплати, квиток (або квитки) має бути роздрукований на принтері, та збережений користувачем.</p><p>Увага! Не перегинайте квиток у місці розміщення коду для коректного зчитування сканером при вході на подію. Поле, де вкзаний штрих-код, має бути чітким, не затертим, без пошкоджень всього коду, або його частини. У випадку невиконання вище перелічених застережень, прохід на подію не гарантується.</p><p class=\"center\">Квитки поверненню чи обміну не підлягають.</p></div></div><div class=\"block_6\"><div style=\"text-align: center; margin-top: 30px\"><img src=\"assets/2/images/11111.jpg\" alt=\"\" height=\"60px\"></div></div></div>");
$templateCache.put("app/print/templates/3/a5.html","<div class=\"ticket_layout_wrapper\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"ticket_layout\"><div class=\"block_1 rotate-90\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</div></div><div class=\"block_2 rotate-90\"><div class=\"sub_1\">{{t.event}}</div><div class=\"sub_2\"><p>{{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></p><p>Замовлено: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div><div class=\"sub_3\"></div></div><div class=\"block_3 rotate-270\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\"><p>{{t.event}} / {{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span> <span>/ #{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</span></p></div></div><div class=\"block_4\"><strong>{{t.event}}</strong></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_3\"><p>Замовлення № {{t.orderID}}</p><p>Надруковано: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div></div><div class=\"block_6\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'dd.MM.yyyy\'}}</strong></div></div><div class=\"block_7\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'HH:mm\'}}</strong></div></div><div class=\"block_8\"><div class=\"sub_1\" ng-if=\"t.paymentStatus !== \'invite\'\"><strong>{{t.price}}</strong> грн.</div><div class=\"sub_1\" ng-if=\"t.paymentStatus === \'invite\'\"><strong>Запрошення</strong></div></div><div class=\"sub_1\" ng-if=\"t.service_charge !== \'0\'\">Сервісний збір: <strong>{{t.service_charge}}</strong> грн.</div><div class=\"block_8-5\" ng-if=\"t.entrydate\"><p>Вхiд з: <span style=\"\">{{t.entrydate | date:\'HH:mm\'}}</span></p></div><div class=\"block_9\"><div class=\"sub_1\"><p><strong>{{t.area}}</strong></p><p>{{t.city}}, {{t.address}}</p></div></div><div class=\"block_10\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span><strong>{{t.zone}}</strong></div></div><div class=\"block_11\"><div class=\"sub_1\" ng-if=\"t.row\">Ряд: <strong>{{t.row}}</strong></div></div><div class=\"block_12\"><div class=\"sub_1\" ng-if=\"t.number\">Мiсце: <strong>{{t.number}}</strong></div></div></div></div>");
$templateCache.put("app/print/templates/3/e_blank.html","<div class=\"ticket_layout ticket_a4\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\"><div class=\"sub_1\">{{t.area}}</div><div class=\"sub_2\">{{t.city}}, {{t.address}}</div><div class=\"sub_3\">{{t.event}}</div></div><div class=\"block_2\"><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_1\">Дата покупки: {{t.dateSold | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_1\">Дата:<span>{{t.startdate | date:\'dd.MM.yyyy\'}}</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_1\">Дата:<div class=\"all_dates\"><span style=\"margin-left: 0\">{{t.startdate | date:\'dd.MM.yyyy\'}} - {{t.enddate | date:\'dd.MM.yyyy\'}}</span></div></div><div ng-if=\"t.longTime === true\" class=\"sub_3\">Термін дії: {{ t.endExpiryTime | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_3\">Початок: <span>{{t.startdate | date:\'HH:mm\'}}</span></div><div class=\"sub_3\" ng-if=\"t.entrydate\">Вхiд з: <span style=\"margin-left: 23px\">{{t.entrydate | date:\'HH:mm\'}}</span></div><div class=\"sub_4\">Ціна: <span ng-if=\"t.paymentStatus !== \'invite\'\">{{t.price}} грн</span> <span ng-if=\"t.paymentStatus === \'invite\'\">Запрошення</span></div><div class=\"sub_4\" ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\">Сервісний збір: <span>{{t.service_charge | number: 2}} грн</span></div><div class=\"sub_4\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</div><div class=\"sub_2\" ng-if=\"t.row\">Ряд: <span>{{t.row}}</span></div><div class=\"sub_3\" ng-if=\"t.number\">Мiсце: <span>{{t.number}}</span></div></div><div class=\"block_4\"><div class=\"sub_2\">{{t.barcode}}</div><!-- <div class=\"sub_1\"> --><div class=\"{{t.barcode}} barcode\"></div><!-- </div> --><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">{{t.event}}</div><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_4\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_6\"><div class=\"sub_1\">{{t.event}}</div><div ng-if=\"t.longTime === true\" class=\"sub_2\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_3\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div><div class=\"sub_5\"><div class=\"{{t.barcode}} barcode\"></div></div></div></div>");
$templateCache.put("app/print/templates/4/a4.html","<div class=\"ticket_layout\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><link rel=\"stylesheet\" href=\"assets/templates/4/css/fonts.css\"><link rel=\"stylesheet\" href=\"assets/templates/4/css/print.css\"><div class=\"block_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"block_2\"><div class=\"sub_1\"><img src=\"assets/templates/4/images/logo_kasa.svg\" alt=\"\"></div><div class=\"sub_2\"><p>+38 097 0000 754</p><p>+38 093 0000 754</p><p>+38 066 0000 754</p><span>* Тарифікація згідно з тарифами даних операторів</span></div><div class=\"clear\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><div class=\"event_name\">{{t.event}}</div><div class=\"event_area\">{{t.area}}</div><div class=\"event_address\">{{t.city}}, {{t.address}}</div><div class=\"event_order\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</div></div><div class=\"sub_2\"><p ng-if=\"t.paymentStatus !== \'invite\'\"><span>Покупець: </span>{{t.client}}</p><p ng-if=\"t.paymentStatus === \'invite\'\"><span>Ціна: </span>Запрошення не для продажу</p><p><span>Дата: </span>{{t.startdate | date:\'dd.MM.yyyy\'}}</p><p><span>Початок: </span>{{t.startdate | date:\'HH:mm\'}}</p><p ng-if=\"t.entrydate\"><span>Вхiд з: </span>{{t.entrydate | date:\'HH:mm\'}}</p><p ng-if=\"t.paymentStatus !== \'invite\'\"><span>Ціна: </span>{{t.price}} грн</p><p ng-if=\"t.paymentStatus === \'invite\'\"><span>Ціна: </span>Запрошення</p><p ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\"><span>Серв. збір: </span>{{t.service_charge|number: 2}} грн</p><p><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</p><p><span ng-if=\"t.row\">Ряд: </span>{{t.row}}</p><p><span ng-if=\"t.number\">Мiсце: </span>{{t.number}}</p><p>&nbsp;</p><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"clear\"></div></div><div class=\"block_4\"></div><div class=\"block_5\"><div class=\"sub_1\" ng-if=\"t.paymentStatus === \'invite\'\"><p><strong>Увага!!! Запрошення потрібно роздрукувати!</strong></p><p>Бланк запрошення містить в собі унікальний штрих-код, в якому зашифрована назва події, дата, час та місце в залі.<br>Закодована на електронному запрошенні інформація та її автентичність перевіряється сканером штрих-кодів.<br>Після успішної перевірки по даному штрих-коду може бути дозволений вхід. Один бланк дає право відвідати захід<br>лише одній особі. Система не пропускає повторів або використання одного й того ж штрих-коду двічі.</p><p>Власник запрошення несе повну відповідальність за збереження бланку протягом усього заходу.<br>Код є унікальним, тому не показуйте його стороннім людям та в жодному разі не копіюйте і не поширюйте<br>запрошення в інтернет мережі. Якщо з вашої вини, штрих-код на запрошенні або само запрошення було<br>скопійовано і інформація стала доступна третім особам, то це розцінюється, як фізична втрата запрошення і ваш<br>доступ на подію буде скасований, оскільки інша людина зможе скористатись вашим запрошенням.</p><p><strong>Увага!</strong> Не перегинайте запрошення у місці розміщення штрих-коду для коректного зчитування коду сканером при вході<br>на подію. Поле, де вказаний штрих-код має бути чітким, не затертим, без пошкоджень всього коду або його частини.</p><p><strong>У випадку невиконання вище перелічених застережень, прохід на подію не гарантується.</strong></p></div><div class=\"sub_1\" ng-if=\"t.paymentStatus !== \'invite\'\"><p><strong>Увага!!! Квиток потрібно роздрукувати!</strong></p><p>Бланк квитка містить в собі унікальний штрих-код, в якому зашифрована назва події, дата, час та місце в залі.<br>Закодована на електронному квитку інформація та її автентичність перевіряється сканером штрих-кодів.<br>Після успішної перевірки по даному штрих-коду може бути дозволений вхід. Один бланк дає право відвідати захід<br>лише одній особі. Система не пропускає повторів або використання одного й того ж штрих-коду двічі.</p><p>Власник квитка несе повну відповідальність за збереження бланку протягом усього заходу.<br>Код є унікальним, тому не показуйте його стороннім людям та в жодному разі не копіюйте і не поширюйте<br>квиток в інтернет мережі. Якщо з вашої вини, штрих-код з квитка або сам квиток було<br>скопійовано і інформація стала доступна третім особам, то це розцінюється, як фізична втрата квитка і ваш<br>доступ на подію буде скасований, оскільки інша людина зможе скористатись вашим квитком.</p><p><strong>Увага!</strong> Не перегинайте квиток у місці розміщення штрих-коду для коректного зчитування коду сканером при вході<br>на подію. Поле, де вказаний штрих-код має бути чітким, не затертим, без пошкоджень всього коду або його частини.</p><p><strong>У випадку невиконання вище перелічених застережень, прохід на подію не гарантується.</strong></p></div></div><div class=\"footer\"><div><img src=\"assets/templates/4/images/icons_footer.svg\" alt=\"\"></div><div><img src=\"assets/templates/4/images/banner_footer_phones.png\" alt=\"\"></div></div></div>");
$templateCache.put("app/print/templates/4/a5.html","<div class=\"ticket_layout_wrapper\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"ticket_layout\"><div class=\"block_1 rotate-90\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</div></div><div class=\"block_2 rotate-90\"><div class=\"sub_1\">{{t.event}}</div><div class=\"sub_2\"><p>{{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></p><p>Замовлено: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div><div class=\"sub_3\"></div></div><div class=\"block_3 rotate-270\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\"><p>{{t.event}} / {{t.startdate | date:\'dd.MM.yyyy\'}} / {{t.startdate | date:\'HH:mm\'}} / {{t.city}}</p><p><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span> <span>/ #{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id:{{vm.userData.id}}</span></p></div></div><div class=\"block_4\"><strong>{{t.event}}</strong></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_3\"><p>Замовлення № {{t.orderID}}</p><p>Надруковано: {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}}</p><p>Касир № {{vm.userData.id}}</p></div></div><div class=\"block_6\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'dd.MM.yyyy\'}}</strong></div></div><div class=\"block_7\"><div class=\"sub_1\"><strong>{{t.startdate | date:\'HH:mm\'}}</strong></div></div><div class=\"block_8\"><div class=\"sub_1\" ng-if=\"t.paymentStatus !== \'invite\'\"><strong>{{t.price}}</strong> {{t.currency === \'UAH\' ? \'грн.\' : t.currency}}</div><div class=\"sub_1\" ng-if=\"t.paymentStatus === \'invite\'\"><strong>Запрошення</strong></div></div><div class=\"sub_1\" ng-if=\"t.service_charge !== \'0\'\">Сервісний збір: <strong>{{t.service_charge}}</strong> {{t.currency === \'UAH\' ? \'грн.\' : t.currency}}</div><div class=\"block_8-5\" ng-if=\"t.entrydate\"><p>Вхiд з: <span style=\"\">{{t.entrydate | date:\'HH:mm\'}}</span></p></div><div class=\"block_9\"><div class=\"sub_1\"><p><strong>{{t.area}}</strong></p><p>{{t.city}}, {{t.address}}</p></div></div><div class=\"block_10\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span><strong>{{t.zone}}</strong></div></div><div class=\"block_11\"><div class=\"sub_1\" ng-if=\"t.row\">Ряд: <strong>{{t.row}}</strong></div></div><div class=\"block_12\"><div class=\"sub_1\" ng-if=\"t.number\">Мiсце: <strong>{{t.number}}</strong></div></div></div></div>");
$templateCache.put("app/print/templates/4/e_blank.html","<div class=\"ticket_layout ticket_a4\" ng-class=\"{ticketrotate: vm.ticketsRotationAngle}\"><div class=\"block_1\"><div class=\"sub_1\">{{t.area}}</div><div class=\"sub_2\">{{t.city}}, {{t.address}}</div><div class=\"sub_3\">{{t.event}}</div></div><div class=\"block_2\"><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_1\">Дата покупки: {{t.dateSold | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_1\">Дата:<span>{{t.startdate | date:\'dd.MM.yyyy\'}}</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_1\">Дата:<div class=\"all_dates\"><span style=\"margin-left: 0\">{{t.startdate | date:\'dd.MM.yyyy\'}} - {{t.enddate | date:\'dd.MM.yyyy\'}}</span></div></div><div ng-if=\"t.longTime === true\" class=\"sub_3\">Термін дії: {{ t.endExpiryTime | date:\'dd.MM.yyyy\'}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_3\">Початок: <span>{{t.startdate | date:\'HH:mm\'}}</span></div><div class=\"sub_3\" ng-if=\"t.entrydate\">Вхiд з: <span style=\"margin-left: 23px\">{{t.entrydate | date:\'HH:mm\'}}</span></div><div class=\"sub_4\">Ціна: <span ng-if=\"t.paymentStatus !== \'invite\'\">{{t.price}} {{t.currency === \'UAH\' ? \'грн\' : t.currency}}</span> <span ng-if=\"t.paymentStatus === \'invite\'\">Запрошення</span></div><div class=\"sub_4\" ng-if=\"t.service_charge > 0 && !(t.paymentStatus === \'invite\')\">Сервісний збір: <span>{{t.service_charge | number: 2}} {{t.currency === \'UAH\' ? \'грн\' : t.currency}}</span></div><div class=\"sub_4\"></div></div><div class=\"block_3\"><div class=\"sub_1\"><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</div><div class=\"sub_2\" ng-if=\"t.row\">Ряд: <span>{{t.row}}</span></div><div class=\"sub_3\" ng-if=\"t.number\">Мiсце: <span>{{t.number}}</span></div></div><div class=\"block_4\"><div class=\"sub_2\">{{t.barcode}}</div><!-- <div class=\"sub_1\"> --><div class=\"{{t.barcode}} barcode\"></div><!-- </div> --><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_5\"><div class=\"sub_1\"><div class=\"{{t.barcode}} barcode\"></div></div><div class=\"sub_2\">{{t.event}}</div><div ng-if=\"t.longTime === true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_3\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_4\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div></div><div class=\"block_6\"><div class=\"sub_1\">{{t.event}}</div><div ng-if=\"t.longTime === true\" class=\"sub_2\">{{t.city}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates !== true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div ng-if=\"t.longTime !== true && t.displayAllDates === true\" class=\"sub_2\">{{t.city}}, {{t.startdate | date:\'dd.MM.yyyy HH:mm\'}} - {{t.enddate | date:\'dd.MM.yyyy HH:mm\'}}, <span ng-if=\"t.paymentStatus !== \'invite\'\">Ціна: {{t.price}} </span><span ng-if=\"t.paymentStatus === \'invite\'\">Ціна: Запрошення</span></div><div class=\"sub_3\"><span><span ng-if=\"t.row && t.number\">Сектор: </span>{{t.zone}}</span> <span ng-if=\"t.row\">, Ряд: {{t.row}}</span> <span ng-if=\"t.number\">, Мiсце: {{t.number}}</span></div><div ng-if=\"t.longTime === true\" class=\"sub_4\">#{{t.orderID}} / термін дії: {{t.endExpiryTime | date:\'dd.MM.yyyy\'}} / id: {{vm.userData.id}}</div><div ng-if=\"t.longTime !== true\" class=\"sub_4\">#{{t.orderID}} / {{vm.currentDate | date:\'dd.MM.yyyy HH:mm\'}} / id: {{vm.userData.id}}</div><div class=\"sub_5\"><div class=\"{{t.barcode}} barcode\"></div></div></div></div>");
$templateCache.put("app/main/configs/event-permissions/parts/filters.html","<div class=\"row\"><div class=\"col-md-12\"><h4>Фільтри</h4></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label>Місто проведення</label><selectlist input-method=\"vm.getCities\" output-model=\"vm.filters.cityID\" disabled=\"vm.filters.eventID.length > 0\"></selectlist></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3\"><label>ID події</label><input type=\"text\" ng-model=\"vm.filters.eventID\" class=\"form-control\"></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><label>Назва події</label><events-filter output-model=\"vm.filters.eventID\" hidestate city=\"vm.filters.cityID\" reset=\"vm.eventReset\"></events-filter></div></div><br><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>Дата події</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._dateFrom\" on-blur=\"vm.applyDateFilter()\" max=\"vm.filters._dateTo\"><input type=\"text\" class=\"form-control\" placeholder=\"Початкова дата\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\"><label>&nbsp;</label><div class=\"input-group datepicker\" datetimepicker options=\"vm.calendarOptions\" ng-model=\"vm.filters._dateTo\" on-blur=\"vm.applyDateFilter()\"><input type=\"text\" class=\"form-control\" placeholder=\"Кiнцева дата\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-calendar\"></span></span></div></div><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"></div></div><hr><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"vm.clearFilters()\" stateful>Скинути фільтри</button></div></div>");
$templateCache.put("app/main/configs/event-permissions/parts/form.html","<div class=\"row\"><div class=\"col-md-12\"><h4>Додати подію</h4></div><form name=\"vm.eventForm\" novalidate autocomplete=\"off\"><div class=\"form-group col-xs-12 col-sm-6 col-md-6 col-lg-6\" show-dd-errors=\"vm.event.id\"><label class=\"control-label star\" for=\"eventId\">Назва події</label><events-filter output-model=\"vm.event.id\" hidestate></events-filter><input type=\"hidden\" name=\"eventId\" class=\"form-control\" ng-model=\"vm.event.id\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4 col-lg-4\"><label class=\"control-label\" for=\"eventId\">&nbsp</label><br><a class=\"btn btn-success\" ng-click=\"vm.addEvent()\" stateful>Додати</a></div></form></div><hr>");
$templateCache.put("app/main/configs/users/modal/user-change-password.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Змінити пароль</h3></div><div class=\"modal-body\"><form class=\"form\" name=\"changepassword\" novalidate><div class=\"form-group\" show-errors><label class=\"star\">Новий пароль</label><input type=\"password\" name=\"password\" ng-model=\"model.password\" class=\"form-control\" required> <span class=\"help-block\">Обов\'язкове поле</span></div><div class=\"form-group\" show-dd-errors=\"!changepassword.confirm_password.$error.validator\"><label class=\"star\">Ще раз пароль</label><input type=\"password\" name=\"confirm_password\" ng-model=\"model.confirm_password\" ui-validate=\"\'$value == model.password\'\" ui-validate-watch=\"\'model.password\'\" class=\"form-control\" required> <span class=\"help-block\">Пароль не збігається</span></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"changepassword.$invalid\" ng-click=\"ok()\">Змінити</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Відміна</button></div>");
$templateCache.put("app/main/configs/subdivisions/modal/modal.delete.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Увага!</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-md-12\">Ви підтверджуєте видалення підрозділу?</div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary pull-left\" type=\"button\" ng-click=\"ok()\">Так</button> <button class=\"btn btn-warning pull-right\" type=\"button\" ng-click=\"close()\">Ні</button></div>");
$templateCache.put("app/main/site/recommendations/modal/modal.delete.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Увага!</h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-md-12\">Ви підтверджуєте видалення події з рекомендацій?</div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary pull-left\" type=\"button\" ng-click=\"ok()\">Так</button> <button class=\"btn btn-warning pull-right\" type=\"button\" ng-click=\"close()\">Ні</button></div>");}]);